export const messages = {
  en: {
    _name: 'English',
    policy: 'Privacy Policy',
    policyAML: 'AML Policy',
    policyKYC: 'KYC Policy',
    locense: 'License',
    view_all: 'View All',
    sell_btn: 'Sell',
    buy_btn: 'Buy',
    currency_action: 'currency',

    importantAccountDetails: 'Important account details',
    viewAdditionalSettings: 'View additional settings',
    switchDarkMode: 'Switch dark/light mode',
    writeProblem: 'Write your problem to us',
    darkMode: 'Dark mode',

    yay: 'Yay',
    purchased: 'You successfully purchased',
    from: 'from',
    walet: 'Wallet',
    trade: 'Trade',

    withdrawDetails: 'Withdrawal details',
    saveDetails: 'Save details for next time',
    amountToWithdraw: 'Amount to withdraw',
    withdrawLimit: '$1,000,000.00 daily withdrawal limit remaining.',

    serviceFee: 'Service fee',
    youWillPay: 'You will pay',
    cancel: 'Cancel',
    understand: 'I understand, continue',

    select: 'Select',
    enterAmount: 'Enter amount',
    orderInfo: 'Order Info',
    confirmOrder: 'Confirm Order',
    get: 'Get',
    spend: 'Spend',
    buying: 'Buying',
    accountTransactions: 'Account Transactions',
    overview: 'Overview',
    accountBalances: 'Account Balances',
    details: 'Details',
    loginHistory: 'Login history',
    device: 'Device',
    contactUs: 'Contact us',
    sessionLog: 'Sessions & login history',
    selectMethods: 'Select methods',
    depositDetails: 'Deposit details',
    order: 'Order',
    support: 'Support',
    supportChat: 'Support Chat',
    createChat: 'Create Chat',
    homepage: 'Home',
    takeProfitStopLoss: 'Take Profit & Stop Loss',
    takeProfit: 'Take Profit',
    stopLoss: 'Stop Loss',
    updateOrder: 'Update Order',
    balance: 'Balance',
    credit: 'Credit',
    equity: 'Equity',
    practice: 'PRACTICE',
    real: 'REAL',
    account: 'ACCOUNT',
    invested: 'Invested',
    profit: 'Profit',
    loss: 'Loss',
    margin: 'Margin',
    marginLevel: 'Margin Level',
    marginFree: 'Free Margin',
    cfd: 'CFD',
    platform: 'Platform',
    deposit: 'Deposit',
    marketWatch: 'Market Watch',
    activeOrders: 'Open Orders',
    tradingHistory: 'Trading History',
    economicCalendar: 'Economic Calendar',
    marketNews: 'Market News',
    closeOrder: 'Close Position',
    areYouSure: 'Are you sure to close the position',
    buy: 'Buy',
    sell: 'Sell',
    yes: 'Yes',
    no: 'No',
    addNewChart: 'Add New Chart',
    watchlist: 'Watchlist',
    asset: 'Asset',
    price: 'Price',
    changePct: 'Change 24h',
    pending: 'Pending',
    assetPrice: 'Asset Price',
    current: 'Current',
    revert: 'Revert to Market Price',
    automatically:
      'Position will be opened automatically when the price reaches this level',
    default: 'default',
    volume: 'Volume',
    lots: 'lots',
    units: 'units',
    currency: 'currency',
    contractSize: 'Contract size',
    position: 'Position',
    margin: 'Margin',
    freeMargin: 'Free Margin',
    takeProfitStopLoss: 'Take Profit & Stop Loss',
    pending: 'Pending',
    market: 'Market',
    leverage: 'Leverage',
    spread: 'Spread',
    notSet: 'Not set',
    at: 'at',
    buy: 'buy',
    sell: 'sell',
    supportBanner: 'EVERY DAY, AROUND THE CLOCK',
    currentTime: 'CURRENT TIME',
    liveChat: 'Live Chat',
    balance: 'Balance',
    credit: 'Credit',
    equity: 'Equity',
    margin: 'Margin',
    marginLevel: 'Margin level',
    freeMargin: 'Free Margin',
    pnl: 'PnL',
    profitTotal: 'Lifetime PnL',
    dateRegistered: 'Date Registered',
    userId: 'User ID',
    dashboard: 'Dashboard',
    personalData: 'Personal Data',
    deposit: 'Deposit',
    withdrawFunds: 'Withdraw Funds',
    savings: 'Savings',
    settings: 'Settings',
    logout: 'Logout',
    BT_INVOICE: 'Enter amount and generate invoice',
    BT_TITLE: 'Our banking details',
    account: 'Account',
    bank_name: 'Bank Name',
    beneficiary: 'Beneficiary',
    beneficiary_address: 'Beneficiary Address',
    swift: 'Swift',
    iban: 'IBAN',
    ru_inn: 'INN',
    ru_kpp: 'KPP',
    corresponding_account: 'Correspondent account',
    TOKEN_AMOUNT: 'Amount',
    TOKEN_SUBTOTAL: 'Subtotal',
    TOKEN_TOTAL: 'Total',
    TOKEN_DESCRIPTION: 'Description',
    TOKEN_PAYMENT_DETAILS: 'Payment Details',
    PENDING_DEPOSITS_LIMIT: 'Deposit Limit',
    makeDeposit: 'Make a Deposit',
    practiceAccount: 'Practice Account',
    realAccount: 'Real Account',
    noWithdrawals: 'No Withdrawals',
    easyWithdrawals: 'Easy Withdrawals',
    allAssets: 'All assets available',
    fullFledged: 'Full-ledged platform',
    fillUpTo: 'Fill Up To',
    freeReplenishment: 'Free replenishment',
    topUp: 'Top Up Your Account',
    minimumAmount: 'Minimum amount',
    maxAmount: 'Max amount',
    withdrawalType: 'Withdrawal Type',
    canSwitch: 'You can switch between your accounts at any moment',
    chartGrids: 'CHART GRIDS',
    chart1: '1 chart',
    chart2: '2 charts',
    chart3: '3 charts',
    chart4: '4 charts',
    connectionLost: 'Connection with the server is lost',
    retryNow: 'Retry Now',
    loginToTradeRoom: 'Login To Traderoom',
    email: 'Email address',
    enterEmail: 'Enter your email',
    twoFactor: '2FA Code (if enabled)',
    twoFactorAuth: 'Two-factor authentication',
    password: 'Password',
    yourPassword: 'Your password',
    signIn: 'Sign In',
    dontHaveAccount: 'Don’t have an account?',
    restore: 'Restore',
    fullName: 'Full Name',
    havePromo: 'I have a promo-code',
    promo: 'Promo code',
    login: 'Login',
    haveAccount: 'Already have an account?',
    hide: 'Hide',
    goTo: 'Go to back',

    setNewPassword: 'Set New Password',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm new password',
    setButton: 'Set',

    repeatPassword: 'Repeat Password',
    createNewAccount: 'Create A New Account',
    email: 'Email address',
    firstName: 'First Name',
    lastName: 'Last Name',
    country: 'Country',
    phone: 'Phone',
    password: 'Password',
    createAccount: 'Create Account',
    currency: 'Currency',

    forgotPassword: 'Forgot Password?',
    submitEmail:
      'Please submit an email used for registration, check your inbox and follow the instructions provided',
    submit: 'Submit',
    error: 'Error',
    success: 'Success',
    deposit: 'Deposit',
    withdrawal: 'Withdrawal',
    depositApproved: 'Deposit has been approved',
    depositDeclined: 'Deposit has been declined',
    withdrawalApproved: 'Withdrawal has been approved',
    withdrawalDeclined: 'Withdrawal has been declined',

    forex: 'Forex',
    stocks: 'Stocks',
    commodities: 'Commodities',
    indices: 'Indices',
    crypto: 'Crypto',
    metals: 'Metals',
    nft: 'NFT',

    buy: 'BUY',
    profitCalculator: 'Profit Calculator',
    sell: 'SELL',
    volume: 'Volume',
    entryPrice: 'Entry Price',
    takeProfit: 'Take Profit',
    stopLoss: 'Stop Loss',
    maxPosition: 'Max Position',
    calculate: 'Calculate',
    calculationsFor: 'Calculations for',
    leverage: 'Leverage',
    requiredMargin: 'Required Margin',
    profitFromTP: 'Profit from TP',
    lossFromSL: 'Loss from SL',
    roe: 'ROE',

    title: 'Deposit successful',
    text: 'Your deposit has been processed successfully!',

    title: 'Deposit failed',
    text: 'Your deposit has not been processed.',

    marketWatch: 'Market Watch',
    search: 'Search...',

    commission: 'Commission',
    volume: 'Volume',
    margin: 'Margin',
    active: 'Active',
    pending: 'Pending',
    activeOrders: 'Active Orders',
    portfolio: 'Portfolio',
    allPositions: 'All Positions',
    noPositionsLine1: 'You have no open',
    noPositionsLine2: 'positions yet',
    show: 'Show',
    more: 'more',
    less: 'less',
    purchaseTime: 'Purchase Time',
    closePosition: 'Close Position',
    priceOpen: 'Purchase Price',
    priceSl: 'Stop Loss Price',
    priceTp: 'Take Profit Price',
    type: 'Position Direction',
    pnl: 'Profit/Loss',
    cancelOrder: 'Cancel Order',
    orderType: 'Order Type',
    cancelled: 'Cancelled',
    tradingHistory: 'Trading History',
    noHistoryLine1: "You don't have any",
    noHistoryLine2: 'closed deals yet',

    economicCalendar: 'Economic Calendar',

    marketNews: 'Market News',

    ordersActive: 'Active Orders',
    ordersHistory: 'Closed Orders',
    id: 'ID',
    symbol: 'Symbol',
    documentType: 'Type',
    volume: 'Volume',
    openPrice: 'Open Price',
    openTime: 'Open Time',
    closePrice: 'Close Price',
    closeTime: 'Close Time',
    sl: 'SL',
    tp: 'TP',
    price: 'Price',
    pnl: 'PnL',
    actions: 'Actions',
    edit: 'Edit',
    close: 'Close',
    commission: 'Commission',
    swap: 'Swap',
    swapLong: 'Swap Long',
    swapShort: 'Swap Short',

    assetInfo: 'Asset Info',
    tradingConditions: 'Trading Conditions',
    information: 'Session Change',
    bid: 'Bid',
    ask: 'Ask',
    sessionChange: 'Session Change',
    tradeNow: 'Trade Now',
    opens: 'Opens',
    closes: 'Closes',
    at: 'at',
    open247: 'Open 24/7',
    today: 'today',
    tomorrow: 'tomorrow',
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    contractSpecification: 'Contract Specification',
    symbol: 'Symbol',
    name: 'Name',
    market: 'Market',
    baseCurrency: 'Base Currency',
    digits: 'Digits',
    lotSize: 'Lot Size',
    lotStep: 'Lot Step',
    minVolume: 'Min Volume',
    maxVolume: 'Max Volume',
    leverage: 'Leverage',
    commission: 'Commission',
    swapLong: 'Swap Long',
    swapShort: 'Swap Short',
    schedule: 'Schedule',
    weekday: 'Weekday',
    tradingTime: 'Trading Time',
    closed: 'closed',
    sell: 'Sell',
    buy: 'Buy',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    oneHourChange: '1 hour change',
    oneDayChange: '1 day change',
    oneWeekChange: '1 week change',
    oneMonthChange: '1 month change',
    threeMonthsChange: '3 months change',
    oneYearChange: '1 year change',
    loading: 'Loading...',

    traderTitle: 'Auto Trader',
    traderConfirm: 'Confirm and save',
    riskLevelLow: 'Risk Level: ',
    riskLevelMedium: 'Risk Level: Medium',
    riskLevelHigh: 'Risk Level: High',
    perDay: 'Trades per day:',
    desc: `Trading CFDs and other leveraged products can lead to losses. Before trading, clients should
              read the
              relevant risk statements on our Risk Disclosure page. Automated trading does not guarantee results. The
              company accepts no responsibility for the loss of funds in automatic trading. Please make sure that you
              fully understand the risks and take measures to manage risks.`,
    accept: 'Accept',

    trade: 'Trade',
    startTrading: 'Start Trading',
    deposit: 'Deposit',
    dashboard: 'Dashboard',
    personalInfo: 'Personal Info',
    withdrawal: 'Withdrawal',
    verification: 'Verification',
    accounts: 'Accounts',
    liveChat: 'Live Chat',
    savings: 'Savings',
    settings: 'Settings',
    logOut: 'Log Out',

    methods: 'METHODS',
    confirm: 'Confirm in the application of your bank',
    sendOtp: 'Send otp',
    otpCode: 'Otp code',
    addWalletAddress:
      'Wallet for this deposit method is not set. Please contact your agent or support team.',
    addressReceipt: 'Please wait for the address to load',
    makeDeposit: 'MAKE A DEPOSIT',
    instant: 'Instant',
    minutes: 'minutes',
    hours: 'hours',
    days: 'days',
    amount: 'Amount',
    continue: 'Continue',
    qrCode: 'QR CODE',
    depositAddress: 'DEPOSIT ADDRESS',
    copy: 'Copy',
    last: 'LAST',
    deposits: 'DEPOSITS',
    time: 'Time',
    currency: 'Currency',
    status: 'Status',
    info: 'Info',

    pleaseWait: 'Please wait. Connecting to payment service provider...',
    cardPayment: 'Card payment',
    inOrder: 'In order to send the amount',
    pleaseProvide: 'please provide card details:',

    completeVerification: 'Please Complete Verification',
    noOrderYet: 'No order yet',
    totalBalance: 'Total Balance',
    totalDeposits: 'Total Deposits',
    profitableOrders: 'Profitable Orders',
    totalPnl: 'Total PNL',
    roi: 'ROI',
    activityLog: 'Activity Log',
    loginFromIp: 'Login from IP',
    tradingResults: 'Trading Results',
    week: 'Week',
    month: 'Month',
    year: 'Year',
    successRate: 'Success rate',
    closedWithProfit: 'Closed With Profit',
    closedWithLoss: 'Closed With Loss',
    account: 'Account',
    balance: 'Balance',
    leverage: 'Leverage',
    credit: 'Credit',
    tradeNow: 'Trade Now',
    usingCurrentRate: 'using current exchange rate',

    personalDetails: 'Personal Details',
    profilePhoto: 'Profile Photo',
    firstName: 'First Name',
    country: 'Country',
    lastName: 'Last Name',
    address: 'Address',
    email: 'E-mail',
    phone: 'Phone number',
    saveChanges: 'Save Changes',

    dropFile: 'Drop a file on the circle above to upload',
    notAllowed: 'It is not allowed to publish',
    notAllowedLine1: 'Photos of an explicitly sexual or pornographic nature',
    notAllowedLine2:
      'Images aimed at inciting ethnic or racial hatred or aggression',
    notAllowedLine3: 'Photos involving persons under 18 years of age',
    notAllowedLine4: 'Third-party copyright protected photos',
    notAllowedLine5:
      'Images larger than 5 MB and in a format other than JPG, GIF or PNG',
    requirements:
      'Your face must be clearly visible on the photo. All photos and videos uploaded by you must comply with these requirements, otherwise they can be removed.',

    withdrawalOff: 'Please contact your account manager for withdrawal details',
    cryptocurrency: 'Cryptocurrency',
    withdrawal: 'Withdrawal',
    requestNewWithdrawal: 'REQUEST A NEW WITHDRAWAL',
    amount: 'Amount',
    currentBalance: 'Your current account balance is',
    withdrawAll: 'Withdraw all',
    requestWithdrawal: 'Request Withdrawal',
    last: 'LAST',
    withdrawalRequests: 'WITHDRAWAL REQUESTS',
    time: 'Time',
    currency: 'Currency',
    info: 'Info',
    status: 'Status',
    bank: 'Bank',
    bitcoin: 'Bitcoin',
    card: 'Card',
    ethereum: 'Ethereum',
    eth: 'Ethereum',
    usdt: 'USDT',
    withdrawalDetails: 'Withdrawal Details',
    address: 'Wallet Address',
    bankAccount: 'Account Number',
    bankHolder: 'Account Holder Name',
    bankIban: 'IBAN',
    bankSwift: 'Bank SWIFT code',
    cardNumber: 'Card Number',
    cardHolder: 'Card Holder Name',

    dragAndDrop: 'drag and drop the document to this area',
    documentsList: 'LIST OF UPLOADED DOCUMENTS',
    document: 'Document',
    timeUploaded: 'Time Uploaded',
    timeProcessed: 'Time Processed',
    status: 'Status',
    types: [
      'Proof of Id',
      'Proof of Residence',
      'Credit Card Front',
      'Credit Card Back',
      'Proof of Id Back',
      'Selfie',
    ],
    types2: [
      'Proof of identification (POI)',
      'Proof of residential address',
      'Credit Card Front',
      'Credit Card Back',
      'Proof of identification Back',
      'Selfie with ID',
    ],
    upload: 'Upload',
    isConfirmed: 'is confirmed',
    uploadAnotherDocument: 'Upload another document',
    isUnderReview: 'is under review',
    questionnaire: 'Questionnaire',
    sendAnswers: 'Send Answers',
    progressBarOf: 'of',
    progressBarText: 'of your documents have been uploaded and confirmed',

    manageAccounts: 'Transfer funds between your accounts',
    transferFrom: 'From account',
    transferTo: 'To account',
    amount: 'Amount',
    makeTransfer: 'Make Transfer',
    yourAccounts: 'Your Accounts',
    account: 'Account',
    currency: 'Currency',
    balance: 'Balance',
    credit: 'Credit',
    makeActive: 'Make Active',
    active: 'Active',

    sendMessage: 'Send Message',

    pct_0: 'Flexible',
    pct_30: 'Locked 1 Month',
    pct_90: 'Locked 1 Quarter',
    pct_180: 'Locked 6 Months',
    pct_365: 'Locked 1 Year',
    savings: 'Savings',
    detailedInformation: 'Detailed Information',
    pleaseSelect: 'Please select a currency and a period',
    openSavings: 'Open Savings',
    currentTime: 'Current Time',
    releaseTime: 'Release Time',
    currencyChosen: 'Currency Chosen',
    periodChosen: 'Period Chosen',
    yourRate: 'Your Rate',
    yourEarnings: 'Your earnings',
    accountFrom: 'Account to transfer funds from',
    enterAmount: 'Enter Amount',
    in: 'In',
    openAndInvest: 'Open Savings Account and invest',
    investment: 'Investment',
    period: 'Period',
    daysTotal: 'Days total',
    finalEarnings: 'Final earnings',
    created: 'Created',
    daysElapsed: 'Days Elapsed',
    days: 'days',
    earnings: 'Earnings',
    fundsReleasedIn: 'Funds Released In',
    claim: 'Claim',

    updatePassword: 'UPDATE PASSWORD',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    changePassword: 'Change Password',
    activationForGoogle: 'Activation code for Google Authenticator',
    activateAndEnter:
      'Activate Authenticator and enter a generated code in field below',
    qrCode: 'QR Code',
    activateProtection: 'Activate 2FA Protection',
    protectionActive: '2FA protection is active',
    twoFactorCode: '2FA Code',
    disableProtection: 'Disable 2FA Protection',
    language: 'Language',
    dashboardCurrency: 'Dashboard Currency',
    confirmNewPassword: 'Confirm new password',

    yourLink: 'YOUR REFERRAL LINK',
    referredFriends: 'REFERRED FRIENDS',
    id: 'ID',
    name: 'Name',
    registered: 'Register',
    level: 'Level',
    payout: 'Payout',
    lastPayouts: 'LAST REFERRAL PAYOUTS',
    time: 'Time',
    amount: 'Amount',
    currency: 'Currency',
    info: 'Info',

    Jan: 'Jan',
    Feb: 'Feb',
    Mar: 'Mar',
    Apr: 'Apr',
    May: 'May',
    Jun: 'Jun',
    Jul: 'Jul',
    Aug: 'Aug',
    Sep: 'Sep',
    Oct: 'Oct',
    Nov: 'Nov',
    Dec: 'Dec',

    orderTypes: [
      'Buy',
      'Sell',
      'Buy Limit',
      'Sell Limit',
      'Buy Stop',
      'Sell Stop',
    ],
    statuses: ['Pending', 'Approved', 'Declined', 'Processing'],

    NOT_FOUND: 'Request error',
    FORBIDDEN: 'Access denied. Please re-login',
    SERVER_ERROR: 'Action failed. Please try again later',
    INVALID_ACCOUNT: 'Session expired. Please re-login',
    INVALID_EMAIL: 'Invalid e-mail address',
    INVALID_PHONE: 'Invalid phone number',
    INVALID_COUNTRY: 'Invalid country',
    INVALID_LOGIN: 'Invalid login credentials',
    USER_BLOCKED: 'Account is blocked. Please contact support',
    USER_REGISTERED:
      'User with entered e-mail or phone number is already registered',
    INVALID_USER: 'User is not found',
    REJECTED: 'Operation is not allowed due to platform restrictions',
    INVALID_OLD_PASSWORD: 'Old password is invalid',
    INVALID_SYMBOL: 'Invalid trading symbol',
    INVALID_SYMBOL_PRECISION: 'Invalid symbol precision',
    INVALID_FRAME: 'Invalid chart frame',
    INVALID_CURRENCY: 'Invalid currency',
    INVALID_PRODUCT: 'Invalid account trading type',
    INSUFFICIENT_FUNDS: 'Insufficient funds',
    INVALID_WITHDRAWAL: 'Withdrawal is not found',
    INVALID_STATUS: 'Invalid status',
    INVALID_FILE: 'Invalid file extension or file is too large',
    INVALID_DOCUMENT: 'Document is not found',
    INVALID_NAME: 'Invalid name',
    INVALID_LOT_SIZE: 'Invalid lot size',
    INVALID_LOT_STEP: 'Invalid lot step',
    INVALID_MIN_VOLUME: 'Invalid minimal volume',
    INVALID_MAX_VOLUME: 'Invalid maximal volume',
    INVALID_GROUP: 'Invalid group',
    INVALID_SPREAD: 'Invalid spread',
    REQUEST_TIMEOUT: 'Request timed out. Please try again later',
    INVALID_TYPE: 'Invalid order type',
    INVALID_VOLUME: 'Invalid order volume',
    INVALID_SL: 'Invalid stop loss value',
    INVALID_TP: 'Invalid take profit value',
    INVALID_PRICE: 'Invalid order price',
    INVALID_EXPIRATION: 'Invalid order expiration',
    NOT_ENOUGH_MARGIN: 'Not enough margin',
    INVALID_ORDER: 'Order is not found',
    MARKET_CLOSED: 'Trading is not available. Please try again',
    INVALID_BALANCE_TYPE: 'Invalid type of balance operation',
    INVALID_HASH: 'Invalid hash',
    HASH_EXPIRED:
      'Your password reset link is expired. Please request a new one',
    INVALID_CODE: 'Invalid 2FA code',
    CHAT_DISABLED: 'Access to the support chat has been closed',
    WITHDRAWAL_NOT_ALLOWED: 'Access to the withdrawals has been closed',
    TRADING_DISABLED: 'Trading is disabled for current account',
    PENDING_DEPOSITS_LIMIT: 'Deposits limit exceeded',
    LOCAL_ONE_PENDING_WITHDRAWAL: 'Only one pending withdrawal allowed',
    LOCAL_DEPOSIT_ONLY_REAL: 'Deposit is available only for real account',
    LOCAL_DEPOSIT_POSITIVE: 'Amount of deposit must be more than 0',
    LOCAL_INVALID_CARD_NUMBER: 'Invalid card number',
    LOCAL_INVALID_CARD_EXPIRATION: 'Invalid card expiration',
    LOCAL_INVALID_CVC: 'Invalid CVV/CVC code',
    LOCAL_PASSWORDS_NOT_MATCH: 'Passwords do not match, please re-enter',
    LOCAL_NO_TRADING_ACCOUNTS:
      'You do not have trading accounts available. Please contact the support',
    LOCAL_MIN_DEPOSIT: 'Minimum deposit is $',
    LOCAL_MIN_WITHDRAWAL: 'Minimum withdrawal amount is $',
    LOCAL_INVALID_FILE_TYPE:
      'File format not supported. Please attach only JPG, PNG or PDF',
    LOCAL_MIN_STAKING: 'Minimum deposit for this currency is ',
    FLOOD_REJECTED:
      'You are sending messages too often. Please try again later',
    countries: {
      AF: 'Afghanistan',
      AX: 'Aland Islands',
      AL: 'Albania',
      DZ: 'Algeria',
      AS: 'American Samoa',
      AD: 'Andorra',
      AO: 'Angola',
      AI: 'Anguilla',
      AQ: 'Antarctica',
      AG: 'Antigua And Barbuda',
      AR: 'Argentina',
      AM: 'Armenia',
      AW: 'Aruba',
      AU: 'Australia',
      AT: 'Austria',
      AZ: 'Azerbaijan',
      BS: 'Bahamas',
      BH: 'Bahrain',
      BD: 'Bangladesh',
      BB: 'Barbados',
      BY: 'Belarus',
      BE: 'Belgium',
      BZ: 'Belize',
      BJ: 'Benin',
      BM: 'Bermuda',
      BT: 'Bhutan',
      BO: 'Bolivia',
      BA: 'Bosnia And Herzegovina',
      BW: 'Botswana',
      BV: 'Bouvet Island',
      BR: 'Brazil',
      IO: 'British Indian Ocean Territory',
      BN: 'Brunei Darussalam',
      BG: 'Bulgaria',
      BF: 'Burkina Faso',
      BI: 'Burundi',
      KH: 'Cambodia',
      CM: 'Cameroon',
      CA: 'Canada',
      CV: 'Cape Verde',
      KY: 'Cayman Islands',
      CF: 'Central African Republic',
      TD: 'Chad',
      CL: 'Chile',
      CN: 'China',
      CX: 'Christmas Island',
      CC: 'Cocos (Keeling) Islands',
      CO: 'Colombia',
      KM: 'Comoros',
      CG: 'Congo',
      CD: 'Congo, Democratic Republic',
      CK: 'Cook Islands',
      CR: 'Costa Rica',
      CI: "Cote D'Ivoire",
      HR: 'Croatia',
      CU: 'Cuba',
      CY: 'Cyprus',
      CZ: 'Czech Republic',
      DK: 'Denmark',
      DJ: 'Djibouti',
      DM: 'Dominica',
      DO: 'Dominican Republic',
      EC: 'Ecuador',
      EG: 'Egypt',
      SV: 'El Salvador',
      GQ: 'Equatorial Guinea',
      ER: 'Eritrea',
      EE: 'Estonia',
      ET: 'Ethiopia',
      FK: 'Falkland Islands (Malvinas)',
      FO: 'Faroe Islands',
      FJ: 'Fiji',
      FI: 'Finland',
      FR: 'France',
      GF: 'French Guiana',
      PF: 'French Polynesia',
      TF: 'French Southern Territories',
      GA: 'Gabon',
      GM: 'Gambia',
      GE: 'Georgia',
      DE: 'Germany',
      GH: 'Ghana',
      GI: 'Gibraltar',
      GR: 'Greece',
      GL: 'Greenland',
      GD: 'Grenada',
      GP: 'Guadeloupe',
      GU: 'Guam',
      GT: 'Guatemala',
      GG: 'Guernsey',
      GN: 'Guinea',
      GW: 'Guinea-Bissau',
      GY: 'Guyana',
      HT: 'Haiti',
      HM: 'Heard Island & Mcdonald Islands',
      VA: 'Holy See (Vatican City State)',
      HN: 'Honduras',
      HK: 'Hong Kong',
      HU: 'Hungary',
      IS: 'Iceland',
      IN: 'India',
      ID: 'Indonesia',
      IR: 'Iran',
      IQ: 'Iraq',
      IE: 'Ireland',
      IM: 'Isle Of Man',
      IL: 'Israel',
      IT: 'Italy',
      JM: 'Jamaica',
      JP: 'Japan',
      JE: 'Jersey',
      JO: 'Jordan',
      KZ: 'Kazakhstan',
      KE: 'Kenya',
      KI: 'Kiribati',
      KR: 'Korea',
      KW: 'Kuwait',
      KG: 'Kyrgyzstan',
      LA: "Lao People's Democratic Republic",
      LV: 'Latvia',
      LB: 'Lebanon',
      LS: 'Lesotho',
      LR: 'Liberia',
      LY: 'Libyan Arab Jamahiriya',
      LI: 'Liechtenstein',
      LT: 'Lithuania',
      LU: 'Luxembourg',
      MO: 'Macao',
      MK: 'Macedonia',
      MG: 'Madagascar',
      MW: 'Malawi',
      MY: 'Malaysia',
      MV: 'Maldives',
      ML: 'Mali',
      MT: 'Malta',
      MH: 'Marshall Islands',
      MQ: 'Martinique',
      MR: 'Mauritania',
      MU: 'Mauritius',
      YT: 'Mayotte',
      MX: 'Mexico',
      FM: 'Micronesia',
      MD: 'Moldova',
      MC: 'Monaco',
      MN: 'Mongolia',
      ME: 'Montenegro',
      MS: 'Montserrat',
      MA: 'Morocco',
      MZ: 'Mozambique',
      MM: 'Myanmar',
      NA: 'Namibia',
      NR: 'Nauru',
      NP: 'Nepal',
      NL: 'Netherlands',
      AN: 'Netherlands Antilles',
      NC: 'New Caledonia',
      NZ: 'New Zealand',
      NI: 'Nicaragua',
      NE: 'Niger',
      NG: 'Nigeria',
      NU: 'Niue',
      NF: 'Norfolk Island',
      MP: 'Northern Mariana Islands',
      NO: 'Norway',
      OM: 'Oman',
      PK: 'Pakistan',
      PW: 'Palau',
      PS: 'Palestinian Territory, Occupied',
      PA: 'Panama',
      PG: 'Papua New Guinea',
      PY: 'Paraguay',
      PE: 'Peru',
      PH: 'Philippines',
      PN: 'Pitcairn',
      PL: 'Poland',
      PT: 'Portugal',
      PR: 'Puerto Rico',
      QA: 'Qatar',
      RE: 'Reunion',
      RO: 'Romania',
      RU: 'Russia',
      RW: 'Rwanda',
      BL: 'Saint Barthelemy',
      SH: 'Saint Helena',
      KN: 'Saint Kitts And Nevis',
      LC: 'Saint Lucia',
      MF: 'Saint Martin',
      PM: 'Saint Pierre And Miquelon',
      VC: 'Saint Vincent And Grenadines',
      WS: 'Samoa',
      SM: 'San Marino',
      ST: 'Sao Tome And Principe',
      SA: 'Saudi Arabia',
      SN: 'Senegal',
      RS: 'Serbia',
      SC: 'Seychelles',
      SL: 'Sierra Leone',
      SG: 'Singapore',
      SK: 'Slovakia',
      SI: 'Slovenia',
      SB: 'Solomon Islands',
      SO: 'Somalia',
      ZA: 'South Africa',
      GS: 'South Georgia And Sandwich Isl.',
      ES: 'Spain',
      LK: 'Sri Lanka',
      SD: 'Sudan',
      SR: 'Suriname',
      SJ: 'Svalbard And Jan Mayen',
      SZ: 'Swaziland',
      SE: 'Sweden',
      CH: 'Switzerland',
      SY: 'Syrian Arab Republic',
      TW: 'Taiwan',
      TJ: 'Tajikistan',
      TZ: 'Tanzania',
      TH: 'Thailand',
      TL: 'Timor-Leste',
      TG: 'Togo',
      TK: 'Tokelau',
      TO: 'Tonga',
      TT: 'Trinidad And Tobago',
      TN: 'Tunisia',
      TR: 'Turkey',
      TM: 'Turkmenistan',
      TC: 'Turks And Caicos Islands',
      TV: 'Tuvalu',
      UG: 'Uganda',
      UA: 'Ukraine',
      AE: 'United Arab Emirates',
      GB: 'United Kingdom',
      US: 'United States',
      UM: 'United States Outlying Islands',
      UY: 'Uruguay',
      UZ: 'Uzbekistan',
      VU: 'Vanuatu',
      VE: 'Venezuela',
      VN: 'Viet Nam',
      VG: 'Virgin Islands, British',
      VI: 'Virgin Islands, U.S.',
      WF: 'Wallis And Futuna',
      EH: 'Western Sahara',
      YE: 'Yemen',
      ZM: 'Zambia',
      ZW: 'Zimbabwe',
    },
  },
  ru: {
    _name: 'Русский',
    policy: 'Политика конфиденциальности',
    policyAML: 'Политика противодействия отмыванию денег (AML)',
    policyKYC: 'Политика «Знай своего клиента» (KYC)',
    locense: 'Лицензия',

    view_all: 'Посмотреть все',

    sell_btn: 'Продать',
    buy_btn: 'Купить',

    currency_action: 'валюта',

    importantAccountDetails: 'Важные данные учетной записи',
    viewAdditionalSettings: 'Дополнительные настройки',
    switchDarkMode: 'Переключить темный/светлый режим',
    writeProblem: 'Напишите нам о своей проблеме',
    darkMode: 'Темный режим',

    yay: 'Ура',
    purchased: 'Вы успешно приобрели',
    from: 'из',
    walet: 'Wallet',
    trade: 'Торговля',

    withdrawDetails: 'Подробности вывода',
    saveDetails: 'Сохранить подробности для следующего раза',
    amountToWithdraw: 'Сумма вывода',
    withdrawLimit: 'Оставшийся дневной лимит вывода $1 000 000,00.',

    serviceFee: 'Плата за обслуживание',
    youWillPay: 'Вы заплатите',
    cancel: 'Отмена',
    understand: 'Я понимаю, продолжить',

    select: 'Выбрать',
    enterAmount: 'Ввести сумму',
    orderInfo: 'Информация о заказе',
    confirmOrder: 'Подтвердить заказ',
    get: 'Получить',
    spend: 'Потратить',
    buying: 'Покупка',

    accountTransactions: 'Операции по счету',

    overview: 'Обзор',
    accountBalances: 'Остатки на счетах',
    details: 'Подробности',
    loginHistory: 'История входа',
    device: 'Устройство',
    contactUs: 'Связаться с нами',
    sessionLog: 'Сеансы и история входов',
    selectMethods: 'Выберите методы',
    depositDetails: 'Подробности депозита',
    support: 'Поддержка',
    homepage: 'Домашняя страница',
    supportChat: 'Чат поддержки',
    createChat: 'Создать чат',

    takeProfitStopLoss: 'Тейк Профит и Стоп Лосс',
    takeProfit: 'Тейк Профит',
    stopLoss: 'Стоп Лосс',
    order: 'Ордер',
    updateOrder: 'Изменить ордер',
    balance: 'Баланс',
    credit: 'Кредит',
    equity: 'Средства',
    practice: 'Пробный',
    real: 'Реальный',
    account: 'Счет',
    invested: 'Вложено',
    profit: 'Прибыль',
    loss: 'Убыток',
    margin: 'Маржа',
    marginLevel: 'Уровень маржи',
    marginFree: 'Свободная маржа',
    cfd: 'CFD',
    platform: 'Platform',
    deposit: 'Депозит',
    marketWatch: 'обзор Рынков',
    activeOrders: 'открытые ордера',
    tradingHistory: 'история Торговли',
    economicCalendar: 'экономический Календарь',
    marketNews: 'Новости рынков',

    closeOrder: 'Закрыть позицию',
    areYouSure: 'Вы уверены, что хотите закрыть позицию',
    buy: 'Купить',
    sell: 'Продать',
    yes: 'Да',
    no: 'Нет',

    addNewChart: 'Добавить график',

    watchlist: 'Избранное',
    asset: 'Инструмент',
    price: 'Цена',
    changePct: 'Изменения 24ч',

    pending: 'Цена', // <- NB
    assetPrice: 'Цена инструмента',
    current: 'Текущая',
    revert: 'Вернуть к рыночной',
    automatically:
      'Позиция будет открыта автоматически при достижении указанного уровня',

    default: 'По умолчанию',
    volume: 'Объем',
    lots: 'лоты',
    units: 'юниты',
    currency: 'валюта',
    contractSize: 'Размер контракта',
    position: 'Позиция',
    margin: 'Маржа',
    freeMargin: 'Свободная маржа',
    takeProfitStopLoss: 'Тейк Профит и Стоп Лосс',
    pending: 'Цена',
    market: 'Рынок',
    leverage: 'Плечо',
    spread: 'Спрэд',
    notSet: 'Не задано',
    at: 'по',
    buy: 'купить',
    sell: 'продать',

    supportBanner: 'КАЖДЫЙ ДЕНЬ, 24/7',
    currentTime: 'ТЕКУЩЕЕ ВРЕМЯ',
    liveChat: 'Поддержка',

    balance: 'Баланс',
    credit: 'Кредит',
    equity: 'Средства',
    margin: 'Маржа',
    marginLevel: 'Уровень маржи',
    freeMargin: 'Свободная маржа',
    pnl: 'Прибыль/Убыток',
    profitTotal: 'Прибыль всего',

    dateRegistered: 'Дата Регистрации',
    userId: 'ID Пользователя',
    dashboard: 'Панель пользователя',
    personalData: 'Личные данные',
    deposit: 'Депозит',
    withdrawFunds: 'Вывод Средств',
    savings: 'Накопительные Счета',
    settings: 'Настройки',
    logout: 'Выйти',

    BT_INVOICE: 'Введите сумму и сформируйте счет',
    BT_TITLE: 'Ваши платежные реквизиты',
    PENDING_DEPOSITS_LIMIT: 'Лимит депозитов',
    account: 'Счет получателя',
    bank_name: 'Наименование банка получателя',
    beneficiary: 'Получатель',
    beneficiary_address: 'Счет получателя',
    swift: 'БИК Банка получателя',
    iban: 'IBAN',
    ru_inn: 'ИНН',
    ru_kpp: 'KPP',
    corresponding_account: 'Correspondent accountКорреспондентский счёт',
    TOKEN_AMOUNT: 'Сумма',
    TOKEN_SUBTOTAL: 'Промежуточный итог',
    TOKEN_TOTAL: 'Всего',
    TOKEN_DESCRIPTION: 'Описание',
    TOKEN_PAYMENT_DETAILS: 'Платежные реквизиты',
    makeDeposit: 'Внести Депозит',
    practiceAccount: 'Учебнй Счет',
    realAccount: 'Реальный Счет',
    noWithdrawals: 'Нет вывода средств',
    easyWithdrawals: 'Легкий вывод средств',
    allAssets: 'Доступны все инструменты',
    fullFledged: 'Полнофункциональная платформа',
    fillUpTo: 'Пополнить до',
    freeReplenishment: 'Бесплатное Пополнение',
    topUp: 'Пополните Ваш Счет',
    minimumAmount: 'Минимальная Сумма',
    maxAmount: 'Максимальная Сумма',
    withdrawalType: 'Тип вывода',
    canSwitch: 'Вы можете переключиться между счетами в любое время',

    chartGrids: 'СЕТКА ГРАФИКОВ',
    chart1: '1 график',
    chart2: '2 графика',
    chart3: '3 графика',
    chart4: '4 графика',

    connectionLost: 'Соединение с сервером потеряно',
    retryNow: 'Попробовать еще',

    loginToTradeRoom: 'Авторизация',
    email: 'Электронная Почта',
    enterEmail: 'Введите почту',
    twoFactor: 'Код 2FA (если активна)',
    twoFactorAuth: 'Двухфакторная аутентификация',
    password: 'Пароль',
    yourPassword: 'Ваш пароль',
    signIn: 'Войти',
    dontHaveAccount: 'У вас нет аккаунта?',
    restore: 'Восстановить',
    fullName: 'Полное имя',
    havePromo: 'У меня есть промо код',
    promo: 'Промо код',
    login: 'Вход в систему',
    haveAccount: 'Уже есть аккаунт?',
    hide: 'Скрыть',
    goTo: 'Вернуться назад',

    setNewPassword: 'Установить новый пароль',
    newPassword: 'Новый пароль',
    confirmNewPassword: 'Подтвердите новый пароль',
    setButton: 'Установить',

    repeatPassword: 'Подтверлить Пароль',
    createNewAccount: 'Создать Новый Счет',
    email: 'Электронная Почта',
    firstName: 'Имя',
    lastName: 'Фамилия',
    country: 'Страна',
    phone: 'Телефон',
    password: 'Пароль',
    createAccount: 'Создать Счет',
    currency: 'Валюта',

    forgotPassword: 'Забыли Пароль?',
    submitEmail:
      'Пожалуйста, введите имейл, указанный при регистрации, проверьте свой ящик и следуйте инструкциям, полученным в письме',
    submit: 'Отправить',

    error: 'Ошибка',
    success: 'Успешно',
    deposit: 'Депозит',
    withdrawal: 'Вывод',
    depositApproved: 'Депозит одобрен',
    depositDeclined: 'Депозит отклонен',
    withdrawalApproved: 'Вывод средств одобрен',
    withdrawalDeclined: 'Вывод средств отклонен',

    forex: 'Форекс',
    stocks: 'Акции',
    commodities: 'Сырье',
    indices: 'Индексы',
    crypto: 'Криптовалюта',
    metals: 'Металлы',
    nft: 'NFT',

    buy: 'ПОКУПКА',
    sell: 'ПРОДАЖА',
    volume: 'Объем',
    entryPrice: 'Цена Входа',
    takeProfit: 'Тейк Профит',
    stopLoss: 'Стоп Лосс',
    maxPosition: 'Макс. Позиция',
    calculate: 'Рассчитать',
    calculationsFor: 'Рассчет для',
    leverage: 'Плечо',
    requiredMargin: 'Требуемая Маржа',
    profitFromTP: 'Прибыль от ТП',
    lossFromSL: 'Убыток от СЛ',
    roe: 'ROE',

    title: 'Deposit successful',
    text: 'Your deposit has been processed successfully!',

    title: 'Deposit failed',
    text: 'Your deposit has not been processed.',

    marketWatch: 'Обзор Рынков',
    search: 'Поиск...',

    commission: 'Комиссия',
    volume: 'Объем',
    margin: 'Маржа',
    active: 'Открытые',
    pending: 'В Ожидании',
    activeOrders: 'Открытые ордера',
    portfolio: 'Портфолио',
    allPositions: 'Все Позиции',
    noPositionsLine1: 'У вас ещё нет',
    noPositionsLine2: 'открытых позиций',
    show: 'Показать',
    more: 'больше',
    less: 'меньше',
    purchaseTime: 'Открыт',
    closePosition: 'Закрыть',
    priceOpen: 'Цена открытия',
    priceSl: 'Цена Стоп Лосс',
    priceTp: 'Цена Тейк Профит',
    type: 'Направление позиции',
    pnl: 'Прибыль/Убыток',
    cancelOrder: 'Отменить Ордер',
    orderType: 'Тип Ордера',
    cancelled: 'Отменено',
    tradingHistory: 'Торговая История',
    noHistoryLine1: 'У вас ещё нет',
    noHistoryLine2: 'закрытых позиций',

    economicCalendar: 'Экономический Календарь',

    marketNews: 'Новости Рынков',

    ordersActive: 'Активные ордеры',
    ordersHistory: 'История Ордеров',
    id: 'ID',
    symbol: 'Символ',
    documentType: 'Тип',
    volume: 'Объем',
    openPrice: 'Цена открытия',
    openTime: 'Время открытия',
    closePrice: 'Цена закрытия',
    closeTime: 'Время закрытия',
    sl: 'СЛ',
    tp: 'ТП',
    price: 'Цена',
    pnl: 'ПиУ',
    actions: 'Действия',
    edit: 'Править',
    close: 'Закрыть',
    commission: 'Комиссия',
    swap: 'Своп',
    swapLong: 'Своп Лонг',
    swapShort: 'Своп Шорт',

    assetInfo: 'Информация об Инструменте',
    tradingConditions: 'Торговые Условия',
    information: 'Изменение за сессию',
    bid: 'Покупка',
    ask: 'Продажа',
    sessionChange: 'Изменение за сессию',
    tradeNow: 'Торговать',
    opens: 'Открывается',
    closes: 'Закрывается',
    at: 'в',
    open247: 'Открыто круглосуточно',
    today: 'сегодня',
    tomorrow: 'завтра',
    sunday: 'Воскресенье',
    monday: 'Понедельник',
    tuesday: 'Вторник',
    wednesday: 'Среда',
    thursday: 'Четверг',
    friday: 'Пятница',
    saturday: 'Суббота',
    contractSpecification: 'Спецификация контракта',
    symbol: 'Символ',
    name: 'Наименование',
    market: 'Рынок',
    baseCurrency: 'Базовая Валюта',
    digits: 'Точность',
    lotSize: 'Размер лота',
    lotStep: 'Шаг лота',
    minVolume: 'Мин Объем',
    maxVolume: 'Макс Объем',
    leverage: 'Плечо',
    commission: 'Комиссия',
    swapLong: 'Своп Лонг',
    swapShort: 'Своп Шорт',
    schedule: 'Расписание',
    weekday: 'День Недели',
    tradingTime: 'Время Торгов',
    closed: 'закрыто',
    sell: 'Продавать',
    buy: 'Покупать',
    low: 'Мин',
    medium: 'Средний',
    high: 'Макс',
    oneHourChange: 'Изменение 1 час',
    oneDayChange: 'Изменение 1 день',
    oneWeekChange: 'Изменение 1 неделя',
    oneMonthChange: 'Изменение 1 месяц',
    threeMonthsChange: 'Изменение 3 месяца',
    oneYearChange: 'Изменение 1 год',
    loading: 'Загрузка...',

    traderTitle: 'Автоматический Трейдер',
    traderConfirm: 'Подтвердите и сохраните',
    riskLevelLow: 'Уровень риска: ',
    riskLevelMedium: 'Уровень риска: Средний',
    riskLevelHigh: 'Уровень риска: высокий',
    perDay: 'Количество сделок в день:',
    desc: `Торговля CFD и другими продуктами с кредитным плечом может привести к убыткам. Перед началом торговли клиентам следует
              ознакомиться с
              соответствующими заявлениями о рисках на нашей странице "Информация о рисках". Автоматизированная торговля не гарантирует результатов. Компания
              Компания не несет ответственности за потерю средств при автоматической торговле. Пожалуйста, убедитесь, что вы
              полностью понимаете риски и принимаете меры по управлению ими.`,
    accept: 'Принять',

    trade: 'Торговля',
    startTrading: 'К Торговле',
    deposit: 'Депозит',
    dashboard: 'Панель Управления',
    personalInfo: 'Личные Данные',
    withdrawal: 'Вывод Средств',
    verification: 'Верификация',
    accounts: 'Счета',
    liveChat: 'Поддержка',
    savings: 'Накопительные Счета',
    settings: 'Настройки',
    logOut: 'Выход',

    methods: 'МЕТОДЫ',
    confirm: 'Подтвердите в приложении вашего банка',
    sendOtp: 'Отправить код',
    otpCode: 'OTP Код',
    addWalletAddress:
      'Кошелек для данного метода не установлен. Пожалуйста, обратитсь к Вашему агенту или в службу поддержки.',
    addressReceipt: 'Пожалуйста, подождите, получаем текущий адрес',
    makeDeposit: 'ВНЕСТИ ДЕПОЗИТ',
    instant: 'Моментально',
    minutes: 'минут',
    hours: 'часов',
    days: 'дней',
    amount: 'Сумма',
    continue: 'Продолжить',
    qrCode: 'QR код',
    depositAddress: 'АДРЕС КОШЕЛЬКА',
    copy: 'Копировать',
    last: 'ПОСЛЕДНИЕ',
    deposits: 'ДЕПОЗИТЫ',
    time: 'Время',
    currency: 'Валюта',
    status: 'Статус',
    info: 'Инфо',

    pleaseWait:
      'Пожалуйста, подождите. Идет соединение с сервисом приема платежей...',
    cardPayment: 'Оплата картоу',
    inOrder: 'Чтобы отправить сумму',
    pleaseProvide: 'пожалуйста предоставьте данные карты:',

    completeVerification: 'Пожалуйста, заполните верификацию',
    noOrderYet: 'Закрыто в убыток',
    totalBalance: 'Итоговый Баланс',
    totalDeposits: 'Всего депозитов',
    totalPnl: 'Прибыль / Убыток',
    profitableOrders: 'Прибыльные Ордеры',
    roi: 'ROI',
    activityLog: 'Лог Активности',
    loginFromIp: 'Вход с IP',
    tradingResults: 'Результаты Торговли',
    week: 'неделя',
    month: 'Месяц',
    year: 'Год',
    successRate: 'Успешные сделки',
    closedWithProfit: 'Закрыто с прибылью',
    closedWithLoss: 'Закрыто в убыток',
    account: 'Счет',
    balance: 'Баланс',
    leverage: 'Плечо',
    credit: 'Кредит',
    tradeNow: 'Торговать',
    usingCurrentRate: 'по текущей выбранной валюте',

    personalDetails: 'Персональные Данные',
    profilePhoto: 'Фото Пользователя',
    firstName: 'Имя',
    country: 'Страна',
    lastName: 'Фамилия',
    address: 'Адрес',
    email: 'Электронная почта',
    phone: 'Номер телефона',
    saveChanges: 'Сохранить Изменения',

    dropFile: 'Для загрузки перетащите файл на круг выше',
    notAllowed: 'Не разрешается размещать',
    notAllowedLine1: 'Эротические и порнографические фотографии',
    notAllowedLine2:
      'Изображения, разжигающие этническую или расовую ненависть или агрессию',
    notAllowedLine3: 'Фотографии с детьми до 18 лет',
    notAllowedLine4: 'Фотографии, защищенные авторским правом',
    notAllowedLine5:
      'Фотографии размером более 5 Мб и в формате, отличном от JPG, GIF или PNG',
    requirements:
      'На фото должно быть четко видно Ваше лицо. Все загруженные фотографии должны соответсвовать критериям, описанным выше. В противном случае они будут принудительно удалены.',

    withdrawalOff:
      'Пожалуйста, свяжитесь с вашим менеджером по работе с клиентами для получения информации о снятии средств',
    cryptocurrency: 'Криптовалюта',
    withdrawal: 'Вывод Средств',
    requestNewWithdrawal: 'ЗАПРОСИТЬ ВЫВОД СРЕДСТВ',
    amount: 'Сумма',
    currentBalance: 'Ваш текущий баланс',
    withdrawAll: 'Вывести все',
    requestWithdrawal: 'Вывод',
    last: 'ПОСЛЕДНИЕ',
    withdrawalRequests: 'ВЫВОД СРЕДСТВ',
    time: 'Время',
    currency: 'Валюта',
    info: 'Инфо',
    status: 'Статус',
    bank: 'Банк',
    bitcoin: 'Биткоин',
    card: 'Карта',
    ethereum: 'Ethereum',
    eth: 'Ethereum',
    usdt: 'USDT',
    withdrawalDetails: 'Детали Вывода Средств',
    address: 'Адрес Кошелька',
    bankAccount: 'Номер Счета',
    bankHolder: 'Имя Владельца Счета',
    bankIban: 'IBAN',
    bankSwift: 'SWIFT код',
    cardNumber: 'Номер Карты',
    cardHolder: 'Имя Владельца Карты',

    dragAndDrop: 'для загрузки перетащите документ в эту область',
    documentsList: 'СПИСОК ЗАГРУЖЕННЫХ ДОКУМЕНТОВ',
    document: 'Документ',
    timeUploaded: 'Загружен',
    timeProcessed: 'Обработан',
    status: 'Статус',
    types: [
      'Подтверждeние Личности',
      'Подтверждeние Адреса',
      'Карта - Лицевая Сторона',
      'Карта - Обратная Сторона',
      'Подтверждeние Личности - Обратная Сторона',
      'Селфи',
    ],
    types2: [
      'Подтверждeние Личности',
      'Подтверждeние Адреса',
      'Карта - Лицевая Сторона',
      'Карта - Обратная Сторона',
      'Подтверждeние Личности - Обратная Сторона',
      'Селфи',
    ],
    upload: 'Загрузить',
    isConfirmed: 'одобрено',
    uploadAnotherDocument: 'Загрузите другой документ',
    isUnderReview: 'находится в обработке',
    questionnaire: 'Опросник',
    sendAnswers: 'Отправить Ответы',
    progressBarOf: 'из',
    progressBarText: 'ваших документов были загружены и подтверждены',

    manageAccounts: 'Перевод средств между счетами',
    transferFrom: 'Со счета',
    transferTo: 'На счет',
    amount: 'Сумма',
    makeTransfer: 'Перевести Средства',
    yourAccounts: 'Ваши Счета',
    account: 'Счет',
    currency: 'Валюта',
    balance: 'Баланс',
    credit: 'Кредит',
    makeActive: 'Сделать Активным',
    active: 'Активен',

    sendMessage: 'Отправить сообщение',

    pct_0: 'Гибкий',
    pct_30: 'Фиксированный 1 Месяц',
    pct_90: 'Фиксированный 1 Квартал',
    pct_180: 'Фиксированный 6 Месяцев',
    pct_365: 'Фиксированный 1 Год',
    savings: 'Накопительные счета',
    detailedInformation: 'Подробная Информация',
    pleaseSelect: 'Пожалуйста, выберите валюту и период',
    openSavings: 'Открытые накопительные счета',
    currentTime: 'Текущее время',
    releaseTime: 'Время закрытия счета',
    currencyChosen: 'Выбранная валюта',
    periodChosen: 'Выбранный период',
    yourRate: 'Ваша ставка',
    yourEarnings: 'Ваш доход',
    accountFrom: 'Счет, с которого произвести трансфер',
    enterAmount: 'Введите сумму',
    in: 'в',
    openAndInvest: 'Открыть накопительный счет и вложить',
    investment: 'Вложение',
    period: 'Период',
    daysTotal: 'Дней всего',
    finalEarnings: 'Итоговый доход',
    created: 'Создано',
    daysElapsed: 'Дней прошло',
    days: 'дней',
    earnings: 'Доход',
    fundsReleasedIn: 'До закрытия',
    claim: 'Забрать',

    updatePassword: 'ОБНОВИТЬ ПАРОЛЬ',
    currentPassword: 'Текущий Пароль',
    newPassword: 'Новый Пароль',
    changePassword: 'Изменить Пароль',
    activationForGoogle: 'Код активации для Google Authenticator',
    activateAndEnter:
      'Активируйте Authenticator и введите сгенерированный код в поле ниже',
    qrCode: 'QR код',
    activateProtection: 'Активировать Двухфакторную Защиту',
    protectionActive: 'ДВУХФАКТОРНАЯ ЗАЩИТА АКТИВНА',
    twoFactorCode: 'Код Верификации',
    disableProtection: 'Отключить Двухфакторную Защиту',
    language: 'Язык',
    dashboardCurrency: 'Валюта для панели управления',
    confirmNewPassword: 'Подтвердите новый пароль',

    yourLink: 'ВАША ССЫЛКА ДЛЯ ПРИВЛЕЧЕНИЯ',
    referredFriends: 'ПРИВЛЕЧЕННЫЕ ДРУЗЬЯ',
    id: 'ID',
    name: 'Имя',
    registered: 'Зарегистрироваться',
    level: 'Уровень',
    payout: 'Выплата',
    lastPayouts: 'ПОСЛЕДНИЕ ВЫПЛАТЫ',
    time: 'Время',
    amount: 'Сумма',
    currency: 'Валюта',
    info: 'Комментарий',

    months: {
      Jan: 'Янв',
      Feb: 'Фев',
      Mar: 'Мар',
      Apr: 'Апр',
      May: 'Май',
      Jun: 'Июн',
      Jul: 'Июл',
      Aug: 'Авг',
      Sep: 'Сен',
      Oct: 'Окт',
      Nov: 'Ноя',
      Dec: 'Дек',
    },
    orderTypes: [
      'Покупка',
      'Продажа',
      'Лимитный Покупка',
      'Лимитный Продажа',
      'Стоп Покупка',
      'Стоп Продажа',
    ],
    statuses: ['Новый', 'Одобрен', 'Отклонен', 'В Обработке'],

    NOT_FOUND: 'Ошибка запроса',
    FORBIDDEN: 'Доступ запрещен. Пожалуйста, авторизуйтесь заново',
    SERVER_ERROR: 'Действие не удалось. Пожалуйста, попробуйте позже',
    INVALID_ACCOUNT: 'Сессия истекла. Пожалуйста, авторизуйтесь заново',
    INVALID_EMAIL: 'Неверная электронная почта',
    INVALID_PHONE: 'Неверный номер телефона',
    INVALID_COUNTRY: 'Неверная страна',
    INVALID_LOGIN: 'Неверные данные авторизации',
    USER_BLOCKED:
      'Аккаунт заблокирован. Пожалуйста, свяжитесь со службой поддержки',
    USER_REGISTERED:
      'Пользователь с такими электронной почтой или номером телефона уже зарегистрирован',
    INVALID_USER: 'Пользователь не найден',
    REJECTED: 'Операция запрещена согласно настройкам платформы',
    INVALID_OLD_PASSWORD: 'Текущий пароль неверен',
    INVALID_SYMBOL: 'Неверный торговый инструмент',
    INVALID_SYMBOL_PRECISION: 'Неверная точность после запятой',
    INVALID_FRAME: 'Неверный период',
    INVALID_CURRENCY: 'Неверная валюта',
    INVALID_PRODUCT: 'Неверный тип счета',
    INSUFFICIENT_FUNDS: 'Недостаточно денег. Пожалуйста, внесите депозит',
    INVALID_WITHDRAWAL: 'Запрос на вывод средств не найден',
    INVALID_STATUS: 'Неверный статус',
    INVALID_FILE: 'Неверный тип файла или файл слишком большой',
    INVALID_DOCUMENT: 'Документ не найден',
    INVALID_NAME: 'Неверное имя',
    INVALID_LOT_SIZE: 'Неверный размер лота',
    INVALID_LOT_STEP: 'Неверный шаг лота',
    INVALID_MIN_VOLUME: 'Неверный минимальный объем',
    INVALID_MAX_VOLUME: 'Неверный максимальный объем',
    INVALID_GROUP: 'Неверная группа',
    INVALID_SPREAD: 'Неверный спред',
    REQUEST_TIMEOUT:
      'Время ожидания запроса истекло. Пожалуйста, попробуйте еще раз',
    INVALID_TYPE: 'Неверный тип ордера',
    INVALID_VOLUME: 'Неверный объем ордера',
    INVALID_SL: 'Неверный стоп лосс',
    INVALID_TP: 'Неверный тейк профит',
    INVALID_PRICE: 'Неверная цена ордера',
    INVALID_EXPIRATION: 'Неверное время экспирации',
    NOT_ENOUGH_MARGIN: 'Недостаточно маржи',
    INVALID_ORDER: 'Ордер не найден',
    MARKET_CLOSED: 'Торговля недоступна, рынок закрыт',
    INVALID_BALANCE_TYPE: 'Неверный тип балансовой операции',
    INVALID_HASH: 'Неверный хеш',
    HASH_EXPIRED:
      'Ваша ссылка на сброс пароля истекла. Пожалуйста, запросите новую',
    INVALID_CODE: 'Неверный код 2FA',
    CHAT_DISABLED: 'Доступ к чату поддержки был закрыт',
    WITHDRAWAL_NOT_ALLOWED: 'Доступ к выводу средств был закрыт',
    TRADING_DISABLED: 'Торговля отключена для этого счета',
    PENDING_DEPOSITS_LIMIT: 'Превышен лимит депозитов',
    LOCAL_ONE_PENDING_WITHDRAWAL:
      'Возможно только одно неподтвержденное снятие средств',
    LOCAL_DEPOSIT_ONLY_REAL:
      'Пополнение возможно только для реального аккаунта',
    LOCAL_DEPOSIT_POSITIVE: 'Сумма депозита должна быть больше 0',
    LOCAL_INVALID_CARD_NUMBER: 'Неверный номер карты',
    LOCAL_INVALID_CARD_EXPIRATION: 'Неверная дата истечения срока действия',
    LOCAL_INVALID_CVC: 'Неверный код CVV/CVC',
    LOCAL_PASSWORDS_NOT_MATCH: 'Пароли не сопадают, пожалуйста, введите снова',
    LOCAL_NO_TRADING_ACCOUNTS:
      'У вас нет торговых счетов. Пожалуйста, свяжитесь со службой поддержки',
    LOCAL_MIN_DEPOSIT: 'Минмальная сумма пополнения - $',
    LOCAL_MIN_WITHDRAWAL: 'Минимальная сумма снятия - $',
    LOCAL_INVALID_FILE_TYPE:
      'Неподдерживаемый формат файла. Пожалуйста, приложите файл JPG, PNG или PDF',
    LOCAL_MIN_STAKING: 'Минимальная сумма для выбранной валюты ',
    FLOOD_REJECTED:
      'Вы отправляете сообщения слишком часто. Пожалуйста, повторите попытку позже',

    countries: {
      AF: 'Афганистан',
      AX: 'Аландские острова',
      AL: 'Албания',
      DZ: 'Алжир',
      AS: 'Американское Самоа',
      AD: 'Андорра',
      AO: 'Ангола',
      AI: 'Ангилья',
      AQ: 'Антарктида',
      AG: 'Антигуа и Барбуда',
      AR: 'Аргентина',
      AM: 'Армения',
      AW: 'Аруба',
      AU: 'Австралия',
      AT: 'Австрия',
      AZ: 'Азербайджан',
      BS: 'Багамские Острова',
      BH: 'Бахрейн',
      BD: 'Бангладеш',
      BB: 'Барбадос',
      BY: 'Белоруссия',
      BE: 'Бельгия',
      BZ: 'Белиз',
      BJ: 'Бенин',
      BM: 'Бермудские Острова',
      BT: 'Бутан',
      BO: 'Боливия',
      BA: 'Босния и Герцеговина',
      BW: 'Ботсвана',
      BV: 'Остров Буве',
      BR: 'Бразилия',
      IO: 'Британская территория в Индийском океане',
      BN: 'Бруней',
      BG: 'Болгария',
      BF: 'Буркина-Фасо',
      BI: 'Бурунди',
      KH: 'Камбоджа',
      CM: 'Камерун',
      CA: 'Канада',
      CV: 'Кабо-Верде',
      KY: 'Острова Кайман',
      CF: 'ЦАР',
      TD: 'Чад',
      CL: 'Чили',
      CN: 'Китай',
      CX: 'Остров Рождества',
      CC: 'Кокосовые острова',
      CO: 'Колумбия',
      KM: 'Коморы',
      CG: 'Конго',
      CD: 'Демократическая Республика Конго',
      CK: 'Острова Кука',
      CR: 'Коста-Рика',
      CI: 'Кот-д’Ивуар',
      HR: 'Хорватия',
      CU: 'Куба',
      CY: 'Кипр',
      CZ: 'Чехия',
      DK: 'Дания',
      DJ: 'Джибути',
      DM: 'Доминика',
      DO: 'Доминиканская Республика',
      EC: 'Эквадор',
      EG: 'Египет',
      SV: 'Сальвадор',
      GQ: 'Экваториальная Гвинея',
      ER: 'Эритрея',
      EE: 'Эстония',
      ET: 'Эфиопия',
      FK: 'Фолклендские острова',
      FO: 'Фарерские острова',
      FJ: 'Фиджи',
      FI: 'Финляндия',
      FR: 'Франция',
      GF: 'Гвиана',
      PF: 'Французская Полинезия',
      TF: 'Французские Южные и Антарктические территории',
      GA: 'Габон',
      GM: 'Гамбия',
      GE: 'Грузия',
      DE: 'Германия',
      GH: 'Гана',
      GI: 'Гибралтар',
      GR: 'Греция',
      GL: 'Гренландия',
      GD: 'Гренада',
      GP: 'Гваделупа',
      GU: 'Гуам',
      GT: 'Гватемала',
      GG: 'Гернси',
      GN: 'Гвинея',
      GW: 'Гвинея-Бисау',
      GY: 'Гайана',
      HT: 'Гаити',
      HM: 'Остров Херд и острова Макдональд',
      VA: 'Ватикан',
      HN: 'Гондурас',
      HK: 'Гонк Конг',
      HU: 'Венгрия',
      IS: 'исландия',
      IN: 'Индия',
      ID: 'Индонезия',
      IR: 'Иран',
      IQ: 'Ирак',
      IE: 'Ирландия',
      IM: 'Остров Мэн',
      IL: 'Израиль',
      IT: 'Италия',
      JM: 'Ямайка',
      JP: 'Япония',
      JE: 'Джерси',
      JO: 'Иордания',
      KZ: 'Казахстан',
      KE: 'Кения',
      KI: 'Кирибати',
      KR: 'Корея',
      KW: 'Кувейт',
      KG: 'Киргизия',
      LA: 'Лаос',
      LV: 'Латвия',
      LB: 'Ливан',
      LS: 'Лесото',
      LR: 'Либерия',
      LY: 'Ливия',
      LI: 'Лихтенштейн',
      LT: 'Литва',
      LU: 'Люксембург',
      MO: 'Макао',
      MK: 'Македония',
      MG: 'Мадагаскар',
      MW: 'Малави',
      MY: 'Малайзия',
      MV: 'Мальдивы',
      ML: 'Мали',
      MT: 'Мальта',
      MH: 'Маршалловы Острова',
      MQ: 'Мартиника',
      MR: 'Мавритания',
      MU: 'Маврикий',
      YT: 'Майотта',
      MX: 'Мексика',
      FM: 'Микронезия',
      MD: 'Молдова',
      MC: 'Монако',
      MN: 'Монголия',
      ME: 'Черногория',
      MS: 'Монтсеррат',
      MA: 'Марокко',
      MZ: 'Мозамбик',
      MM: 'Мьянма',
      NA: 'Намибия',
      NR: 'Науру',
      NP: 'Непал',
      NL: 'Нидерланды',
      AN: 'Нидерландские Антильские острова',
      NC: 'Новая Каледония',
      NZ: 'Новая Зеландия',
      NI: 'Никарагуа',
      NE: 'Нигер',
      NG: 'Нигерия',
      NU: 'Ниуэ',
      NF: 'Норфолк',
      MP: 'Северные Марианские острова',
      NO: 'Норвегия',
      OM: 'Оман',
      PK: 'Пакистан',
      PW: 'Палау',
      PS: 'Палестинские Территории',
      PA: 'Панама',
      PG: 'Папуа — НоваяГвинея',
      PY: 'Парагвай',
      PE: 'Перу',
      PH: 'Филиппины',
      PN: 'Острова Питкэрн',
      PL: 'Польша',
      PT: 'Португалия',
      PR: 'Пуэрто-Рико',
      QA: 'Катар',
      RE: 'Реюньон',
      RO: 'Румыния',
      RU: 'Россия',
      RW: 'Руанда',
      BL: 'Сен-Бартелеми',
      SH: 'Остров Святой Елены',
      KN: 'Сент-Китс и Невис',
      LC: 'Сент-Люсия',
      MF: 'Сен-Мартен',
      PM: 'Сен-Пьер и Микелон',
      VC: 'Сент-Винсент и Гренадины',
      WS: 'Самоа',
      SM: 'Сан Марино',
      ST: 'Сан-Томе и Принсипи',
      SA: 'Саудовская Арабия',
      SN: 'Сенегал',
      RS: 'Сербия',
      SC: 'Сейшелы',
      SL: 'Сьерра-Леоне',
      SG: 'Сингапур',
      SK: 'Словакия',
      SI: 'Словения',
      SB: 'Соломоновы Острова',
      SO: 'Сомали',
      ZA: 'ЮАР',
      GS: 'Южная Георгия и Южные Сандвичевы Острова',
      ES: 'Испания',
      LK: 'Шри-Ланка',
      SD: 'Судан',
      SR: 'Суринам',
      SJ: 'Шпицберген и Ян-Майен',
      SZ: 'Эсватини',
      SE: 'Швеция',
      CH: 'Швейцария',
      SY: 'Сирия',
      TW: 'тайвань',
      TJ: 'Таджикистан',
      TZ: 'Танзания',
      TH: 'Тайланд',
      TL: 'Восточный Тимор',
      TG: 'Того',
      TK: 'Токелау',
      TO: 'Тонга',
      TT: 'Тринидад и Тобаго',
      TN: 'Тунис',
      TR: 'Турция',
      TM: 'Туркменистан',
      TC: 'Тёркс и Кайкос',
      TV: 'Тувалу',
      UG: 'Уганда',
      UA: 'Украина',
      AE: 'ОАЭ',
      GB: 'Великобритания',
      US: 'США',
      UM: 'Внешние малые острова США',
      UY: 'Уругвай',
      UZ: 'Узбекистан',
      VU: 'Вануату',
      VE: 'Венесуэла',
      VN: 'Вьетнам',
      VG: 'Виргинские Острова',
      VI: 'Виргинские Острова (США)',
      WF: 'Уоллис и Футуна',
      EH: 'Западная Сахара',
      YE: 'Йемен',
      ZM: 'Замбия',
      ZW: 'Зимбабве',
    },
  },
  pl: {
    _name: 'Polski',

    policy: 'Polityka prywatności',
    policyAML: 'Polityka AML (Przeciwdziałanie praniu pieniędzy)',
    policyKYC: 'Polityka KYC (Poznaj swojego klienta)',
    locense: 'Licencja',

    view_all: 'Zobacz wszystkie',

    sell_btn: 'Sprzedać',
    buy_btn: 'Kupić',

    currency_action: 'waluta',

    importantAccountDetails: 'Ważne szczegóły konta',
    viewAdditionalSettings: 'Wyświetl dodatkowe ustawienia',
    switchDarkMode: 'Przełącz tryb ciemny/jasny',
    writeProblem: 'Napisz do nas swój problem',
    darkMode: 'Tryb ciemny',

    yay: 'Hurra',
    purchased: 'Pomyślnie kupiłeś',
    from: 'z',
    walet: 'Portfela',
    trade: 'Handlu',

    withdrawDetails: 'Szczegóły wypłaty',
    saveDetails: 'Zapisz szczegóły na następny raz',
    amountToWithdraw: 'Kwota do wypłaty',
    withdrawLimit: 'Pozostało 1 000 000,00 USD dziennego limitu wypłat.',

    serviceFee: 'Opłata za usługę',
    youWillPay: 'Zapłacisz',
    cancel: 'Anuluj',
    understand: 'Rozumiem, kontynuuj',

    select: 'Wybierz',
    enterAmount: 'Wprowadź kwotę',
    orderInfo: 'Informacje o zamówieniu',
    confirmOrder: 'Potwierdź zamówienie',
    get: 'Uzyskaj',
    spend: 'Wydaj',
    buying: 'Kupowanie',

    accountTransactions: 'Transakcje na koncie',

    overview: 'Przegląd',
    accountBalances: 'Salda kont',
    details: 'Szczegóły',
    loginHistory: 'Historia logowania',
    device: 'Urządzenie',
    contactUs: 'Skontaktuj się z nami',
    sessionLog: 'Sesje i historia logowania',
    selectMethods: 'Wybierz metody',
    depositDetails: 'Szczegóły depozytu',
    support: 'Wsparcie',
    homepage: 'Strona główna',
    supportChat: 'Czat wsparcia',
    createChat: 'Utwórz czat',

    takeProfitStopLoss: 'TAKE PROFIT & STOP LOSS',
    takeProfit: ' Take Profit',
    stopLoss: ' Stop Loss',
    updateOrder: ' Zaktualizuj zamówienie',

    balance: 'Saldo',
    credit: ' Kredyt',
    equity: ' Kapital',
    practice: ' PRAKTYKA',
    real: ' REALNY',
    account: ' KONTO',
    invested: ' Zainwestowany',
    profit: ' Zysk',
    loss: ' Strata',
    margin: ' Margines',
    marginLevel: 'Poziom marginesu',
    marginFree: 'Wolny margines',

    cfd: 'CFD',
    platform: ' Platforma',
    deposit: ' Depozyt',

    marketWatch: 'Obserwacja rynku',
    activeOrders: 'Aktywne zamówienia',
    tradingHistory: 'Historia handlu',
    economicCalendar: 'Kalendarz ekonomiczny',
    marketNews: 'Wiadomosci rynkowe',

    closeOrder: 'Zamknij pozycje',
    areYouSure: 'Czy na pewno zamkniesz pozycje',
    buy: 'Kupic',
    sell: 'Sprzedac',
    yes: 'Tak',
    no: 'Nie',

    addNewChart: 'Dodaj nowy wykres',

    watchlist: 'Lista obserwowanych',
    asset: 'Aktywa',
    price: 'Cena',
    changePct: 'Wymiana 24h',

    pending: 'W oczekiwaniu',
    assetPrice: 'Cena aktywów',
    current: ' Aktualny',
    revert: 'Powrót do ceny rynkowej',
    automatically:
      'Pozycja zostanie otwarta automatycznie, gdy cena osiegnie ten poziom',

    default: 'default',
    volume: 'Pojemnosc',
    lots: 'partii',
    units: ' jednostki',
    currency: 'waluta',
    contractSize: 'Wielkosc kontraktu',
    position: 'Pozycja',
    margin: 'Margines',
    freeMargin: 'Wolny margines',
    takeProfitStopLoss: 'Odbierz zysk i zatrzymaj strate',
    pending: 'W oczekiwaniu',
    market: 'Rynek',
    leverage: 'Dźwignia',
    spread: 'Spread',
    notSet: 'Nie ustawiony',
    at: 'w',
    buy: 'kupić',
    sell: 'sprzedać',

    supportBanner: 'KAZDEGO DNIA PRZEZ CALE DOBE',
    currentTime: 'OBECNY CZAS',
    liveChat: 'Czat na zywo',

    balance: 'Saldo',
    credit: 'Kredyt',
    equity: 'Kapital',
    margin: 'Margines',
    marginLevel: 'Poziom marginesu',
    freeMargin: 'Wolny margines',
    pnl: 'PnL',
    profitTotal: 'Lifetime PnL',

    dateRegistered: 'Data rejestracji',
    userId: 'Identyfikator uzytkownika',
    dashboard: 'Dashboard',
    personalData: 'Dane osobiste',
    deposit: 'Depozyt',
    withdrawFunds: 'Wypłatę srodków',
    savings: 'Oszczednosci',
    settings: 'Ustawienia',
    logout: 'Wyloguj sie',

    BT_INVOICE: 'Enter amount and generate invoice',
    BT_TITLE: 'Our banking details',
    PENDING_DEPOSITS_LIMIT: 'Deposit Limit',
    account: 'Account',
    bank_name: 'Bank Name',
    beneficiary: 'Beneficiary',
    beneficiary_address: 'Beneficiary Address',
    swift: 'Swift',
    iban: 'IBAN',
    ru_inn: 'INN',
    ru_kpp: 'KPP',
    corresponding_account: 'Correspondent account',
    TOKEN_AMOUNT: 'Amount',
    TOKEN_SUBTOTAL: 'Subtotal',
    TOKEN_TOTAL: 'Total',
    TOKEN_DESCRIPTION: 'Description',
    TOKEN_PAYMENT_DETAILS: 'Payment Details',
    makeDeposit: 'Zlozyc depozyt',
    practiceAccount: 'Konto treningowe',
    realAccount: 'Prawdziwe konto',
    noWithdrawals: 'Brak wyplat',
    easyWithdrawals: 'latwe wyplaty',
    allAssets: 'Wszystkie aktywy dostepne',
    fullFledged: 'Pelnoprawna platforma',
    fillUpTo: 'Wypelnij do',
    freeReplenishment: 'Bezplatne uzupelnianie',
    topUp: 'Doladuj swoje konto',
    minimumAmount: 'Stawka minimalna',
    maxAmount: 'Maksymalna kwota',
    withdrawalType: 'Typ wypłaty',
    canSwitch:
      'Mozesz przelaczac sie miedzy swoimi kontami w dowolnym momencie',

    chartGrids: 'SIATKI WYKRESÓW',
    chart1: '1 wykres',
    chart2: '2 wykres',
    chart3: '3 wykres',
    chart4: '4 wykres',

    connectionLost: 'Polaczenie z serwerem zostalo utracone',
    retryNow: 'Spróbuj teraz',

    loginToTradeRoom: 'Zaloguj sie do Traderoom',
    email: 'Adres e-mail',
    enterEmail: 'Wpisz swój e-mail',
    twoFactor: 'Kod 2FA (jesli jest wlaczony)',
    twoFactorAuth: 'Uwierzytelnianie dwuskladnikowe',
    password: 'Haslo',
    yourPassword: 'Twoje haslo',
    signIn: 'Zaloguj sie',
    dontHaveAccount: 'Don’t have an account?',
    restore: 'Restore',
    fullName: 'Full Name',
    havePromo: 'I have a promo-code',
    promo: 'Promo code',
    login: 'Login',
    haveAccount: 'Already have an account?',
    hide: 'Hide',
    goTo: 'Go to back',

    setNewPassword: 'Ustaw nowe haslo',
    newPassword: 'Nasza zalety',
    confirmNewPassword: 'Potwierdź nowe hasło',
    setButton: 'Ustaw',

    repeatPassword: 'Repeat Password',
    createNewAccount: 'Utwórz nowe konto',
    email: 'Adres e-mail',
    firstName: 'Imie',
    lastName: 'Nazwisko',
    country: 'Kraj',
    phone: 'Telefon',
    password: 'Haslo',
    createAccount: 'Utwórz konto',
    currency: 'Waluta',

    forgotPassword: 'Nie pamietam hasla?',
    submitEmail:
      'Prosimy o podanie e-maila uzytego do rejestracji, sprawdzenie skrzynki odbiorczej i postepowanie zgodnie z podanymi instrukcjami.',
    submit: 'Przeslij',

    error: 'Blad',
    success: 'Sukces',
    deposit: 'Depozyt',
    withdrawal: 'Wycofanie',
    depositApproved: 'Depozyt zostal zatwierdzony',
    depositDeclined: 'Depozyt zostal odrzucony',
    withdrawalApproved: 'Wycofanie zatwierdzone',
    withdrawalDeclined: 'Odmówiono wyplaty',

    forex: 'Forex',
    stocks: 'Akcje',
    commodities: 'Towary',
    indices: 'Wskazniki',
    crypto: 'Kryptowaluta',
    metals: 'Metale',
    nft: 'NFT',

    buy: 'BUY',
    profitCalculator: 'Profit Calculator',
    sell: 'SELL',
    volume: 'Volume',
    entryPrice: 'Entry Price',
    takeProfit: 'Take Profit',
    stopLoss: 'Stop Loss',
    maxPosition: 'Max Position',
    calculate: 'Calculate',
    calculationsFor: 'Calculations for',
    leverage: 'Leverage',
    requiredMargin: 'Required Margin',
    profitFromTP: 'Profit from TP',
    lossFromSL: 'Loss from SL',
    roe: 'ROE',

    title: 'Deposit successful',
    text: 'Your deposit has been processed successfully!',

    title: 'Deposit failed',
    text: 'Your deposit has not been processed.',

    marketWatch: 'Obserwacja rynku',
    search: 'Szukac  ...',

    commission: 'Commission',
    volume: 'Tom',
    margin: 'Marza',
    active: 'Aktywny',
    pending: 'W trakcie realizacji',
    activeOrders: 'Zamówienia aktywne',
    portfolio: 'Portfolio',
    allPositions: 'Wszystkie stanowiska',
    noPositionsLine1: 'Nie masz otwartego',
    noPositionsLine2: 'jeszcze stanowiska',
    show: 'Pokaz',
    more: 'wiecej',
    less: 'mniej',
    purchaseTime: 'Czas zakupu',
    closePosition: 'Pozycja zamkniecia',
    priceOpen: 'Cena zakupu',
    priceSl: 'Cena Stop Loss',
    priceTp: 'Cena Take Profit',
    type: 'Pozycja Kierunek',
    pnl: 'Zysk/Strata',
    cancelOrder: 'Anuluj zamówienie',
    order: 'Zamówienie',

    orderType: 'Typ zamówienia',
    cancelled: 'Anulowane',
    tradingHistory: 'Historia handlu',
    noHistoryLine1: 'Nie masz zadnych',
    noHistoryLine2: 'jeszcze zamkniete transakcje',

    economicCalendar: 'Kalendarz ekonomiczny',

    marketNews: 'Wiadomosci rynkowe',

    ordersActive: 'Zamówienia Aktywne',
    ordersHistory: 'Historia zamówien',
    id: 'ID',
    symbol: 'Symbol',
    documentType: 'Typ',
    volume: 'Tom',
    openPrice: 'Cena wywolawcza',
    openTime: 'Czas otwarcia',
    closePrice: 'Zamknij cene',
    closeTime: 'Czas zamkniecia',
    sl: 'SL',
    tp: 'TP',
    price: 'Cena',
    pnl: 'PnL',
    actions: 'Dzialania',
    edit: 'Edytować',
    close: 'Zamknać',
    commission: 'Prowizja',
    swap: 'Swap',
    swapLong: 'Swap długi',
    swapShort: 'Swap krótki',
    assetInfo: 'Informacje o aktywach',
    tradingConditions: 'Warunki handlu',
    information: 'Zmiana sesji',
    bid: 'Bid',
    ask: 'Ask',
    sessionChange: 'Zmiana sesji',
    tradeNow: 'Handluj teraz',
    opens: 'Otwarcie',
    closes: 'Zamknięcie',
    at: 'o',
    open247: 'Otwarte 24/7',
    today: 'dzisiaj',
    tomorrow: 'jutro',
    sunday: 'niedziela',
    monday: 'poniedziałek',
    tuesday: 'wtorek',
    wednesday: 'środa',
    thursday: 'czwartek',
    friday: 'piątek',
    saturday: 'sobota',
    contractSpecification: 'Specyfikacja kontraktu',
    symbol: 'Symbol',
    name: 'Nazwa',
    market: 'Rynek',
    baseCurrency: 'Waluta bazowa',
    digits: 'Cyfry',
    lotSize: 'Wielkość lota',
    lotStep: 'Krok lota',
    minVolume: 'Min. wolumen',
    maxVolume: 'Maks. wolumen',
    leverage: 'Dźwignia',
    schedule: 'Harmonogram',
    weekday: 'Dzień tygodnia',
    tradingTime: 'Godziny handlu',
    closed: 'zamknięte',
    sell: 'Sprzedaj',
    buy: 'Kup',
    low: 'Niski',
    medium: 'Średni',
    high: 'Wysoki',
    oneHourChange: 'Zmiana w 1 godzinę',
    oneDayChange: 'Zmiana w 1 dzień',
    oneWeekChange: 'Zmiana w 1 tydzień',
    oneMonthChange: 'Zmiana w 1 miesiąc',
    threeMonthsChange: 'Zmiana w 3 miesiące',
    oneYearChange: 'Zmiana w 1 rok',
    loading: 'Ładowanie...',
    months: {
      Jan: 'Styczen',
      Feb: 'Luty',
      Mar: 'Marzec',
      Apr: 'Kwiecien',
      May: 'Maj',
      Jun: 'Czerwiec',
      Jul: 'Lipiec',
      Aug: 'Sierpien',
      Sep: 'Wrzesien',
      Oct: 'Pazdziernik',
      Nov: 'Listopad',
      Dec: 'Grudzien',
    },

    traderTitle: 'Automatyczny trader',
    traderConfirm: 'Potwierdź i zapisz',
    riskLevelLow: 'Poziom ryzyka',
    riskLevelMedium: 'Poziom ryzyka: średni',
    riskLevelHigh: 'Poziom ryzyka: wysoki',
    perDay: 'Transakcje na dzień:',
    desc: 'Handel kontraktami CFD i innymi produktami z dźwignią może prowadzić do strat. Zanim zaczniesz handlować, klienci powinni zapoznać się z odpowiednimi informacjami o ryzyku na naszej stronie z oświadczeniami o ryzyku. Automatyczny handel nie gwarantuje wyników. Firma nie ponosi odpowiedzialności za utratę środków w automatycznym handlu. Upewnij się, że w pełni rozumiesz związane z tym ryzyko i podejmujesz kroki w celu jego ograniczenia.',
    accept: 'Akceptuj',

    trade: 'Handel',
    startTrading: 'Rozpocznij Handel',
    deposit: 'Dokonaj wplaty',
    dashboard: 'Pulpit',
    personalInfo: 'Aktualizacja danych osobowych',
    withdrawal: 'Wypłata środków',
    verification: 'Weryfikacja tożsamości',
    accounts: 'Zarządzaj kontami',
    liveChat: 'Czat na żywo',
    savings: 'Lokaty',
    settings: 'Ustawienia platformy',
    logOut: 'Wyloguj się',

    methods: 'METHODS',
    confirm: 'Confirm in the application of your bank',
    sendOtp: 'Send otp',
    otpCode: 'Otp code',
    addWalletAddress:
      'Wallet for this deposit method is not set. Please contact your agent or support team.',
    addressReceipt: 'Please wait for the address to load',
    makeDeposit: 'DOKONAJ WPLATY DEPOZYTU',
    instant: 'Natychmiast',
    minutes: 'minuty',
    hours: 'godziny',
    days: 'dni',
    amount: 'Kwota',
    continue: 'Kontynuuj',
    qrCode: 'KOD QR',
    depositAddress: 'ADRES DEPOZYTOWY',
    copy: 'Kopia',
    last: 'OSTATNI',
    deposits: 'DEPOZYTY',
    time: 'Czas',
    currency: 'Waluta',
    status: 'Status',
    info: 'Informacje',

    pleaseWait: 'Prosze czekac. Polaczenie z dostawca uslug platniczych...',
    cardPayment: 'Platnosc karta',
    inOrder: 'W celu wyslania kwoty',
    pleaseProvide: 'Prosze podac dane karty:',

    completeVerification: 'Please Complete Verification',
    noOrderYet: 'No order yet',
    totalBalance: 'Całkowite Saldo',
    totalDeposits: 'Razem depozyty',
    totalPnl: 'Całkowity PNL',
    profitableOrders: 'Zyskowne pozycję',
    roi: 'ROI',
    activityLog: 'Lista Aktywności',
    loginFromIp: 'Login from IP',
    tradingResults: 'Trading Results',
    week: 'Tydzień',
    month: 'Miesiąc',
    year: 'Rok',
    successRate: 'Wskaźnik Sukcesu',
    closedWithProfit: 'Zamknięte z Zyskiem',
    closedWithLoss: 'Zamknięte ze stratą',
    account: 'Konto',
    balance: 'Saldo',
    leverage: 'Dźwignia',
    credit: 'Kredyt',
    tradeNow: 'Rozpocznij Handel',
    usingCurrentRate: 'using current exchange rate',

    personalDetails: 'Dane osobowe',
    profilePhoto: 'Zdjecie profilowe',
    firstName: 'Imię',
    country: 'Kraj',
    lastName: 'Nazwisko',
    address: 'Adres',
    email: 'E-mail',
    phone: 'Numer telefonu',
    saveChanges: 'Zapisac zmiany',

    dropFile: 'Wrzuc plik na okrag powyzej, aby go przeslac',
    notAllowed: 'Niedozwolone jest publikowanie',
    notAllowedLine1:
      'Zdjecia o charakterze jednoznacznie seksualnym lub pornograficznym',
    notAllowedLine2:
      'Obrazy majace na celu podzeganie do nienawisci lub agresji na tle etnicznym lub rasowym',
    notAllowedLine3: 'Zdjecia z udzialem osób ponizej 18 roku zycia',
    notAllowedLine4: 'Zdjecia chronione prawami autorskimi osób trzecich',
    notAllowedLine5:
      'Obrazy wieksze niz 5 MB i w formacie innym niz JPG, GIF lub PNG',
    requirements:
      'Twoja twarz musi byc wyraznie widoczna na zdjeciu. Wszystkie zdjecia i filmy zamieszczane przez Ciebie musza spelniac te wymagania, w przeciwnym razie moga zostac usuniete.',

    withdrawalOff: 'Please contact your account manager for withdrawal details',
    cryptocurrency: 'Cryptocurrency',
    withdrawal: 'Withdrawal',
    requestNewWithdrawal: 'WNIOSEK O NOWA WYPŁATĘ',
    amount: 'Kwota',
    currentBalance: 'Stan Twojego rachunku biezacego wynosi',
    withdrawAll: 'Wycofac wszystkie',
    requestWithdrawal: 'Wypłać',
    last: 'OSTATNI',
    withdrawalRequests: 'Historia',
    time: 'Czas',
    currency: 'WALUTA',
    info: 'Informacje',
    status: 'Status',
    bank: 'Bank',
    bitcoin: 'Bitcoin',
    card: 'Karta',
    ethereum: 'Ethereum',
    eth: 'Ethereum',
    usdt: 'USDT',
    withdrawalDetails: 'Szczególy wypłaty',
    address: 'Adres portfela',
    bankAccount: 'Numer konta',
    bankHolder: 'Nazwa posiadacza konta',
    bankIban: 'IBAN',
    bankSwift: 'Kod SWIFT banku',
    cardNumber: 'Numer karty',
    cardHolder: 'Nazwa posiadacza karty',

    dragAndDrop: 'przeciagnij i upuść dokument na ten obszar',
    documentsList: 'LISTA PRZESLANYCH DOKUMENTÓW',
    document: 'Dokument',
    timeUploaded: 'Wyslano',
    timeProcessed: 'Zweryfikowano',
    status: 'Status',
    types: [
      'Przód dowodu',
      'Dokument potwierdzający adres zamieszkania',
      'Przód karty kredytowej',
      'Tył karty kredytowej',
      'Tył dowodu',
      'Selfie',
    ],
    types2: [
      'Proof of identification (POI)',
      'Proof of residential address',
      'Credit Card Front',
      'Credit Card Back',
      'Proof of identification Back',
      'Selfie with ID',
    ],
    upload: 'Wyślij',
    isConfirmed: 'jest potwierdzony',
    uploadAnotherDocument: 'Wyślij inny dokument',
    isUnderReview: 'jest w trakcie przegladu',
    questionnaire: 'Kwestionariusz',
    sendAnswers: 'Wyslij odpowiedzi',
    progressBarOf: 'z',
    progressBarText: 'twoich dokumentów zostały wgrane i potwierdzone',

    manageAccounts: 'Przelewaj srodki pomiedzy swoimi kontami',
    transferFrom: 'Z konta',
    transferTo: 'Na konto',
    amount: 'Kwota',
    makeTransfer: 'Dokonaj transferu',
    yourAccounts: 'Twoje konta',
    account: 'Konto',
    currency: 'Waluta',
    balance: 'Saldo',
    credit: 'Kredyt',
    makeActive: 'Uczyn aktywnym',
    active: 'Aktywny',

    sendMessage: 'Napisz wiadomość...',

    pct_0: 'Dynamiczna',
    pct_30: 'Terminowa miesiąc',
    pct_90: 'Terminowa kwartał',
    pct_180: 'Terminowa 6 miesięcy',
    pct_365: 'Terminowa rok',
    savings: 'Oszczednosci',
    detailedInformation: 'Szczególowe informacje',
    pleaseSelect: 'Prosze wybrac walute i okres',
    openSavings: 'Oszczednosci otwarte',
    currentTime: 'Aktualny czas',
    releaseTime: 'Czas wydania',
    currencyChosen: 'Wybrana waluta',
    periodChosen: 'Wybrany okres',
    yourRate: 'Twoja stawka',
    yourEarnings: 'Twoje zarobki',
    accountFrom: 'Z konta',
    enterAmount: 'Wprowadz kwote',
    in: 'W',
    openAndInvest: 'Otwórz konto oszczednosciowe i inwestuj',
    investment: 'Lokata',
    period: 'Okres',
    daysTotal: 'Dni',
    finalEarnings: 'Potencjialny zysk',
    created: 'Utworzony',
    daysElapsed: 'Dni, które uplynely',
    days: 'dni',
    earnings: 'Zarobki',
    fundsReleasedIn: 'Odbłokowane za',
    claim: 'Roszczenie',

    updatePassword: 'AKTUALIZACJA HASLA',
    currentPassword: 'Aktualne haslo',
    newPassword: 'Nowe hasło',
    changePassword: 'Zmiana hasła',
    activationForGoogle: 'Kod aktywacyjny dla Google Authenticator',
    activateAndEnter:
      'Aktywuj kod uwierzytelniający i wprowadź wygenerowany kod w polu poniżej',
    qrCode: 'Kod QR',
    activateProtection: 'Aktywuj ochrone 2FA',
    protectionActive: 'Ochrona 2FA jest aktywna',
    twoFactorCode: 'Kod 2FA',
    disableProtection: 'Wylacz ochrone 2FA',
    language: 'Jezyk',
    dashboardCurrency: 'Waluta na Panelu',
    confirmNewPassword: 'Potwierdź nowe hasło',

    yourLink: 'TWÓJ LINK POLECAJACY',
    referredFriends: 'POLECENI ZNAJOMI',
    id: 'ID',
    name: 'Imie',
    registered: 'Zarejestrowany',
    level: 'Poziom',
    payout: 'Wypłatę',
    lastPayouts: 'OSTATNIE WYPLATY ZA POLECENIE',
    time: 'Czas',
    amount: 'Kwota',
    currency: 'Walut',
    info: 'Informacje',

    orderTypes: [
      'Kupic',
      'Sprzedac',
      'Wykupic limit',
      'Limit sprzedazy',
      'Zakup Stop',
      'Sprzedac Stop',
    ],
    statuses: ['W trakcie realizacji', 'Zatwierdzony', 'Odrzucony', 'Obróbka'],

    NOT_FOUND: 'Blad zadania',
    FORBIDDEN: 'Odmowa dostepu. Prosimy o ponowne zalogowanie.',
    SERVER_ERROR: 'Akcja nie powiodla sie. Prosze spróbowac ponownie pózniej',
    INVALID_ACCOUNT:
      'Akcja nie powiodla sie. Prosze spróbowac ponownie pózniej',
    INVALID_EMAIL: 'Nieprawidlowy adres e-mail',
    INVALID_PHONE: 'Nieprawidlowy numer telefonu',
    INVALID_COUNTRY: 'Nieprawidlowy kraj',
    INVALID_LOGIN: 'Nieprawidlowe poswiadczenia logowania',
    USER_BLOCKED: 'Konto jest zablokowane. Prosimy o kontakt z obsluga',
    USER_REGISTERED:
      'Uzytkownik o podanym adresie e-mail lub numerze telefonu jest juz zarejestrowany',
    INVALID_USER: 'Uzytkownik nie zostal znaleziony',
    REJECTED: 'Dzialanie nie jest dozwolone z powodu ograniczen platformy',
    INVALID_OLD_PASSWORD: 'Stare haslo jest niewazne',
    INVALID_SYMBOL: 'Nieprawidlowy symbol handlowy',
    INVALID_SYMBOL_PRECISION: 'Nieprawidlowa precyzja symbolu',
    INVALID_FRAME: 'Nieprawidlowa ramka wykresu',
    INVALID_CURRENCY: 'Nieprawidlowa waluta',
    INVALID_PRODUCT: 'Nieprawidlowy typ handlowy konta',
    INSUFFICIENT_FUNDS: 'Niewystarczajace srodki finansowe',
    INVALID_WITHDRAWAL: 'Wycofanie nie zostalo odnalezione',
    INVALID_STATUS: 'Nieprawidlowy status',
    INVALID_FILE: 'Nieprawidlowe rozszerzenie pliku lub plik jest zbyt duzy',
    INVALID_DOCUMENT: 'Dokument nie zostal znaleziony',
    INVALID_NAME: 'Nieprawidlowa nazwa',
    INVALID_LOT_SIZE: 'Nieprawidlowa wielkosc dzialki',
    INVALID_LOT_STEP: 'Nieprawidlowy krok partii',
    INVALID_MIN_VOLUME: 'Nieprawidlowa objetosc minimalna',
    INVALID_MAX_VOLUME: 'Nieprawidlowa objetosc maksymalna',
    INVALID_GROUP: 'Nieprawidlowa grupa',
    INVALID_SPREAD: 'Niewazny rozrzut',
    REQUEST_TIMEOUT:
      'Zadanie zostalo przerwane. Prosze spróbowac ponownie pózniej',
    INVALID_TYPE: 'Nieprawidlowy typ zamówienia',
    INVALID_VOLUME: 'Nieprawidlowa wielkosc zamówienia',
    INVALID_SL: 'Nieprawidlowa wartosc stop loss',
    INVALID_TP: 'Nieprawidlowa wartosc take profit',
    INVALID_PRICE: 'Nieprawidlowa cena zamówienia',
    INVALID_EXPIRATION: 'Nieprawidlowy termin waznosci zamówienia',
    NOT_ENOUGH_MARGIN: 'Niewystarczajaca marza',
    INVALID_ORDER: 'Zamówienie nie zostalo znalezione',
    MARKET_CLOSED: 'Handel nie jest dostepny. Prosze spróbowac ponownie',
    INVALID_BALANCE_TYPE: 'Nieprawidlowy typ operacji bilansowej',
    INVALID_HASH: 'Nieprawidlowy hash',
    HASH_EXPIRED: 'Twój link do resetowania hasla wygasl. Popros o nowe haslo.',
    INVALID_CODE: 'Nieprawidlowy kod 2FA',
    CHAT_DISABLED: 'Dostep do czatu pomocy technicznej zostal zamkniety',
    WITHDRAWAL_NOT_ALLOWED: 'Dostep do wyplat zostal zamkniety',
    TRADING_DISABLED: 'Trading is disabled for current account',
    PENDING_DEPOSITS_LIMIT: 'Deposits limit exceeded',
    LOCAL_ONE_PENDING_WITHDRAWAL: 'Only one pending withdrawal allowed',
    LOCAL_DEPOSIT_ONLY_REAL: 'Deposit is available only for real account',
    LOCAL_DEPOSIT_POSITIVE: 'Amount of deposit must be more than 0',
    LOCAL_INVALID_CARD_NUMBER: 'Invalid card number',
    LOCAL_INVALID_CARD_EXPIRATION: 'Invalid card expiration',
    LOCAL_INVALID_CVC: 'Invalid CVV/CVC code',
    LOCAL_PASSWORDS_NOT_MATCH: 'Passwords do not match, please re-enter',
    LOCAL_NO_TRADING_ACCOUNTS:
      'You do not have trading accounts available. Please contact the support',
    LOCAL_MIN_DEPOSIT: 'Minimum deposit is $',
    LOCAL_MIN_WITHDRAWAL: 'Minimum withdrawal amount is $',
    LOCAL_INVALID_FILE_TYPE:
      'File format not supported. Please attach only JPG, PNG or PDF',
    FLOOD_REJECTED:
      'You are sending messages too often. Please try again later',
    LOCAL_MIN_STAKING: 'Minimum deposit for this currency is ',

    countries: {
      AF: 'Afganistan',
      AX: 'Wyspy Alandzkie',
      AL: 'Albania',
      DZ: 'Algieria',
      AS: 'Samoa Amerykanskie',
      AD: 'Andora',
      AO: 'Angola',
      AI: 'Anguilla',
      AQ: 'Antarktyda',
      AG: 'Antigua i Barbuda',
      AR: 'Argentyna',
      AM: 'Armenia',
      AW: 'Aruba',
      AU: 'Australia',
      AT: 'Austria',
      AZ: 'Azerbejdzan',
      BS: 'Bahamy',
      BH: 'Bahrajn',
      BD: 'Bangladesz',
      BB: 'Barbados',
      BY: 'Bialorus',
      BE: 'Belgia',
      BZ: 'Belize',
      BJ: 'Benin',
      BM: 'Bermudy',
      BT: 'Bhutan',
      BO: 'Boliwia',
      BA: 'Bosnia i Hercegowina',
      BW: 'Botswana',
      BV: 'Wyspa Bouveta',
      BR: 'Brazylia',
      IO: 'Brytyjskie Terytorium Oceanu Indyjskiego',
      BN: 'Panstwo Brunei Darussalam',
      BG: 'Bulgaria',
      BF: 'Burkina Faso',
      BI: 'Burundi',
      KH: 'Kambodza',
      CM: 'Kamerun',
      CA: 'Kanada',
      CV: 'Republika Zielonego Przyladka',
      KY: 'Kajmany',
      CF: 'Republika Srodkowoafrykanska',
      TD: 'Chad',
      CL: 'Chile',
      CN: 'Chiny',
      CX: 'Wyspa Bozego Narodzenia',
      CC: 'Wyspy Kokosowe (Keelinga)',
      CO: 'Kolumbia',
      KM: 'Komory',
      CG: 'Kongo',
      CD: 'Kongo, Republika Demokratyczna',
      CK: 'Wyspy Cooka',
      CR: 'Kostaryka',
      CI: 'Wybrzeze Kosci Sloniowej',
      HR: 'Chorwacja',
      CU: 'Kuba',
      CY: 'Cypr',
      CZ: 'Republika Czeska',
      DK: 'Dania',
      DJ: 'Dzibuti',
      DM: 'Dominika',
      DO: 'Republika Dominikanska',
      EC: 'Ekwador',
      EG: 'Egipt',
      SV: 'Salwador',
      GQ: 'Gwinea Równikowa',
      ER: 'Erytrea',
      EE: 'Estonia',
      ET: 'Etiopia',
      FK: 'Wyspy Falklandzkie (Malwiny)',
      FO: 'Wyspy Owcze',
      FJ: 'Fidzi',
      FI: 'Finlandia',
      FR: 'Francja',
      GF: 'Gujana Francuska',
      PF: 'Polinezja Francuska',
      TF: 'Francuskie Terytoria Poludniowe',
      GA: 'Gabon',
      GM: 'Gambia',
      GE: 'Georgia',
      DE: 'Niemcy',
      GH: 'Ghana',
      GI: 'Gibraltar',
      GR: 'Grecja',
      GL: 'Grenlandia',
      GD: 'Grenada',
      GP: 'Gwadelupa',
      GU: 'Guam',
      GT: 'Gwatemala',
      GG: 'Guernsey',
      GN: 'Gwinea',
      GW: 'Gwinea Bissau',
      GY: 'Gujana',
      HT: 'Haiti',
      HM: 'Wyspa Heard i Wyspy Mcdonalda',
      VA: 'Stolica Apostolska (Panstwo Watykanskie)',
      HN: 'Honduras',
      HK: 'Hongkong',
      HU: 'Wegry',
      IS: 'Islandia',
      IN: 'Indie',
      ID: 'Indonezja',
      IR: 'Iran',
      IQ: 'Irak',
      IE: 'Irlandia',
      IM: 'Wyspa Man',
      IL: 'Izrael',
      IT: 'Wlochy',
      JM: 'Jamajka',
      JP: 'Japonia',
      JE: 'Jersey',
      JO: 'Jordan',
      KZ: 'Kazachstan',
      KE: 'Kenia',
      KI: 'Kiribati',
      KR: 'Korea',
      KW: 'Kuwejt',
      KG: 'Kirgistan',
      LA: 'Laotanska Republika Ludowo-Demokratyczna',
      LV: 'Lotwa',
      LB: 'Liban',
      LS: 'Lesotho',
      LR: 'Liberia',
      LY: 'Libijska Arabska Dzamahirija',
      LI: 'Liechtenstein',
      LT: 'Litwa',
      LU: 'Luksemburg',
      MO: 'Macao',
      MK: 'Macedonia',
      MG: 'Madagaskar',
      MW: 'Malawi',
      MY: 'Malezja',
      MV: 'Malediwy',
      ML: 'Mali',
      MT: 'Malta',
      MH: 'Wyspy Marshalla',
      MQ: 'Martynika',
      MR: 'Mauretania',
      MU: 'Mauritius',
      YT: 'Majotta',
      MX: 'Meksyk',
      FM: 'Mikronezja',
      MD: 'Moldawia',
      MC: 'Monako',
      MN: 'Mongolia',
      ME: 'Montenegro',
      MS: 'Montserrat',
      MA: 'Maroko',
      MZ: 'Mozambik',
      MM: 'Myanmar',
      NA: 'Namibia',
      NR: 'Nauru',
      NP: 'Nepal',
      NL: 'Niderlandy',
      AN: 'Antyle Holenderskie',
      NC: 'Nowa Kaledonia',
      NZ: 'Nowa Zelandia',
      NI: 'Nikaragua',
      NE: 'Niger',
      NG: 'Nigeria',
      NU: 'Niue',
      NF: 'Wyspa Norfolk',
      MP: 'Mariany Pólnocne',
      NO: 'Norwegia',
      OM: 'Oman',
      PK: 'Pakistan',
      PW: 'Palau',
      PS: 'Terytorium Palestynskie, Okupowane',
      PA: 'Panama',
      PG: 'Papua Nowa Gwinea',
      PY: 'Paragwaj',
      PE: 'Peru',
      PH: 'Filipiny',
      PN: 'Pitcairn',
      PL: 'Polska',
      PT: 'Portugalia',
      PR: 'Puerto Rico',
      QA: 'Katar',
      RE: 'Zjazd',
      RO: 'Rumunia',
      RU: 'Rosja',
      RW: 'Rwanda',
      BL: 'Swiety Bartymeusz',
      SH: 'Swieta Helena',
      KN: 'Saint Kitts i Nevis',
      LC: 'Saint Lucia (Lucja Pólnocna)',
      MF: 'Swiety Marcin',
      PM: 'Saint Pierre i Miquelon',
      VC: 'Saint Vincent i Grenadyny',
      WS: 'Samoa',
      SM: 'San Marino',
      ST: 'Wyspy Swietego Tomasza i Ksiazeca',
      SA: 'Arabia Saudyjska',
      SN: 'Senegal',
      RS: 'Serbia',
      SC: 'Seszele',
      SL: 'Sierra Leone',
      SG: 'Singapur',
      SK: 'Slowacja',
      SI: 'Slowenia',
      SB: 'Wyspy Salomona',
      SO: 'Somalia',
      ZA: 'Republika Poludniowej Afryki',
      GS: 'Poludniowa Georgia i Sandwich Isl.',
      ES: 'Hiszpania',
      LK: 'Sri Lanka',
      SD: 'Sudan',
      SR: 'Surinam',
      SJ: 'Svalbard i Jan Mayen',
      SZ: 'Suazi',
      SE: 'Szwecja',
      CH: 'Szwajcaria',
      SY: 'Syryjska Republika Arabska',
      TW: 'Taiwan',
      TJ: 'Tadzykistan',
      TZ: 'Tanzania',
      TH: 'Tajlandia',
      TL: 'Timor Wschodni',
      TG: 'Togo',
      TK: 'Tokelau',
      TO: 'Tonga',
      TT: 'Trynidad i Tobago',
      TN: 'Tunezja',
      TR: 'Turcja',
      TM: 'Turkmenistan',
      TC: 'Wyspy Turks i Caicos',
      TV: 'Tuvalu',
      UG: 'Uganda',
      UA: 'Ukraina',
      AE: 'Zjednoczone Emiraty Arabskie',
      GB: 'Zjednoczone Królestwo',
      US: 'Stany Zjednoczone',
      UM: 'Wyspy Zewnetrzne Stanów Zjednoczonych',
      UY: 'Urugwaj',
      UZ: 'Uzbekistan',
      VU: 'Vanuatu',
      VE: 'Wenezuela',
      VN: 'Wietnam',
      VG: 'Brytyjskie Wyspy Dziewicze',
      VI: 'Wyspy Dziewicze, U.S.',
      WF: 'Wallis i Futuna',
      EH: 'Sahara Zachodnia',
      YE: 'Jemen',
      ZM: 'Zambia',
      ZW: 'Zimbabwe',
    },
  },
  de: {
    _name: 'Deutsch',

    policy: 'Datenschutzerklärung',
    policyAML: 'AML-Richtlinie (Anti-Geldwäsche)',
    policyKYC: 'KYC-Richtlinie (Kenne deinen Kunden)',
    locense: 'Lizenz',
    view_all: 'Alle ansehen',

    sell_btn: 'Verkaufen',
    buy_btn: 'Kaufen',
    currency_action: 'währung',

    importantAccountDetails: 'Wichtige Kontodetails',
    viewAdditionalSettings: 'Weitere Einstellungen anzeigen',
    switchDarkMode: 'Dunkel-/Hellmodus umschalten',
    writeProblem: 'Schreiben Sie uns Ihr Problem',
    darkMode: 'Dunkelmodus',

    yay: 'Juhuu',
    purchased: 'Sie haben erfolgreich gekauft',
    from: 'von',
    walet: 'Wallet',
    trade: 'Trade',

    withdrawDetails: 'Auszahlungsdetails',
    saveDetails: 'Details für nächstes Mal speichern',
    amountToWithdraw: 'Auszuzahlender Betrag',
    withdrawLimit: 'Tägliches Auszahlungslimit von 1.000.000,00 $ verbleibend.',

    serviceFee: 'Servicegebühr',
    youWillPay: 'Sie zahlen',
    cancel: 'Abbrechen',
    understand: 'Ich verstehe, weiter',
    select: 'Auswählen',
    enterAmount: 'Betrag eingeben',
    orderInfo: 'Bestellinfo',
    confirmOrder: 'Bestellung bestätigen',
    get: 'Erhalten',
    spend: 'Ausgeben',
    buying: 'Kaufen',

    accountTransactions: 'Kontotransaktionen',

    overview: 'Übersicht',
    accountBalances: 'Kontostände',
    details: 'Details',
    loginHistory: 'Anmeldeverlauf',
    device: 'Gerät',
    contactUs: 'Kontaktieren Sie uns',
    deposit: 'Einzahlung ',
    sessionLog: 'Sitzungen und Anmeldeverlauf',
    selectMethods: 'Methoden auswählen',
    depositDetails: 'Einzahlungsdetails',
    support: 'Unterstützung',
    homepage: 'Startseite',
    supportChat: 'Support-Chat',
    createChat: 'Chat erstellen',

    takeProfitStopLoss: 'Gewinnmitnahme & Stop-Loss',
    takeProfit: ' Gewinnmitnahme',
    stopLoss: 'Stop-Loss',
    updateOrder: 'Handel aktualisieren',
    balance: 'Kontostand',
    credit: ' Kredit',
    equity: 'Eigenkapital ',
    practice: 'Praxis',
    real: 'Real',
    account: 'Konto',
    invested: 'Investiert',
    profit: 'Profit',
    loss: 'Verlust',
    margin: 'Margin',
    marginLevel: 'Margin Level',
    marginFree: 'Freie Margin',

    cfd: 'CFD',
    platform: 'Plattform',
    deposit: 'Einzahlung ',

    marketWatch: 'Marktübersicht',
    activeOrders: 'Aktive Handel',
    tradingHistory: 'Handelsgeschichte',
    economicCalendar: 'Wirtschaftskalender',
    marketNews: 'Marktnachrichten',

    closeOrder: 'Handel schließen',
    areYouSure: 'Sind Sie sicher, den Order zu schließen?',
    buy: 'Kaufen',
    sell: 'Verkaufen',
    yes: 'Ja',
    no: 'Nein',

    addNewChart: 'Neue Chart hinzufügen',

    watchlist: 'Überwachungsliste',
    asset: 'Vermögenswert',
    price: 'Preise',
    changePct: '24h Wechsel',

    pending: 'Ausstehend',
    assetPrice: 'Vermögenswertpreis',
    current: 'aktuell',
    revert: 'Zurück zum Marktpreis',
    automatically:
      'Handel wird automatisch eröffnet, wenn der Preis dieses Niveau erreicht',

    default: 'default',
    volume: 'Volumen',
    lots: 'lots',
    units: 'einheiten',
    currency: 'währung',
    contractSize: 'kontraktgröße',
    position: 'Position',
    margin: 'Margin',
    freeMargin: 'Freie Margin',
    takeProfitStopLoss: 'Gewinnmitnahme & Stop-Loss',
    pending: 'Ausstehend',
    market: 'Markt',
    leverage: 'Hebelwirkung',
    spread: 'Spread',
    notSet: 'Nicht eingestellt',
    at: 'um',
    buy: 'Kaufen',
    sell: 'Verkaufen',

    supportBanner: 'JEDEN TAG, RUND UM DIE UHR',
    currentTime: 'AKTUELLE UHRZEIT',
    liveChat: 'Live Chat',

    balance: 'Kontostand',
    credit: 'Kredit',
    equity: 'Eigenkapital',
    margin: 'Margin',
    marginLevel: 'Margin level',
    freeMargin: 'Freie Margin',
    pnl: 'PnL',
    profitTotal: 'Lifetime PnL',

    dateRegistered: 'Registrierungsdatum',
    userId: 'Benutzer ID',
    dashboard: 'Dashboard',
    personalData: 'Persönliche Daten',
    deposit: 'Einzahlung',
    withdrawFunds: 'Auszahlung',
    savings: 'Ersparnisse',
    settings: 'Einstelungen',
    logout: 'Ausloggen',

    BT_INVOICE: 'Enter amount and generate invoice',
    BT_TITLE: 'Our banking details',
    PENDING_DEPOSITS_LIMIT: 'Deposit Limit',
    account: 'Account',
    bank_name: 'Bank Name',
    beneficiary: 'Beneficiary',
    beneficiary_address: 'Beneficiary Address',
    swift: 'Swift',
    iban: 'IBAN',
    ru_inn: 'INN',
    ru_kpp: 'KPP',
    corresponding_account: 'Correspondent account',
    TOKEN_AMOUNT: 'Amount',
    TOKEN_SUBTOTAL: 'Subtotal',
    TOKEN_TOTAL: 'Total',
    TOKEN_DESCRIPTION: 'Description',
    TOKEN_PAYMENT_DETAILS: 'Payment Details',
    makeDeposit: 'Einzahlung',
    practiceAccount: 'Demokonto',
    realAccount: 'Reales Konto',
    noWithdrawals: 'Keine Auszahlungen',
    easyWithdrawals: 'Einfache Auszahlungen ',
    allAssets: 'Alle Vermögenswerte verfügbar',
    fullFledged: 'Vollgeführte Plattform',
    fillUpTo: 'Auffüllen bis',
    freeReplenishment: 'Kostenloser Nachschub',
    topUp: 'Laden Sie Ihr Konto auf',
    minimumAmount: 'Mindestbetrag',
    maxAmount: 'Maximalbetrag',
    withdrawalType: 'Auszahlungstyp',
    canSwitch: 'Sie können jederzeit zwischen Ihren Konten wechseln',

    chartGrids: 'Chartaufstellung',
    chart1: '1 chart',
    chart2: '2 charts',
    chart3: '3 charts',
    chart4: '4 charts',

    connectionLost: 'Die Verbindung mit dem Server wurde unterbrochen',
    retryNow: 'Jetzt erneut versuchen',

    loginToTradeRoom: 'Melden Sie sich bei Handelsroom an',
    email: 'E-Mail-Addresse',
    enterEmail: 'Geben sie ihre E-Mail Adresse ein',
    twoFactor: '2FA-Code (falls aktiviert)',
    twoFactorAuth: 'Zwei-Faktor-Authentifizierung',
    password: 'Passwort',
    yourPassword: 'Ihr Passwort',
    signIn: 'Anmelden',
    dontHaveAccount: 'Don’t have an account?',
    restore: 'Restore',
    fullName: 'Full Name',
    havePromo: 'I have a promo-code',
    promo: 'Promo code',
    login: 'Login',
    haveAccount: 'Already have an account?',
    hide: 'Hide',
    goTo: 'Go to back',

    setNewPassword: 'Neues Passwort festlegen',
    newPassword: 'Neues Passwort',
    confirmNewPassword: 'Bestätige neues Passwort',
    setButton: 'Festsetzen',

    repeatPassword: 'Repeat Password',
    createNewAccount: 'Ein neues Konto erstellen',
    email: 'E-Mail-Addresse',
    firstName: 'Vorname',
    lastName: 'Nachname',
    country: 'Land',
    phone: 'Telefon',
    password: 'Passwort',
    createAccount: 'Benutzerkonto erstellen',
    currency: 'Währung',

    forgotPassword: 'Passwort vergessen?',
    submitEmail:
      'Bitte senden Sie eine für die Registrierung verwendete E-Mail-Adresse, überprüfen Sie Ihren Posteingang und befolgen Sie die bereitgestellten Anweisungen',
    submit: 'Bestätigen',

    error: 'Fehler',
    success: 'Erfolg',
    deposit: 'Einzahlung',
    withdrawal: 'Auszahlung',
    depositApproved: 'Einzahlung wurde genehmigt',
    depositDeclined: 'Einzahlung wurde abgelehnt',
    withdrawalApproved: 'Auszahlung wurde genehmigt',
    withdrawalDeclined: 'Auszahlung wurde abgelehnt',

    forex: 'Devisen',
    stocks: 'Aktien',
    commodities: 'Rohstoffe',
    indices: 'Indizes',
    crypto: 'Krypto',
    metals: 'Metalle',
    nft: 'NFT',

    buy: 'BUY',
    profitCalculator: 'Profit Calculator',
    sell: 'SELL',
    volume: 'Volume',
    entryPrice: 'Entry Price',
    takeProfit: 'Take Profit',
    stopLoss: 'Stop Loss',
    maxPosition: 'Max Position',
    calculate: 'Calculate',
    calculationsFor: 'Calculations for',
    leverage: 'Leverage',
    requiredMargin: 'Required Margin',
    profitFromTP: 'Profit from TP',
    lossFromSL: 'Loss from SL',
    roe: 'ROE',

    title: 'Deposit successful',
    text: 'Your deposit has been processed successfully!',

    title: 'Deposit failed',
    text: 'Your deposit has not been processed.',

    marketWatch: 'Marktübersicht',
    search: 'Suche...',

    commission: 'Commission',
    volume: 'Volumen',
    margin: 'Margin',
    active: 'Aktiv',
    pending: 'Ausstehend',
    activeOrders: 'Aktive Orders',
    portfolio: 'Portfolio',
    allPositions: 'Alle Positionen',
    noPositionsLine1: 'Sie haben noch keine',
    noPositionsLine2: 'geöffneten Positionen',
    show: 'Anzeigen',
    more: 'mehr',
    less: 'weniger',
    purchaseTime: 'Transaktionszeit',
    closePosition: 'Position schließen',
    priceOpen: 'Transaktionspreis',
    priceSl: 'Stop Loss Preis',
    priceTp: 'Take Profit Pries',
    type: 'Positionsrichtung',
    pnl: 'Profit/Verlust',
    cancelOrder: 'Order stornieren',
    order: 'Order',

    orderType: 'Ordertyp',
    cancelled: 'Storniert',
    tradingHistory: 'Handelsgeschichte',
    noHistoryLine1: 'Sie haben noch keine',
    noHistoryLine2: 'geschlossenen Positionen',

    economicCalendar: 'Wirtschaftskalender',

    marketNews: 'Marktnachrichten',

    ordersActive: 'Aktive Orders',
    ordersHistory: 'Handelsgeschichte',
    id: 'ID',
    symbol: 'Symbol',
    documentType: 'Type',
    volume: 'Volumen',
    openPrice: 'Eröffnungspreis',
    openTime: 'Eröffnungszeit',
    closePrice: 'Schlusskurs',
    closeTime: 'Schließzeit',
    sl: 'SL',
    tp: 'TP',
    price: 'Preis',
    pnl: 'PnL',
    actions: 'Aktionen',
    edit: 'Bearbeiten',
    close: 'Schließen',
    commission: 'Commission',
    swap: 'Swap',
    swapLong: 'Swap Long',
    swapShort: 'Swap Short',

    assetInfo: 'Asset Info',
    tradingConditions: 'Trading Conditions',
    information: 'Session Change',
    bid: 'Bid',
    ask: 'Ask',
    sessionChange: 'Session Change',
    tradeNow: 'Trade Now',
    opens: 'Opens',
    closes: 'Closes',
    at: 'at',
    open247: 'Open 24/7',
    today: 'today',
    tomorrow: 'tomorrow',
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    contractSpecification: 'Contract Specification',
    symbol: 'Symbol',
    name: 'Name',
    market: 'Market',
    baseCurrency: 'Base Currency',
    digits: 'Digits',
    lotSize: 'Lot Size',
    lotStep: 'Lot Step',
    minVolume: 'Min Volume',
    maxVolume: 'Max Volume',
    leverage: 'Leverage',
    commission: 'Commission',
    swapLong: 'Swap Long',
    swapShort: 'Swap Short',
    schedule: 'Schedule',
    weekday: 'Weekday',
    tradingTime: 'Trading Time',
    closed: 'closed',
    sell: 'Sell',
    buy: 'Buy',
    low: 'Low',
    high: 'High',
    oneHourChange: '1 hour change',
    oneDayChange: '1 day change',
    oneWeekChange: '1 week change',
    oneMonthChange: '1 month change',
    threeMonthsChange: '3 months change',
    oneYearChange: '1 year change',
    loading: 'Loading...',

    traderTitle: 'Autohändler',
    traderConfirm: 'Bestätigen und speichern',
    riskLevelLow: 'Risk Level',
    riskLevelMedium: 'Risk Level: Medium',
    riskLevelHigh: 'Risk Level: High',
    perDay: 'Trades per day:',
    desc: `Trading CFDs and other leveraged products can lead to losses. Before trading, clients should
              read the
              relevant risk statements on our Risk Disclosure page. Automated trading does not guarantee results. The
              company accepts no responsibility for the loss of funds in automatic trading. Please make sure that you
              fully understand the risks and take measures to manage risks.`,
    accept: 'Accept',

    trade: 'Handel',
    startTrading: 'Handel starten',
    deposit: 'Einzahlung',
    dashboard: 'Dashboard',
    personalInfo: 'Persönliche Daten',
    withdrawal: 'Die Auszahlung',
    verification: 'Identitätsprüfung',
    accounts: 'Konten verwalten',
    liveChat: 'Live Chat',
    savings: 'Ersparnisse',
    settings: 'Plattformeinstellungen',
    logOut: 'Ausloggen',

    methods: 'METHODS',
    confirm: 'Confirm in the application of your bank',
    sendOtp: 'Send otp',
    otpCode: 'Otp code',
    addWalletAddress:
      'Wallet for this deposit method is not set. Please contact your agent or support team.',
    addressReceipt: 'Please wait for the address to load',
    makeDeposit: 'MACHEN SIE EINE EINZAHLUNG',
    instant: 'Sofort',
    minutes: 'Minuten',
    hours: 'Stunden',
    days: 'Tage',
    amount: 'Betrag',
    continue: 'Fortsetzen',
    qrCode: 'QR-CODE',
    depositAddress: 'EINZAHLUNGSADRESSE',
    copy: 'Kopieren',
    last: 'ZULETZT',
    deposits: 'EINZAHLUNGEN',
    time: 'Zeit',
    currency: 'Währung',
    status: 'Status',
    info: 'Info',

    pleaseWait:
      'Warten Sie mal. Verbindung zum Zahlungsdienstleister wird hergestellt...',
    cardPayment: 'Kartenzahlung',
    inOrder: 'Um den Betrag zu senden',
    pleaseProvide: 'Bitte geben Sie die Kartendaten an:',

    completeVerification: 'Please Complete Verification',
    noOrderYet: 'No order yet',
    totalBalance: 'Kontostand',
    totalDeposits: 'Gesamteinlagen',
    totalPnl: 'PnL Insgesamt',
    profitableOrders: 'Erfolgreiche Trades',
    roi: 'ROI',
    activityLog: 'Aktivitätsprotokoll',
    loginFromIp: 'Login from IP',
    tradingResults: 'Handelsergebnisse',
    week: 'Woche',
    month: 'Monat',
    year: 'Jahr',
    successRate: 'Erfolgsquote',
    closedWithProfit: 'Geschlossen mit Gewinn',
    closedWithLoss: 'Geschlossen mit Verlust',
    account: 'Konto',
    balance: 'Saldo',
    leverage: 'Hebelwirkung',
    credit: 'Kredit',
    tradeNow: 'Zum Handel',
    usingCurrentRate: 'zum aktuellen Wechselkurs',

    personalDetails: 'Persönliche Daten',
    profilePhoto: 'Profilfoto',
    firstName: 'Vorname',
    country: 'Land',
    lastName: 'Nachname',
    address: 'Adresse',
    email: 'E-Mail',
    phone: 'Telefonnummer',
    saveChanges: 'Änderungen speichern',

    dropFile: 'Legen Sie eine Datei zum Hochladen auf dem Kreis oben ab',
    notAllowed: 'Es darf nicht veröffentlicht werden',
    notAllowedLine1: 'Fotos explizit sexueller oder pornografischer Natur',
    notAllowedLine2:
      'Bilder, die darauf abzielen, zu ethnischem oder rassistischem Hass oder Aggression aufzustacheln',
    notAllowedLine3: 'Fotos mit Personen unter 18 Jahren',
    notAllowedLine4: 'Fotos mit Third-party Urheberrechte Schutz',
    notAllowedLine5:
      'Bilder größer als 5 MB und in einem anderen Format als JPG, GIF oder PNG',
    requirements:
      'Auf dem Foto muss Ihr Gesicht gut zu erkennen sein. Alle von Ihnen hochgeladenen Fotos und Videos müssen diese Anforderungen erfüllen, andernfalls können sie entfernt werden.',

    cryptocurrency: 'Cryptocurrency',
    withdrawal: 'Auszahlung',
    requestNewWithdrawal: 'NEUE AUSZAHLUNG ANFORDERN',
    amount: 'Betrag',
    currentBalance: 'Ihr aktueller Kontostand ist',
    withdrawAll: 'Alles auszahlen',
    requestWithdrawal: 'Auszahlung anfordern',
    last: 'ZULETZT',
    withdrawalRequests: 'AUSZAHLUNGSANTRÄGE',
    time: 'Zeit',
    currency: 'Währung',
    info: 'Info',
    status: 'Status',
    bank: 'Bank',
    bitcoin: 'Bitcoin',
    card: 'Karte',
    ethereum: 'Ethereum',
    eth: 'Ethereum',
    usdt: 'USDT',
    withdrawalDetails: 'Auszahlungsdetails',
    address: 'Wallet Address',
    bankAccount: 'Kontonummer',
    bankHolder: 'Name des Kontoinhabers',
    bankIban: 'IBAN',
    bankSwift: 'Bank SWIFT code',
    cardNumber: 'Kartennummer',
    cardHolder: 'Name des Karteninhabers',

    dragAndDrop: 'Ziehen Sie das Dokument per Drag & Drop in diesen Bereich',
    documentsList: 'LISTE DER HOCHGELADENEN DOKUMENTE',
    document: 'Dokument',
    timeUploaded: 'Zeit hochgeladen',
    timeProcessed: 'Zeit verarbeitet',
    status: 'Status',
    types: [
      'Ausweis',
      'Nachweis des Wohnsitzes',
      'Kreditkartenvorderseite',
      'Kreditkartenrückseite',
      'Ausweisrückseite',
      'Selfie',
    ],
    types2: [
      'Proof of identification (POI)',
      'Proof of residential address',
      'Credit Card Front',
      'Credit Card Back',
      'Proof of identification Back',
      'Selfie with ID',
    ],
    upload: 'Hochladen',
    isConfirmed: 'bestätigt',
    uploadAnotherDocument: 'Anderes Dokument hochladen',
    isUnderReview: 'wird überprüft',
    questionnaire: 'Fragebogen',
    sendAnswers: 'Antworten senden',
    progressBarOf: 'von',
    progressBarText: 'Ihrer Dokumente sind hochgeladen und geprüft',

    manageAccounts: 'Überweisen Sie Gelder zwischen Ihren Konten',
    transferFrom: 'Vom Konto',
    transferTo: 'Auf Konto ',
    amount: 'Betrag',
    makeTransfer: 'Überweisung vornehmen',
    yourAccounts: 'Ihre Konten',
    account: 'Konto',
    currency: 'Währung',
    balance: 'Kontostand',
    credit: 'Kredit',
    makeActive: 'Aktivieren',
    active: 'Aktiv',

    sendMessage: 'Nachricht zu senden',

    pct_0: 'Flexibel',
    pct_30: '1 Monat gesperrt',
    pct_90: '1 Quartal gesperrt',
    pct_180: '6 Monate gesperrt',
    pct_365: '1 Jahr gesperrt',
    savings: 'Ersparnisse',
    detailedInformation: 'Genaue Information',
    pleaseSelect: 'Bitte wählen Sie eine Währung und einen Zeitraum',
    openSavings: 'Ersparnisse öffnen',
    currentTime: 'Aktuelle Uhrzeit',
    releaseTime: 'Eröffnungsdatum',
    currencyChosen: 'Gewählte Währung',
    periodChosen: 'Gewählter Zeitraum',
    yourRate: 'Ihr Tarif',
    yourEarnings: 'Dein Verdienst',
    accountFrom: 'Konto, von dem Geld überwiesen werden soll',
    enterAmount: 'Enter Amount',
    in: 'In',
    openAndInvest: 'Sparkonto eröffnen und anlegen',
    investment: 'Investition',
    period: 'Zeitraum',
    daysTotal: 'Tage insgesamt',
    finalEarnings: 'Totales Einkommen',
    created: 'Erstellt',
    daysElapsed: 'Verstrichene Tage',
    days: 'Tage',
    earnings: 'Verdienste',
    fundsReleasedIn: 'Freigegebene Mittel in',
    claim: 'Versicherungsanspruch ',

    updatePassword: 'Passwort AKTUALISIEREN',
    currentPassword: 'Aktuelles Passwort',
    newPassword: 'Neues Passwort',
    changePassword: 'Passwort ändern',
    activationForGoogle: 'Aktivierungscode für Google Authenticator',
    activateAndEnter:
      'Aktivieren Sie Authenticator und geben Sie einen generierten Code in das Feld unten ein',
    qrCode: 'QR-Code',
    activateProtection: 'Aktivieren Sie den 2FA-Schutz',
    protectionActive: '2FA-Schutz ist aktiv',
    twoFactorCode: '2FA-Code',
    disableProtection: 'Deaktivieren Sie den 2FA-Schutz',
    language: 'Sprache',
    dashboardCurrency: 'Dashboard-Währung',
    confirmNewPassword: 'Bestätige neues Passwort',

    yourLink: 'IHR EMPFEHLUNGSLINK',
    referredFriends: 'EMPFOHLENE FREUNDE',
    id: 'ID',
    name: 'Name',
    registered: 'Registriert',
    level: 'Niveua',
    payout: 'Gewinnauszahlung',
    lastPayouts: 'LETZTE EMPFOHLENE Gewinnauszahlung',
    time: 'Zeit',
    amount: 'Betrag',
    currency: 'Währung',
    info: 'Info',
    months: {
      Jan: 'Jan',
      Feb: 'Feb',
      Mar: 'Mar',
      Apr: 'Apr',
      May: 'May',
      Jun: 'Jun',
      Jul: 'Jul',
      Aug: 'Aug',
      Sep: 'Sep',
      Oct: 'Oct',
      Nov: 'Nov',
      Dec: 'Dec',
    },
    orderTypes: [
      'Kaufen',
      'Verkaufen',
      'Kaufen Limit',
      'Verkaufen Limit',
      'Kaufen Stop',
      'Verkaufen Stop',
    ],
    statuses: ['Ausstehend', 'Genehmigt', 'Abgelehnt', 'Wird bearbeitet'],

    NOT_FOUND: 'Anforderungsfehler',
    FORBIDDEN: 'Zugriff abgelehnt. Bitte neu einloggen',
    SERVER_ERROR:
      'Aktion: fehlgeschlagen. Bitte versuchen Sie es später noch einmal.',
    INVALID_ACCOUNT: 'Sitzung abgelaufen. Bitte neu einloggen',
    INVALID_EMAIL: 'Ungültige E-Mail-Adresse',
    INVALID_PHONE: 'Ungültige Telefonnummer',
    INVALID_COUNTRY: 'Ungültiges Land',
    INVALID_LOGIN: 'Ungültige Login-Details',
    USER_BLOCKED: 'Konto ist gesperrt. Bitte wenden Sie sich an den Support.',
    USER_REGISTERED:
      'Benutzer mit eingegebener E-Mail oder Telefonnummer ist bereits registriert',
    INVALID_USER: 'Benutzer wurde nicht gefunden',
    REJECTED:
      'Der Betrieb ist aufgrund von Plattformbeschränkungen nicht erlaubt',
    INVALID_OLD_PASSWORD: 'Altes Passwort ist ungültig',
    INVALID_SYMBOL: 'Ungültiges Handelssymbol',
    INVALID_SYMBOL_PRECISION: 'Ungültige Symbolpräzision',
    INVALID_FRAME: 'Ungültiger Diagrammrahmen',
    INVALID_CURRENCY: 'Ungültige Währung',
    INVALID_PRODUCT: 'Ungültiger Typ des Handelskontos',
    INSUFFICIENT_FUNDS: 'Nicht genügend Geld auf dem Konto',
    INVALID_WITHDRAWAL: 'Auszahlung nicht gefunden',
    INVALID_STATUS: 'Ungültiger Status',
    INVALID_FILE: 'Ungültige Dateierweiterung oder Datei ist zu groß',
    INVALID_DOCUMENT: 'Dokument wurde nicht gefunden',
    INVALID_NAME: 'Ungültiger Name',
    INVALID_LOT_SIZE: 'Ungültige Lotgröße',
    INVALID_LOT_STEP: 'Ungültiger Lotschritt',
    INVALID_MIN_VOLUME: 'Ungültiges Mindestvolumen',
    INVALID_MAX_VOLUME: 'Ungültiges maximales Volumen',
    INVALID_GROUP: 'Ungültige Gruppe',
    INVALID_SPREAD: 'Ungültiger Spread',
    REQUEST_TIMEOUT:
      'Zeitüberschreitung der Anforderung. Bitte versuchen Sie es später noch einmal',
    INVALID_TYPE: 'Ungültiger Auftragstyp',
    INVALID_VOLUME: 'Ungültiges Auftragsvolumen',
    INVALID_SL: 'Ungültiger Stop-Verlust-Wert',
    INVALID_TP: 'Ungültiger Gewinnmitnahme-Wert',
    INVALID_PRICE: 'Ungültiger Auftragspreis',
    INVALID_EXPIRATION: 'Ungültiger Auftragsablauf',
    NOT_ENOUGH_MARGIN: 'Nicht genug Margin',
    INVALID_ORDER: 'Auftrag nicht gefunden',
    MARKET_CLOSED: 'Handel ist nicht verfügbar. Bitte versuche es erneut',
    INVALID_BALANCE_TYPE: 'Ungültiger Typ der Kontostandoperation',
    INVALID_HASH: 'Ungültiger Hash',
    HASH_EXPIRED:
      'Ihr Link zum Zurücksetzen des Passworts ist abgelaufen. Bitte fordern Sie eine neue an',
    INVALID_CODE: 'Ungültiger 2FA-Code',
    CHAT_DISABLED: 'Zugriff auf den Support-Chat wurde geschlossen',
    WITHDRAWAL_NOT_ALLOWED: 'Zugriff auf die Auszahlungen wurde gesperrt',
    TRADING_DISABLED: 'Trading is disabled for current account',
    PENDING_DEPOSITS_LIMIT: 'Deposits limit exceeded',
    LOCAL_ONE_PENDING_WITHDRAWAL: 'Only one pending withdrawal allowed',
    LOCAL_DEPOSIT_ONLY_REAL: 'Deposit is available only for real account',
    LOCAL_DEPOSIT_POSITIVE: 'Amount of deposit must be more than 0',
    LOCAL_INVALID_CARD_NUMBER: 'Invalid card number',
    LOCAL_INVALID_CARD_EXPIRATION: 'Invalid card expiration',
    LOCAL_INVALID_CVC: 'Invalid CVV/CVC code',
    LOCAL_PASSWORDS_NOT_MATCH: 'Passwords do not match, please re-enter',
    LOCAL_NO_TRADING_ACCOUNTS:
      'You do not have trading accounts available. Please contact the support',
    LOCAL_MIN_DEPOSIT: 'Minimum deposit is $',
    LOCAL_MIN_WITHDRAWAL: 'Minimum withdrawal amount is $',
    LOCAL_INVALID_FILE_TYPE:
      'File format not supported. Please attach only JPG, PNG or PDF',
    LOCAL_MIN_STAKING: 'Minimum deposit for this currency is ',
    FLOOD_REJECTED:
      'You are sending messages too often. Please try again later',

    countries: {
      AF: 'Afghanistan',
      AX: 'Aland-Inseln',
      AL: 'Albanien',
      DZ: 'Algerien',
      AS: 'Amerikanisch-Samoa',
      AD: 'Andorra',
      AO: 'Angola',
      AI: 'Anguilla',
      AQ: 'Antarktis',
      AG: 'Antigua und Barbuda',
      AR: 'Argentinien',
      AM: 'Armenien',
      AW: 'Aruba',
      AU: 'Australien',
      AT: 'Österreich',
      AZ: 'Aserbaidschan',
      BS: 'Bahamas',
      BH: 'Bahrain',
      BD: 'Bangladesch',
      BB: 'Barbados',
      BY: 'Weißrussland',
      BE: 'Belgien',
      BZ: 'Belize',
      BJ: 'Benin',
      BM: 'Bermuda',
      BT: 'Bhutan',
      BO: 'Bolivien',
      BA: 'Bosnien und Herzegowina',
      BW: 'Botswana',
      BV: 'Bouvetinsel',
      BR: 'Brasilien',
      IO: 'Britisches Territorium im Indischen Ozean',
      BN: 'Brunei Darussalam',
      BG: 'Bulgarien',
      BF: 'Burkina Faso',
      BI: 'Burundi',
      KH: 'Kambodscha',
      CM: 'Kamerun',
      CA: 'Kanada',
      CV: 'Kap Verde',
      KY: 'Kaimaninseln',
      CF: 'Zentralafrikanische Republik',
      TD: 'Chad',
      CL: 'Chile',
      CN: 'China',
      CX: 'Weihnachtsinsel',
      CC: 'Cocos (Keeling) Inseln',
      CO: 'Kolumbien',
      KM: 'Komoren',
      CG: 'Kongo',
      CD: 'Kongo, Demokratische Republik',
      CK: 'Cookinseln',
      CR: 'Costa Rica',
      CI: "Cote D'Ivoire",
      HR: 'Kroatien',
      CU: 'Kuba',
      CY: 'Zypern',
      CZ: 'Tschechische Republik',
      DK: 'Dänemark',
      DJ: 'Dschibuti',
      DM: 'Dominica',
      DO: 'Dominikanische Republik',
      EC: 'Ecuador',
      EG: 'Ägypten',
      SV: 'El Salvador',
      GQ: 'Äquatorialguinea',
      ER: 'Eritrea',
      EE: 'Estland',
      ET: 'Äthiopien',
      FK: 'Falklandinseln (Malwinen)',
      FO: 'Färöer Inseln',
      FJ: 'Fidschi',
      FI: 'Finnland',
      FR: 'Frankreich',
      GF: 'Französisch-Guayana',
      PF: 'Französisch-Polynesien',
      TF: 'Französische Süd-Territorien',
      GA: 'Gabun',
      GM: 'Gambia',
      GE: 'Georgien',
      DE: 'Deutschland',
      GH: 'Ghana',
      GI: 'Gibraltar',
      GR: 'Griechenland',
      GL: 'Grönland',
      GD: 'Grenada',
      GP: 'Guadeloupe',
      GU: 'Guam',
      GT: 'Guatemala',
      GG: 'Guernsey',
      GN: 'Guinea',
      GW: 'Guinea-Bissau',
      GY: 'Guyana',
      HT: 'Haiti',
      HM: 'Heard-Insel & Mcdonald-Inseln',
      VA: 'Heiliger Stuhl (Staat Vatikanstadt)',
      HN: 'Honduras',
      HK: 'Hongkong',
      HU: 'Ungarn',
      IS: 'Island',
      IN: 'Indien',
      ID: 'Indonesien',
      IR: 'Iran',
      IQ: 'Irak',
      IE: 'Irland',
      IM: 'Isle Of Man',
      IL: 'Israel',
      IT: 'Italien',
      JM: 'Jamaika',
      JP: 'Japan',
      JE: 'Jersey',
      JO: 'Jordanien',
      KZ: 'Kasachstan',
      KE: 'Kenia',
      KI: 'Kiribati',
      KR: 'Korea',
      KW: 'Kuwait',
      KG: 'Kirgisistan',
      LA: 'Demokratische Volksrepublik Laos',
      LV: 'Lettland',
      LB: 'Libanon',
      LS: 'Lesotho',
      LR: 'Liberia',
      LY: 'Libysch-Arabische Dschamahirija',
      LI: 'Liechtenstein',
      LT: 'Litauen',
      LU: 'Luxemburg',
      MO: 'Macao',
      MK: 'Mazedonien',
      MG: 'Madagaskar',
      MW: 'Malawi',
      MY: 'Malaysia',
      MV: 'Malediven',
      ML: 'Mali',
      MT: 'Malta',
      MH: 'Marshallinseln',
      MQ: 'Martinique',
      MR: 'Mauretanien',
      MU: 'Mauritius',
      YT: 'Mayotte',
      MX: 'Mexiko',
      FM: 'Mikronesien',
      MD: 'Moldawien',
      MC: 'Monaco',
      MN: 'Mongolei',
      ME: 'Montenegro',
      MS: 'Montserrat',
      MA: 'Marokko',
      MZ: 'Mosambik',
      MM: 'Myanmar',
      NA: 'Namibia',
      NR: 'Nauru',
      NP: 'Nepal',
      NL: 'Niederlande',
      AN: 'Niederländische Antillen',
      NC: 'Neukaledonien',
      NZ: 'Neuseeland',
      NI: 'Nicaragua',
      NE: 'Niger',
      NG: 'Nigeria',
      NU: 'Niue',
      NF: 'Norfolkinsel',
      MP: 'Nördliche Marianen',
      NO: 'Norwegen',
      OM: 'Oman',
      PK: 'Pakistan',
      PW: 'Palau',
      PS: 'Palästinensische Gebiete, Besetzt',
      PA: 'Panama',
      PG: 'Papua-Neuguinea',
      PY: 'Paraguay',
      PE: 'Peru',
      PH: 'Philippinen',
      PN: 'Pitcairn',
      PL: 'Polen',
      PT: 'Portugal',
      PR: 'Puerto Rico',
      QA: 'Katar',
      RE: 'Wiedersehen',
      RO: 'Rumänien',
      RU: 'Russland',
      RW: 'Ruanda',
      BL: 'St. Barthelemy',
      SH: 'Sankt Helena',
      KN: 'St. Kitts und Nevis',
      LC: 'St. Lucia',
      MF: 'Sankt Martin',
      PM: 'St. Pierre und Miquelon',
      VC: 'St. Vincent und Grenadinen',
      WS: 'Samoa',
      SM: 'San Marino',
      ST: 'Sao Tome und Principe',
      SA: 'Saudi-Arabien',
      SN: 'Senegal',
      RS: 'Serbien',
      SC: 'Seychellen',
      SL: 'Sierra Leone',
      SG: 'Singapur',
      SK: 'Slowakei',
      SI: 'Slowenien',
      SB: 'Salomoninseln',
      SO: 'Somalia',
      ZA: 'Südafrika',
      GS: 'Südgeorgien und Sandwichinseln',
      ES: 'Spanien',
      LK: 'Sri Lanka',
      SD: 'Sudan',
      SR: 'Surinam',
      SJ: 'Svalbard und Jan Mayen',
      SZ: 'Swasiland',
      SE: 'Schweden',
      CH: 'Schweiz',
      SY: 'Arabische Republik Syrien',
      TW: 'Taiwan',
      TJ: 'Tadschikistan',
      TZ: 'Tansania',
      TH: 'Thailand',
      TL: 'Timor-Leste',
      TG: 'Togo',
      TK: 'Tokelau',
      TO: 'Tonga',
      TT: 'Trinidad und Tobago',
      TN: 'Tunesien',
      TR: 'Türkei',
      TM: 'Turkmenistan',
      TC: 'Turks- und Caicosinseln',
      TV: 'Tuvalu',
      UG: 'Uganda',
      UA: 'Ukraine',
      AE: 'Vereinigte Arabische Emirate',
      GB: 'Vereinigtes Königreich',
      US: 'Vereinigte Staaten',
      UM: 'Überseeische Inseln der Vereinigten Staaten',
      UY: 'Uruguay',
      UZ: 'Usbekistan',
      VU: 'Vanuatu',
      VE: 'Venezuela',
      VN: 'Vietnam',
      VG: 'Jungferninseln, Britisch',
      VI: 'Jungferninseln, U.S.A.',
      WF: 'Wallis und Futuna',
      EH: 'Westsahara',
      YE: 'Jemen',
      ZM: 'Sambia',
      ZW: 'Simbabwe',
    },
  },
  fr: {
    _name: 'Française',

    policy: 'Politique de confidentialité',
    policyAML: `Politique AML (Lutte contre le blanchiment d'argent)`,
    policyKYC: 'Politique KYC (Connaître son client)',
    locense: 'Licence',

    view_all: 'Voir tout',

    sell_btn: 'Vendre',
    buy_btn: 'Acheter',

    currency_action: 'devise',

    importantAccountDetails: 'Informations importantes sur le compte',
    viewAdditionalSettings: 'Afficher les paramètres supplémentaires',
    switchDarkMode: 'Basculer entre le mode sombre et clair',
    writeProblem: 'Écrivez-nous votre problème',
    darkMode: 'Mode sombre',

    yay: 'Yay',
    purchased: 'Vous avez effectué avec succès',
    from: 'un achat sur',
    walet: 'Wallet',
    trade: 'Trade',

    withdrawDetails: 'Détails du retrait',
    saveDetails: 'Enregistrer les détails pour la prochaine fois',
    amountToWithdraw: 'Montant à retirer',
    withdrawLimit: 'Limite de retrait quotidienne restante de 1 000 000,00 $.',
    serviceFee: 'Frais de service',
    youWillPay: 'Vous allez payer',
    cancel: 'Annuler',
    understand: `J'ai compris, continuer`,

    select: 'Sélectionner',
    enterAmount: 'Entrer le montant',
    orderInfo: 'Informations sur la commande',
    confirmOrder: 'Confirmer la commande',
    get: 'Obtenir',
    spend: 'Dépenser',
    buying: 'Achat',

    accountTransactions: 'Transactions sur compte',

    overview: 'Présentation',
    accountBalances: 'Soldes des comptes',
    details: 'Détails',
    loginHistory: 'Historique de connexion',
    device: 'Appareil',
    contactUs: 'Nous contacter',
    sessionLog: 'Sessions et historique de connexion',
    selectMethods: 'Sélectionner les méthodes',
    depositDetails: 'Détails du dépôt',
    support: 'Soutien',
    homepage: `Page d'accueil`,
    supportChat: `Chat d'assistance`,
    createChat: 'Créer un chat',

    takeProfitStopLoss: 'Take Profit & Stop Loss',
    takeProfit: 'Take Profit',
    stopLoss: 'Stop Loss',
    updateOrder: 'Ordre de mise à jour',

    balance: 'Balance',
    credit: 'Crédit',
    equity: 'Equity',
    practice: 'PRACTICE',
    real: 'REAL',
    account: 'ACCOUNT',
    invested: 'Investi',
    profit: 'Profit',
    loss: 'Perte',
    margin: 'Marge',
    marginLevel: 'Marge Niveau',
    marginFree: 'Marge libre',

    cfd: 'CFD',
    platform: 'Plateforme',
    deposit: 'Dépôt',

    marketWatch: 'Surveillance du marché',
    activeOrders: 'Commandes actives',
    tradingHistory: 'Historique des transactions',
    economicCalendar: 'Calendrier économique',
    marketNews: 'Nouvelles du marché',

    closeOrder: 'Position fermée',
    areYouSure: 'Etes-vous sûr de fermer la position',
    buy: 'Acheter',
    sell: 'Vendez',
    yes: 'Oui',
    no: 'Non',

    addNewChart: 'Ajouter un nouveau graphique',

    watchlist: 'Liste de surveillance',
    asset: 'Actif',
    price: 'Prix',
    changePct: 'Changement 24h',

    pending: 'En attente',
    assetPrice: "Prix de l'actif",
    current: 'Actuel',
    revert: 'Retour au prix du marché',
    automatically:
      'La position sera ouverte automatiquement lorsque le prix atteindra ce niveau',

    default: 'default',
    volume: 'Volume',
    lots: 'lots',
    units: 'unités',
    currency: 'devise',
    contractSize: 'Taille du contrat',
    position: 'Position',
    margin: 'Marge',
    freeMargin: 'Marge libre',
    takeProfitStopLoss: 'Take Profit & Stop Loss',
    pending: 'En attente',
    market: 'Marché',
    leverage: 'Effet de levier',
    spread: 'Écartement',
    notSet: 'Non défini',
    at: "à l'adresse",
    buy: 'acheter',
    sell: 'vendre',

    supportBanner: 'TOUS LES JOURS, 24 HEURES SUR 24',
    currentTime: 'HEURE ACTUELLE',
    liveChat: 'Chat en direct',

    balance: 'Balance',
    credit: 'Crédit',
    equity: 'Equity',
    margin: 'Marge',
    marginLevel: 'Niveau de marge',
    freeMargin: 'Marge libre',
    pnl: 'PnL',
    profitTotal: 'Lifetime PnL',

    dateRegistered: "Date d'enregistrement",
    userId: 'ID utilisateur',
    dashboard: 'Dashboard',
    personalData: 'Données personnelles',
    deposit: 'Dépôt',
    withdrawFunds: 'Retirer des fonds',
    savings: 'Épargne',
    settings: 'Paramètres',
    logout: 'Déconnexion',

    BT_INVOICE: 'Enter amount and generate invoice',
    BT_TITLE: 'Our banking details',
    PENDING_DEPOSITS_LIMIT: 'Deposit Limit',
    account: 'Account',
    bank_name: 'Bank Name',
    beneficiary: 'Beneficiary',
    beneficiary_address: 'Beneficiary Address',
    swift: 'Swift',
    iban: 'IBAN',
    ru_inn: 'INN',
    ru_kpp: 'KPP',
    corresponding_account: 'Correspondent account',
    TOKEN_AMOUNT: 'Amount',
    TOKEN_SUBTOTAL: 'Subtotal',
    TOKEN_TOTAL: 'Total',
    TOKEN_DESCRIPTION: 'Description',
    TOKEN_PAYMENT_DETAILS: 'Payment Details',
    makeDeposit: 'Effectuer un dépôt',
    practiceAccount: 'Effectuer un dépôt',
    realAccount: 'Compte réel',
    noWithdrawals: 'Pas de retraits',
    easyWithdrawals: 'Retraits faciles',
    allAssets: 'Tous les actifs disponibles',
    fullFledged: 'Une plateforme complète',
    fillUpTo: "Remplir jusqu'à",
    freeReplenishment: 'Réapprovisionnement gratuit',
    topUp: 'Rechargez votre compte',
    minimumAmount: 'Montant minimum',
    maxAmount: 'Montant maximum',
    withdrawalType: 'Type de retrait',
    canSwitch: "Vous pouvez passer d'un compte à l'autre à tout moment",

    chartGrids: 'GRILLES DE CARTES',
    chart1: '1 graphique',
    chart2: '2 graphiques',
    chart3: '3 graphiques',
    chart4: '4 graphiques',

    connectionLost: 'La connexion avec le serveur est perdue',
    retryNow: 'Réessayer maintenant',

    loginToTradeRoom: 'Se connecter à Traderoom',
    email: 'Adresse électronique',
    enterEmail: 'Entrez votre courriel',
    twoFactor: 'Code 2FA (si activé)',
    twoFactorAuth: 'Authentification à deux facteurs',
    password: 'Mot de passe',
    yourPassword: 'Votre mot de passe',
    signIn: "S'inscrire",
    dontHaveAccount: "Vous n'avez pas de compte?",
    restore: 'Restaurer',
    fullName: 'Nom complet',
    havePromo: "J'ai un code promo",
    promo: 'Code promo',
    login: 'Connexion',
    haveAccount: 'Vous avez déjà un compte?',
    hide: 'Cacher',
    goTo: 'Retourner au début',

    setNewPassword: 'Définir un nouveau mot de passe',
    newPassword: 'Nouveau mot de passe',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    setButton: 'Définir',

    repeatPassword: 'Repeat Password',
    createNewAccount: 'Créer un nouveau compte',
    email: 'Adresse électronique',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    country: 'Pays',
    phone: 'Téléphone',
    password: 'Mot de passe',
    createAccount: 'Créer un compte',
    currency: 'Monnaie',

    forgotPassword: 'Mot de passe oublié?',
    submitEmail:
      "Veuillez soumettre un courriel utilisé pour l'inscription, vérifiez votre boîte de réception et suivez les instructions fournies.",
    submit: 'Soumettre',

    error: 'Erreur',
    success: 'Succès',
    deposit: 'Dépôt',
    withdrawal: 'Retrait',
    depositApproved: 'Le dépôt a été approuvé',
    depositDeclined: 'Le dépôt a été refusé',
    withdrawalApproved: 'Le retrait a été approuvé',
    withdrawalDeclined: 'Le retrait a été refusé',

    forex: 'Forex',
    stocks: 'Stocks',
    commodities: 'Produits de base',
    indices: 'Indices',
    crypto: 'Crypto',
    metals: 'Métaux',
    nft: 'NFT',

    buy: 'BUY',
    profitCalculator: 'Profit Calculator',
    sell: 'SELL',
    volume: 'Volume',
    entryPrice: 'Entry Price',
    takeProfit: 'Take Profit',
    stopLoss: 'Stop Loss',
    maxPosition: 'Max Position',
    calculate: 'Calculate',
    calculationsFor: 'Calculations for',
    leverage: 'Leverage',
    requiredMargin: 'Required Margin',
    profitFromTP: 'Profit from TP',
    lossFromSL: 'Loss from SL',
    roe: 'ROE',

    title: 'Dépôt réussi',
    text: 'Votre dépôt a été traité avec succès !',

    title: 'Dépôt échoué',
    text: "Votre dépôt n'a pas été traité.",

    marketWatch: 'Surveillance du marché',
    search: 'Recherche...',

    commission: 'Commission',
    volume: 'Volume',
    margin: 'Marge',
    active: 'Actif',
    pending: 'En attente',
    activeOrders: 'Commandes actives',
    portfolio: 'Portefeuille',
    allPositions: 'Tous les postes',
    noPositionsLine1: "Vous n'avez pas d'ouverture",
    noPositionsLine2: 'postes encore',
    show: 'Afficher',
    more: 'plus',
    less: 'moins',
    purchaseTime: "Temps d'achat",
    closePosition: 'Position fermée',
    priceOpen: "Prix d'achat",
    priceSl: 'Prix du Stop Loss',
    priceTp: 'Prix du Take Profit',
    type: 'Envoyer les réponses',
    pnl: 'Bénéfice/perte',
    cancelOrder: 'Annuler la commande',
    order: 'Commande',
    orderType: 'Type de commande',
    cancelled: 'Annulé',
    tradingHistory: 'Historique des transactions',
    noHistoryLine1: "Vous n'avez pas de",
    noHistoryLine2: 'des affaires conclues pour le moment',

    economicCalendar: 'Calendrier économique',

    marketNews: 'Nouvelles du marché',

    ordersActive: 'Commandes actives',
    ordersHistory: 'Historique des commandes',
    id: 'ID',
    symbol: 'Symbole',
    documentType: 'Type',
    volume: 'Volume',
    openPrice: "Prix d'ouverture",
    openTime: "Heure d'ouverture",
    closePrice: 'Prix de clôture',
    closeTime: 'Heure de clôture',
    sl: 'SL',
    tp: 'TP',
    price: 'Prix',
    pnl: 'PnL',
    actions: 'Actions',
    edit: 'Modifier',
    close: 'Fermer',
    commission: 'Commission',
    swap: 'Swap',
    swapLong: 'Swap long',
    swapShort: 'Swap court',

    assetInfo: "Informations sur l'actif",
    tradingConditions: 'Conditions de négociation',
    information: 'Changement de session',
    bid: 'Bid',
    ask: 'Ask',
    sessionChange: 'Changement de session',
    tradeNow: 'Trader maintenant',
    opens: 'Ouverture',
    closes: 'Fermeture',
    at: 'à',
    open247: 'Ouvert 24 h/24 et 7 j/7',
    today: "aujourd'hui",
    tomorrow: 'demain',
    sunday: 'dimanche',
    monday: 'lundi',
    tuesday: 'mardi',
    wednesday: 'mercredi',
    thursday: 'jeudi',
    friday: 'vendredi',
    saturday: 'samedi',

    contractSpecification: 'Spécification du contrat',
    name: 'Nom',
    market: 'Marché',
    baseCurrency: 'Devise de base',
    digits: 'Chiffres',
    lotSize: 'Taille de lot',
    lotStep: 'Pas de lot',
    minVolume: 'Vol min',
    maxVolume: 'Vol max',
    leverage: 'Effet de levier',
    schedule: 'Calendrier',
    weekday: 'Jour de la semaine',
    tradingTime: 'Heures de trading',
    closed: 'fermé',
    sell: 'Vendre',
    buy: 'Acheter',
    low: 'Bas',
    high: 'Élevé',
    oneHourChange: 'Variation sur 1 heure',
    oneDayChange: 'Variation sur 1 jour',
    oneWeekChange: 'Variation sur 1 semaine',
    oneMonthChange: 'Variation sur 1 mois',
    threeMonthsChange: 'Variation sur 3 mois',
    oneYearChange: 'Variation sur 1 an',
    loading: 'Chargement...',

    traderTitle: 'Négociant automobile',
    traderConfirm: 'Confirmer et enregistrer',
    riskLevelLow: 'Niveau de risque : bas',
    riskLevelMedium: 'Niveau de risque : moyen',
    riskLevelHigh: 'Niveau de risque : élevé',
    perDay: 'Transactions par jour :',
    desc: "Le trading de CFD et d'autres produits à effet de levier peut entraîner des pertes. Avant de trader, les clients doivent lire les déclarations de risque pertinentes sur notre page de divulgation des risques. Le trading automatisé ne garantit pas de résultats. La société n'assume aucune responsabilité en cas de perte de fonds lors d'un trading automatique. Veuillez vous assurer de bien comprendre les risques et de prendre des mesures pour les gérer.",
    accept: 'Accepter',

    trade: 'Commerce',
    startTrading: 'Commencer à trader',
    deposit: 'Effectuer un dépôt',
    dashboard: 'Dashboard',
    personalInfo: 'Mise à jour des données personnelles',
    withdrawal: 'Demander un retrait',
    verification: "Vérification de l'identité",
    accounts: 'Gérer les comptes',
    liveChat: 'Chat en direct',
    savings: 'Épargne',
    settings: 'Paramètres de la plate-forme',
    logOut: 'Déconnexion',

    methods: 'METHODS',
    confirm: 'Confirm in the application of your bank',
    sendOtp: 'Send otp',
    otpCode: 'Otp code',
    addWalletAddress:
      'Wallet for this deposit method is not set. Please contact your agent or support team.',
    addressReceipt: 'Please wait for the address to load',
    makeDeposit: 'FAIRE UN DÉPÔT',
    instant: 'Instantané',
    minutes: 'minutes',
    hours: 'heures',
    days: 'jours',
    amount: 'Montant',
    continue: 'Continuer',
    qrCode: 'QR CODE',
    depositAddress: 'ADRESSE DE DÉPÔT',
    copy: 'Copie',
    last: 'DERNIER',
    deposits: 'DÉPÔTS',
    time: 'Temps',
    currency: 'Monnaie',
    status: 'Statut',
    info: 'Info',

    pleaseWait:
      'Veuillez patienter. Connexion au fournisseur de services de paiement...',
    cardPayment: 'Paiement par carte',
    inOrder: "Afin d'envoyer le montant",
    pleaseProvide: 'veuillez fournir les détails de la carte :',

    completeVerification: 'Please Complete Verification',
    noOrderYet: 'No order yet',
    totalBalance: 'Solde Total',
    totalDeposits: 'Total des dépôts',
    totalPnl: 'PnL Total',
    profitableOrders: 'Commandes Rentables',
    roi: 'ROI',
    activityLog: "Journal d'activités",
    loginFromIp: 'Login from IP',
    tradingResults: 'Résultats de Trading',
    week: 'Semaine',
    month: 'Mois',
    year: 'Année',
    successRate: 'Taux de Réussite',
    closedWithProfit: 'Clôturé avec un Bénéfice',
    closedWithLoss: 'Clôturé avec une Perte',
    account: 'Compte',
    balance: 'Solde',
    leverage: 'Levier',
    credit: 'Crédit',
    tradeNow: 'Trading Maintenant',
    usingCurrentRate: 'using current exchange rate',

    personalDetails: 'Détails personnels',
    profilePhoto: 'Photo de profil',
    firstName: 'Prénom',
    country: 'Pays',
    lastName: 'Nom de famille',
    address: 'Adresse',
    email: 'Courriel',
    phone: 'Numéro de téléphone',
    saveChanges: 'Sauvegarder les changements',

    dropFile: 'Déposez un fichier sur le cercle ci-dessus pour le télécharger',
    notAllowed: "Il n'est pas permis de publier",
    notAllowedLine1:
      'Photos à caractère explicitement sexuel ou pornographique',
    notAllowedLine2:
      "Images visant à inciter à la haine ou à l'agression ethnique ou raciale",
    notAllowedLine3: 'Photos impliquant des personnes de moins de 18 ans',
    notAllowedLine4: "Photos protégées par le droit d'auteur de tiers",
    notAllowedLine5:
      'Images de plus de 5 MB et dans un format autre que JPG, GIF ou PNG',
    requirements:
      'Votre visage doit être clairement visible sur la photo. Toutes les photos et vidéos que vous mettez en ligne doivent respecter ces exigences, faute de quoi elles peuvent être supprimées.',

    withdrawalOff: 'Please contact your account manager for withdrawal details',
    cryptocurrency: 'Cryptocurrency',
    withdrawal: 'Withdrawal',
    requestNewWithdrawal: 'DEMANDER UN NOUVEAU RETRAIT',
    amount: 'Montant',
    currentBalance: 'Le solde de votre compte courant est de',
    withdrawAll: 'Retirer tout',
    requestWithdrawal: 'Demande de retrait',
    last: 'DERNIER',
    withdrawalRequests: 'DEMANDES DE RETRAIT',
    time: 'Temps',
    currency: 'Monnaie',
    info: 'Info',
    status: 'Statut',
    bank: 'Banque',
    bitcoin: 'Bitcoin',
    card: 'Carte',
    ethereum: 'Ethereum',
    eth: 'Ethereum',
    usdt: 'USDT',
    withdrawalDetails: 'Détails du retrait',
    address: 'Adresse du portefeuille',
    bankAccount: 'Numéro de compte',
    bankHolder: 'Nom du titulaire du compte',
    bankIban: 'IBAN',
    bankSwift: 'Code SWIFT de la banque',
    cardNumber: 'Numéro de la carte',
    cardHolder: 'Nom du titulaire de la carte',

    dragAndDrop: 'glisser et déposer le document dans cette zone',
    documentsList: 'LISTE DES DOCUMENTS TÉLÉCHARGÉS',
    document: 'Document',
    timeUploaded: 'Temps téléchargé',
    timeProcessed: 'Temps traité',
    status: 'Statut',
    types: [
      "Preuve d'identité",
      'Preuve de résidence',
      'Recto de la carte de crédit',
      'Retour de la carte de crédit',
      "Preuve d'identité en arrière",
      'Selfie',
    ],
    types2: [
      'Proof of identification (POI)',
      'Proof of residential address',
      'Credit Card Front',
      'Credit Card Back',
      'Proof of identification Back',
      'Selfie with ID',
    ],
    upload: 'Télécharger',
    isConfirmed: 'est confirmé',
    uploadAnotherDocument: 'Télécharger un autre document',
    isUnderReview: 'est en cours de révision',
    questionnaire: 'Questionnaire',
    sendAnswers: 'Envoyer les réponses',
    progressBarOf: 'of',
    progressBarText: 'of your documents have been uploaded and confirmed',

    manageAccounts: 'Transférer des fonds entre vos comptes',
    transferFrom: 'Du compte',
    transferTo: 'Pour le compte',
    amount: 'Montant',
    makeTransfer: 'Effectuer un transfert',
    yourAccounts: 'Vos comptes',
    account: 'Compte',
    currency: 'Monnaie',
    balance: 'Balance',
    credit: 'Crédit',
    makeActive: 'Rendre actif',
    active: 'Actif',

    sendMessage: 'Envoyer un message',

    pct_0: 'Flexible',
    pct_30: 'Verrouillé 1 mois',
    pct_90: 'Verrouillé 1 trimestre',
    pct_180: 'Verrouillé 6 mois',
    pct_365: 'Verrouillé 1 an',
    savings: 'Épargne',
    detailedInformation: 'Informations détaillées',
    pleaseSelect: 'Veuillez sélectionner une devise et une période',
    openSavings: 'Épargne ouverte',
    currentTime: 'Heure actuelle',
    releaseTime: 'Heure de sortie',
    currencyChosen: 'Devise choisie',
    periodChosen: 'Période choisie',
    yourRate: 'Votre taux',
    yourEarnings: 'Vos revenus',
    accountFrom: 'Compte pour transférer des fonds de',
    enterAmount: 'Entrez le montant',
    in: 'Sur',
    openAndInvest: "Ouvrir un compte d'épargne et investir",
    investment: 'Investissement',
    period: 'Période',
    daysTotal: 'Nombre total de jours',
    finalEarnings: 'Revenu final',
    created: 'Créé',
    daysElapsed: 'Jours écoulés',
    days: 'jours',
    earnings: 'Revenus',
    fundsReleasedIn: 'Fonds libérés en',
    claim: "Demande d'indemnisation",

    updatePassword: 'METTRE À JOUR LE MOT DE PASSE',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    changePassword: 'Changer le mot de passe',
    activationForGoogle: "Code d'activation pour Google Authenticator",
    activateAndEnter:
      "Activez l'Authenticator et entrez un code généré dans le champ ci-dessous.",
    qrCode: 'QR Code',
    activateProtection: 'Activer la protection 2FA',
    protectionActive: 'La protection 2FA est active',
    twoFactorCode: 'Code 2FA',
    disableProtection: 'Désactiver la protection 2FA',
    language: 'Langue',
    dashboardCurrency: 'Tableau de bord des devises',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',

    yourLink: 'VOTRE LIEN DE RÉFÉRENCE',
    referredFriends: 'AMIS RÉFÉRENCÉS',
    id: 'ID',
    name: 'Nom',
    registered: 'Enregistré',
    level: 'Niveau',
    payout: 'Payout',
    lastPayouts: 'LES DERNIERS PAIEMENTS DE PARRAINAGE',
    time: 'Temps',
    amount: 'Montant',
    currency: 'Monnaie',
    info: 'Info',

    months: {
      Jan: 'Jan',
      Feb: 'Fev',
      Mar: 'Mar',
      Apr: 'Abr',
      May: 'Mai',
      Jun: 'Juin',
      Jul: 'Jui',
      Aug: 'Aoû',
      Sep: 'Sep',
      Oct: 'Oct',
      Nov: 'Nov',
      Dec: 'Dec',
    },
    orderTypes: [
      'Acheter',
      'Vendez',
      "Limite d'achat",
      'Limite de vente',
      "Stop à l'achat",
      'Stop à la vente',
    ],
    statuses: ['En attente', 'Approuvé', 'Refusé', 'Traitement'],

    NOT_FOUND: 'Erreur de demande',
    FORBIDDEN: 'Accès refusé. Veuillez vous reconnecter',
    SERVER_ERROR: "L'action a échoué. Veuillez réessayer plus tard",
    INVALID_ACCOUNT: 'La session a expiré. Veuillez vous reconnecter',
    INVALID_EMAIL: 'Adresse électronique non valide',
    INVALID_PHONE: 'Numéro de téléphone non valide',
    INVALID_COUNTRY: 'Pays non valide',
    INVALID_LOGIN: 'Identifiants de connexion non valides',
    USER_BLOCKED: 'Le compte est bloqué. Veuillez contacter le support',
    USER_REGISTERED:
      "L'utilisateur dont l'adresse électronique ou le numéro de téléphone a été saisi est déjà enregistré.",
    INVALID_USER: "L'utilisateur n'est pas trouvé",
    REJECTED:
      "L'opération n'est pas autorisée en raison des restrictions de la plate-forme",
    INVALID_OLD_PASSWORD: "L'ancien mot de passe n'est pas valide",
    INVALID_SYMBOL: 'Symbole commercial non valide',
    INVALID_SYMBOL_PRECISION: 'Précision du symbole non valide',
    INVALID_FRAME: 'Cadre graphique non valide',
    INVALID_CURRENCY: 'Devise non valide',
    INVALID_PRODUCT: 'Type de trading de compte invalide',
    INSUFFICIENT_FUNDS: 'Fonds insuffisants',
    INVALID_WITHDRAWAL: "Le retrait n'est pas trouvé",
    INVALID_STATUS: 'Statut non valide',
    INVALID_FILE: 'Extension de fichier non valide ou fichier trop volumineux',
    INVALID_DOCUMENT: "Le document n'est pas trouvé",
    INVALID_NAME: 'Nom non valide',
    INVALID_LOT_SIZE: 'Taille de lot non valide',
    INVALID_LOT_STEP: 'Pas de lot invalide',
    INVALID_MIN_VOLUME: 'Volume minimal non valide',
    INVALID_MAX_VOLUME: 'Volume maximal invalide',
    INVALID_GROUP: 'Groupe non valide',
    INVALID_SPREAD: 'Diffusion non valide',
    REQUEST_TIMEOUT: 'La demande a expiré. Veuillez réessayer plus tard',
    INVALID_TYPE: 'Type de commande non valide',
    INVALID_VOLUME: "Volume d'ordre invalide",
    INVALID_SL: "Valeur invalide de l'excédent de pertes",
    INVALID_TP: 'Valeur de prise de bénéfices invalide',
    INVALID_PRICE: 'Prix de la commande invalide',
    INVALID_EXPIRATION: 'Expiration de la commande invalide',
    NOT_ENOUGH_MARGIN: 'Pas assez de marge',
    INVALID_ORDER: "L'ordre n'est pas trouvé",
    MARKET_CLOSED: "Le commerce n'est pas disponible. Veuillez réessayer",
    INVALID_BALANCE_TYPE: "Type d'opération de balance non valide",
    INVALID_HASH: 'Hachage non valide',
    HASH_EXPIRED:
      'Le lien de réinitialisation de votre mot de passe a expiré. Veuillez en demander un nouveau',
    INVALID_CODE: 'Code 2FA invalide',
    CHAT_DISABLED: "L'accès au chat d'assistance a été fermé",
    WITHDRAWAL_NOT_ALLOWED: "L'accès aux retraits a été fermé",
    TRADING_DISABLED: 'Trading is disabled for current account',
    PENDING_DEPOSITS_LIMIT: 'Deposits limit exceeded',
    LOCAL_ONE_PENDING_WITHDRAWAL: 'Only one pending withdrawal allowed',
    LOCAL_DEPOSIT_ONLY_REAL: 'Deposit is available only for real account',
    LOCAL_DEPOSIT_POSITIVE: 'Amount of deposit must be more than 0',
    LOCAL_INVALID_CARD_NUMBER: 'Invalid card number',
    LOCAL_INVALID_CARD_EXPIRATION: 'Invalid card expiration',
    LOCAL_INVALID_CVC: 'Invalid CVV/CVC code',
    LOCAL_PASSWORDS_NOT_MATCH: 'Passwords do not match, please re-enter',
    LOCAL_NO_TRADING_ACCOUNTS:
      'You do not have trading accounts available. Please contact the support',
    LOCAL_MIN_DEPOSIT: 'Minimum deposit is $',
    LOCAL_MIN_WITHDRAWAL: 'Minimum withdrawal amount is $',
    LOCAL_INVALID_FILE_TYPE:
      'File format not supported. Please attach only JPG, PNG or PDF',
    FLOOD_REJECTED:
      'You are sending messages too often. Please try again later',
    LOCAL_MIN_STAKING: 'Minimum deposit for this currency is ',

    countries: {
      AF: 'Afghanistan',
      AX: 'Aland Islands',
      AL: 'Albania',
      DZ: 'Algeria',
      AS: 'American Samoa',
      AD: 'Andorra',
      AO: 'Angola',
      AI: 'Anguilla',
      AQ: 'Antarctica',
      AG: 'Antigua And Barbuda',
      AR: 'Argentina',
      AM: 'Armenia',
      AW: 'Aruba',
      AU: 'Australia',
      AT: 'Austria',
      AZ: 'Azerbaijan',
      BS: 'Bahamas',
      BH: 'Bahrain',
      BD: 'Bangladesh',
      BB: 'Barbados',
      BY: 'Belarus',
      BE: 'Belgium',
      BZ: 'Belize',
      BJ: 'Benin',
      BM: 'Bermuda',
      BT: 'Bhutan',
      BO: 'Bolivia',
      BA: 'Bosnia And Herzegovina',
      BW: 'Botswana',
      BV: 'Bouvet Island',
      BR: 'Brazil',
      IO: 'British Indian Ocean Territory',
      BN: 'Brunei Darussalam',
      BG: 'Bulgaria',
      BF: 'Burkina Faso',
      BI: 'Burundi',
      KH: 'Cambodia',
      CM: 'Cameroon',
      CA: 'Canada',
      CV: 'Cape Verde',
      KY: 'Cayman Islands',
      CF: 'Central African Republic',
      TD: 'Chad',
      CL: 'Chile',
      CN: 'China',
      CX: 'Christmas Island',
      CC: 'Cocos (Keeling) Islands',
      CO: 'Colombia',
      KM: 'Comoros',
      CG: 'Congo',
      CD: 'Congo, Democratic Republic',
      CK: 'Cook Islands',
      CR: 'Costa Rica',
      CI: "Cote D'Ivoire",
      HR: 'Croatia',
      CU: 'Cuba',
      CY: 'Cyprus',
      CZ: 'Czech Republic',
      DK: 'Denmark',
      DJ: 'Djibouti',
      DM: 'Dominica',
      DO: 'Dominican Republic',
      EC: 'Ecuador',
      EG: 'Egypt',
      SV: 'El Salvador',
      GQ: 'Equatorial Guinea',
      ER: 'Eritrea',
      EE: 'Estonia',
      ET: 'Ethiopia',
      FK: 'Falkland Islands (Malvinas)',
      FO: 'Faroe Islands',
      FJ: 'Fiji',
      FI: 'Finland',
      FR: 'France',
      GF: 'French Guiana',
      PF: 'French Polynesia',
      TF: 'French Southern Territories',
      GA: 'Gabon',
      GM: 'Gambia',
      GE: 'Georgia',
      DE: 'Germany',
      GH: 'Ghana',
      GI: 'Gibraltar',
      GR: 'Greece',
      GL: 'Greenland',
      GD: 'Grenada',
      GP: 'Guadeloupe',
      GU: 'Guam',
      GT: 'Guatemala',
      GG: 'Guernsey',
      GN: 'Guinea',
      GW: 'Guinea-Bissau',
      GY: 'Guyana',
      HT: 'Haiti',
      HM: 'Heard Island & Mcdonald Islands',
      VA: 'Holy See (Vatican City State)',
      HN: 'Honduras',
      HK: 'Hong Kong',
      HU: 'Hungary',
      IS: 'Iceland',
      IN: 'India',
      ID: 'Indonesia',
      IR: 'Iran',
      IQ: 'Iraq',
      IE: 'Ireland',
      IM: 'Isle Of Man',
      IL: 'Israel',
      IT: 'Italy',
      JM: 'Jamaica',
      JP: 'Japan',
      JE: 'Jersey',
      JO: 'Jordan',
      KZ: 'Kazakhstan',
      KE: 'Kenya',
      KI: 'Kiribati',
      KR: 'Korea',
      KW: 'Kuwait',
      KG: 'Kyrgyzstan',
      LA: "Lao People's Democratic Republic",
      LV: 'Latvia',
      LB: 'Lebanon',
      LS: 'Lesotho',
      LR: 'Liberia',
      LY: 'Libyan Arab Jamahiriya',
      LI: 'Liechtenstein',
      LT: 'Lithuania',
      LU: 'Luxembourg',
      MO: 'Macao',
      MK: 'Macedonia',
      MG: 'Madagascar',
      MW: 'Malawi',
      MY: 'Malaysia',
      MV: 'Maldives',
      ML: 'Mali',
      MT: 'Malta',
      MH: 'Marshall Islands',
      MQ: 'Martinique',
      MR: 'Mauritania',
      MU: 'Mauritius',
      YT: 'Mayotte',
      MX: 'Mexico',
      FM: 'Micronesia',
      MD: 'Moldova',
      MC: 'Monaco',
      MN: 'Mongolia',
      ME: 'Montenegro',
      MS: 'Montserrat',
      MA: 'Morocco',
      MZ: 'Mozambique',
      MM: 'Myanmar',
      NA: 'Namibia',
      NR: 'Nauru',
      NP: 'Nepal',
      NL: 'Netherlands',
      AN: 'Netherlands Antilles',
      NC: 'New Caledonia',
      NZ: 'New Zealand',
      NI: 'Nicaragua',
      NE: 'Niger',
      NG: 'Nigeria',
      NU: 'Niue',
      NF: 'Norfolk Island',
      MP: 'Northern Mariana Islands',
      NO: 'Norway',
      OM: 'Oman',
      PK: 'Pakistan',
      PW: 'Palau',
      PS: 'Palestinian Territory, Occupied',
      PA: 'Panama',
      PG: 'Papua New Guinea',
      PY: 'Paraguay',
      PE: 'Peru',
      PH: 'Philippines',
      PN: 'Pitcairn',
      PL: 'Poland',
      PT: 'Portugal',
      PR: 'Puerto Rico',
      QA: 'Qatar',
      RE: 'Reunion',
      RO: 'Romania',
      RU: 'Russia',
      RW: 'Rwanda',
      BL: 'Saint Barthelemy',
      SH: 'Saint Helena',
      KN: 'Saint Kitts And Nevis',
      LC: 'Saint Lucia',
      MF: 'Saint Martin',
      PM: 'Saint Pierre And Miquelon',
      VC: 'Saint Vincent And Grenadines',
      WS: 'Samoa',
      SM: 'San Marino',
      ST: 'Sao Tome And Principe',
      SA: 'Saudi Arabia',
      SN: 'Senegal',
      RS: 'Serbia',
      SC: 'Seychelles',
      SL: 'Sierra Leone',
      SG: 'Singapore',
      SK: 'Slovakia',
      SI: 'Slovenia',
      SB: 'Solomon Islands',
      SO: 'Somalia',
      ZA: 'South Africa',
      GS: 'South Georgia And Sandwich Isl.',
      ES: 'Spain',
      LK: 'Sri Lanka',
      SD: 'Sudan',
      SR: 'Suriname',
      SJ: 'Svalbard And Jan Mayen',
      SZ: 'Swaziland',
      SE: 'Sweden',
      CH: 'Switzerland',
      SY: 'Syrian Arab Republic',
      TW: 'Taiwan',
      TJ: 'Tajikistan',
      TZ: 'Tanzania',
      TH: 'Thailand',
      TL: 'Timor-Leste',
      TG: 'Togo',
      TK: 'Tokelau',
      TO: 'Tonga',
      TT: 'Trinidad And Tobago',
      TN: 'Tunisia',
      TR: 'Turkey',
      TM: 'Turkmenistan',
      TC: 'Turks And Caicos Islands',
      TV: 'Tuvalu',
      UG: 'Uganda',
      UA: 'Ukraine',
      AE: 'United Arab Emirates',
      GB: 'United Kingdom',
      US: 'United States',
      UM: 'United States Outlying Islands',
      UY: 'Uruguay',
      UZ: 'Uzbekistan',
      VU: 'Vanuatu',
      VE: 'Venezuela',
      VN: 'Viet Nam',
      VG: 'Virgin Islands, British',
      VI: 'Virgin Islands, U.S.',
      WF: 'Wallis And Futuna',
      EH: 'Western Sahara',
      YE: 'Yemen',
      ZM: 'Zambia',
      ZW: 'Zimbabwe',
    },
  },
  az: {
    _name: 'Azərbaycan',
    policy: 'Məxfilik Siyasəti',
    policyAML: 'AML Siyasəti',
    policyKYC: 'KYC Siyasəti',
    locense: 'Lisenziya',
    view_all: 'Hamısını Göstər',
    sell_btn: 'Sat',
    buy_btn: 'Al',
    currency_action: 'valyuta',

    importantAccountDetails: 'Vacib hesab məlumatları',
    viewAdditionalSettings: 'Əlavə parametrləri bax',
    switchDarkMode: 'Tünd/İşıq rejimini dəyiş',
    writeProblem: 'Probleminizi bizə yazın',
    darkMode: 'Tünd rejim',

    yay: 'Təbriklər',
    purchased: 'Uğurla aldınız',
    from: 'kimi',
    walet: 'Cüzdan',
    trade: 'Ticarət',

    withdrawDetails: 'Çıxarış məlumatları',
    saveDetails: 'Növbəti dəfə üçün məlumatları saxla',
    amountToWithdraw: 'Çıxarış məbləği',
    withdrawLimit: 'Gündəlik çıxarış limiti: $1,000,000.00 qalıq.',

    serviceFee: 'Xidmət haqqı',
    youWillPay: 'Ödəyəcəksiniz',
    cancel: 'Ləğv et',
    understand: 'Başa düşürəm, davam et',

    select: 'Seçin',
    enterAmount: 'Məbləği daxil edin',
    orderInfo: 'Sifariş Məlumatı',
    confirmOrder: 'Sifarişi Təsdiqlə',
    get: 'Almaq',
    spend: 'Xərcləmək',
    buying: 'Alış',
    accountTransactions: 'Hesab Əməliyyatları',
    overview: 'Ümumi baxış',
    accountBalances: 'Hesab Balansları',
    details: 'Detallar',
    loginHistory: 'Giriş tarixi',
    device: 'Cihaz',
    contactUs: 'Bizimlə Əlaqə',
    sessionLog: 'Sessiyalar və giriş tarixi',
    selectMethods: 'Metodları seçin',
    depositDetails: 'Depozit məlumatları',
    order: 'Sifariş',
    support: 'Dəstək',
    supportChat: 'Dəstək Çatı',
    createChat: 'Çat Yaradın',
    homepage: 'Ana Səhifə',
    takeProfitStopLoss: 'Gəlir/Qeydiyyat Stopu',
    takeProfit: 'Gəlir Al',
    stopLoss: 'Zərər Dayandır',
    updateOrder: 'Sifarişi Yenilə',
    balance: 'Balans',
    credit: 'Kredit',
    equity: 'Kapital',
    practice: 'TƏCRÜBƏ',
    real: 'GERÇƏK',
    account: 'HESAB',
    invested: 'İnvestisiya edilmiş',
    profit: 'Gəlir',
    loss: 'Zərər',
    margin: 'Marja',
    marginLevel: 'Marja Səviyyəsi',
    marginFree: 'Azad Marja',
    cfd: 'CFD',
    platform: 'Platforma',
    deposit: 'Depozit',
    marketWatch: 'Bazar Baxışı',
    activeOrders: 'Aktiv Sifarişlər',
    tradingHistory: 'Ticarət Tarixi',
    economicCalendar: 'İqtisadi Təqvim',
    marketNews: 'Bazar Xəbərləri',
    closeOrder: 'Mövqeyi Bağla',
    areYouSure: 'Mövqeyi bağlamağa əminsiniz?',
    buy: 'Al',
    sell: 'Sat',
    yes: 'Bəli',
    no: 'Xeyr',
    addNewChart: 'Yeni Çart Əlavə Et',
    watchlist: 'İzləmə Siyahısı',
    asset: 'Aktiv',
    price: 'Qiymət',
    changePct: '24 saatlıq dəyişiklik',
    pending: 'Gözləyir',
    assetPrice: 'Aktiv Qiyməti',
    current: 'Cari',
    revert: 'Bazar Qiymətinə Qayıt',
    automatically: 'Qiymət bu səviyyəyə çatanda mövqe avtomatik açılacaq',
    default: 'standart',
    volume: 'Həcm',
    lots: 'lotlar',
    units: 'vahidlər',

    currency: 'Valyuta',
    contractSize: 'Müqavilə Ölçüsü',
    position: 'Mövqe',
    margin: 'Marja',
    freeMargin: 'Azad Marja',
    takeProfitStopLoss: 'Gəlir Al & Zərər Dayandır',
    pending: 'Gözləyir',
    market: 'Bazar',
    leverage: 'Leveraj',
    spread: 'Səpələnmə',
    notSet: 'Təyin edilməyib',
    at: 'vaxtı',
    buy: 'al',
    sell: 'sat',
    supportBanner: 'HƏR GÜN, GÜNÜN HƏR SAATI',
    currentTime: 'CARİ VAXT',
    liveChat: 'Canlı Çat',
    balance: 'Balans',
    credit: 'Kredit',
    equity: 'Kapital',
    marginLevel: 'Marja səviyyəsi',
    pnl: 'PnL',
    profitTotal: 'Ömürlük PnL',
    dateRegistered: 'Qeydiyyat Tarixi',
    userId: 'İstifadəçi ID',
    dashboard: 'İdarə Paneli',
    personalData: 'Şəxsi Məlumatlar',
    deposit: 'Depozit',
    withdrawFunds: 'Vəsait Çıxarışı',
    savings: 'Əmanətlər',
    settings: 'Parametrlər',
    logout: 'Çıxış',
    BT_INVOICE: 'Məbləği daxil edin və faktura yaradın',
    BT_TITLE: 'Bank detallarımız',
    account: 'Hesab',
    bank_name: 'Bankın Adı',
    beneficiary: 'Benefisiar',
    beneficiary_address: 'Benefisiar Ünvanı',
    swift: 'SWIFT',
    iban: 'IBAN',
    ru_inn: 'İNН',
    ru_kpp: 'KPP',
    corresponding_account: 'Müxbir Hesabı',
    TOKEN_AMOUNT: 'Məbləğ',
    TOKEN_SUBTOTAL: 'Ara Cəmi',
    TOKEN_TOTAL: 'Cəmi',
    TOKEN_DESCRIPTION: 'Təsvir',
    TOKEN_PAYMENT_DETAILS: 'Ödəniş Təfərrüatları',
    PENDING_DEPOSITS_LIMIT: 'Depozit Limiti',
    makeDeposit: 'Depozit Yatırın',
    practiceAccount: 'Təcrübə Hesabı',
    realAccount: 'Gerçək Hesab',
    noWithdrawals: 'Çıxarış yoxdur',
    easyWithdrawals: 'Asan Çıxarışlar',
    allAssets: 'Bütün aktivlər mövcuddur',
    fullFledged: 'Tam funksional platforma',
    fillUpTo: 'Doldurun qədər',
    freeReplenishment: 'Pulsuz Tamamlama',
    topUp: 'Hesabınızı Artırın',
    minimumAmount: 'Minimal Məbləğ',
    maxAmount: 'Maks Məbləğ',
    withdrawalType: 'Çıxarış Tipi',
    canSwitch: 'Hesablar arasında istənilən vaxt keçid edə bilərsiniz',
    chartGrids: 'QRAFİK ŞƏBƏKƏLƏRİ',
    chart1: '1 qrafik',
    chart2: '2 qrafik',
    chart3: '3 qrafik',
    chart4: '4 qrafik',
    connectionLost: 'Serverlə əlaqə kəsildi',
    retryNow: 'Təkrar cəhd et',
    loginToTradeRoom: 'Ticarət Otağına Giriş',
    email: 'E-poçt ünvanı',
    enterEmail: 'E-poçt ünvanınızı daxil edin',
    twoFactor: '2FA Kodu (əgər aktivdirsə)',
    twoFactorAuth: 'İki Faktorlu Doğrulama',
    password: 'Şifrə',
    yourPassword: 'Şifrəniz',
    signIn: 'Daxil Ol',
    dontHaveAccount: 'Hesabınız yoxdur?',
    restore: 'Bərpa et',
    fullName: 'Tam Ad',
    havePromo: 'Promokodum var',
    promo: 'Promokod',
    login: 'Giriş',
    haveAccount: 'Artıq hesabınız var?',
    hide: 'Gizlət',
    goTo: 'Geri qayıt',

    setNewPassword: 'Yeni Şifrə Təyin Et',
    newPassword: 'Yeni şifrə',
    confirmNewPassword: 'Yeni şifrəni təsdiqləyin',
    setButton: 'Təyin Et',

    repeatPassword: 'Şifrəni Təkrarla',
    createNewAccount: 'Yeni Hesab Yarat',
    email: 'E-poçt ünvanı',
    firstName: 'Ad',
    lastName: 'Soyad',
    country: 'Ölkə',
    phone: 'Telefon',
    password: 'Şifrə',
    createAccount: 'Hesab Yarat',
    currency: 'Valyuta',

    forgotPassword: 'Şifrəni Unutmusunuz?',
    submitEmail:
      'Qeydiyyat zamanı istifadə olunan e-poçt ünvanını daxil edin, poçtunuzu yoxlayın və göstərilən təlimatlara əməl edin',
    submit: 'Təsdiq et',

    error: 'Xəta',
    success: 'Uğur',
    deposit: 'Depozit',
    withdrawal: 'Çıxarış',
    depositApproved: 'Depozit təsdiqləndi',
    depositDeclined: 'Depozit rədd edildi',
    withdrawalApproved: 'Çıxarış təsdiqləndi',
    withdrawalDeclined: 'Çıxarış rədd edildi',

    forex: 'Forex',
    stocks: 'Səhmlər',
    commodities: 'Əmtəələr',
    indices: 'İndekslər',
    crypto: 'Kripto',
    metals: 'Metallar',
    nft: 'NFT',

    buy: 'AL',
    profitCalculator: 'Gəlir Kalkulyatoru',
    sell: 'SAT',
    volume: 'Həcm',
    entryPrice: 'Giriş Qiyməti',
    takeProfit: 'Gəlir Al',
    stopLoss: 'Zərər Dayandır',
    maxPosition: 'Maksimal Mövqe',
    calculate: 'Hesabla',
    calculationsFor: 'Üçün Hesablamalar',
    leverage: 'Leveraj',
    requiredMargin: 'Tələb olunan Marja',
    profitFromTP: 'Gəlir TP-dən',
    lossFromSL: 'Zərər SL-dən',
    roe: 'ROE',

    title: 'Depozit uğurlu',
    text: 'Depozitiniz uğurla işlənildi!',

    title: 'Depozit uğursuz oldu',
    text: 'Depozitiniz işlənmədi.',

    marketWatch: 'Bazar Baxışı',
    search: 'Axtarış...',

    commission: 'Komissiya',
    volume: 'Həcm',
    margin: 'Marja',
    active: 'Aktiv',
    pending: 'Gözləyir',
    activeOrders: 'Aktiv Sifarişlər',
    portfolio: 'Portfel',
    allPositions: 'Bütün Mövqelər',
    noPositionsLine1: 'Açıq mövqeləriniz yoxdur',
    noPositionsLine2: 'hələlik mövqe yoxdur',
    show: 'Göstər',
    more: 'daha çox',
    less: 'daha az',
    purchaseTime: 'Alış Vaxtı',
    closePosition: 'Mövqeyi Bağla',
    priceOpen: 'Alış Qiyməti',
    priceSl: 'Zərər Dayandır Qiyməti',
    priceTp: 'Gəlir Al Qiyməti',
    type: 'Mövqe İstiqaməti',
    pnl: 'Gəlir/Zərər',
    cancelOrder: 'Sifarişi Ləğv et',
    orderType: 'Sifariş Növü',
    cancelled: 'Ləğv edildi',
    tradingHistory: 'Ticarət Tarixi',
    noHistoryLine1: 'Heç bir bağlanmış',
    noHistoryLine2: 'əməliyyatınız yoxdur',

    economicCalendar: 'İqtisadi Təqvim',

    marketNews: 'Bazar Xəbərləri',

    ordersActive: 'Aktiv Sifarişlər',
    ordersHistory: 'Sifarişlərin Tarixi',
    id: 'ID',
    symbol: 'Simvol',
    documentType: 'Növ',
    volume: 'Həcm',
    openPrice: 'Açılış Qiyməti',
    openTime: 'Açılış Vaxtı',
    closePrice: 'Bağlanış Qiyməti',
    closeTime: 'Bağlanış Vaxtı',
    sl: 'SL',
    tp: 'TP',
    price: 'Qiymət',
    pnl: 'PnL',
    actions: 'Əməliyyatlar',
    edit: 'Redaktə et',
    close: 'Bağla',
    commission: 'Komissiya',
    swap: 'Swap',
    swapLong: 'Uzun Swap',
    swapShort: 'Qısa Swap',

    assetInfo: 'Aktiv Məlumatı',
    tradingConditions: 'Ticarət Şərtləri',
    information: 'Sessiya Dəyişikliyi',
    bid: 'Təklif',
    ask: 'Sorğu',
    sessionChange: 'Sessiya Dəyişikliyi',
    tradeNow: 'İndi Ticarət et',
    opens: 'Açılır',
    closes: 'Bağlanır',
    at: 'vaxtı',
    open247: '24/7 Açıqdır',
    today: 'bu gün',
    tomorrow: 'sabah',
    sunday: 'Bazar günü',
    monday: 'Bazar ertəsi',
    tuesday: 'Çərşənbə axşamı',
    wednesday: 'Çərşənbə',
    thursday: 'Cümə axşamı',
    friday: 'Cümə',
    saturday: 'Şənbə',
    contractSpecification: 'Müqavilə Xüsusiyyəti',
    symbol: 'Simvol',
    name: 'Ad',
    market: 'Bazar',
    baseCurrency: 'Baza Valyutası',
    digits: 'Rəqəmlər',
    lotSize: 'Lot Ölçüsü',
    lotStep: 'Lot Addımı',
    minVolume: 'Minimal Həcm',
    maxVolume: 'Maksimal Həcm',
    leverage: 'Güc (Leverage)',
    commission: 'Komissiya',
    swapLong: 'Uzun Swap',
    swapShort: 'Qısa Swap',
    schedule: 'Cədvəl',
    weekday: 'Həftə günü',
    tradingTime: 'Ticarət Vaxtı',
    closed: 'bağlıdır',
    sell: 'Sat',
    buy: 'Al',
    low: 'Ən Aşağı',
    high: 'Ən Yuxarı',
    oneHourChange: '1 saatlıq dəyişiklik',
    oneDayChange: '1 günlük dəyişiklik',
    oneWeekChange: '1 həftəlik dəyişiklik',
    oneMonthChange: '1 aylıq dəyişiklik',
    threeMonthsChange: '3 aylıq dəyişiklik',
    oneYearChange: '1 illik dəyişiklik',
    loading: 'Yüklənir...',

    title: 'Avtomatik Ticarətçi',
    riskLevelLow: 'Risk Səviyyəsi: ',
    riskLevelMedium: 'Risk Səviyyəsi: Orta',
    riskLevelHigh: 'Risk Səviyyəsi: Yüksək',
    perDay: 'Gündəlik əməliyyatlar:',
    desc: `CFD-lər və digər leverage ilə məhsullar ticarət zamanı itkilərə səbəb ola bilər. Ticarətə başlamazdan əvvəl,
             müştərilər Risk Bəyanatları səhifəsində müvafiq risk bəyanatlarını oxumalıdırlar. Avtomatik ticarət nəticələri
             təmin etmir. Şirkət avtomatik ticarət zamanı vəsaitlərin itirilməsinə görə məsuliyyət daşımır. Riskləri tam
             başa düşdüyünüzdən və riskləri idarə etmək üçün tədbirlər gördüyünüzdən əmin olun.`,
    accept: 'Qəbul et',

    trade: 'Ticarət',
    startTrading: 'Ticarətə Başla',
    deposit: 'Depozit',
    dashboard: 'İdarə Paneli',
    personalInfo: 'Şəxsi Məlumat',
    withdrawal: 'Çıxarış',
    verification: 'Doğrulama',
    accounts: 'Hesablar',
    liveChat: 'Canlı Çat',
    savings: 'Əmanətlər',
    settings: 'Parametrlər',
    logOut: 'Çıxış',

    methods: 'METODLAR',
    confirm: 'Bank tətbiqinizdə təsdiqləyin',
    sendOtp: 'OTP göndər',
    otpCode: 'OTP kodu',
    addWalletAddress:
      'Bu depozit metodu üçün cüzdan təyin edilməyib. Zəhmət olmasa agentinizlə və ya dəstək komandası ilə əlaqə saxlayın.',
    addressReceipt: 'Ünvanın yüklənməsini gözləyin',
    makeDeposit: 'DEPOZİT YATIRIN',
    instant: 'Ani',
    minutes: 'dəqiqə',
    hours: 'saat',
    days: 'gün',
    amount: 'Məbləğ',
    continue: 'Davam et',
    qrCode: 'QR KOD',
    depositAddress: 'DEPOZİT ÜNVANI',
    copy: 'Kopyala',
    last: 'SON',
    deposits: 'DEPOZİTLƏR',
    time: 'Vaxt',
    currency: 'Valyuta',
    status: 'Status',
    info: 'Məlumat',

    pleaseWait:
      'Zəhmət olmasa gözləyin. Ödəniş xidmət təminatçısına qoşulur...',
    cardPayment: 'Kartla ödəniş',
    inOrder: 'Məbləği göndərmək üçün',
    pleaseProvide: 'zəhmət olmasa kart məlumatlarını təqdim edin:',

    completeVerification: 'Zəhmət olmasa doğrulamanı tamamlayın',
    noOrderYet: 'Hələ sifariş yoxdur',
    totalBalance: 'Ümumi Balans',
    totalDeposits: 'Ümumi Depozitlər',
    profitableOrders: 'Gəlirli Sifarişlər',
    totalPnl: 'Ümumi PnL',
    roi: 'ROI',
    activityLog: 'Fəaliyyət Jurnalı',
    loginFromIp: 'IP-dən giriş',
    tradingResults: 'Ticarət Nəticələri',
    week: 'Həftə',
    month: 'Ay',
    year: 'İl',
    successRate: 'Uğur dərəcəsi',
    closedWithProfit: 'Gəlirlə Bağlandı',
    closedWithLoss: 'Zərərlə Bağlandı',
    account: 'Hesab',
    balance: 'Balans',
    leverage: 'Leveraj',
    credit: 'Kredit',
    tradeNow: 'İndi Ticarət et',
    usingCurrentRate: 'cari məzənnədən istifadə edərək',

    personalDetails: 'Şəxsi Məlumatlar',
    profilePhoto: 'Profil Şəkli',
    firstName: 'Ad',
    country: 'Ölkə',
    lastName: 'Soyad',
    address: 'Ünvan',
    email: 'E-poçt',
    phone: 'Telefon nömrəsi',
    saveChanges: 'Dəyişiklikləri Saxla',

    dropFile: 'Yükləmək üçün faylı yuxarıdakı dairəyə sürüşdürün',
    notAllowed: 'Bu yayımlamaq qadağandır',
    notAllowedLine1:
      'Açıq şəkildə seksual və ya pornografik xarakterli şəkillər',
    notAllowedLine2:
      'Etnik və ya irqi nifrəti və ya təcavüzü qızışdırmağa yönəlmiş şəkillər',
    notAllowedLine3: '18 yaşdan kiçik şəxsləri əhatə edən şəkillər',
    notAllowedLine4: 'Üçüncü tərəfə aid müəllif hüquqları ilə qorunan şəkillər',
    notAllowedLine5:
      '5 MB-dan böyük və JPG, GIF və ya PNG formatından fərqli olan şəkillər',
    requirements:
      'Şəkildə üzünüz aydın şəkildə görünməlidir. Sizin tərəfinizdən yüklənmiş bütün şəkillər və videolar bu tələblərə uyğun olmalıdır, əks halda onlar silinə bilər.',

    withdrawalOff:
      'Çıxarış məlumatları üçün hesab menecerinizlə əlaqə saxlayın',
    cryptocurrency: 'Kriptovalyuta',
    withdrawal: 'Çıxarış',
    requestNewWithdrawal: 'YENİ ÇIXARIŞ TƏLƏB ET',
    amount: 'Məbləğ',
    currentBalance: 'Cari hesab balansınız',
    withdrawAll: 'Hamısını çıxar',
    requestWithdrawal: 'Çıxarış Tələb Et',
    last: 'SON',
    withdrawalRequests: 'ÇIXARIŞ TƏLƏBLƏRİ',
    time: 'Vaxt',
    currency: 'Valyuta',
    info: 'Məlumat',
    status: 'Status',
    bank: 'Bank',
    bitcoin: 'Bitcoin',
    card: 'Kart',
    ethereum: 'Ethereum',
    eth: 'Ethereum',
    usdt: 'USDT',
    withdrawalDetails: 'Çıxarış Təfərrüatları',
    address: 'Cüzdan Ünvanı',
    bankAccount: 'Hesab Nömrəsi',
    bankHolder: 'Hesab Sahibinin Adı',
    bankIban: 'IBAN',
    bankSwift: 'Bank SWIFT Kodu',
    cardNumber: 'Kart Nömrəsi',
    cardHolder: 'Kart Sahibinin Adı',

    dragAndDrop: 'Sənədi bu sahəyə sürüşdürüb buraxın',
    documentsList: 'YÜKLƏNƏN SƏNƏDLƏRİN SİYAHISI',
    document: 'Sənəd',
    timeUploaded: 'Yüklənmə Vaxtı',
    timeProcessed: 'Emal Vaxtı',
    status: 'Status',
    types: [
      'Şəxsiyyət Sübutu',
      'Yaşayış Sübutu',
      'Kredit Kartı Ön Hissəsi',
      'Kredit Kartı Arxa Hissəsi',
      'Şəxsiyyət Sübutunun Arxası',
      'Selfi',
    ],

    types2: [
      'Şəxsiyyət Sübutu (POI)',
      'Yaşayış Ünvanının Sübutu',
      'Kredit Kartı Ön Hissəsi',
      'Kredit Kartı Arxa Hissəsi',
      'Şəxsiyyət Sübutunun Arxası',
      'Şəxsiyyət Vəsiqəsi ilə Selfi',
    ],
    upload: 'Yüklə',
    isConfirmed: 'təsdiqlənib',
    uploadAnotherDocument: 'Başqa sənəd yüklə',
    isUnderReview: 'baxışdadır',
    questionnaire: 'Sorğu',
    sendAnswers: 'Cavabları Göndər',
    progressBarOf: 'of',
    progressBarText: 'sənədləriniz yüklənib və təsdiqlənib',

    manageAccounts: 'Hesablar arasında vəsait köçürün',
    transferFrom: 'Hesabdan',
    transferTo: 'Hesaba',
    amount: 'Məbləğ',
    makeTransfer: 'Köçürmə Et',
    yourAccounts: 'Hesablarınız',
    account: 'Hesab',
    currency: 'Valyuta',
    balance: 'Balans',
    credit: 'Kredit',
    makeActive: 'Aktiv Et',
    active: 'Aktiv',

    sendMessage: 'Mesaj Göndər',

    pct_0: 'Elastik',
    pct_30: '1 Ay Bağlı',
    pct_90: '1 Rüb Bağlı',
    pct_180: '6 Ay Bağlı',
    pct_365: '1 İl Bağlı',
    savings: 'Əmanətlər',
    detailedInformation: 'Ətraflı Məlumat',
    pleaseSelect: 'Zəhmət olmasa valyuta və dövrü seçin',
    openSavings: 'Əmanət Hesabı Açın',
    currentTime: 'Cari Vaxt',
    releaseTime: 'Buraxılış Vaxtı',
    currencyChosen: 'Seçilmiş Valyuta',
    periodChosen: 'Seçilmiş Dövr',
    yourRate: 'Sizin Faiz Dərəcəniz',
    yourEarnings: 'Gəliriniz',
    accountFrom: 'Vəsait köçürmək üçün hesab',
    enterAmount: 'Məbləği Daxil Edin',
    in: 'İçində',
    openAndInvest: 'Əmanət Hesabı Açın və İnvestisiya Edin',
    investment: 'İnvestisiya',
    period: 'Dövr',
    daysTotal: 'Ümumi Günlər',
    finalEarnings: 'Son Gəlir',
    created: 'Yaradıldı',
    daysElapsed: 'Keçən Günlər',
    days: 'gün',
    earnings: 'Gəlir',
    fundsReleasedIn: 'Vəsait Buraxılacaq',
    claim: 'Tələb Et',

    updatePassword: 'ŞİFRƏNİ YENİLƏYİN',
    currentPassword: 'Cari Şifrə',
    newPassword: 'Yeni Şifrə',
    changePassword: 'Şifrəni Dəyiş',
    activationForGoogle: 'Google Authenticator üçün Aktivasiya Kodu',
    activateAndEnter:
      'Authenticator-u aktivləşdirin və aşağıdakı sahəyə yaradılmış kodu daxil edin',
    qrCode: 'QR Kodu',
    activateProtection: '2FA Mühafizəsini Aktiv Et',
    protectionActive: '2FA mühafizəsi aktivdir',
    twoFactorCode: '2FA Kodu',
    disableProtection: '2FA Mühafizəsini Deaktiv Et',
    language: 'Dil',
    dashboardCurrency: 'İdarə Paneli Valyutası',
    confirmNewPassword: 'Yeni şifrəni təsdiqləyin',

    yourLink: 'SİZİN TÖVSİYƏ LİNKİNİZ',
    referredFriends: 'TÖVSİYƏ EDİLƏN DOSTLAR',
    id: 'ID',
    name: 'Ad',
    registered: 'Qeydiyyat',
    level: 'Səviyyə',
    payout: 'Ödəniş',
    lastPayouts: 'SON TÖVSİYƏ ÖDƏNİŞLƏRİ',
    time: 'Vaxt',
    amount: 'Məbləğ',
    currency: 'Valyuta',
    info: 'Məlumat',

    Jan: 'Yan',
    Feb: 'Fev',
    Mar: 'Mar',
    Apr: 'Apr',
    May: 'May',
    Jun: 'İyun',
    Jul: 'İyul',
    Aug: 'Avq',
    Sep: 'Sen',
    Oct: 'Okt',
    Nov: 'Noy',
    Dec: 'Dek',

    orderTypes: [
      'Al',
      'Sat',
      'Alış Limit',
      'Satış Limit',
      'Alış Stop',
      'Satış Stop',
    ],
    statuses: ['Gözləyir', 'Təsdiqləndi', 'Rədd edildi', 'Emal olunur'],

    NOT_FOUND: 'Sorğu xətası',
    FORBIDDEN: 'Giriş qadağandır. Zəhmət olmasa yenidən daxil olun',
    SERVER_ERROR:
      'Əməliyyat uğursuz oldu. Zəhmət olmasa sonra yenidən cəhd edin',
    INVALID_ACCOUNT: 'Sessiya müddəti bitib. Zəhmət olmasa yenidən daxil olun',
    INVALID_EMAIL: 'Yanlış e-poçt ünvanı',
    INVALID_PHONE: 'Yanlış telefon nömrəsi',
    INVALID_COUNTRY: 'Yanlış ölkə',
    INVALID_LOGIN: 'Yanlış giriş məlumatları',
    USER_BLOCKED: 'Hesab bloklanıb. Dəstək xidməti ilə əlaqə saxlayın',
    USER_REGISTERED:
      'Daxil edilmiş e-poçt və ya telefon nömrəsi ilə istifadəçi artıq qeydiyyatdan keçib',
    INVALID_USER: 'İstifadəçi tapılmadı',
    REJECTED: 'Əməliyyat platforma məhdudiyyətlərinə görə icazəsizdir',
    INVALID_OLD_PASSWORD: 'Köhnə şifrə yanlışdır',
    INVALID_SYMBOL: 'Yanlış ticarət simvolu',
    INVALID_SYMBOL_PRECISION: 'Yanlış simvol dəqiqliyi',
    INVALID_FRAME: 'Yanlış qrafik çərçivəsi',
    INVALID_CURRENCY: 'Yanlış valyuta',
    INVALID_PRODUCT: 'Yanlış ticarət hesabı növü',
    INSUFFICIENT_FUNDS: 'Yetersiz vəsait',
    INVALID_WITHDRAWAL: 'Çıxarış tapılmadı',
    INVALID_STATUS: 'Yanlış status',
    INVALID_FILE: 'Yanlış fayl genişləndirilməsi və ya fayl çox böyükdür',
    INVALID_DOCUMENT: 'Sənəd tapılmadı',
    INVALID_NAME: 'Yanlış ad',
    INVALID_LOT_SIZE: 'Yanlış lot ölçüsü',
    INVALID_LOT_STEP: 'Yanlış lot addımı',
    INVALID_MIN_VOLUME: 'Yanlış minimum həcm',
    INVALID_MAX_VOLUME: 'Yanlış maksimum həcm',
    INVALID_GROUP: 'Yanlış qrup',
    INVALID_SPREAD: 'Yanlış yayılma',
    REQUEST_TIMEOUT:
      'Sorğunun vaxtı bitdi. Zəhmət olmasa sonra yenidən cəhd edin',
    INVALID_TYPE: 'Yanlış sifariş növü',
    INVALID_VOLUME: 'Yanlış sifariş həcmi',
    INVALID_SL: 'Yanlış stop loss dəyəri',
    INVALID_TP: 'Yanlış take profit dəyəri',
    INVALID_PRICE: 'Yanlış sifariş qiyməti',
    INVALID_EXPIRATION: 'Yanlış sifariş müddəti',
    NOT_ENOUGH_MARGIN: 'Kifayət qədər marja yoxdur',
    INVALID_ORDER: 'Sifariş tapılmadı',
    MARKET_CLOSED: 'Ticarət mövcud deyil. Zəhmət olmasa yenidən cəhd edin',
    INVALID_BALANCE_TYPE: 'Yanlış balans əməliyyatı növü',
    INVALID_HASH: 'Yanlış hash',
    HASH_EXPIRED:
      'Şifrə sıfırlama linkinizin müddəti bitib. Zəhmət olmasa yenisini tələb edin',
    INVALID_CODE: 'Yanlış 2FA kodu',
    CHAT_DISABLED: 'Dəstək çatına giriş bağlanıb',
    WITHDRAWAL_NOT_ALLOWED: 'Çıxarışlara giriş bağlanıb',
    TRADING_DISABLED: 'Cari hesab üçün ticarət deaktiv edilib',
    PENDING_DEPOSITS_LIMIT: 'Depozit limiti aşılıb',
    LOCAL_ONE_PENDING_WITHDRAWAL: 'Yalnız bir gözləyən çıxarış icazəlidir',
    LOCAL_DEPOSIT_ONLY_REAL: 'Depozit yalnız real hesab üçün mövcuddur',
    LOCAL_DEPOSIT_POSITIVE: 'Depozit məbləği 0-dan çox olmalıdır',
    LOCAL_INVALID_CARD_NUMBER: 'Yanlış kart nömrəsi',
    LOCAL_INVALID_CARD_EXPIRATION: 'Yanlış kart müddəti',
    LOCAL_INVALID_CVC: 'Yanlış CVV/CVC kodu',
    LOCAL_PASSWORDS_NOT_MATCH:
      'Şifrələr uyğun gəlmir, zəhmət olmasa yenidən daxil edin',
    LOCAL_NO_TRADING_ACCOUNTS:
      'Mövcud ticarət hesabınız yoxdur. Zəhmət olmasa dəstək xidməti ilə əlaqə saxlayın',
    LOCAL_MIN_DEPOSIT: 'Minimum depozit $',
    LOCAL_MIN_WITHDRAWAL: 'Minimum çıxarış məbləği $',
    LOCAL_INVALID_FILE_TYPE:
      'Fayl formatı dəstəklənmir. Zəhmət olmasa yalnız JPG, PNG və ya PDF əlavə edin',
    LOCAL_MIN_STAKING: 'Bu valyuta üçün minimum depozit',
    FLOOD_REJECTED:
      'Çox tez-tez mesaj göndərirsiniz. Zəhmət olmasa sonra yenidən cəhd edin',
    countries: {
      AF: 'Əfqanıstan',
      AX: 'Aland Adaları',
      AL: 'Albaniya',
      DZ: 'Əlcəzair',
      AS: 'Amerika Samoası',
      AD: 'Andorra',
      AO: 'Anqola',
      AI: 'Angilya',
      AQ: 'Antarktika',
      AG: 'Antiqua və Barbuda',
      AR: 'Argentina',
      AM: 'Ermənistan',
      AW: 'Aruba',
      AU: 'Avstraliya',
      AT: 'Avstriya',
      AZ: 'Azərbaycan',
      BS: 'Bahamalar',
      BH: 'Bəhreyn',
      BD: 'Banqladeş',
      BB: 'Barbados',
      BY: 'Belarus',
      BE: 'Belçika',
      BZ: 'Beliz',
      BJ: 'Benin',
      BM: 'Bermud Adaları',
      BT: 'Butan',
      BO: 'Boliviya',
      BA: 'Bosniya və Herseqovina',
      BW: 'Botsvana',
      BV: 'Buve Adası',
      BR: 'Braziliya',
      IO: 'Britaniya Hind Okeanı Ərazisi',
      BN: 'Bruney-Darüssalam',
      BG: 'Bolqarıstan',
      BF: 'Burkina Faso',
      BI: 'Burundi',
      KH: 'Kamboca',
      CM: 'Kamerun',
      CA: 'Kanada',
      CV: 'Kabo-Verde',
      KY: 'Kayman Adaları',
      CF: 'Mərkəzi Afrika Respublikası',
      TD: 'Çad',
      CL: 'Çili',
      CN: 'Çin',
      CX: 'Milad Adası',
      CC: 'Kokos (Kiling) Adaları',
      CO: 'Kolumbiya',
      KM: 'Komor Adaları',
      CG: 'Konqo',
      CD: 'Konqo Demokratik Respublikası',
      CK: 'Kuk Adaları',
      CR: 'Kosta-Rika',
      CI: "Kot-d'İvuar",
      HR: 'Xorvatiya',
      CU: 'Kuba',
      CY: 'Kipr',
      CZ: 'Çexiya',
      DK: 'Danimarka',
      DJ: 'Cibuti',
      DM: 'Dominika',
      DO: 'Dominikan Respublikası',
      EC: 'Ekvador',
      EG: 'Misir',
      SV: 'El-Salvador',
      GQ: 'Ekvatorial Qvineya',
      ER: 'Eritreya',
      EE: 'Estoniya',
      ET: 'Efiopiya',
      FK: 'Folklend Adaları (Malvin Adaları)',
      FO: 'Farer Adaları',
      FJ: 'Fici',
      FI: 'Finlandiya',
      FR: 'Fransa',
      GF: 'Fransa Qvianası',
      PF: 'Fransa Polineziyası',
      TF: 'Fransız Cənubi Əraziləri',
      GA: 'Qabon',
      GM: 'Qambiya',
      GE: 'Gürcüstan',
      DE: 'Almaniya',
      GH: 'Qana',
      GI: 'Cəbəllütariq',
      GR: 'Yunanıstan',
      GL: 'Qrenlandiya',
      GD: 'Qrenada',
      GP: 'Qvadelupa',
      GU: 'Quam',
      GT: 'Qvatemala',
      GG: 'Gernsi',
      GN: 'Qvineya',
      GW: 'Qvineya-Bisau',
      GY: 'Qayana',
      HT: 'Haiti',
      HM: 'Herd və Makdonald Adaları',
      VA: 'Müqəddəs Taxt (Vatikan Şəhər Dövləti)',
      HN: 'Honduras',
      HK: 'Honq-Konq',
      HU: 'Macarıstan',
      IS: 'İslandiya',
      IN: 'Hindistan',
      ID: 'İndoneziya',
      IR: 'İran',
      IQ: 'İraq',
      IE: 'İrlandiya',
      IM: 'Men Adası',
      IL: 'İsrail',
      IT: 'İtaliya',
      JM: 'Yamayka',
      JP: 'Yaponiya',
      JE: 'Cersi',
      JO: 'İordaniya',
      KZ: 'Qazaxıstan',
      KE: 'Keniya',
      KI: 'Kiribati',
      KR: 'Koreya',
      KW: 'Küveyt',
      KG: 'Qırğızıstan',
      LA: 'Laos Xalq Demokratik Respublikası',
      LV: 'Latviya',
      LB: 'Livan',
      LS: 'Lesoto',
      LR: 'Liberiya',
      LY: 'Liviya Ərəb Camahiriyyəsi',
      LI: 'Lixtenşteyn',
      LT: 'Litva',
      LU: 'Lüksemburq',
      MO: 'Makao',
      MK: 'Şimali Makedoniya',
      MG: 'Madaqaskar',
      MW: 'Malavi',
      MY: 'Malayziya',
      MV: 'Maldiv Adaları',
      ML: 'Mali',
      MT: 'Malta',
      MH: 'Marşal Adaları',
      MQ: 'Martinik',
      MR: 'Mavritaniya',
      MU: 'Mavriki',
      YT: 'Mayotta',
      MX: 'Meksika',
      FM: 'Mikroneziya',
      MD: 'Moldova',
      MC: 'Monako',
      MN: 'Monqolustan',
      ME: 'Monteneqro',
      MS: 'Monserat',
      MA: 'Mərakeş',
      MZ: 'Mozambik',
      MM: 'Myanma',
      NA: 'Namibiya',
      NR: 'Nauru',
      NP: 'Nepal',
      NL: 'Niderland',
      AN: 'Niderland Antil Adaları',
      NC: 'Yeni Kaledoniya',
      NZ: 'Yeni Zelandiya',
      NI: 'Nikaraqua',
      NE: 'Niger',
      NG: 'Nigeriya',
      NU: 'Niu',
      NF: 'Norfolk Adası',
      MP: 'Şimal Marian Adaları',
      NO: 'Norveç',
      OM: 'Oman',
      PK: 'Pakistan',
      PW: 'Palau',
      PS: 'Fələstin Ərazisi, İşğal Altında',
      PA: 'Panama',
      PG: 'Papua Yeni Qvineya',
      PY: 'Paraqvay',
      PE: 'Peru',
      PH: 'Filippin',
      PN: 'Pitkern',
      PL: 'Polşa',
      PT: 'Portuqaliya',
      PR: 'Puerto Riko',
      QA: 'Qətər',
      RE: 'Reunion',
      RO: 'Rumıniya',
      RU: 'Rusiya',
      RW: 'Ruanda',
      BL: 'Müqəddəs Bartolomey',
      SH: 'Müqəddəs Yelena',
      KN: 'Sent-Kits və Nevis',
      LC: 'Sent-Lusiya',
      MF: 'Müqəddəs Martin',
      PM: 'Sent-Pyer və Mikelon',
      VC: 'Sent-Vinsent və Qrenadinlər',
      WS: 'Samoa',
      SM: 'San-Marino',
      ST: 'San-Tome və Prinsipi',
      SA: 'Səudiyyə Ərəbistanı',
      SN: 'Seneqal',
      RS: 'Serbiya',
      SC: 'Seyşel Adaları',
      SL: 'Syerra Leone',
      SG: 'Sinqapur',
      SK: 'Slovakiya',
      SI: 'Sloveniya',
      SB: 'Solomon Adaları',
      SO: 'Somali',
      ZA: 'Cənubi Afrika',
      GS: 'Cənubi Corciya və Sandviç Adaları',
      ES: 'İspaniya',
      LK: 'Şri Lanka',
      SD: 'Sudan',
      SR: 'Surinam',
      SJ: 'Svalbard və Yan-Mayen',
      SZ: 'Esvatini',
      SE: 'İsveç',
      CH: 'İsveçrə',
      SY: 'Suriya Ərəb Respublikası',
      TW: 'Tayvan',
      TJ: 'Tacikistan',
      TZ: 'Tanzaniya',
      TH: 'Tayland',
      TL: 'Timor-Leste',
      TG: 'Toqo',
      TK: 'Tokelau',
      TO: 'Tonqa',
      TT: 'Trinidad və Tobaqo',
      TN: 'Tunis',
      TR: 'Türkiyə',
      TM: 'Türkmənistan',
      TC: 'Türks və Kaykos Adaları',
      TV: 'Tuvalu',
      UG: 'Uqanda',
      UA: 'Ukrayna',
      AE: 'Birləşmiş Ərəb Əmirlikləri',
      GB: 'Böyük Britaniya',
      US: 'Amerika Birləşmiş Ştatları',
      UM: 'ABŞ Uzaq Adaları',
      UY: 'Uruqvay',
      UZ: 'Özbəkistan',
      VU: 'Vanuatu',
      VE: 'Venesuela',
      VN: 'Vyetnam',
      VG: 'Britaniya Virgin Adaları',
      VI: 'ABŞ Virgin Adaları',
      WF: 'Uollis və Futuna',
      EH: 'Qərbi Saxara',
      YE: 'Yəmən',
      ZM: 'Zambiya',
      ZW: 'Zimbabve',
    },
  },
  tr: {
    _name: 'Türkçe',
    policy: 'Gizlilik Politikası',
    policyAML: 'AML Politikası',
    policyKYC: 'KYC Politikası',
    locense: 'Lisans',
    view_all: 'Hepsini Göster',
    sell_btn: 'Sat',
    buy_btn: 'Al',
    currency_action: 'Para Birimi',
    importantAccountDetails: 'Önemli hesap bilgileri',
    viewAdditionalSettings: 'Ek ayarları görüntüle',
    switchDarkMode: 'Koyu/Aydın modunu değiştir',
    writeProblem: 'Sorununuzu bize yazın',
    darkMode: 'Koyu mod',
    yay: 'Tebrikler',
    purchased: 'Başarıyla satın aldınız',
    from: 'olarak',
    walet: 'Cüzdan',
    trade: 'Ticaret',
    withdrawDetails: 'Çekim bilgileri',
    saveDetails: 'Sonraki sefer için bilgileri sakla',
    amountToWithdraw: 'Çekilecek tutar',
    withdrawLimit: 'Günlük çekim limiti: $1,000,000.00 bakiye.',
    serviceFee: 'Hizmet ücreti',
    youWillPay: 'Ödeyeceksiniz',
    cancel: 'İptal et',
    understand: 'Anladım, devam et',
    select: 'Seçin',
    enterAmount: 'Tutarı girin',
    orderInfo: 'Sipariş Bilgisi',
    confirmOrder: 'Siparişi Onayla',
    get: 'Al',
    spend: 'Harcamak',
    buying: 'Alış',
    accountTransactions: 'Hesap İşlemleri',
    overview: 'Genel Bakış',
    accountBalances: 'Hesap Bakiyeleri',
    details: 'Detaylar',
    loginHistory: 'Giriş geçmişi',
    device: 'Cihaz',
    contactUs: 'Bize Ulaşın',
    sessionLog: 'Oturumlar ve giriş geçmişi',
    selectMethods: 'Yöntemleri seçin',
    depositDetails: 'Para yatırma bilgileri',
    order: 'Sipariş',
    support: 'Destek',
    supportChat: 'Destek Sohbeti',
    createChat: 'Sohbet Oluştur',
    homepage: 'Ana Sayfa',
    takeProfitStopLoss: 'Kar Al / Zarar Durdur',
    takeProfit: 'Kar Al',
    stopLoss: 'Zarar Durdur',
    updateOrder: 'Siparişi Güncelle',
    balance: 'Bakiye',
    credit: 'Kredi',
    equity: 'Sermaye',
    practice: 'DEMO',
    real: 'GERÇEK',
    account: 'Hesap',
    invested: 'Yatırılmış',
    profit: 'Kar',
    loss: 'Zarar',
    margin: 'Marjin',
    marginLevel: 'Marjin Seviyesi',
    marginFree: 'Serbest Marjin',
    cfd: 'CFD',
    platform: 'Platform',
    deposit: 'Para Yatırma',
    marketWatch: 'Piyasa Takibi',
    activeOrders: 'Aktif Siparişler',
    tradingHistory: 'Ticaret Geçmişi',
    economicCalendar: 'Ekonomik Takvim',
    marketNews: 'Piyasa Haberleri',
    closeOrder: 'Pozisyonu Kapat',
    areYouSure: 'Pozisyonu kapatmaya emin misiniz?',
    buy: 'Al',
    sell: 'Sat',
    yes: 'Evet',
    no: 'Hayır',
    addNewChart: 'Yeni Grafik Ekle',
    watchlist: 'İzleme Listesi',
    asset: 'Varlık',
    price: 'Fiyat',
    changePct: '24 saatlik değişim',
    pending: 'Beklemede',
    assetPrice: 'Varlık Fiyatı',
    current: 'Şu anki',
    revert: 'Piyasa Fiyatına Dön',
    automatically:
      'Fiyat bu seviyeye ulaştığında pozisyon otomatik olarak açılacak',
    default: 'varsayılan',
    volume: 'Hacim',
    lots: 'lotlar',
    units: 'birimler',
    currency: 'Para Birimi',
    contractSize: 'Sözleşme Boyutu',
    position: 'Pozisyon',
    freeMargin: 'Serbest Marjin',
    takeProfitStopLoss: 'Kar Al & Zarar Durdur',
    market: 'Piyasa',
    leverage: 'Kaldıraç',
    spread: 'Spread',
    notSet: 'Belirlenmedi',
    at: 'zaman',
    supportBanner: 'HER GÜN, HER SAAT',
    currentTime: 'ŞU ANDAKİ ZAMAN',
    liveChat: 'Canlı Sohbet',
    pnl: 'PnL',
    profitTotal: 'Ömür Boyu PnL',
    dateRegistered: 'Kayıt Tarihi',
    userId: 'Kullanıcı ID',
    dashboard: 'Kontrol Paneli',
    personalData: 'Kişisel Bilgiler',
    withdrawFunds: 'Para Çekme',
    savings: 'Birikimler',
    settings: 'Ayarlar',
    logout: 'Çıkış',
    BT_INVOICE: 'Tutarı girin ve fatura oluşturun',
    BT_TITLE: 'Banka bilgilerimiz',
    bank_name: 'Banka Adı',
    beneficiary: 'Lehdar',
    beneficiary_address: 'Lehdarın Adresi',
    swift: 'SWIFT',
    iban: 'IBAN',
    ru_inn: 'INN',
    ru_kpp: 'KPP',
    corresponding_account: 'Muhabir Hesap',
    TOKEN_AMOUNT: 'Tutar',
    TOKEN_SUBTOTAL: 'Ara Toplam',
    TOKEN_TOTAL: 'Toplam',
    TOKEN_DESCRIPTION: 'Açıklama',
    TOKEN_PAYMENT_DETAILS: 'Ödeme Detayları',
    PENDING_DEPOSITS_LIMIT: 'Para Yatırma Limiti',
    makeDeposit: 'Para Yatırın',
    practiceAccount: 'Demo Hesap',
    realAccount: 'Gerçek Hesap',
    noWithdrawals: 'Çekim yok',
    easyWithdrawals: 'Kolay Çekimler',
    allAssets: 'Tüm varlıklar mevcut',
    fullFledged: 'Tam fonksiyonlu platform',
    fillUpTo: 'Kadar doldurun',
    freeReplenishment: 'Ücretsiz Tamamlama',
    topUp: 'Hesabınızı Yükleyin',
    minimumAmount: 'Minimum Tutar',
    maxAmount: 'Maksimum Tutar',
    withdrawalType: 'Para Çekme Türü',
    canSwitch: 'Hesaplar arasında istediğiniz zaman geçiş yapabilirsiniz',
    chartGrids: 'Grafik Ağları',
    chart1: '1 grafik',
    chart2: '2 grafik',
    chart3: '3 grafik',
    chart4: '4 grafik',
    connectionLost: 'Sunucu bağlantısı kesildi',
    retryNow: 'Şimdi tekrar dene',
    loginToTradeRoom: 'Ticaret Odasına Giriş',
    email: 'E-posta adresi',
    enterEmail: 'E-posta adresinizi girin',
    twoFactor: '2FA Kodu (aktifse)',
    twoFactorAuth: 'İki Faktörlü Doğrulama',
    password: 'Şifre',
    yourPassword: 'Şifreniz',
    signIn: 'Giriş Yap',
    dontHaveAccount: 'Hesabınız yok mu?',
    restore: 'Geri Yükle',
    fullName: 'Tam Ad',
    havePromo: 'Promokodum var',
    promo: 'Promokod',
    login: 'Giriş',
    haveAccount: 'Zaten bir hesabınız var mı?',
    hide: 'Gizle',
    goTo: 'Geri dön',
    setNewPassword: 'Yeni Şifre Belirle',
    newPassword: 'Yeni şifre',
    confirmNewPassword: 'Yeni şifreyi onaylayın',
    setButton: 'Belirle',
    repeatPassword: 'Şifreyi Tekrarla',
    createNewAccount: 'Yeni Hesap Oluştur',
    firstName: 'Ad',
    lastName: 'Soyad',
    country: 'Ülke',
    phone: 'Telefon',
    createAccount: 'Hesap Oluştur',
    forgotPassword: 'Şifrenizi mi Unuttunuz?',
    submitEmail:
      'Kayıt sırasında kullanılan e-posta adresini girin, e-postanızı kontrol edin ve verilen talimatları izleyin',
    submit: 'Onayla',
    error: 'Hata',
    success: 'Başarı',
    withdrawal: 'Para Çekme',
    depositApproved: 'Para yatırma onaylandı',
    depositDeclined: 'Para yatırma reddedildi',
    withdrawalApproved: 'Para çekme onaylandı',
    withdrawalDeclined: 'Para çekme reddedildi',
    forex: 'Forex',
    stocks: 'Hisseler',
    commodities: 'Emtialar',
    indices: 'Endeksler',
    crypto: 'Kripto',
    metals: 'Metaller',
    nft: 'NFT',
    profitCalculator: 'Kar Hesaplayıcı',
    volume: 'Hacim',
    entryPrice: 'Giriş Fiyatı',
    takeProfit: 'Kar Al',
    stopLoss: 'Zarar Durdur',
    maxPosition: 'Maksimum Pozisyon',
    calculate: 'Hesapla',
    calculationsFor: 'İçin Hesaplamalar',
    requiredMargin: 'Gerekli Marjin',
    profitFromTP: "TP'den Kar",
    lossFromSL: "SL'den Zarar",
    roe: 'ROE',
    title: 'Para Yatırma Başarılı',
    text: 'Para yatırmanız başarıyla işlendi!',
    title: 'Para Yatırma Başarısız',
    text: 'Para yatırmanız işlenmedi.',
    search: 'Arama...',
    commission: 'Komisyon',
    active: 'Aktif',
    portfolio: 'Portföy',
    allPositions: 'Tüm Pozisyonlar',
    noPositionsLine1: 'Açık pozisyonunuz yok',
    noPositionsLine2: 'şimdilik pozisyon yok',
    show: 'Göster',
    more: 'daha fazla',
    less: 'daha az',
    purchaseTime: 'Alış Zamanı',
    closePosition: 'Pozisyonu Kapat',
    priceOpen: 'Alış Fiyatı',
    priceSl: 'Zarar Durdurma Fiyatı',
    priceTp: 'Kar Alma Fiyatı',
    type: 'Pozisyon Yönü',
    cancelOrder: 'Siparişi İptal Et',
    orderType: 'Sipariş Türü',
    cancelled: 'İptal edildi',
    tradingHistory: 'Ticaret Geçmişi',
    noHistoryLine1: 'Hiçbir kapanmış',
    noHistoryLine2: 'işleminiz yok',
    ordersActive: 'Aktif Siparişler',
    ordersHistory: 'Sipariş Geçmişi',
    id: 'ID',
    symbol: 'Sembol',
    documentType: 'Tür',
    openPrice: 'Açılış Fiyatı',
    openTime: 'Açılış Zamanı',
    closePrice: 'Kapanış Fiyatı',
    closeTime: 'Kapanış Zamanı',
    sl: 'SL',
    tp: 'TP',
    price: 'Fiyat',
    actions: 'İşlemler',
    edit: 'Düzenle',
    close: 'Kapat',
    swap: 'Swap',
    swapLong: 'Uzun Swap',
    swapShort: 'Kısa Swap',
    assetInfo: 'Varlık Bilgisi',
    tradingConditions: 'Ticaret Şartları',
    information: 'Oturum Değişikliği',
    bid: 'Alış',
    ask: 'Satış',
    sessionChange: 'Oturum Değişikliği',
    tradeNow: 'Şimdi Ticaret Yap',
    opens: 'Açılıyor',
    closes: 'Kapanıyor',
    at: 'zamanında',
    open247: '7/24 Açık',
    today: 'bugün',
    tomorrow: 'yarın',
    sunday: 'Pazar',
    monday: 'Pazartesi',
    tuesday: 'Salı',
    wednesday: 'Çarşamba',
    thursday: 'Perşembe',
    friday: 'Cuma',
    saturday: 'Cumartesi',
    contractSpecification: 'Sözleşme Özelliği',
    name: 'Ad',
    baseCurrency: 'Temel Para Birimi',
    digits: 'Rakamlar',
    lotSize: 'Lot Büyüklüğü',
    lotStep: 'Lot Adımı',
    minVolume: 'Minimum Hacim',
    maxVolume: 'Maksimum Hacim',
    leverage: 'Kaldıraç (Leverage)',
    swapLong: 'Uzun Swap',
    swapShort: 'Kısa Swap',
    schedule: 'Program',
    weekday: 'Haftanın günü',
    tradingTime: 'Ticaret Zamanı',
    closed: 'kapalı',
    sell: 'Sat',
    buy: 'Al',
    low: 'En Düşük',
    high: 'En Yüksek',
    oneHourChange: '1 saatlik değişim',
    oneDayChange: '1 günlük değişim',
    oneWeekChange: '1 haftalık değişim',
    oneMonthChange: '1 aylık değişim',
    threeMonthsChange: '3 aylık değişim',
    oneYearChange: '1 yıllık değişim',
    loading: 'Yükleniyor...',
    title: 'Otomatik Trader',
    riskLevelLow: 'Risk Seviyesi:',
    riskLevelMedium: 'Risk Seviyesi: Orta',
    riskLevelHigh: 'Risk Seviyesi: Yüksek',
    perDay: 'Günlük işlemler:',
    desc: "CFD'ler ve diğer kaldıraçlı ürünler ticaret sırasında kayıplara yol açabilir. Ticarete başlamadan önce, müşteriler Risk Beyanları sayfasında ilgili risk bildirimlerini okumalıdır. Otomatik ticaret sonuç garanti etmez. Şirket, otomatik ticarette para kaybından sorumlu değildir. Riskleri tam olarak anladığınızdan ve riskleri yönetmek için önlemler aldığınızdan emin olun.",
    accept: 'Kabul et',
    trade: 'Ticaret',
    startTrading: 'Ticarete Başla',
    personalInfo: 'Kişisel Bilgiler',
    verification: 'Doğrulama',
    accounts: 'Hesaplar',
    liveChat: 'Canlı Sohbet',
    logOut: 'Çıkış',
    methods: 'YÖNTEMLER',
    confirm: 'Banka uygulamanızda onaylayın',
    sendOtp: 'OTP gönder',
    otpCode: 'OTP kodu',
    addWalletAddress:
      'Bu para yatırma yöntemi için cüzdan belirlenmedi. Lütfen temsilciniz veya destek ekibi ile iletişime geçin.',
    addressReceipt: 'Adresin yüklenmesini bekleyin',
    makeDeposit: 'PARA YATIRIN',
    instant: 'Anında',
    minutes: 'dakika',
    hours: 'saat',
    days: 'gün',
    amount: 'Tutar',
    continue: 'Devam et',
    qrCode: 'QR KOD',
    depositAddress: 'PARA YATIRMA ADRESİ',
    copy: 'Kopyala',
    last: 'SON',
    deposits: 'PARA YATIRMALARI',
    time: 'Zaman',
    status: 'Durum',
    info: 'Bilgi',
    pleaseWait: 'Lütfen bekleyin. Ödeme hizmet sağlayıcısına bağlanılıyor...',
    cardPayment: 'Kart ile ödeme',
    inOrder: 'Tutarı göndermek için',
    pleaseProvide: 'lütfen kart bilgilerini girin:',
    completeVerification: 'Lütfen doğrulamayı tamamlayın',
    noOrderYet: 'Henüz sipariş yok',
    totalBalance: 'Toplam Bakiye',
    totalDeposits: 'Toplam Para Yatırmaları',
    profitableOrders: 'Karlı Siparişler',
    totalPnl: 'Toplam PnL',
    roi: 'ROI',
    activityLog: 'Aktivite Kaydı',
    loginFromIp: "IP'den giriş",
    tradingResults: 'Ticaret Sonuçları',
    week: 'Hafta',
    month: 'Ay',
    year: 'Yıl',
    successRate: 'Başarı Oranı',
    closedWithProfit: 'Kar ile kapandı',
    closedWithLoss: 'Zarar ile kapandı',
    usingCurrentRate: 'güncel kur kullanılarak',
    personalDetails: 'Kişisel Bilgiler',
    profilePhoto: 'Profil Fotoğrafı',
    address: 'Adres',
    phone: 'Telefon numarası',
    saveChanges: 'Değişiklikleri Kaydet',
    dropFile: 'Yüklemek için dosyayı yukarıdaki daireye sürükleyin',
    notAllowed: 'Bu paylaşım yasaktır',
    notAllowedLine1: 'Açıkça cinsel veya pornografik nitelikteki resimler',
    notAllowedLine2:
      'Etnik veya ırksal nefreti veya saldırıyı kışkırtmaya yönelik resimler',
    notAllowedLine3: '18 yaş altı bireyleri içeren resimler',
    notAllowedLine4: 'Üçüncü şahıslara ait telif hakkı korumalı resimler',
    notAllowedLine5:
      "5 MB'den büyük ve JPG, GIF veya PNG formatı dışında olan resimler",
    requirements:
      'Resimde yüzünüz net bir şekilde görünmelidir. Tarafınızdan yüklenen tüm resim ve videolar bu gereksinimlere uymalıdır, aksi halde silinebilir.',
    withdrawalOff: 'Çekim bilgileri için hesap yöneticinizle iletişime geçin',
    cryptocurrency: 'Kripto para',
    withdrawal: 'Para Çekme',
    requestNewWithdrawal: 'YENİ ÇEKİM İSTE',
    currentBalance: 'Mevcut hesap bakiyeniz',
    withdrawAll: 'Hepsini çek',
    requestWithdrawal: 'Çekim Talep Et',
    withdrawalRequests: 'ÇEKİM TALEPLERİ',
    bank: 'Banka',
    bitcoin: 'Bitcoin',
    card: 'Kart',
    ethereum: 'Ethereum',
    eth: 'Ethereum',
    usdt: 'USDT',
    withdrawalDetails: 'Çekim Detayları',
    address: 'Cüzdan Adresi',
    bankAccount: 'Hesap Numarası',
    bankHolder: 'Hesap Sahibinin Adı',
    bankIban: 'IBAN',
    bankSwift: 'Banka SWIFT Kodu',
    cardNumber: 'Kart Numarası',
    cardHolder: 'Kart Sahibinin Adı',
    dragAndDrop: 'Belgeyi bu alana sürükleyip bırakın',
    documentsList: 'YÜKLENEN BELGELERİN LİSTESİ',
    document: 'Belge',
    timeUploaded: 'Yüklenme Zamanı',
    timeProcessed: 'İşlenme Zamanı',
    types: [
      'Kimlik Belgesi',
      'İkametgah Belgesi',
      'Kredi Kartı Ön Yüzü',
      'Kredi Kartı Arka Yüzü',
      'Kimlik Belgesinin Arka Yüzü',
      'Selfi',
    ],
    types2: [
      'Kimlik Belgesi (POI)',
      'İkamet Adresi Kanıtı',
      'Kredi Kartı Ön Yüzü',
      'Kredi Kartı Arka Yüzü',
      'Kimlik Belgesinin Arka Yüzü',
      'Kimlik Kartı ile Selfi',
    ],
    upload: 'Yükle',
    isConfirmed: 'onaylandı',
    uploadAnotherDocument: 'Başka belge yükle',
    isUnderReview: 'incelemede',
    questionnaire: 'Anket',
    sendAnswers: 'Cevapları Gönder',
    progressBarOf: 'of',
    progressBarText: 'Belgeleriniz yüklendi ve onaylandı',
    manageAccounts: 'Hesaplar arasında para transferi yapın',
    transferFrom: 'Hesaptan',
    transferTo: 'Hesaba',
    makeTransfer: 'Transfer Yap',
    yourAccounts: 'Hesaplarınız',
    makeActive: 'Aktif Yap',
    active: 'Aktif',
    sendMessage: 'Mesaj Gönder',
    pct_0: 'Esnek',
    pct_30: '1 Ay Kilitli',
    pct_90: '1 Çeyrek Kilitli',
    pct_180: '6 Ay Kilitli',
    pct_365: '1 Yıl Kilitli',
    detailedInformation: 'Detaylı Bilgi',
    pleaseSelect: 'Lütfen para birimini ve dönemi seçin',
    openSavings: 'Birikim Hesabı Açın',
    currentTime: 'Şu Anki Zaman',
    releaseTime: 'Serbest Bırakılacak Zaman',
    currencyChosen: 'Seçilen Para Birimi',
    periodChosen: 'Seçilen Dönem',
    yourRate: 'Faiz Oranınız',
    yourEarnings: 'Kazancınız',
    accountFrom: 'Para transferi için hesap',
    enterAmount: 'Tutarı Girin',
    in: 'içinde',
    openAndInvest: 'Birikim Hesabı Açın ve Yatırım Yapın',
    investment: 'Yatırım',
    period: 'Dönem',
    daysTotal: 'Toplam Gün',
    finalEarnings: 'Nihai Kazanç',
    created: 'Oluşturuldu',
    daysElapsed: 'Geçen Günler',
    days: 'gün',
    earnings: 'Kazanç',
    fundsReleasedIn: 'Paralar serbest bırakılacak',
    claim: 'Talep Et',
    updatePassword: 'ŞİFRENİ YENİLE',
    currentPassword: 'Mevcut Şifre',
    newPassword: 'Yeni Şifre',
    changePassword: 'Şifreyi Değiştir',
    activationForGoogle: 'Google Authenticator için Aktivasyon Kodu',
    activateAndEnter:
      "Authenticator'u etkinleştirin ve aşağıdaki alana oluşturulan kodu girin",
    activateProtection: '2FA Korumasını Etkinleştir',
    protectionActive: '2FA koruması etkin',
    twoFactorCode: '2FA Kodu',
    disableProtection: '2FA Korumasını Devre dışı bırak',
    language: 'Dil',
    dashboardCurrency: 'Kontrol Paneli Para Birimi',
    confirmNewPassword: 'Yeni şifreyi onaylayın',
    yourLink: 'SİZİN TAVSİYE LİNKİNİZ',
    referredFriends: 'TAVSİYE EDİLEN DOSTLAR',
    registered: 'Kayıt',
    level: 'Seviye',
    payout: 'Ödeme',
    lastPayouts: 'SON TAVSİYE ÖDEMELERİ',
    Jan: 'Oca',
    Feb: 'Şub',
    Mar: 'Mar',
    Apr: 'Nis',
    May: 'May',
    Jun: 'Haz',
    Jul: 'Tem',
    Aug: 'Ağu',
    Sep: 'Eyl',
    Oct: 'Eki',
    Nov: 'Kas',
    Dec: 'Ara',
    orderTypes: [
      'Al',
      'Sat',
      'Alış Limiti',
      'Satış Limiti',
      'Alış Stop',
      'Satış Stop',
    ],
    statuses: ['Beklemede', 'Onaylandı', 'Reddedildi', 'İşleniyor'],
    NOT_FOUND: 'Sorgu hatası',
    FORBIDDEN: 'Giriş yasak. Lütfen tekrar giriş yapın',
    SERVER_ERROR: 'İşlem başarısız oldu. Lütfen daha sonra tekrar deneyin',
    INVALID_ACCOUNT: 'Oturum süresi doldu. Lütfen tekrar giriş yapın',
    INVALID_EMAIL: 'Yanlış e-posta adresi',
    INVALID_PHONE: 'Yanlış telefon numarası',
    INVALID_COUNTRY: 'Yanlış ülke',
    INVALID_LOGIN: 'Yanlış giriş bilgileri',
    USER_BLOCKED: 'Hesap engellendi. Destek servisi ile iletişime geçin',
    USER_REGISTERED:
      'Girilen e-posta veya telefon numarası ile kullanıcı zaten kayıtlı',
    INVALID_USER: 'Kullanıcı bulunamadı',
    REJECTED: 'İşlem platform kısıtlamaları nedeniyle yetkisizdir',
    INVALID_OLD_PASSWORD: 'Eski şifre yanlış',
    INVALID_SYMBOL: 'Yanlış ticaret sembolü',
    INVALID_SYMBOL_PRECISION: 'Yanlış sembol hassasiyeti',
    INVALID_FRAME: 'Yanlış grafik çerçevesi',
    INVALID_CURRENCY: 'Yanlış para birimi',
    INVALID_PRODUCT: 'Yanlış ticaret hesap türü',
    INSUFFICIENT_FUNDS: 'Yetersiz bakiye',
    INVALID_WITHDRAWAL: 'Çekim bulunamadı',
    INVALID_STATUS: 'Yanlış durum',
    INVALID_FILE: 'Yanlış dosya uzantısı veya dosya çok büyük',
    INVALID_DOCUMENT: 'Belge bulunamadı',
    INVALID_NAME: 'Yanlış ad',
    INVALID_LOT_SIZE: 'Yanlış lot büyüklüğü',
    INVALID_LOT_STEP: 'Yanlış lot adımı',
    INVALID_MIN_VOLUME: 'Yanlış minimum hacim',
    INVALID_MAX_VOLUME: 'Yanlış maksimum hacim',
    INVALID_GROUP: 'Yanlış grup',
    INVALID_SPREAD: 'Yanlış spread',
    REQUEST_TIMEOUT:
      'Sorgu zaman aşımına uğradı. Lütfen daha sonra tekrar deneyin',
    INVALID_TYPE: 'Yanlış sipariş türü',
    INVALID_VOLUME: 'Yanlış sipariş hacmi',
    INVALID_SL: 'Yanlış stop loss değeri',
    INVALID_TP: 'Yanlış take profit değeri',
    INVALID_PRICE: 'Yanlış sipariş fiyatı',
    INVALID_EXPIRATION: 'Yanlış sipariş süresi',
    NOT_ENOUGH_MARGIN: 'Yeterli marjin yok',
    INVALID_ORDER: 'Sipariş bulunamadı',
    MARKET_CLOSED: 'Ticaret mevcut değil. Lütfen tekrar deneyin',
    INVALID_BALANCE_TYPE: 'Yanlış bakiye işlem türü',
    INVALID_HASH: 'Yanlış hash',
    HASH_EXPIRED:
      'Şifre sıfırlama bağlantınızın süresi doldu. Lütfen yenisini talep edin',
    INVALID_CODE: 'Yanlış 2FA kodu',
    CHAT_DISABLED: 'Destek sohbetine erişim kapalı',
    WITHDRAWAL_NOT_ALLOWED: 'Çekimlere erişim kapalı',
    TRADING_DISABLED: 'Mevcut hesap için ticaret devre dışı bırakıldı',
    PENDING_DEPOSITS_LIMIT: 'Para yatırma limiti aşıldı',
    LOCAL_ONE_PENDING_WITHDRAWAL: 'Sadece bir bekleyen çekime izin verilir',
    LOCAL_DEPOSIT_ONLY_REAL: 'Para yatırma yalnız gerçek hesap için mevcuttur',
    LOCAL_DEPOSIT_POSITIVE: "Para yatırma tutarı 0'dan fazla olmalıdır",
    LOCAL_INVALID_CARD_NUMBER: 'Yanlış kart numarası',
    LOCAL_INVALID_CARD_EXPIRATION: 'Yanlış kart son kullanma tarihi',
    LOCAL_INVALID_CVC: 'Yanlış CVV/CVC kodu',
    LOCAL_PASSWORDS_NOT_MATCH: 'Şifreler uyuşmuyor, lütfen tekrar girin',
    LOCAL_NO_TRADING_ACCOUNTS:
      'Mevcut ticaret hesabınız yok. Lütfen destek servisi ile iletişime geçin',
    LOCAL_MIN_DEPOSIT: 'Minimum para yatırma $',
    LOCAL_MIN_WITHDRAWAL: 'Minimum çekim tutarı $',
    LOCAL_INVALID_FILE_TYPE:
      'Dosya formatı desteklenmiyor. Lütfen sadece JPG, PNG veya PDF ekleyin',
    LOCAL_MIN_STAKING: 'Bu para birimi için minimum para yatırma',
    FLOOD_REJECTED:
      'Çok sık mesaj gönderiyorsunuz. Lütfen sonra tekrar deneyin',
    countries: {
      AF: 'Afganistan',
      AX: 'Aland Adaları',
      AL: 'Arnavutluk',
      DZ: 'Cezayir',
      AS: 'Amerikan Samoası',
      AD: 'Andorra',
      AO: 'Angola',
      AI: 'Anguilla',
      AQ: 'Antarktika',
      AG: 'Antigua ve Barbuda',
      AR: 'Arjantin',
      AM: 'Ermenistan',
      AW: 'Aruba',
      AU: 'Avustralya',
      AT: 'Avusturya',
      AZ: 'Azerbaycan',
      BS: 'Bahamalar',
      BH: 'Bahreyn',
      BD: 'Bangladeş',
      BB: 'Barbados',
      BY: 'Belarus',
      BE: 'Belçika',
      BZ: 'Belize',
      BJ: 'Benin',
      BM: 'Bermuda Adaları',
      BT: 'Butan',
      BO: 'Bolivya',
      BA: 'Bosna Hersek',
      BW: 'Botsvana',
      BV: 'Bouvet Adası',
      BR: 'Brezilya',
      IO: 'Britanya Hint Okyanusu Toprağı',
      BN: 'Brunei',
      BG: 'Bulgaristan',
      BF: 'Burkina Faso',
      BI: 'Burundi',
      KH: 'Kamboçya',
      CM: 'Kamerun',
      CA: 'Kanada',
      CV: 'Cape Verde',
      KY: 'Cayman Adaları',
      CF: 'Orta Afrika Cumhuriyeti',
      TD: 'Çad',
      CL: 'Şili',
      CN: 'Çin',
      CX: 'Noel Adası',
      CC: 'Cocos (Keeling) Adaları',
      CO: 'Kolombiya',
      KM: 'Komor Adaları',
      CG: 'Kongo',
      CD: 'Kongo Demokratik Cumhuriyeti',
      CK: 'Cook Adaları',
      CR: 'Kosta Rika',
      CI: 'Fildişi Sahili',
      HR: 'Hırvatistan',
      CU: 'Küba',
      CY: 'Kıbrıs',
      CZ: 'Çek Cumhuriyeti',
      DK: 'Danimarka',
      DJ: 'Cibuti',
      DM: 'Dominika',
      DO: 'Dominik Cumhuriyeti',
      EC: 'Ekvador',
      EG: 'Mısır',
      SV: 'El Salvador',
      GQ: 'Ekvator Ginesi',
      ER: 'Eritre',
      EE: 'Estonya',
      ET: 'Etiyopya',
      FK: 'Falkland Adaları (Malvinas)',
      FO: 'Faroe Adaları',
      FJ: 'Fiji',
      FI: 'Finlandiya',
      FR: 'Fransa',
      GF: 'Fransız Guyanası',
      PF: 'Fransız Polinezyası',
      TF: 'Fransız Güney Toprakları',
      GA: 'Gabon',
      GM: 'Gambiya',
      GE: 'Gürcistan',
      DE: 'Almanya',
      GH: 'Gana',
      GI: 'Cebelitarık',
      GR: 'Yunanistan',
      GL: 'Grönland',
      GD: 'Grenada',
      GP: 'Guadeloupe',
      GU: 'Guam',
      GT: 'Guatemala',
      GG: 'Guernsey',
      GN: 'Gine',
      GW: 'Gine-Bissau',
      GY: 'Guyana',
      HT: 'Haiti',
      HM: 'Heard ve McDonald Adaları',
      VA: 'Vatikan (Vatikan Şehir Devleti)',
      HN: 'Honduras',
      HK: 'Hong Kong',
      HU: 'Macaristan',
      IS: 'İzlanda',
      IN: 'Hindistan',
      ID: 'Endonezya',
      IR: 'İran',
      IQ: 'Irak',
      IE: 'İrlanda',
      IM: 'Man Adası',
      IL: 'İsrail',
      IT: 'İtalya',
      JM: 'Jamaika',
      JP: 'Japonya',
      JE: 'Jersey',
      JO: 'Ürdün',
      KZ: 'Kazakistan',
      KE: 'Kenya',
      KI: 'Kiribati',
      KR: 'Kore',
      KW: 'Kuveyt',
      KG: 'Kırgızistan',
      LA: 'Laos Halk Demokratik Cumhuriyeti',
      LV: 'Letonya',
      LB: 'Lübnan',
      LS: 'Lesotho',
      LR: 'Liberya',
      LY: 'Libya Arap Cumhuriyeti',
      LI: 'Liechtenstein',
      LT: 'Litvanya',
      LU: 'Lüksemburg',
      MO: 'Makao',
      MK: 'Kuzey Makedonya',
      MG: 'Madagaskar',
      MW: 'Malavi',
      MY: 'Malezya',
      MV: 'Maldivler',
      ML: 'Mali',
      MT: 'Malta',
      MH: 'Marshall Adaları',
      MQ: 'Martinik',
      MR: 'Moritanya',
      MU: 'Mauritius',
      YT: 'Mayotte',
      MX: 'Meksika',
      FM: 'Mikronezya',
      MD: 'Moldova',
      MC: 'Monako',
      MN: 'Moğolistan',
      ME: 'Karadağ',
      MS: 'Montserrat',
      MA: 'Fas',
      MZ: 'Mozambik',
      MM: 'Myanmar',
      NA: 'Namibya',
      NR: 'Nauru',
      NP: 'Nepal',
      NL: 'Hollanda',
      AN: 'Hollanda Antilleri',
      NC: 'Yeni Kaledonya',
      NZ: 'Yeni Zelanda',
      NI: 'Nikaragua',
      NE: 'Nijer',
      NG: 'Nijerya',
      NU: 'Niue',
      NF: 'Norfolk Adası',
      MP: 'Kuzey Mariana Adaları',
      NO: 'Norveç',
      OM: 'Umman',
      PK: 'Pakistan',
      PW: 'Palau',
      PS: 'Filistin Bölgesi, İşgal Altında',
      PA: 'Panama',
      PG: 'Papua Yeni Gine',
      PY: 'Paraguay',
      PE: 'Peru',
      PH: 'Filipinler',
      PN: 'Pitcairn',
      PL: 'Polonya',
      PT: 'Portekiz',
      PR: 'Porto Riko',
      QA: 'Katar',
      RE: 'Reunion',
      RO: 'Romanya',
      RU: 'Rusya',
      RW: 'Ruanda',
      BL: 'Saint Barthélemy',
      SH: 'Saint Helena',
      KN: 'Saint Kitts ve Nevis',
      LC: 'Saint Lucia',
      MF: 'Saint Martin',
      PM: 'Saint Pierre ve Miquelon',
      VC: 'Saint Vincent ve Grenadinler',
      WS: 'Samoa',
      SM: 'San Marino',
      ST: 'Sao Tome ve Principe',
      SA: 'Suudi Arabistan',
      SN: 'Senegal',
      RS: 'Sırbistan',
      SC: 'Seyşeller',
      SL: 'Sierra Leone',
      SG: 'Singapur',
      SK: 'Slovakya',
      SI: 'Slovenya',
      SB: 'Solomon Adaları',
      SO: 'Somali',
      ZA: 'Güney Afrika',
      GS: 'Güney Georgia ve Güney Sandwich Adaları',
      ES: 'İspanya',
      LK: 'Sri Lanka',
      SD: 'Sudan',
      SR: 'Surinam',
      SJ: 'Svalbard ve Jan Mayen',
      SZ: 'Esvatini',
      SE: 'İsveç',
      CH: 'İsviçre',
      SY: 'Suriye Arap Cumhuriyeti',
      TW: 'Tayvan',
      TJ: 'Tacikistan',
      TZ: 'Tanzanya',
      TH: 'Tayland',
      TL: 'Doğu Timor',
      TG: 'Togo',
      TK: 'Tokelau',
      TO: 'Tonga',
      TT: 'Trinidad ve Tobago',
      TN: 'Tunus',
      TR: 'Türkiye',
      TM: 'Türkmenistan',
      TC: 'Turks ve Caicos Adaları',
      TV: 'Tuvalu',
      UG: 'Uganda',
      UA: 'Ukrayna',
      AE: 'Birleşik Arap Emirlikleri',
      GB: 'Büyük Britanya',
      US: 'Amerika Birleşik Devletleri',
      UM: 'ABD Uzak Adaları',
      UY: 'Uruguay',
      UZ: 'Özbekistan',
      VU: 'Vanuatu',
      VE: 'Venezuela',
      VN: 'Vietnam',
      VG: 'İngiliz Virgin Adaları',
      VI: 'ABD Virgin Adaları',
      WF: 'Wallis ve Futuna',
      EH: 'Batı Sahara',
      YE: 'Yemen',
      ZM: 'Zambiya',
      ZW: 'Zimbabve',
    },
  },
  es: {
    _name: 'Español',
    policy: 'Política de privacidad',
    policyAML: 'Política AML',
    policyKYC: 'Política KYC',
    locense: 'Licencia',
    view_all: 'Ver todo',
    sell_btn: 'Vender',
    buy_btn: 'Comprar',
    currency_action: 'Moneda',

    importantAccountDetails: 'Detalles importantes de la cuenta',
    viewAdditionalSettings: 'Ver ajustes adicionales',
    switchDarkMode: 'Cambiar modo oscuro/claro',
    writeProblem: 'Escríbenos tu problema',
    darkMode: 'Modo oscuro',

    yay: '¡Genial!',
    purchased: 'Has comprado con éxito',
    from: 'De',
    walet: 'Cartera',
    trade: 'Operar',

    withdrawDetails: 'Detalles de retiro',
    saveDetails: 'Guardar detalles para la próxima vez',
    amountToWithdraw: 'Cantidad a retirar',
    withdrawLimit: 'Límite de retiro diario restante: $1.000.000,00.',

    serviceFee: 'Tarifa de servicio',
    youWillPay: 'Pagarás',
    cancel: 'Cancelar',
    understand: 'Entiendo, continúa',

    select: 'Seleccionar',
    enterAmount: 'Introduce la cantidad',
    orderInfo: 'Información del pedido',
    confirmOrder: 'Confirmar pedido',
    get: 'Obtener',
    spend: 'Gastar',
    buying: 'Comprando',

    accountTransactions: 'Transacciones de la cuenta',
    overview: 'Resumen',
    accountBalances: 'Saldos de la cuenta',
    details: 'Detalles',
    loginHistory: 'Historial de inicio de sesión',
    device: 'Dispositivo',
    contactUs: 'Contáctanos',
    sessionLog: 'Sesiones e historial de inicio de sesión',
    selectMethods: 'Seleccionar métodos',
    depositDetails: 'Detalles del depósito',
    order: 'Pedido',
    support: 'Soporte',
    supportChat: 'Chat de soporte',
    createChat: 'Crear chat',
    homepage: 'Inicio',
    takeProfitStopLoss: 'Take Profit y Stop Loss',
    takeProfit: 'Take Profit',
    stopLoss: 'Stop Loss',
    updateOrder: 'Actualizar pedido',
    balance: 'Saldo',
    credit: 'Crédito',
    equity: 'Patrimonio',
    practice: 'PRACTICA',
    real: 'REAL',
    account: 'CUENTA',
    invested: 'Invertido',
    profit: 'Ganancia',
    loss: 'Pérdida',
    margin: 'Margen',
    marginLevel: 'Nivel de margen',
    marginFree: 'Margen libre',
    cfd: 'CFD',
    platform: 'Plataforma',
    deposit: 'Depósito',
    marketWatch: 'Observación de mercado',
    activeOrders: 'Órdenes activas',
    tradingHistory: 'Historial de operaciones',
    economicCalendar: 'Calendario económico',
    marketNews: 'Noticias del mercado',
    closeOrder: 'Cerrar posición',
    areYouSure: '¿Estás seguro de cerrar la posición?',
    buy: 'Comprar',
    sell: 'Vender',
    yes: 'Sí',
    no: 'No',
    addNewChart: 'Añadir gráfico nuevo',
    watchlist: 'Lista de seguimiento',
    asset: 'Activo',
    price: 'Precio',
    changePct: 'Cambio 24h',
    pending: 'Pendiente',
    assetPrice: 'Precio del activo',
    current: 'Actual',
    revert: 'Revertir al precio de mercado',
    automatically:
      'La posición se abrirá automáticamente cuando el precio alcance este nivel',
    default: 'Predeterminado',
    volume: 'Volumen',
    lots: 'Lotes',
    units: 'Unidades',
    currency: 'Moneda',
    contractSize: 'Tamaño del contrato',
    position: 'Posición',
    margin: 'Margen',
    freeMargin: 'Margen libre',
    takeProfitStopLoss: 'Take Profit y Stop Loss',
    pending: 'Pendiente',
    market: 'Mercado',
    leverage: 'Apalancamiento',
    spread: 'Spread',
    notSet: 'No establecido',
    at: 'a',
    buy: 'comprar',
    sell: 'vender',
    supportBanner: 'TODOS LOS DÍAS, LAS 24 HORAS',
    currentTime: 'HORA ACTUAL',
    liveChat: 'Chat en vivo',
    balance: 'Saldo',
    credit: 'Crédito',
    equity: 'Patrimonio',
    margin: 'Margen',
    marginLevel: 'Nivel de margen',
    freeMargin: 'Margen libre',
    pnl: 'PnL',
    profitTotal: 'PnL de por vida',
    dateRegistered: 'Fecha de registro',
    userId: 'ID de usuario',
    dashboard: 'Panel',
    personalData: 'Datos personales',
    deposit: 'Depósito',
    withdrawFunds: 'Retirar fondos',
    savings: 'Ahorros',
    settings: 'Ajustes',
    logout: 'Cerrar sesión',
    BT_INVOICE: 'Introduce la cantidad y genera la factura',
    BT_TITLE: 'Nuestros datos bancarios',
    account: 'Cuenta',
    bank_name: 'Nombre del banco',
    beneficiary: 'Beneficiario',
    beneficiary_address: 'Dirección del beneficiario',
    swift: 'Swift',
    iban: 'IBAN',
    ru_inn: 'INN',
    ru_kpp: 'KPP',
    corresponding_account: 'Cuenta corresponsal',
    TOKEN_AMOUNT: 'Cantidad',
    TOKEN_SUBTOTAL: 'Subtotal',
    TOKEN_TOTAL: 'Total',
    TOKEN_DESCRIPTION: 'Descripción',
    TOKEN_PAYMENT_DETAILS: 'Detalles del pago',
    PENDING_DEPOSITS_LIMIT: 'Límite de depósito',
    makeDeposit: 'Realizar un depósito',
    practiceAccount: 'Cuenta de práctica',
    realAccount: 'Cuenta real',
    noWithdrawals: 'Sin retiros',
    easyWithdrawals: 'Retiros fáciles',
    allAssets: 'Todos los activos disponibles',
    fullFledged: 'Plataforma completa',
    fillUpTo: 'Rellenar hasta',
    freeReplenishment: 'Reaprovisionamiento gratuito',
    topUp: 'Recarga tu cuenta',
    minimumAmount: 'Cantidad mínima',
    maxAmount: 'Cantidad máxima',
    withdrawalType: 'Tipo de retiro',
    canSwitch: 'Puedes cambiar entre tus cuentas en cualquier momento',
    chartGrids: 'CUADRÍCULAS DE GRÁFICOS',
    chart1: '1 gráfico',
    chart2: '2 gráficos',
    chart3: '3 gráficos',
    chart4: '4 gráficos',
    connectionLost: 'Se perdió la conexión con el servidor',
    retryNow: 'Reintentar ahora',
    loginToTradeRoom: 'Iniciar sesión en la sala de trading',
    email: 'Dirección de correo',
    enterEmail: 'Introduce tu correo',
    twoFactor: 'Código 2FA (si está habilitado)',
    twoFactorAuth: 'Autenticación de dos factores',
    password: 'Contraseña',
    yourPassword: 'Tu contraseña',
    signIn: 'Iniciar sesión',
    dontHaveAccount: '¿No tienes una cuenta?',
    restore: 'Restaurar',
    fullName: 'Nombre completo',
    havePromo: 'Tengo un código promocional',
    promo: 'Código promocional',
    login: 'Iniciar sesión',
    haveAccount: '¿Ya tienes una cuenta?',
    hide: 'Ocultar',
    goTo: 'Volver atrás',

    setNewPassword: 'Establecer nueva contraseña',
    newPassword: 'Nueva contraseña',
    confirmNewPassword: 'Confirmar nueva contraseña',
    setButton: 'Establecer',

    repeatPassword: 'Repetir contraseña',
    createNewAccount: 'Crear una nueva cuenta',
    email: 'Dirección de correo',
    firstName: 'Nombre',
    lastName: 'Apellido',
    country: 'País',
    phone: 'Teléfono',
    password: 'Contraseña',
    createAccount: 'Crear cuenta',
    currency: 'Moneda',

    forgotPassword: '¿Olvidaste tu contraseña?',
    submitEmail:
      'Por favor, envía un correo usado para el registro, revisa tu bandeja de entrada y sigue las instrucciones proporcionadas',
    submit: 'Enviar',
    error: 'Error',
    success: 'Éxito',
    deposit: 'Depósito',
    withdrawal: 'Retiro',
    depositApproved: 'El depósito ha sido aprobado',
    depositDeclined: 'El depósito ha sido rechazado',
    withdrawalApproved: 'El retiro ha sido aprobado',
    withdrawalDeclined: 'El retiro ha sido rechazado',

    forex: 'Forex',
    stocks: 'Acciones',
    commodities: 'Materias primas',
    indices: 'Índices',
    crypto: 'Cripto',
    metals: 'Metales',
    nft: 'NFT',

    buy: 'COMPRAR',
    profitCalculator: 'Calculadora de ganancias',
    sell: 'VENDER',
    volume: 'Volumen',
    entryPrice: 'Precio de entrada',
    takeProfit: 'Take Profit',
    stopLoss: 'Stop Loss',
    maxPosition: 'Posición máxima',
    calculate: 'Calcular',
    calculationsFor: 'Cálculos para',
    leverage: 'Apalancamiento',
    requiredMargin: 'Margen requerido',
    profitFromTP: 'Ganancia de TP',
    lossFromSL: 'Pérdida de SL',
    roe: 'ROE',

    title: 'Depósito exitoso',
    text: '¡Tu depósito ha sido procesado con éxito!',
    title: 'Depósito fallido',
    text: 'Tu depósito no ha sido procesado.',

    marketWatch: 'Observación de mercado',
    search: 'Buscar...',

    commission: 'Comisión',
    volume: 'Volumen',
    margin: 'Margen',
    active: 'Activo',
    pending: 'Pendiente',
    activeOrders: 'Órdenes activas',
    portfolio: 'Cartera',
    allPositions: 'Todas las posiciones',
    noPositionsLine1: 'No tienes posiciones',
    noPositionsLine2: 'aún',
    show: 'Mostrar',
    more: 'Más',
    less: 'Menos',
    purchaseTime: 'Hora de compra',
    closePosition: 'Cerrar posición',
    priceOpen: 'Precio de compra',
    priceSl: 'Precio de Stop Loss',
    priceTp: 'Precio de Take Profit',
    type: 'Dirección de la posición',
    pnl: 'Ganancia/Pérdida',
    cancelOrder: 'Cancelar orden',
    orderType: 'Tipo de orden',
    cancelled: 'Cancelado',
    tradingHistory: 'Historial de operaciones',
    noHistoryLine1: 'No tienes ningún',
    noHistoryLine2: 'acuerdo cerrado aún',

    economicCalendar: 'Calendario económico',
    marketNews: 'Noticias del mercado',
    ordersActive: 'Órdenes activas',
    ordersHistory: 'Historial de órdenes',
    id: 'ID',
    symbol: 'Símbolo',
    documentType: 'Tipo',
    volume: 'Volumen',
    openPrice: 'Precio de apertura',
    openTime: 'Hora de apertura',
    closePrice: 'Precio de cierre',
    closeTime: 'Hora de cierre',
    sl: 'SL',
    tp: 'TP',
    price: 'Precio',
    pnl: 'PnL',
    actions: 'Acciones',
    edit: 'Editar',
    close: 'Cerrar',
    commission: 'Comisión',
    swap: 'Swap',
    swapLong: 'Swap largo',
    swapShort: 'Swap corto',

    assetInfo: 'Información del activo',
    tradingConditions: 'Condiciones de trading',
    information: 'Cambio de sesión',
    bid: 'Precio de compra',
    ask: 'Precio de venta',
    sessionChange: 'Cambio de sesión',
    tradeNow: 'Operar ahora',
    opens: 'Abre',
    closes: 'Cierra',
    at: 'a las',
    open247: 'Abierto 24/7',
    today: 'hoy',
    tomorrow: 'mañana',
    sunday: 'domingo',
    monday: 'lunes',
    tuesday: 'martes',
    wednesday: 'miércoles',
    thursday: 'jueves',
    friday: 'viernes',
    saturday: 'sábado',
    contractSpecification: 'Especificación del contrato',
    symbol: 'Símbolo',
    name: 'Nombre',
    market: 'Mercado',
    baseCurrency: 'Moneda base',
    digits: 'Decimales',
    lotSize: 'Tamaño de lote',
    lotStep: 'Incremento de lote',
    minVolume: 'Volumen mínimo',
    maxVolume: 'Volumen máximo',
    leverage: 'Apalancamiento',
    commission: 'Comisión',
    swapLong: 'Swap largo',
    swapShort: 'Swap corto',
    schedule: 'Horario',
    weekday: 'Día de la semana',
    tradingTime: 'Horario de trading',
    closed: 'cerrado',
    sell: 'Vender',
    buy: 'Comprar',
    low: 'Mínimo',
    high: 'Máximo',
    oneHourChange: 'Cambio 1 h',
    oneDayChange: 'Cambio 1 día',
    oneWeekChange: 'Cambio 1 semana',
    oneMonthChange: 'Cambio 1 mes',
    threeMonthsChange: 'Cambio 3 meses',
    oneYearChange: 'Cambio 1 año',
    loading: 'Cargando...',

    traderTitle: 'Comerciante de automóviles',
    traderConfirm: 'Confirmar y guardar',
    riskLevelLow: 'Nivel de riesgo:',
    riskLevelMedium: 'Nivel de riesgo: Medio',
    riskLevelHigh: 'Nivel de riesgo: Alto',
    perDay: 'Operaciones por día:',
    desc: `El trading de CFDs y otros productos apalancados puede generar pérdidas. Antes de operar, los clientes deben
leer las declaraciones de riesgos relevantes en nuestra página de Divulgación de Riesgos. El trading automatizado
no garantiza resultados. La empresa no asume responsabilidad por la pérdida de fondos en el trading automático.
Asegúrate de comprender completamente los riesgos y de tomar medidas para gestionarlos.`,
    accept: 'Aceptar',

    trade: 'Operar',
    startTrading: 'Comenzar a operar',
    deposit: 'Depósito',
    dashboard: 'Panel',
    personalInfo: 'Información personal',
    withdrawal: 'Retiro',
    verification: 'Verificación',
    accounts: 'Cuentas',
    liveChat: 'Chat en vivo',
    savings: 'Ahorros',
    settings: 'Ajustes',
    logOut: 'Cerrar sesión',

    methods: 'MÉTODOS',
    confirm: 'Confirma en la aplicación de tu banco',
    sendOtp: 'Enviar OTP',
    otpCode: 'Código OTP',
    addWalletAddress:
      'La cartera para este método de depósito no está configurada. Contacta con tu agente o con soporte.',
    addressReceipt: 'Por favor espera a que se cargue la dirección',
    makeDeposit: 'REALIZAR DEPÓSITO',
    instant: 'Instantáneo',
    minutes: 'minutos',
    hours: 'horas',
    days: 'días',
    amount: 'Cantidad',
    continue: 'Continuar',
    qrCode: 'CÓDIGO QR',
    depositAddress: 'DIRECCIÓN DE DEPÓSITO',
    copy: 'Copiar',
    last: 'ÚLTIMO',
    deposits: 'DEPÓSITOS',
    time: 'Hora',
    currency: 'Moneda',
    status: 'Estado',
    info: 'Info',

    pleaseWait: 'Por favor espera. Conectando con el proveedor de pago...',
    cardPayment: 'Pago con tarjeta',
    inOrder: 'Para enviar el importe',
    pleaseProvide: 'por favor proporciona los datos de la tarjeta:',

    completeVerification: 'Por favor completa la verificación',
    noOrderYet: 'No hay pedidos aún',
    totalBalance: 'Saldo total',
    totalDeposits: 'Depósitos totales',
    profitableOrders: 'Operaciones rentables',
    totalPnl: 'PNL total',
    roi: 'ROI',
    activityLog: 'Registro de actividad',
    loginFromIp: 'Inicio desde IP',
    tradingResults: 'Resultados de trading',
    week: 'Semana',
    month: 'Mes',
    year: 'Año',
    successRate: 'Tasa de éxito',
    closedWithProfit: 'Cerradas con ganancia',
    closedWithLoss: 'Cerradas con pérdida',
    account: 'Cuenta',
    balance: 'Saldo',
    leverage: 'Apalancamiento',
    credit: 'Crédito',
    tradeNow: 'Operar ahora',
    usingCurrentRate: 'usando tasa de cambio actual',

    personalDetails: 'Detalles personales',
    profilePhoto: 'Foto de perfil',
    firstName: 'Nombre',
    country: 'País',
    lastName: 'Apellido',
    address: 'Dirección',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    saveChanges: 'Guardar cambios',

    dropFile: 'Arrastra un archivo al círculo de arriba para subirlo',
    notAllowed: 'No está permitido publicar',
    notAllowedLine1: 'Fotos de naturaleza explícita sexual o pornográfica',
    notAllowedLine2: 'Imágenes que inciten odio étnico o racial',
    notAllowedLine3: 'Fotos con menores de 18 años',
    notAllowedLine4: 'Fotos protegidas por derechos de autor de terceros',
    notAllowedLine5:
      'Imágenes mayores de 5 MB o en formato distinto de JPG, GIF o PNG',
    requirements:
      'Tu rostro debe ser claramente visible en la foto. Todas las fotos y vídeos subidos deben cumplir estos requisitos, de lo contrario podrán ser eliminados.',

    withdrawalOff: 'Contacta con tu gestor de cuenta para detalles de retiro',
    cryptocurrency: 'Criptomoneda',
    withdrawal: 'Retiro',
    requestNewWithdrawal: 'SOLICITAR NUEVO RETIRO',
    amount: 'Cantidad',
    currentBalance: 'El saldo actual de tu cuenta es',
    withdrawAll: 'Retirar todo',
    requestWithdrawal: 'Solicitar retiro',
    last: 'ÚLTIMO',
    withdrawalRequests: 'SOLICITUDES DE RETIRO',
    time: 'Hora',
    currency: 'Moneda',
    info: 'Info',
    status: 'Estado',
    bank: 'Banco',
    bitcoin: 'Bitcoin',
    card: 'Tarjeta',
    ethereum: 'Ethereum',
    eth: 'Ethereum',
    usdt: 'USDT',
    withdrawalDetails: 'Detalles de retiro',
    address: 'Dirección de cartera',
    bankAccount: 'Número de cuenta',
    bankHolder: 'Nombre del titular',
    bankIban: 'IBAN',
    bankSwift: 'Código SWIFT',
    cardNumber: 'Número de tarjeta',
    cardHolder: 'Nombre del titular',

    dragAndDrop: 'arrastra y suelta el documento en esta área',
    documentsList: 'LISTA DE DOCUMENTOS SUBIDOS',
    document: 'Documento',
    timeUploaded: 'Hora de subida',
    timeProcessed: 'Hora de procesamiento',
    status: 'Estado',
    types: [
      'Prueba de identidad',
      'Prueba de residencia',
      'Anverso de tarjeta',
      'Reverso de tarjeta',
      'Reverso de prueba de identidad',
      'Selfie',
    ],
    types2: [
      'Prueba de identificación',
      'Prueba de dirección',
      'Anverso de tarjeta de crédito',
      'Reverso de tarjeta de crédito',
      'Reverso de identificación',
      'Selfie con ID',
    ],
    upload: 'Subir',
    isConfirmed: 'está confirmado',
    uploadAnotherDocument: 'Subir otro documento',
    isUnderReview: 'está en revisión',
    questionnaire: 'Cuestionario',
    sendAnswers: 'Enviar respuestas',
    progressBarOf: 'de',
    progressBarText: 'de tus documentos han sido subidos y confirmados',

    manageAccounts: 'Transferir fondos entre tus cuentas',
    transferFrom: 'Desde cuenta',
    transferTo: 'A cuenta',
    amount: 'Cantidad',
    makeTransfer: 'Realizar transferencia',
    yourAccounts: 'Tus cuentas',
    account: 'Cuenta',
    currency: 'Moneda',
    balance: 'Saldo',
    credit: 'Crédito',
    makeActive: 'Activar',
    active: 'Activo',

    sendMessage: 'Enviar mensaje',

    pct_0: 'Flexible',
    pct_30: 'Bloqueado 1 mes',
    pct_90: 'Bloqueado 1 trimestre',
    pct_180: 'Bloqueado 6 meses',
    pct_365: 'Bloqueado 1 año',
    savings: 'Ahorros',
    detailedInformation: 'Información detallada',
    pleaseSelect: 'Selecciona una moneda y un período',
    openSavings: 'Abrir ahorros',
    currentTime: 'Hora actual',
    releaseTime: 'Hora de liberación',
    currencyChosen: 'Moneda seleccionada',
    periodChosen: 'Período seleccionado',
    yourRate: 'Tu tasa',
    yourEarnings: 'Tus ganancias',
    accountFrom: 'Cuenta de origen',
    enterAmount: 'Introduce cantidad',
    in: 'Es',
    openAndInvest: 'Abrir ahorros e invertir',
    investment: 'Inversión',
    period: 'Período',
    daysTotal: 'Días totales',
    finalEarnings: 'Ganancias finales',
    created: 'Creado',
    daysElapsed: 'Días transcurridos',
    days: 'días',
    earnings: 'Ganancias',
    fundsReleasedIn: 'Fondos liberados en',
    claim: 'Reclamar',

    updatePassword: 'ACTUALIZAR CONTRASEÑA',
    currentPassword: 'Contraseña actual',
    newPassword: 'Nueva contraseña',
    changePassword: 'Cambiar contraseña',
    activationForGoogle: 'Código de activación para Google Authenticator',
    activateAndEnter: 'Activa Authenticator e introduce el código generado',
    qrCode: 'Código QR',
    activateProtection: 'Activar protección 2FA',
    protectionActive: 'Protección 2FA activa',
    twoFactorCode: 'Código 2FA',
    disableProtection: 'Desactivar protección 2FA',
    language: 'Idioma',
    dashboardCurrency: 'Moneda del panel',
    confirmNewPassword: 'Confirmar nueva contraseña',

    yourLink: 'TU ENLACE DE REFERENCIA',
    referredFriends: 'AMIGOS REFERIDOS',
    id: 'ID',
    name: 'Nombre',
    registered: 'Registrado',
    level: 'Nivel',
    payout: 'Pago',
    lastPayouts: 'ÚLTIMOS PAGOS DE REFERENCIA',
    time: 'Hora',
    amount: 'Cantidad',
    currency: 'Moneda',
    info: 'Info',

    Jan: 'Ene',
    Feb: 'Feb',
    Mar: 'Mar',
    Apr: 'Abr',
    May: 'May',
    Jun: 'Jun',
    Jul: 'Jul',
    Aug: 'Ago',
    Sep: 'Sep',
    Oct: 'Oct',
    Nov: 'Nov',
    Dec: 'Dic',

    orderTypes: [
      'Comprar',
      'Vender',
      'Buy Limit',
      'Sell Limit',
      'Buy Stop',
      'Sell Stop',
    ],
    statuses: ['Pendiente', 'Aprobado', 'Rechazado', 'En proceso'],
    NOT_FOUND: 'Error de solicitud',
    FORBIDDEN: 'Acceso denegado. Por favor, inicie sesión de nuevo',
    SERVER_ERROR: 'Acción fallida. Por favor, inténtelo más tarde',
    INVALID_ACCOUNT: 'Sesión expirada. Por favor, inicie sesión de nuevo',
    INVALID_EMAIL: 'Dirección de correo inválida',
    INVALID_PHONE: 'Número de teléfono inválido',
    INVALID_COUNTRY: 'País inválido',
    INVALID_LOGIN: 'Credenciales de inicio de sesión inválidas',
    USER_BLOCKED: 'Cuenta bloqueada. Por favor, contacte con soporte',
    USER_REGISTERED:
      'Usuario con el correo o teléfono ingresado ya está registrado',
    INVALID_USER: 'Usuario no encontrado',
    REJECTED: 'Operación no permitida por restricciones de la plataforma',
    INVALID_OLD_PASSWORD: 'Contraseña antigua inválida',
    INVALID_SYMBOL: 'Símbolo de trading inválido',
    INVALID_SYMBOL_PRECISION: 'Precisión de símbolo inválida',
    INVALID_FRAME: 'Marco de gráfico inválido',
    INVALID_CURRENCY: 'Moneda inválida',
    INVALID_PRODUCT: 'Tipo de cuenta de trading inválido',
    INSUFFICIENT_FUNDS: 'Fondos insuficientes',
    INVALID_WITHDRAWAL: 'Retiro no encontrado',
    INVALID_STATUS: 'Estado inválido',
    INVALID_FILE: 'Extensión de archivo inválida o archivo demasiado grande',
    INVALID_DOCUMENT: 'Documento no encontrado',
    INVALID_NAME: 'Nombre inválido',
    INVALID_LOT_SIZE: 'Tamaño de lote inválido',
    INVALID_LOT_STEP: 'Incremento de lote inválido',
    INVALID_MIN_VOLUME: 'Volumen mínimo inválido',
    INVALID_MAX_VOLUME: 'Volumen máximo inválido',
    INVALID_GROUP: 'Grupo inválido',
    INVALID_SPREAD: 'Spread inválido',
    REQUEST_TIMEOUT:
      'Tiempo de solicitud agotado. Por favor, inténtelo más tarde',
    INVALID_TYPE: 'Tipo de orden inválido',
    INVALID_VOLUME: 'Volumen de orden inválido',
    INVALID_SL: 'Valor de stop loss inválido',
    INVALID_TP: 'Valor de take profit inválido',
    INVALID_PRICE: 'Precio de orden inválido',
    INVALID_EXPIRATION: 'Expiración de orden inválida',
    NOT_ENOUGH_MARGIN: 'Margen insuficiente',
    INVALID_ORDER: 'Orden no encontrada',
    MARKET_CLOSED: 'Trading no disponible. Por favor, inténtelo más tarde',
    INVALID_BALANCE_TYPE: 'Tipo de operación de saldo inválido',
    INVALID_HASH: 'Hash inválido',
    HASH_EXPIRED:
      'El enlace para restablecer contraseña ha expirado. Por favor, solicite uno nuevo',
    INVALID_CODE: 'Código 2FA inválido',
    CHAT_DISABLED: 'Acceso al chat de soporte cerrado',
    WITHDRAWAL_NOT_ALLOWED: 'Acceso a retiros cerrado',
    TRADING_DISABLED: 'Trading deshabilitado para la cuenta actual',
    PENDING_DEPOSITS_LIMIT: 'Límite de depósitos excedido',
    LOCAL_ONE_PENDING_WITHDRAWAL: 'Solo se permite un retiro pendiente',
    LOCAL_DEPOSIT_ONLY_REAL:
      'El depósito está disponible solo para cuenta real',
    LOCAL_DEPOSIT_POSITIVE: 'La cantidad de depósito debe ser mayor que 0',
    LOCAL_INVALID_CARD_NUMBER: 'Número de tarjeta inválido',
    LOCAL_INVALID_CARD_EXPIRATION: 'Fecha de expiración de tarjeta inválida',
    LOCAL_INVALID_CVC: 'Código CVV/CVC inválido',
    LOCAL_PASSWORDS_NOT_MATCH:
      'Las contraseñas no coinciden, por favor reingréselas',
    LOCAL_NO_TRADING_ACCOUNTS:
      'No tienes cuentas de trading disponibles. Por favor, contacta con soporte',
    LOCAL_MIN_DEPOSIT: 'El depósito mínimo es $',
    LOCAL_MIN_WITHDRAWAL: 'La cantidad mínima de retiro es $',
    LOCAL_INVALID_FILE_TYPE:
      'Formato de archivo no soportado. Adjunte sólo JPG, PNG o PDF',
    LOCAL_MIN_STAKING: 'El depósito mínimo para esta moneda es ',
    FLOOD_REJECTED:
      'Estás enviando mensajes muy rápido. Por favor, inténtalo más tarde',
    countries: {
      AF: 'Afganistán',
      AX: 'Islas Åland',
      AL: 'Albania',
      DZ: 'Argelia',
      AS: 'Samoa Americana',
      AD: 'Andorra',
      AO: 'Angola',
      AI: 'Anguilla',
      AQ: 'Antártida',
      AG: 'Antigua y Barbuda',
      AR: 'Argentina',
      AM: 'Armenia',
      AW: 'Aruba',
      AU: 'Australia',
      AT: 'Austria',
      AZ: 'Azerbaiyán',
      BS: 'Bahamas',
      BH: 'Baréin',
      BD: 'Bangladés',
      BB: 'Barbados',
      BY: 'Bielorrusia',
      BE: 'Bélgica',
      BZ: 'Belice',
      BJ: 'Benín',
      BM: 'Bermudas',
      BT: 'Bután',
      BO: 'Bolivia',
      BA: 'Bosnia y Herzegovina',
      BW: 'Botsuana',
      BV: 'Isla Bouvet',
      BR: 'Brasil',
      IO: 'Territorio Británico del Océano Índico',
      BN: 'Brunéi',
      BG: 'Bulgaria',
      BF: 'Burkina Faso',
      BI: 'Burundi',
      KH: 'Camboya',
      CM: 'Camerún',
      CA: 'Canadá',
      CV: 'Cabo Verde',
      KY: 'Islas Caimán',
      CF: 'República Centroafricana',
      TD: 'Chad',
      CL: 'Chile',
      CN: 'China',
      CX: 'Isla Christmas',
      CC: 'Islas Cocos (Keeling)',
      CO: 'Colombia',
      KM: 'Comoras',
      CG: 'Congo',
      CD: 'República Democrática del Congo',
      CK: 'Islas Cook',
      CR: 'Costa Rica',
      CI: 'Costa de Marfil',
      HR: 'Croacia',
      CU: 'Cuba',
      CY: 'Chipre',
      CZ: 'República Checa',
      DK: 'Dinamarca',
      DJ: 'Yibuti',
      DM: 'Dominica',
      DO: 'República Dominicana',
      EC: 'Ecuador',
      EG: 'Egipto',
      SV: 'El Salvador',
      GQ: 'Guinea Ecuatorial',
      ER: 'Eritrea',
      EE: 'Estonia',
      ET: 'Etiopía',
      FK: 'Islas Malvinas',
      FO: 'Islas Feroe',
      FJ: 'Fiyi',
      FI: 'Finlandia',
      FR: 'Francia',
      GF: 'Guayana Francesa',
      PF: 'Polinesia Francesa',
      TF: 'Territorios Australes Franceses',
      GA: 'Gabón',
      GM: 'Gambia',
      GE: 'Georgia',
      DE: 'Alemania',
      GH: 'Ghana',
      GI: 'Gibraltar',
      GR: 'Grecia',
      GL: 'Groenlandia',
      GD: 'Granada',
      GP: 'Guadalupe',
      GU: 'Guam',
      GT: 'Guatemala',
      GG: 'Guernsey',
      GN: 'Guinea',
      GW: 'Guinea-Bisáu',
      GY: 'Guyana',
      HT: 'Haití',
      HM: 'Islas Heard y McDonald',
      VA: 'Santa Sede (Ciudad del Vaticano)',
      HN: 'Honduras',
      HK: 'Hong Kong',
      HU: 'Hungría',
      IS: 'Islandia',
      IN: 'India',
      ID: 'Indonesia',
      IR: 'Irán',
      IQ: 'Iraq',
      IE: 'Irlanda',
      IM: 'Isla de Man',
      IL: 'Israel',
      IT: 'Italia',
      JM: 'Jamaica',
      JP: 'Japón',
      JE: 'Jersey',
      JO: 'Jordania',
      KZ: 'Kazajistán',
      KE: 'Kenia',
      KI: 'Kiribati',
      KR: 'Corea',
      KW: 'Kuwait',
      KG: 'Kirguistán',
      LA: 'República Democrática Popular Lao',
      LV: 'Letonia',
      LB: 'Líbano',
      LS: 'Lesoto',
      LR: 'Liberia',
      LY: 'Jamahiriya Árabe Libia',
      LI: 'Liechtenstein',
      LT: 'Lituania',
      LU: 'Luxemburgo',
      MO: 'Macao',
      MK: 'Macedonia',
      MG: 'Madagascar',
      MW: 'Malaui',
      MY: 'Malasia',
      MV: 'Maldivas',
      ML: 'Malí',
      MT: 'Malta',
      MH: 'Islas Marshall',
      MQ: 'Martinica',
      MR: 'Mauritania',
      MU: 'Mauricio',
      YT: 'Mayotte',
      MX: 'México',
      FM: 'Micronesia',
      MD: 'Moldavia',
      MC: 'Mónaco',
      MN: 'Mongolia',
      ME: 'Montenegro',
      MS: 'Montserrat',
      MA: 'Marruecos',
      MZ: 'Mozambique',
      MM: 'Myanmar',
      NA: 'Namibia',
      NR: 'Nauru',
      NP: 'Nepal',
      NL: 'Países Bajos',
      AN: 'Antillas Neerlandesas',
      NC: 'Nueva Caledonia',
      NZ: 'Nueva Zelanda',
      NI: 'Nicaragua',
      NE: 'Níger',
      NG: 'Nigeria',
      NU: 'Niue',
      NF: 'Isla Norfolk',
      MP: 'Islas Marianas del Norte',
      NO: 'Noruega',
      OM: 'Omán',
      PK: 'Pakistán',
      PW: 'Palaos',
      PS: 'Territorio Palestino Ocupado',
      PA: 'Panamá',
      PG: 'Papúa Nueva Guinea',
      PY: 'Paraguay',
      PE: 'Perú',
      PH: 'Filipinas',
      PN: 'Islas Pitcairn',
      PL: 'Polonia',
      PT: 'Portugal',
      PR: 'Puerto Rico',
      QA: 'Catar',
      RE: 'Reunión',
      RO: 'Rumania',
      RU: 'Rusia',
      RW: 'Ruanda',
      BL: 'San Bartolomé',
      SH: 'Santa Elena',
      KN: 'San Cristóbal y Nieves',
      LC: 'Santa Lucía',
      MF: 'San Martín',
      PM: 'San Pedro y Miquelón',
      VC: 'San Vicente y las Granadinas',
      WS: 'Samoa',
      SM: 'San Marino',
      ST: 'Santo Tomé y Príncipe',
      SA: 'Arabia Saudita',
      SN: 'Senegal',
      RS: 'Serbia',
      SC: 'Seychelles',
      SL: 'Sierra Leona',
      SG: 'Singapur',
      SK: 'Eslovaquia',
      SI: 'Eslovenia',
      SB: 'Islas Salomón',
      SO: 'Somalia',
      ZA: 'Sudáfrica',
      GS: 'Islas Georgias del Sur y Sandwich del Sur',
      ES: 'España',
      LK: 'Sri Lanka',
      SD: 'Sudán',
      SR: 'Surinam',
      SJ: 'Svalbard y Jan Mayen',
      SZ: 'Suazilandia',
      SE: 'Suecia',
      CH: 'Suiza',
      SY: 'República Árabe Siria',
      TJ: 'Tajikistan',
      TW: 'Taiwan',
      TZ: 'Tanzania',
      TH: 'Thailand',
      TL: 'Timor-Leste',
      TG: 'Togo',
      TK: 'Tokelau',
      TO: 'Tonga',
      TT: 'Trinidad And Tobago',
      TN: 'Tunisia',
      TR: 'Turkey',
      TM: 'Turkmenistan',
      TC: 'Turks And Caicos Islands',
      TV: 'Tuvalu',
      UG: 'Uganda',
      UA: 'Ukraine',
      AE: 'United Arab Emirates',
      GB: 'United Kingdom',
      US: 'United States',
      UM: 'United States Outlying Islands',
      UY: 'Uruguay',
      UZ: 'Uzbekistan',
      VU: 'Vanuatu',
      VE: 'Venezuela',
      VN: 'Viet Nam',
      VG: 'Virgin Islands, British',
      VI: 'Virgin Islands, U.S.',
      WF: 'Wallis And Futuna',
      EH: 'Western Sahara',
      YE: 'Yemen',
      ZM: 'Zambia',
      ZW: 'Zimbabwe',
    },
  },
  it: {
    _name: 'Italiano',
    policy: 'Informativa sulla privacy',
    policyAML: 'Politica AML',
    policyKYC: 'Politica KYC',
    locense: 'Licenza',
    view_all: 'Vedi tutto',
    sell_btn: 'Vendi',
    buy_btn: 'Acquista',
    currency_action: 'valuta',

    importantAccountDetails: 'Dettagli importanti del conto',
    viewAdditionalSettings: 'Visualizza impostazioni aggiuntive',
    switchDarkMode: 'Passa modalità scura/chiara',
    writeProblem: 'Descrivi il tuo problema',
    darkMode: 'Modalità scura',

    yay: 'Evviva',
    purchased: 'Hai acquistato con successo',
    from: 'da',
    walet: 'Portafoglio',
    trade: 'Operazione',

    withdrawDetails: 'Dettagli prelievo',
    saveDetails: 'Salva dettagli per la prossima volta',
    amountToWithdraw: 'Importo da prelevare',
    withdrawLimit: 'Limite giornaliero di prelievo rimanente: $1.000.000,00',

    serviceFee: 'Commissione di servizio',
    youWillPay: 'Pagherai',
    cancel: 'Annulla',
    understand: 'Ho capito, continua',

    select: 'Seleziona',
    enterAmount: 'Inserisci importo',
    orderInfo: 'Informazioni ordine',
    confirmOrder: 'Conferma ordine',
    get: 'Ricevi',
    spend: 'Spendi',
    buying: 'Acquisto',
    accountTransactions: 'Transazioni del conto',
    overview: 'Panoramica',
    accountBalances: 'Saldo del conto',
    details: 'Dettagli',
    loginHistory: 'Cronologia accessi',
    device: 'Dispositivo',
    contactUs: 'Contattaci',
    sessionLog: 'Sessioni e cronologia accessi',
    selectMethods: 'Seleziona metodi',
    depositDetails: 'Dettagli deposito',
    order: 'Ordine',
    support: 'Supporto',
    supportChat: 'Chat di supporto',
    createChat: 'Crea chat',
    homepage: 'Home',
    takeProfitStopLoss: 'Take Profit e Stop Loss',
    takeProfit: 'Take Profit',
    stopLoss: 'Stop Loss',
    updateOrder: 'Aggiorna ordine',
    balance: 'Saldo',
    credit: 'Credito',
    equity: 'Patrimonio',
    practice: 'DEMO',
    real: 'REALE',
    account: 'CONTO',
    invested: 'Investito',
    profit: 'Profitto',
    loss: 'Perdita',
    margin: 'Margine',
    marginLevel: 'Livello margine',
    marginFree: 'Margine libero',
    cfd: 'CFD',
    platform: 'Piattaforma',
    deposit: 'Deposita',
    marketWatch: 'Market Watch',
    activeOrders: 'Ordini aperti',
    tradingHistory: 'Cronologia operazioni',
    economicCalendar: 'Calendario economico',
    marketNews: 'Notizie di mercato',
    closeOrder: 'Chiudi posizione',
    areYouSure: 'Sei sicuro di voler chiudere la posizione',
    buy: 'Acquista',
    sell: 'Vendi',
    yes: 'Sì',
    no: 'No',
    addNewChart: 'Aggiungi nuovo grafico',
    watchlist: 'Lista di osservazione',
    asset: 'Attività',
    price: 'Prezzo',
    changePct: 'Variazione 24h',
    pending: 'In sospeso',
    assetPrice: 'Prezzo attività',
    current: 'Corrente',
    revert: 'Ripristina prezzo di mercato',
    automatically:
      'La posizione si aprirà automaticamente quando il prezzo raggiunge questo livello',
    default: 'predefinito',
    volume: 'Volume',
    lots: 'Lotti',
    units: 'Unità',
    currency: 'Valuta',
    contractSize: 'Dimensione contratto',
    position: 'Posizione',
    freeMargin: 'Margine libero',
    market: 'Mercato',
    leverage: 'Leva',
    spread: 'Spread',
    notSet: 'Non impostato',
    at: 'a',
    supportBanner: 'OGNI GIORNO, 24 ORE SU 24',
    currentTime: 'ORA ATTUALE',
    liveChat: 'Chat Live',
    pnl: 'PnL',
    profitTotal: 'PnL totale',
    dateRegistered: 'Data di registrazione',
    userId: 'ID utente',
    dashboard: 'Dashboard',
    personalData: 'Dati personali',
    withdrawFunds: 'Preleva fondi',
    savings: 'Risparmi',
    settings: 'Impostazioni',
    logout: 'Esci',
    BT_INVOICE: 'Inserisci importo e genera fattura',
    BT_TITLE: 'I nostri dati bancari',
    account: 'Account',
    bank_name: 'Nome banca',
    beneficiary: 'Beneficiario',
    beneficiary_address: 'Indirizzo beneficiario',
    swift: 'SWIFT',
    iban: 'IBAN',
    ru_inn: 'INN',
    ru_kpp: 'KPP',
    corresponding_account: 'Conto corrispondente',
    TOKEN_AMOUNT: 'Importo',
    TOKEN_SUBTOTAL: 'Subtotale',
    TOKEN_TOTAL: 'Totale',
    TOKEN_DESCRIPTION: 'Descrizione',
    TOKEN_PAYMENT_DETAILS: 'Dettagli pagamento',
    PENDING_DEPOSITS_LIMIT: 'Limite deposito',
    makeDeposit: 'Effettua un deposito',
    practiceAccount: 'Conto demo',
    realAccount: 'Conto reale',
    noWithdrawals: 'Nessun prelievo',
    easyWithdrawals: 'Prelievi facili',
    allAssets: 'Tutti gli asset disponibili',
    fullFledged: 'Piattaforma completa',
    fillUpTo: 'Ricarica fino a',
    freeReplenishment: 'Ricarica gratuita',
    topUp: 'Ricarica il tuo conto',
    minimumAmount: 'Importo minimo',
    maxAmount: 'Importo massimo',
    withdrawalType: 'Tipo di prelievo',
    canSwitch: 'Puoi passare tra i tuoi conti in qualsiasi momento',
    chartGrids: 'Griglie grafico',
    chart1: '1 grafico',
    chart2: '2 grafici',
    chart3: '3 grafici',
    chart4: '4 grafici',
    connectionLost: 'Connessione al server persa',
    retryNow: 'Riprova ora',
    loginToTradeRoom: 'Accedi alla traderoom',
    email: 'Indirizzo email',
    enterEmail: 'Inserisci la tua email',
    twoFactor: 'Codice 2FA (se abilitato)',
    twoFactorAuth: 'Autenticazione a due fattori',
    password: 'Password',
    yourPassword: 'La tua password',
    signIn: 'Accedi',
    dontHaveAccount: 'Non hai un account?',
    restore: 'Ripristina',
    fullName: 'Nome e cognome',
    havePromo: 'Ho un codice promozionale',
    promo: 'Codice promozionale',
    login: 'Accedi',
    haveAccount: 'Hai già un account?',
    hide: 'Nascondi',
    goTo: 'Torna indietro',
    setNewPassword: 'Imposta nuova password',
    newPassword: 'Nuova password',
    confirmNewPassword: 'Conferma nuova password',
    setButton: 'Imposta',
    repeatPassword: 'Ripeti password',
    createNewAccount: 'Crea un nuovo account',
    firstName: 'Nome',
    lastName: 'Cognome',
    country: 'Paese',
    phone: 'Telefono',
    createAccount: 'Crea account',
    forgotPassword: 'Password dimenticata?',
    submitEmail:
      "Inserisci l'email usata per la registrazione, controlla la posta e segui le istruzioni",
    submit: 'Invia',
    error: 'Errore',
    success: 'Successo',
    withdrawal: 'Prelievo',
    depositApproved: 'Deposito approvato',
    depositDeclined: 'Deposito rifiutato',
    withdrawalApproved: 'Prelievo approvato',
    withdrawalDeclined: 'Prelievo rifiutato',
    forex: 'Forex',
    stocks: 'Azioni',
    commodities: 'Materie prime',
    indices: 'Indici',
    crypto: 'Crypto',
    metals: 'Metalli',
    nft: 'NFT',
    profitCalculator: 'Calcolatore di profitto',
    entryPrice: 'Prezzo di entrata',
    takeProfit: 'Take Profit',
    stopLoss: 'Stop Loss',
    maxPosition: 'Posizione massima',
    calculate: 'Calcola',
    calculationsFor: 'Calcoli per',
    requiredMargin: 'Margine richiesto',
    profitFromTP: 'Profitto da TP',
    lossFromSL: 'Perdita da SL',
    roe: 'ROE',
    title: 'Deposito riuscito',
    text: 'Il tuo deposito è stato elaborato con successo!',
    title_fail: 'Deposito non riuscito',
    text_fail: 'Il tuo deposito non è stato elaborato.',
    search: 'Cerca...',

    commission: 'Commissione',
    volume: 'Volume',
    margin: 'Margine',
    active: 'Attivo',
    pending: 'In sospeso',
    activeOrders: 'Ordini attivi',
    portfolio: 'Portafoglio',
    allPositions: 'Tutte le posizioni',
    noPositionsLine1: 'Non hai posizioni aperte',
    noPositionsLine2: 'ancora',
    show: 'Mostra',
    more: 'più',
    less: 'meno',
    purchaseTime: 'Ora di acquisto',
    closePosition: 'Chiudi posizione',
    priceOpen: 'Prezzo di acquisto',
    priceSl: 'Prezzo Stop Loss',
    priceTp: 'Prezzo Take Profit',
    type: 'Direzione posizione',
    pnl: 'Profitto/Perdita',
    cancelOrder: 'Annulla ordine',
    orderType: 'Tipo di ordine',
    cancelled: 'Annullato',
    tradingHistory: 'Cronologia operazioni',
    noHistoryLine1: 'Non hai ancora',
    noHistoryLine2: 'operazioni chiuse',
    economicCalendar: 'Calendario economico',
    marketNews: 'Notizie di mercato',
    ordersActive: 'Ordini attivi',
    ordersHistory: 'Ordini chiusi',
    id: 'ID',
    symbol: 'Simbolo',
    openPrice: 'Prezzo di apertura',
    openTime: 'Ora apertura',
    closePrice: 'Prezzo di chiusura',
    closeTime: 'Ora chiusura',
    sl: 'SL',
    tp: 'TP',
    price: 'Prezzo',
    actions: 'Azioni',
    edit: 'Modifica',
    close: 'Chiudi',
    swap: 'Swap',
    swapLong: 'Swap Long',
    swapShort: 'Swap Short',
    assetInfo: 'Info asset',
    tradingConditions: 'Condizioni di trading',
    information: 'Variazione sessione',
    bid: 'Bid',
    ask: 'Ask',
    sessionChange: 'Variazione sessione',
    tradeNow: 'Trading ora',
    opens: 'Apre',
    closes: 'Chiude',
    at: 'alle',
    open247: 'Aperto 24/7',
    today: 'oggi',
    tomorrow: 'domani',
    sunday: 'Domenica',
    monday: 'Lunedì',
    tuesday: 'Martedì',
    wednesday: 'Mercoledì',
    thursday: 'Giovedì',
    friday: 'Venerdì',
    saturday: 'Sabato',
    contractSpecification: 'Specifiche contratto',
    name: 'Nome',
    market: 'Mercato',
    baseCurrency: 'Valuta base',
    digits: 'Decimali',
    lotSize: 'Dimensione lotto',
    lotStep: 'Step lotto',
    minVolume: 'Volume min',
    maxVolume: 'Volume max',
    leverage: 'Leva',
    schedule: 'Calendario',
    weekday: 'Giorno settimana',
    tradingTime: 'Orario trading',
    closed: 'chiuso',
    sell: 'Vendi',
    buy: 'Acquista',
    low: 'Min',
    medium: 'Medio',
    high: 'Max',
    oneHourChange: 'Variazione 1h',
    oneDayChange: 'Variazione 1g',
    oneWeekChange: 'Variazione 1w',
    oneMonthChange: 'Variazione 1m',
    threeMonthsChange: 'Variazione 3m',
    oneYearChange: 'Variazione 1a',
    loading: 'Caricamento...',
    traderTitle: "L'autotrading",
    traderConfirm: 'Conferma e salva',
    riskLevelLow: 'Livello rischio: ',
    riskLevelMedium: 'Livello rischio: Medio',
    riskLevelHigh: 'Livello rischio: Alto',
    perDay: 'Operazioni al giorno:',
    desc: `Il trading di CFD e altri prodotti con leva può comportare perdite. Prima di fare trading, i clienti dovrebbero
        leggere i relativi avvisi di rischio nella nostra pagina di Informativa sui rischi. Il trading automatico non garantisce risultati.
        La società non si assume responsabilità per la perdita di fondi nel trading automatico. Assicurati di comprendere
        appieno i rischi e di adottare misure di gestione.`,
    accept: 'Accetto',
    trade: 'Operazione',
    startTrading: 'Inizia trading',
    deposit: 'Deposita',
    dashboard: 'Dashboard',
    personalInfo: 'Dati personali',
    withdrawal: 'Prelievo',
    verification: 'Verifica',
    accounts: 'Conti',
    liveChat: 'Chat live',
    savings: 'Risparmi',
    settings: 'Impostazioni',
    logOut: 'Esci',
    methods: 'METODI',
    confirm: 'Conferma in app della tua banca',
    sendOtp: 'Invia OTP',
    otpCode: 'Codice OTP',
    addWalletAddress:
      'Il wallet per questo metodo non è impostato. Contatta il tuo agente o il supporto.',
    addressReceipt: "Attendi il caricamento dell'indirizzo",
    makeDeposit: 'EFFETTUA UN DEPOSITO',
    instant: 'Istantaneo',
    minutes: 'minuti',
    hours: 'ore',
    days: 'giorni',
    amount: 'Importo',
    continue: 'Continua',
    qrCode: 'QR CODE',
    depositAddress: 'INDIRIZZO DI DEPOSITO',
    copy: 'Copia',
    last: 'ULTIMO',
    deposits: 'DEPOSITI',
    time: 'Ora',
    currency: 'Valuta',
    status: 'Stato',
    info: 'Info',
    pleaseWait: 'Attendere. Connessione al provider di pagamento in corso…',
    cardPayment: 'Pagamento con carta',
    inOrder: 'Per inviare l’importo',
    pleaseProvide: 'fornisci i dati della carta:',
    completeVerification: 'Completa la verifica',
    noOrderYet: 'Nessun ordine ancora',
    totalBalance: 'Saldo totale',
    totalDeposits: 'Depositi totali',
    profitableOrders: 'Ordini redditizi',
    totalPnl: 'PNL totale',
    roi: 'ROI',
    activityLog: 'Registro attività',
    loginFromIp: 'Accesso da IP',
    tradingResults: 'Risultati trading',
    week: 'Settimana',
    month: 'Mese',
    year: 'Anno',
    successRate: 'Tasso di successo',
    closedWithProfit: 'Chiuso in profitto',
    closedWithLoss: 'Chiuso in perdita',
    usingCurrentRate: 'usando il tasso di cambio corrente',
    personalDetails: 'Dati personali',
    profilePhoto: 'Foto profilo',
    address: 'Indirizzo',
    email: 'E-mail',
    phone: 'Numero di telefono',
    saveChanges: 'Salva modifiche',
    dropFile: 'Trascina un file nel cerchio sopra per caricare',
    notAllowed: 'Non è consentito pubblicare',
    notAllowedLine1: 'Foto di natura esplicitamente sessuale o pornografica',
    notAllowedLine2: 'Immagini che incitano odio etnico o razziale',
    notAllowedLine3: 'Foto di minori di 18 anni',
    notAllowedLine4: 'Foto coperte da copyright di terzi',
    notAllowedLine5: 'Immagini >5 MB o non JPG/GIF/PNG',
    requirements:
      'Il viso deve essere chiaramente visibile. Tutti i file caricati devono rispettare questi requisiti.',
    withdrawalOff: 'Contatta il tuo account manager per dettagli sul prelievo',
    cryptocurrency: 'Criptovaluta',
    requestNewWithdrawal: 'RICHIEDI NUOVO PRELIEVO',
    withdrawAll: 'Preleva tutto',
    requestWithdrawal: 'Richiedi prelievo',
    withdrawalRequests: 'RICHIESTE DI PRELIEVO',
    bank: 'Banca',
    bitcoin: 'Bitcoin',
    card: 'Carta',
    ethereum: 'Ethereum',
    eth: 'Ethereum',
    usdt: 'USDT',
    withdrawalDetails: 'Dettagli prelievo',
    address: 'Indirizzo wallet',
    bankAccount: 'Numero conto',
    bankHolder: 'Intestatario conto',
    bankIban: 'IBAN',
    bankSwift: 'Codice SWIFT banca',
    cardNumber: 'Numero carta',
    cardHolder: 'Intestatario carta',

    dragAndDrop: "Trascina e rilascia il documento in quest'area",
    documentsList: 'ELENCO DEI DOCUMENTI CARICATI',
    document: 'Documento',
    timeUploaded: 'Ora di caricamento',
    timeProcessed: 'Ora di elaborazione',
    status: 'Stato',
    types: [
      'Prova d’identità',
      'Prova di residenza',
      'Fronte carta di credito',
      'Retro carta di credito',
      'Retro prova d’identità',
      'Selfie',
    ],
    types2: [
      'Prova di identificazione (POI)',
      'Prova di indirizzo di residenza',
      'Fronte carta di credito',
      'Retro carta di credito',
      'Retro prova di identificazione',
      'Selfie con documento',
    ],
    upload: 'Carica',
    isConfirmed: 'è confermato',
    uploadAnotherDocument: 'Carica un altro documento',
    isUnderReview: 'è in revisione',
    questionnaire: 'Questionario',
    sendAnswers: 'Invia risposte',
    progressBarOf: 'di',
    progressBarText: 'dei tuoi documenti sono stati caricati e confermati',

    manageAccounts: 'Trasferisci fondi tra i tuoi conti',
    transferFrom: 'Conto di origine',
    transferTo: 'Conto di destinazione',
    amount: 'Importo',
    makeTransfer: 'Esegui trasferimento',
    yourAccounts: 'I tuoi conti',
    account: 'Conto',
    currency: 'Valuta',
    balance: 'Saldo',
    credit: 'Credito',
    makeActive: 'Rendi attivo',
    active: 'Attivo',

    sendMessage: 'Invia messaggio',

    pct_0: 'Flessibile',
    pct_30: 'Bloccato 1 mese',
    pct_90: 'Bloccato 1 trimestre',
    pct_180: 'Bloccato 6 mesi',
    pct_365: 'Bloccato 1 anno',
    savings: 'Risparmi',
    detailedInformation: 'Informazioni dettagliate',
    pleaseSelect: 'Seleziona valuta e periodo',
    openSavings: 'Apri risparmi',
    currentTime: 'Ora corrente',
    releaseTime: 'Ora di rilascio',
    currencyChosen: 'Valuta scelta',
    periodChosen: 'Periodo scelto',
    yourRate: 'Tuo tasso',
    yourEarnings: 'I tuoi guadagni',
    accountFrom: 'Conto da cui trasferire',
    enterAmount: 'Inserisci importo',
    in: 'In',
    openAndInvest: 'Apri conto risparmi e investi',
    investment: 'Investimento',
    period: 'Periodo',
    daysTotal: 'Giorni totali',
    finalEarnings: 'Guadagni finali',
    created: 'Creato',
    daysElapsed: 'Giorni trascorsi',
    days: 'giorni',
    earnings: 'Guadagni',
    fundsReleasedIn: 'Fondi disponibili in',
    claim: 'Richiedi',

    updatePassword: 'AGGIORNA PASSWORD',
    currentPassword: 'Password corrente',
    newPassword: 'Nuova password',
    changePassword: 'Cambia password',
    activationForGoogle: 'Codice di attivazione per Google Authenticator',
    activateAndEnter: 'Attiva Authenticator e inserisci il codice generato',
    qrCode: 'QR Code',
    activateProtection: 'Attiva protezione 2FA',
    protectionActive: 'Protezione 2FA attiva',
    twoFactorCode: 'Codice 2FA',
    disableProtection: 'Disattiva protezione 2FA',
    language: 'Lingua',
    dashboardCurrency: 'Valuta Dashboard',
    confirmNewPassword: 'Conferma nuova password',

    yourLink: 'IL TUO LINK DI REFERENZA',
    referredFriends: 'AMICI REFERENZIATI',
    id: 'ID',
    name: 'Nome',
    registered: 'Registrato',
    level: 'Livello',
    payout: 'Pagamento',
    lastPayouts: 'ULTIMI PAGAMENTI DI REFERENZA',
    time: 'Ora',
    amount: 'Importo',
    currency: 'Valuta',
    info: 'Info',

    Jan: 'Gen',
    Feb: 'Feb',
    Mar: 'Mar',
    Apr: 'Apr',
    May: 'Mag',
    Jun: 'Giu',
    Jul: 'Lug',
    Aug: 'Ago',
    Sep: 'Set',
    Oct: 'Ott',
    Nov: 'Nov',
    Dec: 'Dic',

    orderTypes: [
      'Acquista',
      'Vendi',
      'Buy Limit',
      'Sell Limit',
      'Buy Stop',
      'Sell Stop',
    ],
    statuses: ['In sospeso', 'Approvato', 'Rifiutato', 'In lavorazione'],

    NOT_FOUND: 'Errore richiesta',
    FORBIDDEN: 'Accesso negato. Effettua nuovamente il login',
    SERVER_ERROR: 'Azione fallita. Riprova più tardi',
    INVALID_ACCOUNT: 'Sessione scaduta. Effettua nuovamente il login',
    INVALID_EMAIL: 'Indirizzo e-mail non valido',
    INVALID_PHONE: 'Numero di telefono non valido',
    INVALID_COUNTRY: 'Paese non valido',
    INVALID_LOGIN: 'Credenziali non valide',
    USER_BLOCKED: 'Account bloccato. Contatta il supporto',
    USER_REGISTERED: 'Utente già registrato con e-mail o telefono inserito',
    INVALID_USER: 'Utente non trovato',
    REJECTED: 'Operazione non consentita per restrizioni di piattaforma',
    INVALID_OLD_PASSWORD: 'Password precedente non valida',
    INVALID_SYMBOL: 'Simbolo di trading non valido',
    INVALID_SYMBOL_PRECISION: 'Precisione del simbolo non valida',
    INVALID_FRAME: 'Intervallo grafico non valido',
    INVALID_CURRENCY: 'Valuta non valida',
    INVALID_PRODUCT: 'Tipo di conto non valido',
    INSUFFICIENT_FUNDS: 'Fondi insufficienti',
    INVALID_WITHDRAWAL: 'Prelievo non trovato',
    INVALID_STATUS: 'Stato non valido',
    INVALID_FILE: 'Estensione file non valida o file troppo grande',
    INVALID_DOCUMENT: 'Documento non trovato',
    INVALID_NAME: 'Nome non valido',
    INVALID_LOT_SIZE: 'Dimensione lotto non valida',
    INVALID_LOT_STEP: 'Step lotto non valido',
    INVALID_MIN_VOLUME: 'Volume minimo non valido',
    INVALID_MAX_VOLUME: 'Volume massimo non valido',
    INVALID_GROUP: 'Gruppo non valido',
    INVALID_SPREAD: 'Spread non valido',
    REQUEST_TIMEOUT: 'Timeout richiesta. Riprova più tardi',
    INVALID_TYPE: 'Tipo di ordine non valido',
    INVALID_VOLUME: 'Volume d’ordine non valido',
    INVALID_SL: 'Valore stop loss non valido',
    INVALID_TP: 'Valore take profit non valido',
    INVALID_PRICE: 'Prezzo d’ordine non valido',
    INVALID_EXPIRATION: 'Scadenza ordine non valida',
    NOT_ENOUGH_MARGIN: 'Margine insufficiente',
    INVALID_ORDER: 'Ordine non trovato',
    MARKET_CLOSED: 'Trading non disponibile. Riprova più tardi',
    INVALID_BALANCE_TYPE: 'Tipo di operazione saldo non valido',
    INVALID_HASH: 'Hash non valido',
    HASH_EXPIRED: 'Link per reset password scaduto. Richiedi uno nuovo',
    INVALID_CODE: 'Codice 2FA non valido',
    CHAT_DISABLED: 'Chat di supporto non disponibile',
    WITHDRAWAL_NOT_ALLOWED: 'Prelievi non consentiti',
    TRADING_DISABLED: 'Trading disabilitato per questo account',
    PENDING_DEPOSITS_LIMIT: 'Limite depositi superato',
    LOCAL_ONE_PENDING_WITHDRAWAL: 'Solo un prelievo in sospeso consentito',
    LOCAL_DEPOSIT_ONLY_REAL: 'Deposito disponibile solo per account reale',
    LOCAL_DEPOSIT_POSITIVE: 'Importo deposito deve essere maggiore di 0',
    LOCAL_INVALID_CARD_NUMBER: 'Numero carta non valido',
    LOCAL_INVALID_CARD_EXPIRATION: 'Scadenza carta non valida',
    LOCAL_INVALID_CVC: 'Codice CVV/CVC non valido',
    LOCAL_PASSWORDS_NOT_MATCH: 'Le password non corrispondono, reinseriscile',
    LOCAL_NO_TRADING_ACCOUNTS:
      'Non hai conti di trading disponibili. Contatta il supporto',
    LOCAL_MIN_DEPOSIT: 'Deposito minimo: $',
    LOCAL_MIN_WITHDRAWAL: 'Prelievo minimo: $',
    LOCAL_INVALID_FILE_TYPE: 'Formato file non supportato. Solo JPG, PNG o PDF',
    LOCAL_MIN_STAKING: 'Deposito minimo per questa valuta: ',
    FLOOD_REJECTED: 'Invio messaggi troppo frequente. Riprova più tardi',

    countries: {
      AF: 'Afghanistan',
      AX: 'Isole Aland',
      AL: 'Albania',
      DZ: 'Algeria',
      AS: 'Samoa Americane',
      AD: 'Andorra',
      AO: 'Angola',
      AI: 'Anguilla',
      AQ: 'Antartide',
      AG: 'Antigua e Barbuda',
      AR: 'Argentina',
      AM: 'Armenia',
      AW: 'Aruba',
      AU: 'Australia',
      AT: 'Austria',
      AZ: 'Azerbaigian',
      BS: 'Bahamas',
      BH: 'Bahrein',
      BD: 'Bangladesh',
      BB: 'Barbados',
      BY: 'Bielorussia',
      BE: 'Belgio',
      BZ: 'Belize',
      BJ: 'Benin',
      BM: 'Bermuda',
      BT: 'Bhutan',
      BO: 'Bolivia',
      BA: 'Bosnia ed Erzegovina',
      BW: 'Botswana',
      BV: 'Isola Bouvet',
      BR: 'Brasile',
      IO: "Territorio britannico dell'Oceano Indiano",
      BN: 'Brunei',
      BG: 'Bulgaria',
      BF: 'Burkina Faso',
      BI: 'Burundi',
      KH: 'Cambogia',
      CM: 'Camerun',
      CA: 'Canada',
      CV: 'Capo Verde',
      KY: 'Isole Cayman',
      CF: 'Repubblica Centrafricana',
      TD: 'Ciad',
      CL: 'Cile',
      CN: 'Cina',
      CX: 'Isola di Natale',
      CC: 'Isole Cocos (Keeling)',
      CO: 'Colombia',
      KM: 'Comore',
      CG: 'Congo',
      CD: 'Congo (RDC)',
      CK: 'Isole Cook',
      CR: 'Costa Rica',
      CI: "Costa d'Avorio",
      HR: 'Croazia',
      CU: 'Cuba',
      CY: 'Cipro',
      CZ: 'Repubblica Ceca',
      DK: 'Danimarca',
      DJ: 'Gibuti',
      DM: 'Dominica',
      DO: 'Repubblica Dominicana',
      EC: 'Ecuador',
      EG: 'Egitto',
      SV: 'El Salvador',
      GQ: 'Guinea Equatoriale',
      ER: 'Eritrea',
      EE: 'Estonia',
      ET: 'Etiopia',
      FK: 'Isole Falkland (Malvine)',
      FO: 'Isole Fær Øer',
      FJ: 'Figi',
      FI: 'Finlandia',
      FR: 'Francia',
      GF: 'Guiana Francese',
      PF: 'Polinesia Francese',
      TF: 'Territori Francesi Meridionali',
      GA: 'Gabon',
      GM: 'Gambia',
      GE: 'Georgia',
      DE: 'Germania',
      GH: 'Ghana',
      GI: 'Gibilterra',
      GR: 'Grecia',
      GL: 'Groenlandia',
      GD: 'Grenada',
      GP: 'Guadalupa',
      GU: 'Guam',
      GT: 'Guatemala',
      GG: 'Guernsey',
      GN: 'Guinea',
      GW: 'Guinea-Bissau',
      GY: 'Guyana',
      HT: 'Haiti',
      HM: 'Isole Heard e McDonald',
      VA: 'Città del Vaticano',
      HN: 'Honduras',
      HK: 'Hong Kong',
      HU: 'Ungheria',
      IS: 'Islanda',
      IN: 'India',
      ID: 'Indonesia',
      IR: 'Iran',
      IQ: 'Iraq',
      IE: 'Irlanda',
      IM: 'Isola di Man',
      IL: 'Israele',
      IT: 'Italia',
      JM: 'Giamaica',
      JP: 'Giappone',
      JE: 'Jersey',
      JO: 'Giordania',
      KZ: 'Kazakistan',
      KE: 'Kenya',
      KI: 'Kiribati',
      KR: 'Corea del Sud',
      KW: 'Kuwait',
      KG: 'Kirgizistan',
      LA: 'Repubblica Democratica Popolare Lao',
      LV: 'Lettonia',
      LB: 'Libano',
      LS: 'Lesotho',
      LR: 'Liberia',
      LY: 'Libia',
      LI: 'Liechtenstein',
      LT: 'Lituania',
      LU: 'Lussemburgo',
      MO: 'Macao',
      MK: 'Macedonia del Nord',
      MG: 'Madagascar',
      MW: 'Malawi',
      MY: 'Malesia',
      MV: 'Maldive',
      ML: 'Mali',
      MT: 'Malta',
      MH: 'Isole Marshall',
      MQ: 'Martinica',
      MR: 'Mauritania',
      MU: 'Mauritius',
      YT: 'Mayotte',
      MX: 'Messico',
      FM: 'Micronesia',
      MD: 'Moldavia',
      MC: 'Monaco',
      MN: 'Mongolia',
      ME: 'Montenegro',
      MS: 'Montserrat',
      MA: 'Marocco',
      MZ: 'Mozambico',
      MM: 'Myanmar',
      NA: 'Namibia',
      NR: 'Nauru',
      NP: 'Nepal',
      NL: 'Paesi Bassi',
      AN: 'Antille Olandesi',
      NC: 'Nuova Caledonia',
      NZ: 'Nuova Zelanda',
      NI: 'Nicaragua',
      NE: 'Niger',
      NG: 'Nigeria',
      NU: 'Niue',
      NF: 'Isola Norfolk',
      MP: 'Isole Marianne Settentrionali',
      NO: 'Norvegia',
      OM: 'Oman',
      PK: 'Pakistan',
      PW: 'Palau',
      PS: 'Territori Palestinesi',
      PA: 'Panama',
      PG: 'Papua Nuova Guinea',
      PY: 'Paraguay',
      PE: 'Perù',
      PH: 'Filippine',
      PN: 'Pitcairn',
      PL: 'Polonia',
      PT: 'Portogallo',
      PR: 'Porto Rico',
      QA: 'Qatar',
      RE: 'Riunione',
      RO: 'Romania',
      RU: 'Russia',
      RW: 'Ruanda',
      BL: 'Saint-Barthélemy',
      SH: 'Sant’Elena',
      KN: 'Saint Kitts e Nevis',
      LC: 'Saint Lucia',
      MF: 'Saint-Martin',
      PM: 'Saint-Pierre e Miquelon',
      VC: 'Saint Vincent e Grenadine',
      WS: 'Samoa',
      SM: 'San Marino',
      ST: 'São Tomé e Príncipe',
      SA: 'Arabia Saudita',
      SN: 'Senegal',
      RS: 'Serbia',
      SC: 'Seychelles',
      SL: 'Sierra Leone',
      SG: 'Singapore',
      SK: 'Slovacchia',
      SI: 'Slovenia',
      SB: 'Isole Solomon',
      SO: 'Somalia',
      ZA: 'Sudafrica',
      GS: 'Georgia del Sud e Sandwich Australi',
      ES: 'Spagna',
      LK: 'Sri Lanka',
      SD: 'Sudan',
      SR: 'Suriname',
      SJ: 'Svalbard e Jan Mayen',
      SZ: 'Eswatini',
      SE: 'Svezia',
      CH: 'Svizzera',
      SY: 'Siria',
      TW: 'Taiwan',
      TJ: 'Tagikistan',
      TZ: 'Tanzania',
      TH: 'Thailandia',
      TL: 'Timor Est',
      TG: 'Togo',
      TK: 'Tokelau',
      TO: 'Tonga',
      TT: 'Trinidad e Tobago',
      TN: 'Tunisia',
      TR: 'Turchia',
      TM: 'Turkmenistan',
      TC: 'Isole Turks e Caicos',
      TV: 'Tuvalu',
      UG: 'Uganda',
      UA: 'Ucraina',
      AE: 'Emirati Arabi Uniti',
      GB: 'Regno Unito',
      US: 'Stati Uniti',
      UM: 'Isole Minori Esterne USA',
      UY: 'Uruguay',
      UZ: 'Uzbekistan',
      VU: 'Vanuatu',
      VE: 'Venezuela',
      VN: 'Vietnam',
      VG: 'Isole Vergini Britanniche',
      VI: 'Isole Vergini USA',
      WF: 'Wallis e Futuna',
      EH: 'Sahara Occidentale',
      YE: 'Yemen',
      ZM: 'Zambia',
      ZW: 'Zimbabwe',
    },
  },
  cz: {
    _name: 'Čeština',
    policy: 'Zásady ochrany osobních údajů',
    policyAML: 'Zásady AML',
    policyKYC: 'Zásady KYC',
    locense: 'Licence',
    view_all: 'Zobrazit vše',
    sell_btn: 'Prodat',
    buy_btn: 'Koupit',
    currency_action: 'měna',

    importantAccountDetails: 'Důležité údaje o účtu',
    viewAdditionalSettings: 'Zobrazit další nastavení',
    switchDarkMode: 'Přepnout tmavý/světlý režim',
    writeProblem: 'Napište nám svůj problém',
    darkMode: 'Tmavý režim',

    yay: 'Hurá',
    purchased: 'Úspěšně jste zakoupili',
    from: 'od',
    walet: 'Peněženka',
    trade: 'Obchod',

    withdrawDetails: 'Podrobnosti o výběru',
    saveDetails: 'Uložit údaje pro příště',
    amountToWithdraw: 'Částka k výběru',
    withdrawLimit: 'Zbývá denní limit výběrů: 1 000 000,00 $',

    serviceFee: 'Poplatek za službu',
    youWillPay: 'Zaplatíte',
    cancel: 'Zrušit',
    understand: 'Rozumím, pokračovat',

    select: 'Vybrat',
    enterAmount: 'Zadejte částku',
    orderInfo: 'Informace o objednávce',
    confirmOrder: 'Potvrdit objednávku',
    get: 'Získat',
    spend: 'Utratit',
    buying: 'Nákup',
    accountTransactions: 'Transakce na účtu',
    overview: 'Přehled',
    accountBalances: 'Zůstatky účtu',
    details: 'Detaily',
    loginHistory: 'Historie přihlášení',
    device: 'Zařízení',
    contactUs: 'Kontaktujte nás',
    sessionLog: 'Relace a historie přihlášení',
    selectMethods: 'Vybrat metody',
    depositDetails: 'Podrobnosti o vkladu',
    order: 'Objednávka',
    support: 'Podpora',
    supportChat: 'Chat podpory',
    createChat: 'Vytvořit chat',
    homepage: 'Domovská stránka',
    takeProfitStopLoss: 'Take Profit & Stop Loss',
    takeProfit: 'Take Profit',
    stopLoss: 'Stop Loss',
    updateOrder: 'Aktualizovat objednávku',
    balance: 'Zůstatek',
    credit: 'Kredit',
    equity: 'Vlastní kapitál',
    practice: 'DEMO',
    real: 'SKUTEČNÝ',
    account: 'ÚČET',
    invested: 'Investováno',
    profit: 'Zisk',
    loss: 'Ztráta',
    margin: 'Marže',
    marginLevel: 'Úroveň marže',
    marginFree: 'Volná marže',
    cfd: 'CFD',
    platform: 'Platforma',
    deposit: 'Vklad',
    marketWatch: 'Sledování trhu',
    activeOrders: 'Otevřené objednávky',
    tradingHistory: 'Historie obchodování',
    economicCalendar: 'Ekonomický kalendář',
    marketNews: 'Zprávy z trhu',
    closeOrder: 'Uzavřít pozici',
    areYouSure: 'Opravdu chcete uzavřít pozici?',
    buy: 'Koupit',
    sell: 'Prodat',
    yes: 'Ano',
    no: 'Ne',
    addNewChart: 'Přidat nový graf',
    watchlist: 'Sledované',
    asset: 'Aktivum',
    price: 'Cena',
    changePct: 'Změna 24 h',
    pending: 'Čekající',
    assetPrice: 'Cena aktiva',
    current: 'Aktuální',
    revert: 'Obnovit tržní cenu',
    automatically:
      'Pozice bude otevřena automaticky, když cena dosáhne této úrovně',
    default: 'výchozí',
    volume: 'Objem',
    lots: 'loty',
    units: 'jednotky',
    currency: 'měna',
    contractSize: 'Velikost kontraktu',
    position: 'Pozice',
    market: 'Trh',
    leverage: 'Páka',
    spread: 'Spread',
    notSet: 'Není nastaveno',
    at: 'na',
    supportBanner: 'KAŽDÝ DEN, 24 HODIN DENNĚ',
    currentTime: 'AKTUÁLNÍ ČAS',
    liveChat: 'Živý chat',
    pnl: 'PnL',
    profitTotal: 'Celkové PnL',
    dateRegistered: 'Datum registrace',
    userId: 'ID uživatele',
    dashboard: 'Přehled',
    personalData: 'Osobní údaje',
    withdrawFunds: 'Vybrat prostředky',
    savings: 'Spoření',
    settings: 'Nastavení',
    logout: 'Odhlásit se',
    BT_INVOICE: 'Zadejte částku a vygenerujte fakturu',
    BT_TITLE: 'Naše bankovní údaje',
    bank_name: 'Název banky',
    beneficiary: 'Příjemce',
    beneficiary_address: 'Adresa příjemce',
    swift: 'SWIFT',
    iban: 'IBAN',
    ru_inn: 'INN',
    ru_kpp: 'KPP',
    corresponding_account: 'Korešpondenční účet',
    TOKEN_AMOUNT: 'Částka',
    TOKEN_SUBTOTAL: 'Mezisoučet',
    TOKEN_TOTAL: 'Celkem',
    TOKEN_DESCRIPTION: 'Popis',
    TOKEN_PAYMENT_DETAILS: 'Platební údaje',
    PENDING_DEPOSITS_LIMIT: 'Limit vkladů',
    makeDeposit: 'Vložit prostředky',
    practiceAccount: 'Demo účet',
    realAccount: 'Skutečný účet',
    noWithdrawals: 'Žádné výběry',
    easyWithdrawals: 'Snadné výběry',
    allAssets: 'Všechna dostupná aktiva',
    fullFledged: 'Plnohodnotná platforma',
    fillUpTo: 'Doplnit na',
    freeReplenishment: 'Bezplatné doplnění',
    topUp: 'Doplnit účet',
    minimumAmount: 'Minimální částka',
    maxAmount: 'Maximální částka',
    withdrawalType: 'Typ výběru',
    canSwitch: 'Mezi účty můžete kdykoli přepnout',
    chartGrids: 'MŘÍŽKY GRAFŮ',
    chart1: '1 graf',
    chart2: '2 grafy',
    chart3: '3 grafy',
    chart4: '4 grafy',
    connectionLost: 'Ztraceno spojení se serverem',
    retryNow: 'Zkuste znovu',
    loginToTradeRoom: 'Přihlaste se do obchodní místnosti',
    email: 'E-mailová adresa',
    enterEmail: 'Zadejte e-mail',
    twoFactor: 'Kód 2FA (je-li povoleno)',
    twoFactorAuth: 'Dvoufaktorové ověřování',
    password: 'Heslo',
    yourPassword: 'Vaše heslo',
    signIn: 'Přihlásit se',
    dontHaveAccount: 'Nemáte účet?',
    restore: 'Obnovit',
    fullName: 'Celé jméno',
    havePromo: 'Mám promo kód',
    promo: 'Promo kód',
    login: 'Přihlásit se',
    haveAccount: 'Už máte účet?',
    hide: 'Skrýt',
    goTo: 'Jít zpět',

    setNewPassword: 'Nastavit nové heslo',
    newPassword: 'Nové heslo',
    confirmNewPassword: 'Potvrďte nové heslo',
    setButton: 'Nastavit',

    repeatPassword: 'Zopakujte heslo',
    createNewAccount: 'Vytvořit nový účet',
    firstName: 'Jméno',
    lastName: 'Příjmení',
    country: 'Země',
    phone: 'Telefon',
    createAccount: 'Vytvořit účet',

    forgotPassword: 'Zapomněli jste heslo?',
    submitEmail:
      'Zadejte e-mail použitý při registraci, zkontrolujte schránku a postupujte podle pokynů',
    submit: 'Odeslat',
    error: 'Chyba',
    success: 'Úspěch',
    withdrawal: 'Výběr',
    depositApproved: 'Vklad byl schválen',
    depositDeclined: 'Vklad byl zamítnut',
    withdrawalApproved: 'Výběr byl schválen',
    withdrawalDeclined: 'Výběr byl zamítnut',

    forex: 'Forex',
    stocks: 'Akcie',
    commodities: 'Komodity',
    indices: 'Indexy',
    crypto: 'Kryptoměny',
    metals: 'Kovy',
    nft: 'NFT',

    profitCalculator: 'Kalkulačka zisku',
    entryPrice: 'Vstupní cena',
    takeProfit: 'Take Profit',
    stopLoss: 'Stop Loss',
    maxPosition: 'Maximální pozice',
    calculate: 'Vypočítat',
    calculationsFor: 'Výpočty pro',
    requiredMargin: 'Vyžadovaná marže',
    profitFromTP: 'Zisk z TP',
    lossFromSL: 'Ztráta z SL',
    roe: 'ROE',

    title: 'Vklad proběhl úspěšně',
    text: 'Váš vklad byl úspěšně zpracován!',

    title_fail: 'Vklad selhal',
    text_fail: 'Váš vklad nebyl zpracován.',

    search: 'Hledat...',

    commission: 'Poplatek',
    volume: 'Objem',
    margin: 'Marže',
    active: 'Aktivní',
    pending: 'Čeká se',
    activeOrders: 'Aktivní objednávky',
    portfolio: 'Portfolio',
    allPositions: 'Všechny pozice',
    noPositionsLine1: 'Nemáte žádné otevřené',
    noPositionsLine2: 'pozice',
    show: 'Zobrazit',
    more: 'více',
    less: 'méně',
    purchaseTime: 'Čas nákupu',
    closePosition: 'Uzavřít pozici',
    priceOpen: 'Nákupní cena',
    priceSl: 'Cena Stop Loss',
    priceTp: 'Cena Take Profit',
    type: 'Směr pozice',
    pnl: 'Zisk/ Ztráta',
    cancelOrder: 'Zrušit objednávku',
    orderType: 'Typ objednávky',
    cancelled: 'Zrušeno',
    tradingHistory: 'Historie obchodů',
    noHistoryLine1: 'Nemáte žádné',
    noHistoryLine2: 'uzavřené obchody',

    economicCalendar: 'Ekonomický kalendář',

    marketNews: 'Novinky z trhu',

    ordersActive: 'Aktivní objednávky',
    ordersHistory: 'Uzavřené objednávky',
    id: 'ID',
    symbol: 'Symbol',
    openPrice: 'Otevírací cena',
    openTime: 'Čas otevření',
    closePrice: 'Uzavírací cena',
    closeTime: 'Čas uzavření',
    sl: 'SL',
    tp: 'TP',
    price: 'Cena',
    actions: 'Akce',
    edit: 'Upravit',
    close: 'Zavřít',
    swap: 'Swap',
    swapLong: 'Swap dlouhé',
    swapShort: 'Swap krátké',

    assetInfo: 'Informace o aktivu',
    tradingConditions: 'Podmínky obchodování',
    information: 'Změna seance',
    bid: 'Nabídka',
    ask: 'Poptávka',
    sessionChange: 'Změna sezení',
    tradeNow: 'Obchodovat nyní',
    opens: 'Otevírá',
    closes: 'Zavírá',
    at: 've',
    open247: 'Otevřeno 24/7',
    today: 'dnes',
    tomorrow: 'zítra',
    sunday: 'Neděle',
    monday: 'Pondělí',
    tuesday: 'Úterý',
    wednesday: 'Středa',
    thursday: 'Čtvrtek',
    friday: 'Pátek',
    saturday: 'Sobota',
    contractSpecification: 'Specifikace kontraktu',
    name: 'Název',
    market: 'Trh',
    baseCurrency: 'Základní měna',
    digits: 'Desetinná místa',
    lotSize: 'Velikost lotu',
    lotStep: 'Krok lotu',
    minVolume: 'Minimální objem',
    maxVolume: 'Maximální objem',
    leverage: 'Páka',
    schedule: 'Rozvrh',
    weekday: 'Den',
    tradingTime: 'Čas obchodování',
    closed: 'uzavřeno',
    sell: 'Prodat',
    buy: 'Koupit',
    low: 'Nízký',
    medium: 'Střední',
    high: 'Vysoký',
    oneHourChange: 'Změna za 1 hod',
    oneDayChange: 'Změna za 1 den',
    oneWeekChange: 'Změna za 1 týden',
    oneMonthChange: 'Změna za 1 měsíc',
    threeMonthsChange: 'Změna za 3 měsíce',
    oneYearChange: 'Změna za 1 rok',
    loading: 'Načítání...',

    traderTitle: 'Auto Trader',
    traderConfirm: 'Potvrďte a uložte',
    riskLevelLow: 'Úroveň rizika: ',
    riskLevelMedium: 'Úroveň rizika: Střední',
    riskLevelHigh: 'Úroveň rizika: Vysoká',
    perDay: 'Obchodů za den:',
    desc: `Obchodování CFD a dalších pákových produktů může vést ke ztrátám. Před obchodováním by si klienti
        měli přečíst příslušná oznámení o riziku na naší stránce o zveřejnění rizik. Automatizované obchodování
        negarantuje výsledky. Společnost nenese odpovědnost za ztrátu prostředků při automatizovaném obchodování.
        Ujistěte se, že plně rozumíte rizikům a přijímáte opatření k jejich řízení.`,
    accept: 'Přijmout',

    trade: 'Obchod',
    startTrading: 'Začít obchodovat',
    deposit: 'Vklad',
    dashboard: 'Přehled',
    personalInfo: 'Osobní informace',
    withdrawal: 'Výběr',
    verification: 'Ověření',
    accounts: 'Účty',
    liveChat: 'Živý chat',
    savings: 'Spoření',
    settings: 'Nastavení',
    logOut: 'Odhlásit se',

    methods: 'METODY',
    confirm: 'Potvrďte v aplikaci vaší banky',
    sendOtp: 'Odeslat OTP',
    otpCode: 'Kód OTP',
    addWalletAddress:
      'Pro tuto metodu vkladu není nastavena peněženka. Kontaktujte agenta nebo podporu.',
    addressReceipt: 'Počkejte, až se načte adresa',
    makeDeposit: 'PROVÉST VKLAD',
    instant: 'Okamžitě',
    minutes: 'minuty',
    hours: 'hodiny',
    days: 'dny',
    amount: 'Částka',
    continue: 'Pokračovat',
    qrCode: 'QR KÓD',
    depositAddress: 'ADRESA VKLADU',
    copy: 'Kopírovat',
    last: 'POSLEDNÍ',
    deposits: 'VKLADY',
    time: 'Čas',
    currency: 'Měna',
    status: 'Stav',
    info: 'Info',

    pleaseWait:
      'Prosím čekejte. Probíhá připojení k poskytovateli platebních služeb...',
    cardPayment: 'Platba kartou',
    inOrder: 'Pro odeslání částky',
    pleaseProvide: 'zadejte údaje o kartě:',

    completeVerification: 'Dokončete ověření',
    noOrderYet: 'Ještě žádná objednávka',
    totalBalance: 'Celkový zůstatek',
    totalDeposits: 'Celkové vklady',
    profitableOrders: 'Ziskové objednávky',
    totalPnl: 'Celkový PnL',
    roi: 'ROI',
    activityLog: 'Protokol aktivit',
    loginFromIp: 'Přihlášení z IP',
    tradingResults: 'Výsledky obchodování',
    week: 'Týden',
    month: 'Měsíc',
    year: 'Rok',
    successRate: 'Úspěšnost',
    closedWithProfit: 'Uzavřeno v zisku',
    closedWithLoss: 'Uzavřeno se ztrátou',
    account: 'Účet',
    leverage: 'Páka',
    credit: 'Kredit',
    tradeNow: 'Obchodovat nyní',
    usingCurrentRate: 'při použití aktuálního kurzu',

    personalDetails: 'Osobní údaje',
    profilePhoto: 'Profilová fotka',
    firstName: 'Jméno',
    country: 'Země',
    lastName: 'Příjmení',
    address: 'Adresa',
    email: 'E-mail',
    phone: 'Telefonní číslo',
    saveChanges: 'Uložit změny',

    dropFile: 'Přetáhněte soubor sem pro nahrání',
    notAllowed: 'Nelze zveřejnit',
    notAllowedLine1: 'Fotografie výslovně sexuální nebo pornografické povahy',
    notAllowedLine2:
      'Obrázky vyzývající k etnické nebo rasové nenávisti či agresi',
    notAllowedLine3: 'Fotografie osob mladších 18 let',
    notAllowedLine4: 'Fotografie chráněné autorským právem třetích stran',
    notAllowedLine5:
      'Obrázky větší než 5 MB nebo ve formátu jiném než JPG, GIF nebo PNG',
    requirements:
      'Vaše tvář musí být na fotografii jasně viditelná. Všechny nahrané fotografie a videa musí splňovat tyto požadavky, jinak mohou být odstraněny.',

    withdrawalOff: 'Pro podrobnosti o výběru kontaktujte správce účtu',
    cryptocurrency: 'Kryptoměna',
    requestNewWithdrawal: 'POŽÁDAT O NOVÝ VÝBĚR',
    withdrawAll: 'Vybrat vše',
    requestWithdrawal: 'Požádat o výběr',
    withdrawalRequests: 'ŽÁDOSTI O VÝBĚR',
    bank: 'Banka',
    bitcoin: 'Bitcoin',
    card: 'Karta',
    ethereum: 'Ethereum',
    eth: 'Ethereum',
    usdt: 'USDT',
    withdrawalDetails: 'Podrobnosti o výběru',
    address: 'Adresa peněženky',
    bankAccount: 'Číslo účtu',
    bankHolder: 'Jméno majitele účtu',
    bankIban: 'IBAN',
    bankSwift: 'Kód SWIFT banky',
    cardNumber: 'Číslo karty',
    cardHolder: 'Jméno držitele karty',

    dragAndDrop: 'přetáhněte dokument do této oblasti',
    documentsList: 'SEZNAM NAHRANÝCH DOKUMENTŮ',
    document: 'Dokument',
    timeUploaded: 'Čas nahrání',
    timeProcessed: 'Čas zpracování',
    status: 'Stav',
    types: [
      'Průkaz totožnosti',
      'Doklad o pobytu',
      'Přední strana kreditní karty',
      'Zadní strana kreditní karty',
      'Zadní strana průkazu totožnosti',
      'Selfie',
    ],
    types2: [
      'Doklad totožnosti (POI)',
      'Doklad o adrese',
      'Přední strana kreditní karty',
      'Zadní strana kreditní karty',
      'Zadní strana dokladu totožnosti',
      'Selfie s dokladem',
    ],

    upload: 'Nahrát',
    isConfirmed: 'je potvrzeno',
    uploadAnotherDocument: 'Nahrát další dokument',
    isUnderReview: 'je ve zpracování',
    questionnaire: 'Dotazník',
    sendAnswers: 'Odeslat odpovědi',
    progressBarOf: 'z',
    progressBarText: 'dokumentů bylo nahráno a potvrzeno',

    manageAccounts: 'Převést prostředky mezi svými účty',
    transferFrom: 'Z účtu',
    transferTo: 'Na účet',
    amount: 'Částka',
    makeTransfer: 'Proveď převod',
    yourAccounts: 'Vaše účty',
    account: 'Účet',
    currency: 'Měna',
    balance: 'Zůstatek',
    credit: 'Kredit',
    makeActive: 'Aktivovat',
    active: 'Aktivní',

    sendMessage: 'Odeslat zprávu',

    pct_0: 'Flexibilní',
    pct_30: 'Blokováno 1 měsíc',
    pct_90: 'Blokováno 1 čtvrtletí',
    pct_180: 'Blokováno 6 měsíců',
    pct_365: 'Blokováno 1 rok',
    savings: 'Úspory',
    detailedInformation: 'Podrobné informace',
    pleaseSelect: 'Vyberte měnu a období',
    openSavings: 'Otevřít spoření',
    currentTime: 'Aktuální čas',
    releaseTime: 'Čas uvolnění',
    currencyChosen: 'Zvolená měna',
    periodChosen: 'Zvolené období',
    yourRate: 'Vaše sazba',
    yourEarnings: 'Váš výdělek',
    accountFrom: 'Účet pro převod z',
    enterAmount: 'Zadejte částku',
    in: 'V',
    openAndInvest: 'Otevřete spořicí účet a investujte',
    investment: 'Investice',
    period: 'Období',
    daysTotal: 'Celkem dní',
    finalEarnings: 'Konečný výdělek',
    created: 'Vytvořeno',
    daysElapsed: 'Uplynulé dny',
    days: 'dny',
    earnings: 'Výdělky',
    fundsReleasedIn: 'Prostředky budou uvolněny za',
    claim: 'Požádat',

    updatePassword: 'Aktualizovat heslo',
    currentPassword: 'Aktuální heslo',
    newPassword: 'Nové heslo',
    changePassword: 'Změnit heslo',
    activationForGoogle: 'Aktivační kód pro Google Authenticator',
    activateAndEnter: 'Aktivujte Authenticator a zadejte vygenerovaný kód',
    qrCode: 'QR kód',
    activateProtection: 'Aktivovat 2FA ochranu',
    protectionActive: '2FA ochrana je aktivní',
    twoFactorCode: '2FA kód',
    disableProtection: 'Deaktivovat 2FA ochranu',
    language: 'Jazyk',
    dashboardCurrency: 'Měna na přehledu',
    confirmNewPassword: 'Potvrdit nové heslo',

    yourLink: 'Váš referenční odkaz',
    referredFriends: 'Doporučení přátelé',
    id: 'ID',
    name: 'Jméno',
    registered: 'Registrován',
    level: 'Úroveň',
    payout: 'Výplata',
    lastPayouts: 'Poslední výplaty',
    time: 'Čas',
    amount: 'Částka',
    currency: 'Měna',
    info: 'Info',

    Jan: 'Led',
    Feb: 'Ún',
    Mar: 'Bře',
    Apr: 'Dub',
    May: 'Kvě',
    Jun: 'Čvn',
    Jul: 'Čec',
    Aug: 'Srp',
    Sep: 'Zář',
    Oct: 'Říj',
    Nov: 'Lis',
    Dec: 'Pro',

    orderTypes: [
      'Koupit',
      'Prodat',
      'Limitní nákup',
      'Limitní prodej',
      'Nákup Stop',
      'Prodej Stop',
    ],
    statuses: ['Čeká se', 'Schváleno', 'Odmítnuto', 'V procesu'],

    NOT_FOUND: 'Chyba požadavku',
    FORBIDDEN: 'Přístup zamítnut. Přihlaste se znovu',
    SERVER_ERROR: 'Akce selhala. Zkuste to později',
    INVALID_ACCOUNT: 'Vypršela relace. Přihlaste se znovu',
    INVALID_EMAIL: 'Neplatná e-mailová adresa',
    INVALID_PHONE: 'Neplatné telefonní číslo',
    INVALID_COUNTRY: 'Neplatná země',
    INVALID_LOGIN: 'Neplatné přihlašovací údaje',
    USER_BLOCKED: 'Účet je zablokován. Kontaktujte podporu',
    USER_REGISTERED:
      'Uživatel se zadaným e-mailem nebo telefonem je již registrován',
    INVALID_USER: 'Uživatel nenalezen',
    REJECTED: 'Operace není povolena z důvodu omezení platformy',
    INVALID_OLD_PASSWORD: 'Staré heslo je neplatné',
    INVALID_SYMBOL: 'Neplatný obchodní symbol',
    INVALID_SYMBOL_PRECISION: 'Neplatná přesnost symbolu',
    INVALID_FRAME: 'Neplatné rámování grafu',
    INVALID_CURRENCY: 'Neplatná měna',
    INVALID_PRODUCT: 'Neplatný typ obchodního účtu',
    INSUFFICIENT_FUNDS: 'Nedostatek prostředků',
    INVALID_WITHDRAWAL: 'Výběr nenalezen',
    INVALID_STATUS: 'Neplatný stav',
    INVALID_FILE: 'Neplatné rozšíření souboru nebo soubor je příliš velký',
    INVALID_DOCUMENT: 'Dokument nenalezen',
    INVALID_NAME: 'Neplatné jméno',
    INVALID_LOT_SIZE: 'Neplatná velikost lotu',
    INVALID_LOT_STEP: 'Neplatný krok lotu',
    INVALID_MIN_VOLUME: 'Neplatný minimální objem',
    INVALID_MAX_VOLUME: 'Neplatný maximální objem',
    INVALID_GROUP: 'Neplatná skupina',
    INVALID_SPREAD: 'Neplatitelné rozpětí',
    REQUEST_TIMEOUT: 'Vypršel časový limit požadavku. Zkuste to později',
    INVALID_TYPE: 'Neplatný typ objednávky',
    INVALID_VOLUME: 'Neplatitelný objem objednávky',
    INVALID_SL: 'Neplatná hodnota stop loss',
    INVALID_TP: 'Neplatná hodnota take profit',
    INVALID_PRICE: 'Neplatná cena objednávky',
    INVALID_EXPIRATION: 'Neplatné vypršení objednávky',
    NOT_ENOUGH_MARGIN: 'Nedostatek marže',
    INVALID_ORDER: 'Objednávka nenalezena',
    MARKET_CLOSED: 'Obchodování není k dispozici. Zkuste to později',
    INVALID_BALANCE_TYPE: 'Neplatný typ operace se zůstatkem',
    INVALID_HASH: 'Neplatný hash',
    HASH_EXPIRED: 'Odkaz pro obnovení hesla vypršel. Požádejte o nový',
    INVALID_CODE: 'Neplatný 2FA kód',
    CHAT_DISABLED: 'Chat podpory je nedostupný',
    WITHDRAWAL_NOT_ALLOWED: 'Přístup k výběrům je uzavřen',
    TRADING_DISABLED: 'Obchodování je pro tento účet deaktivováno',
    PENDING_DEPOSITS_LIMIT: 'Limit vkladů překročen',
    LOCAL_ONE_PENDING_WITHDRAWAL: 'Je povolen pouze jeden čekající výběr',
    LOCAL_DEPOSIT_ONLY_REAL: 'Vklad je dostupný pouze pro skutečný účet',
    LOCAL_DEPOSIT_POSITIVE: 'Částka vkladu musí být větší než 0',
    LOCAL_INVALID_CARD_NUMBER: 'Neplatné číslo karty',
    LOCAL_INVALID_CARD_EXPIRATION: 'Neplatná platnost karty',
    LOCAL_INVALID_CVC: 'Neplatný kód CVV/CVC',
    LOCAL_PASSWORDS_NOT_MATCH: 'Hesla se neshodují, zadejte je znovu',
    LOCAL_NO_TRADING_ACCOUNTS:
      'Nemáte k dispozici obchodní účty. Kontaktujte podporu',
    LOCAL_MIN_DEPOSIT: 'Minimální vklad je $',
    LOCAL_MIN_WITHDRAWAL: 'Minimální částka výběru je $',
    LOCAL_INVALID_FILE_TYPE:
      'Formát souboru není podporován. Připojte pouze JPG, PNG nebo PDF',
    LOCAL_MIN_STAKING: 'Minimální vklad pro tuto měnu je ',
    FLOOD_REJECTED: 'Odesíláte zprávy příliš často. Zkuste to později',

    countries: {
      AF: 'Afghánistán',
      AX: 'Alandy',
      AL: 'Albánie',
      DZ: 'Alžírsko',
      AS: 'Americká Samoa',
      AD: 'Andorra',
      AO: 'Angola',
      AI: 'Anguilla',
      AQ: 'Antarktida',
      AG: 'Antigua a Barbuda',
      AR: 'Argentina',
      AM: 'Arménie',
      AW: 'Aruba',
      AU: 'Austrálie',
      AT: 'Rakousko',
      AZ: 'Ázerbájdžán',
      BS: 'Bahamy',
      BH: 'Bahrajn',
      BD: 'Bangladéš',
      BB: 'Barbados',
      BY: 'Bělorusko',
      BE: 'Belgie',
      BZ: 'Belize',
      BJ: 'Benin',
      BM: 'Bermudy',
      BT: 'Bhútán',
      BO: 'Bolívie',
      BA: 'Bosna a Hercegovina',
      BW: 'Botswana',
      BV: 'Ostrov Bouvet',
      BR: 'Brazílie',
      IO: 'Britské indickooceánské území',
      BN: 'Brunej',
      BG: 'Bulharsko',
      BF: 'Burkina Faso',
      BI: 'Burundi',
      KH: 'Kambodža',
      CM: 'Kamerun',
      CA: 'Kanada',
      CV: 'Kapverdy',
      KY: 'Kajmanské ostrovy',
      CF: 'Středoafrická republika',
      TD: 'Čad',
      CL: 'Chile',
      CN: 'Čína',
      CX: 'Vánoční ostrov',
      CC: 'Kokosové ostrovy',
      CO: 'Kolumbie',
      KM: 'Komory',
      CG: 'Kongo',
      CD: 'Kongo – Kinshasa',
      CK: 'Cookovy ostrovy',
      CR: 'Kostarika',
      CI: 'Pobřeží slonoviny',
      HR: 'Chorvatsko',
      CU: 'Kuba',
      CY: 'Kypr',
      CZ: 'Česká republika',
      DK: 'Dánsko',
      DJ: 'Džibutsko',
      DM: 'Dominika',
      DO: 'Dominikánská republika',
      EC: 'Ekvádor',
      EG: 'Egypt',
      SV: 'Salvador',
      GQ: 'Rovníková Guinea',
      ER: 'Eritrea',
      EE: 'Estonsko',
      ET: 'Etiopie',
      FK: 'Falklandy',
      FO: 'Faerské ostrovy',
      FJ: 'Fidži',
      FI: 'Finsko',
      FR: 'Francie',
      GF: 'Francouzská Guyana',
      PF: 'Francouzská Polynésie',
      TF: 'Francouzská jižní území',
      GA: 'Gabon',
      GM: 'Gambie',
      GE: 'Gruzie',
      DE: 'Německo',
      GH: 'Ghana',
      GI: 'Gibraltar',
      GR: 'Řecko',
      GL: 'Grónsko',
      GD: 'Grenada',
      GP: 'Guadeloupe',
      GU: 'Guam',
      GT: 'Guatemala',
      GG: 'Guernsey',
      GN: 'Guinea',
      GW: 'Guinea-Bissau',
      GY: 'Guyana',
      HT: 'Haiti',
      HM: 'Heardův ostrov a McDonaldovy ostrovy',
      VA: 'Vatikán',
      HN: 'Honduras',
      HK: 'Hongkong',
      HU: 'Maďarsko',
      IS: 'Island',
      IN: 'Indie',
      ID: 'Indonésie',
      IR: 'Írán',
      IQ: 'Irák',
      IE: 'Irsko',
      IM: 'Ostrov Man',
      IL: 'Izrael',
      IT: 'Itálie',
      JM: 'Jamajka',
      JP: 'Japonsko',
      JE: 'Jersey',
      JO: 'Jordánsko',
      KZ: 'Kazachstán',
      KE: 'Keňa',
      KI: 'Kiribati',
      KR: 'Jižní Korea',
      KW: 'Kuvajt',
      KG: 'Kyrgyzstán',
      LA: 'Laoská lidově demokratická republika',
      LV: 'Lotyšsko',
      LB: 'Libanon',
      LS: 'Lesotho',
      LR: 'Libérie',
      LY: 'Libye',
      LI: 'Lichtenštejnsko',
      LT: 'Litva',
      LU: 'Lucembursko',
      MO: 'Macao',
      MK: 'Severní Makedonie',
      MG: 'Madagaskar',
      MW: 'Malawi',
      MY: 'Malajsie',
      MV: 'Maledivy',
      ML: 'Mali',
      MT: 'Malta',
      MH: 'Marshallovy ostrovy',
      MQ: 'Martinik',
      MR: 'Mauritánie',
      MU: 'Mauricius',
      YT: 'Mayotte',
      MX: 'Mexiko',
      FM: 'Mikronésie',
      MD: 'Moldavsko',
      MC: 'Monako',
      MN: 'Mongolsko',
      ME: 'Černá Hora',
      MS: 'Montserrat',
      MA: 'Maroko',
      MZ: 'Mosambik',
      MM: 'Myanmar',
      NA: 'Namibie',
      NR: 'Nauru',
      NP: 'Nepál',
      NL: 'Nizozemsko',
      AN: 'Nizozemské Antily',
      NC: 'Nová Kaledonie',
      NZ: 'Nový Zéland',
      NI: 'Nikaragua',
      NE: 'Niger',
      NG: 'Nigérie',
      NU: 'Niue',
      NF: 'Norfolk',
      MP: 'Severní Mariany',
      NO: 'Norsko',
      OM: 'Omán',
      PK: 'Pákistán',
      PW: 'Palau',
      PS: 'Palestinská území',
      PA: 'Panama',
      PG: 'Papua-Nová Guinea',
      PY: 'Paraguay',
      PE: 'Peru',
      PH: 'Filipíny',
      PN: 'Pitcairn',
      PL: 'Polsko',
      PT: 'Portugalsko',
      PR: 'Portoriko',
      QA: 'Katar',
      RE: 'Réunion',
      RO: 'Rumunsko',
      RU: 'Rusko',
      RW: 'Rwanda',
      BL: 'Saint-Barthélemy',
      SH: 'Svatá Helena',
      KN: 'Svatý Kryštof a Nevis',
      LC: 'Svatá Lucie',
      MF: 'Svatý Martin',
      PM: 'Saint-Pierre a Miquelon',
      VC: 'Svatý Vincenc a Grenadiny',
      WS: 'Samoa',
      SM: 'San Marino',
      ST: 'Sao Tomé a Príncipe',
      SA: 'Saúdská Arábie',
      SN: 'Senegal',
      RS: 'Srbsko',
      SC: 'Seychely',
      SL: 'Sierra Leone',
      SG: 'Singapur',
      SK: 'Slovensko',
      SI: 'Slovinsko',
      SB: 'Šalamounovy ostrovy',
      SO: 'Somálsko',
      ZA: 'Jižní Afrika',
      GS: 'Jižní Georgie a Jižní Sandwichovy ostrovy',
      ES: 'Španělsko',
      LK: 'Srí Lanka',
      SD: 'Súdán',
      SR: 'Surinam',
      SJ: 'Svalbard a Jan Mayen',
      SZ: 'Svazijsko',
      SE: 'Švédsko',
      CH: 'Švýcarsko',
      SY: 'Sýrie',
      TW: 'Tchaj-wan',
      TJ: 'Tádžikistán',
      TZ: 'Tanzanie',
      TH: 'Thajsko',
      TL: 'Východní Timor',
      TG: 'Togo',
      TK: 'Tokelau',
      TO: 'Tonga',
      TT: 'Trinidad a Tobago',
      TN: 'Tunisko',
      TR: 'Turecko',
      TM: 'Turkmenistán',
      TC: 'Turks a Caicos',
      TV: 'Tuvalu',
      UG: 'Uganda',
      UA: 'Ukrajina',
      AE: 'Spojené arabské emiráty',
      GB: 'Spojené království',
      US: 'Spojené státy',
      UM: 'Menší odlehlé ostrovy USA',
      UY: 'Uruguay',
      UZ: 'Uzbekistán',
      VU: 'Vanuatu',
      VE: 'Venezuela',
      VN: 'Vietnam',
      VG: 'Britské Panenské ostrovy',
      VI: 'Americké Panenské ostrovy',
      WF: 'Wallis a Futuna',
      EH: 'Západní Sahara',
      YE: 'Jemen',
      ZM: 'Zambie',
      ZW: 'Zimbabwe',
    },
  },
  pt: {
    _name: 'Português',
    policy: 'Política de Privacidade',
    policyAML: 'Política AML',
    policyKYC: 'Política KYC',
    locense: 'Licença',
    view_all: 'Ver tudo',
    sell_btn: 'Vender',
    buy_btn: 'Comprar',
    currency_action: 'moeda',

    importantAccountDetails: 'Detalhes importantes da conta',
    viewAdditionalSettings: 'Ver configurações adicionais',
    switchDarkMode: 'Alternar modo escuro/claro',
    writeProblem: 'Descreva seu problema para nós',
    darkMode: 'Modo escuro',

    yay: 'Oba',
    purchased: 'Você comprou com sucesso',
    from: 'de',
    walet: 'Carteira',
    trade: 'Negociar',

    withdrawDetails: 'Detalhes de retirada',
    saveDetails: 'Salvar detalhes para a próxima vez',
    amountToWithdraw: 'Quantia a retirar',
    withdrawLimit: 'Limite diário de retirada restante: $1.000.000,00',

    serviceFee: 'Taxa de serviço',
    youWillPay: 'Você pagará',
    cancel: 'Cancelar',
    understand: 'Entendi, continuar',

    select: 'Selecionar',
    enterAmount: 'Insira a quantia',
    orderInfo: 'Informações do pedido',
    confirmOrder: 'Confirmar pedido',
    get: 'Receber',
    spend: 'Gastar',
    buying: 'Comprando',
    accountTransactions: 'Transações da conta',
    overview: 'Visão geral',
    accountBalances: 'Saldos da conta',
    details: 'Detalhes',
    loginHistory: 'Histórico de login',
    device: 'Dispositivo',
    contactUs: 'Contate-nos',
    sessionLog: 'Sessões e histórico de login',
    selectMethods: 'Selecionar métodos',
    depositDetails: 'Detalhes do depósito',
    order: 'Pedido',
    support: 'Suporte',
    supportChat: 'Chat de suporte',
    createChat: 'Criar chat',
    homepage: 'Início',
    takeProfitStopLoss: 'Take Profit & Stop Loss',
    takeProfit: 'Take Profit',
    stopLoss: 'Stop Loss',
    updateOrder: 'Atualizar pedido',
    balance: 'Saldo',
    credit: 'Crédito',
    equity: 'Patrimônio',
    practice: 'DEMO',
    real: 'REAL',
    account: 'CONTA',
    invested: 'Investido',
    profit: 'Lucro',
    loss: 'Prejuízo',
    margin: 'Margem',
    marginLevel: 'Nível de margem',
    marginFree: 'Margem livre',
    cfd: 'CFD',
    platform: 'Plataforma',
    deposit: 'Depósito',
    marketWatch: 'Observação de mercado',
    activeOrders: 'Ordens abertas',
    tradingHistory: 'Histórico de negociações',
    economicCalendar: 'Calendário econômico',
    marketNews: 'Notícias de mercado',
    closeOrder: 'Fechar posição',
    areYouSure: 'Tem certeza de que deseja fechar a posição?',
    buy: 'Comprar',
    sell: 'Vender',
    yes: 'Sim',
    no: 'Não',
    addNewChart: 'Adicionar novo gráfico',
    watchlist: 'Lista de observação',
    asset: 'Ativo',
    price: 'Preço',
    changePct: 'Variação 24h',
    pending: 'Pendente',
    assetPrice: 'Preço do ativo',
    current: 'Atual',
    revert: 'Reverter para preço de mercado',
    automatically:
      'A posição será aberta automaticamente quando o preço atingir este nível',
    default: 'padrão',
    volume: 'Volume',
    lots: 'lotes',
    units: 'unidades',
    currency: 'moeda',
    contractSize: 'Tamanho do contrato',
    position: 'Posição',
    freeMargin: 'Margem livre',
    market: 'Mercado',
    leverage: 'Alavancagem',
    spread: 'Spread',
    notSet: 'Não definido',
    at: 'em',
    supportBanner: 'TODOS OS DIAS, 24 HORAS POR DIA',
    currentTime: 'HORA ATUAL',
    liveChat: 'Chat ao vivo',
    pnl: 'PnL',
    profitTotal: 'PnL total',
    dateRegistered: 'Data de registro',
    userId: 'ID do usuário',
    dashboard: 'Painel',
    personalData: 'Dados pessoais',
    withdrawFunds: 'Retirar fundos',
    savings: 'Poupanças',
    settings: 'Configurações',
    logout: 'Sair',
    BT_INVOICE: 'Insira o valor e gere a fatura',
    BT_TITLE: 'Nossos dados bancários',
    bank_name: 'Nome do banco',
    beneficiary: 'Beneficiário',
    beneficiary_address: 'Endereço do beneficiário',
    swift: 'SWIFT',
    iban: 'IBAN',
    ru_inn: 'INN',
    ru_kpp: 'KPP',
    corresponding_account: 'Conta correspondente',
    TOKEN_AMOUNT: 'Quantia',
    TOKEN_SUBTOTAL: 'Subtotal',
    TOKEN_TOTAL: 'Total',
    TOKEN_DESCRIPTION: 'Descrição',
    TOKEN_PAYMENT_DETAILS: 'Detalhes do pagamento',
    PENDING_DEPOSITS_LIMIT: 'Limite de depósito',
    makeDeposit: 'Fazer um depósito',
    practiceAccount: 'Conta demo',
    realAccount: 'Conta real',
    noWithdrawals: 'Sem retiradas',
    easyWithdrawals: 'Retiradas fáceis',
    allAssets: 'Todos os ativos disponíveis',
    fullFledged: 'Plataforma completa',
    fillUpTo: 'Preencher até',
    freeReplenishment: 'Reabastecimento gratuito',
    topUp: 'Recarregar sua conta',
    minimumAmount: 'Valor mínimo',
    maxAmount: 'Valor máximo',
    withdrawalType: 'Tipo de retirada',
    canSwitch: 'Você pode alternar entre suas contas a qualquer momento',
    chartGrids: 'GRADE DE GRÁFICOS',
    chart1: '1 gráfico',
    chart2: '2 gráficos',
    chart3: '3 gráficos',
    chart4: '4 gráficos',
    connectionLost: 'Conexão com o servidor perdida',
    retryNow: 'Tentar novamente',
    loginToTradeRoom: 'Entrar na sala de negociação',
    email: 'Endereço de e-mail',
    enterEmail: 'Insira seu e-mail',
    twoFactor: 'Código 2FA (se habilitado)',
    twoFactorAuth: 'Autenticação de dois fatores',
    password: 'Senha',
    yourPassword: 'Sua senha',
    signIn: 'Entrar',
    dontHaveAccount: 'Não tem uma conta?',
    restore: 'Restaurar',
    fullName: 'Nome completo',
    havePromo: 'Tenho um código promocional',
    promo: 'Código promocional',
    login: 'Entrar',
    haveAccount: 'Já tem uma conta?',
    hide: 'Ocultar',
    goTo: 'Voltar',

    setNewPassword: 'Definir nova senha',
    newPassword: 'Nova senha',
    confirmNewPassword: 'Confirmar nova senha',
    setButton: 'Definir',

    repeatPassword: 'Repetir senha',
    createNewAccount: 'Criar uma nova conta',
    firstName: 'Nome',
    lastName: 'Sobrenome',
    country: 'País',
    phone: 'Telefone',
    createAccount: 'Criar conta',

    forgotPassword: 'Esqueceu a senha?',
    submitEmail:
      'Por favor, envie um e-mail usado no registro, verifique sua caixa de entrada e siga as instruções',
    submit: 'Enviar',
    error: 'Erro',
    success: 'Sucesso',
    depositApproved: 'Depósito aprovado',
    depositDeclined: 'Depósito recusado',
    withdrawalApproved: 'Retirada aprovada',
    withdrawalDeclined: 'Retirada recusada',

    forex: 'Forex',
    stocks: 'Ações',
    commodities: 'Commodities',
    indices: 'Índices',
    crypto: 'Cripto',
    metals: 'Metais',
    nft: 'NFT',

    buy: 'COMPRAR',
    profitCalculator: 'Calculadora de lucro',
    sell: 'VENDER',
    entryPrice: 'Preço de entrada',
    takeProfit: 'Take Profit',
    stopLoss: 'Stop Loss',
    maxPosition: 'Posição máxima',
    calculate: 'Calcular',
    calculationsFor: 'Cálculos para',
    requiredMargin: 'Margem necessária',
    profitFromTP: 'Lucro de TP',
    lossFromSL: 'Prejuízo de SL',
    roe: 'ROE',

    title: 'Depósito bem-sucedido',
    text: 'Seu depósito foi processado com sucesso!',

    title_fail: 'Falha no depósito',
    text_fail: 'Seu depósito não foi processado.',

    marketWatch: 'Observação de mercado',
    search: 'Buscar...',

    commission: 'Comissão',
    volume: 'Volume',
    margin: 'Margem',
    active: 'Ativo',
    pending: 'Pendente',
    activeOrders: 'Ordens Ativas',
    portfolio: 'Portfólio',
    allPositions: 'Todas as Posições',
    noPositionsLine1: 'Você não tem posições',
    noPositionsLine2: 'abertas ainda',
    show: 'Mostrar',
    more: 'mais',
    less: 'menos',
    purchaseTime: 'Hora da Compra',
    closePosition: 'Fechar Posição',
    priceOpen: 'Preço de Compra',
    priceSl: 'Preço Stop Loss',
    priceTp: 'Preço Take Profit',
    type: 'Direção da Posição',
    pnl: 'Lucro/Prejuízo',
    cancelOrder: 'Cancelar Ordem',
    orderType: 'Tipo de Ordem',
    cancelled: 'Cancelado',
    tradingHistory: 'Histórico de Negociações',
    noHistoryLine1: 'Você não tem',
    noHistoryLine2: 'negociações fechadas ainda',

    economicCalendar: 'Calendário Econômico',

    marketNews: 'Notícias do Mercado',

    ordersActive: 'Ordens Ativas',
    ordersHistory: 'Ordens Fechadas',
    id: 'ID',
    symbol: 'Símbolo',
    openPrice: 'Preço de Abertura',
    openTime: 'Hora de Abertura',
    closePrice: 'Preço de Fechamento',
    closeTime: 'Hora de Fechamento',
    sl: 'SL',
    tp: 'TP',
    price: 'Preço',
    actions: 'Ações',
    edit: 'Editar',
    close: 'Fechar',
    swap: 'Swap',
    swapLong: 'Swap Long',
    swapShort: 'Swap Short',

    assetInfo: 'Informações do Ativo',
    tradingConditions: 'Condições de Negociação',
    information: 'Mudança de Sessão',
    bid: 'Bid',
    ask: 'Ask',
    sessionChange: 'Mudança de Sessão',
    tradeNow: 'Negociar Agora',
    opens: 'Abre',
    closes: 'Fecha',
    at: 'em',
    open247: 'Aberto 24/7',
    today: 'hoje',
    tomorrow: 'amanhã',
    sunday: 'Domingo',
    monday: 'Segunda-feira',
    tuesday: 'Terça-feira',
    wednesday: 'Quarta-feira',
    thursday: 'Quinta-feira',
    friday: 'Sexta-feira',
    saturday: 'Sábado',
    contractSpecification: 'Especificação de Contrato',
    name: 'Nome',
    market: 'Mercado',
    baseCurrency: 'Moeda Base',
    digits: 'Decimais',
    lotSize: 'Tamanho do Lote',
    lotStep: 'Passo do Lote',
    minVolume: 'Volume Mínimo',
    maxVolume: 'Volume Máximo',
    leverage: 'Alavancagem',
    schedule: 'Programação',
    weekday: 'Dia da Semana',
    tradingTime: 'Horário de Negociação',
    closed: 'fechado',
    sell: 'Vender',
    buy: 'Comprar',
    low: 'Baixo',
    medium: 'Médio',
    high: 'Alto',
    oneHourChange: 'Variação 1h',
    oneDayChange: 'Variação 1d',
    oneWeekChange: 'Variação 1s',
    oneMonthChange: 'Variação 1m',
    threeMonthsChange: 'Variação 3m',
    oneYearChange: 'Variação 1a',
    loading: 'Carregando...',

    traderTitle: 'Comerciante de automóveis',
    traderConfirm: 'Confirme e salve',
    riskLevelLow: 'Nível de Risco: ',
    riskLevelMedium: 'Nível de Risco: Médio',
    riskLevelHigh: 'Nível de Risco: Alto',
    perDay: 'Negociações por dia:',
    desc: `Operar CFDs e outros produtos alavancados pode gerar perdas. Antes de operar, os clientes devem
        ler as declarações de risco na nossa página de Divulgação de Riscos. A negociação automatizada não garante resultados.
        A empresa não se responsabiliza por perdas em negociações automáticas. Certifique-se de compreender
        totalmente os riscos e adotar medidas de gestão.`,

    accept: 'Aceitar',

    trade: 'Negociar',
    startTrading: 'Começar a Negociar',
    deposit: 'Depósito',
    dashboard: 'Painel',
    personalInfo: 'Informações Pessoais',
    withdrawal: 'Retirada',
    verification: 'Verificação',
    accounts: 'Contas',
    liveChat: 'Chat ao Vivo',
    savings: 'Poupanças',
    settings: 'Configurações',
    logOut: 'Sair',

    methods: 'MÉTODOS',
    confirm: 'Confirme no app do seu banco',
    sendOtp: 'Enviar OTP',
    otpCode: 'Código OTP',
    addWalletAddress:
      'Carteira para este método não configurada. Contate seu agente ou suporte.',
    addressReceipt: 'Aguarde o carregamento do endereço',
    makeDeposit: 'REALIZAR DEPÓSITO',
    instant: 'Instantâneo',
    minutes: 'minutos',
    hours: 'horas',
    days: 'dias',
    amount: 'Quantia',
    continue: 'Continuar',
    qrCode: 'CÓDIGO QR',
    depositAddress: 'ENDEREÇO DE DEPÓSITO',
    copy: 'Copiar',
    last: 'ÚLTIMO',
    deposits: 'DEPÓSITOS',
    time: 'Hora',
    currency: 'Moeda',
    status: 'Status',
    info: 'Info',

    dragAndDrop: 'arraste e solte o documento nesta área',
    documentsList: 'LISTA DE DOCUMENTOS ENVIADOS',
    document: 'Documento',
    timeUploaded: 'Hora do Envio',
    timeProcessed: 'Hora do Processamento',
    status: 'Status',
    types: [
      'Comprovante de Identidade',
      'Comprovante de Residência',
      'Frente do Cartão de Crédito',
      'Verso do Cartão de Crédito',
      'Verso do Documento de Identidade',
      'Selfie',
    ],
    types2: [
      'Comprovante de Identificação (POI)',
      'Comprovante de Endereço',
      'Frente do Cartão de Crédito',
      'Verso do Cartão de Crédito',
      'Verso do Comprovante de Identificação',
      'Selfie com Documento',
    ],

    upload: 'Enviar',
    isConfirmed: 'está confirmado',
    uploadAnotherDocument: 'Enviar outro documento',
    isUnderReview: 'está em análise',
    questionnaire: 'Questionário',
    sendAnswers: 'Enviar respostas',
    progressBarOf: 'de',
    progressBarText: 'dos seus documentos foram enviados e confirmados',

    manageAccounts: 'Transferir fundos entre suas contas',
    transferFrom: 'Da conta',
    transferTo: 'Para a conta',
    amount: 'Quantia',
    makeTransfer: 'Fazer Transferência',
    yourAccounts: 'Suas Contas',
    account: 'Conta',
    currency: 'Moeda',
    balance: 'Saldo',
    credit: 'Crédito',
    makeActive: 'Ativar',
    active: 'Ativo',

    sendMessage: 'Enviar Mensagem',

    pct_0: 'Flexível',
    pct_30: 'Bloqueado 1 Mês',
    pct_90: 'Bloqueado 1 Trimestre',
    pct_180: 'Bloqueado 6 Meses',
    pct_365: 'Bloqueado 1 Ano',
    savings: 'Poupança',
    detailedInformation: 'Informações Detalhadas',
    pleaseSelect: 'Selecione uma moeda e um período',
    openSavings: 'Abrir Poupança',
    currentTime: 'Hora Atual',
    releaseTime: 'Hora de Liberação',
    currencyChosen: 'Moeda Escolhida',
    periodChosen: 'Período Escolhido',
    yourRate: 'Sua Taxa',
    yourEarnings: 'Seus Ganhos',
    accountFrom: 'Conta de origem',
    enterAmount: 'Insira a Quantia',
    in: 'Em',
    openAndInvest: 'Abrir Conta Poupança e Investir',
    investment: 'Investimento',
    period: 'Período',
    daysTotal: 'Total de Dias',
    finalEarnings: 'Ganhos Finais',
    created: 'Criado',
    daysElapsed: 'Dias Decorridos',
    days: 'dias',
    earnings: 'Ganhos',
    fundsReleasedIn: 'Fundos liberados em',
    claim: 'Resgatar',

    updatePassword: 'ATUALIZAR SENHA',
    currentPassword: 'Senha Atual',
    newPassword: 'Nova Senha',
    changePassword: 'Alterar Senha',
    activationForGoogle: 'Código de ativação do Google Authenticator',
    activateAndEnter: 'Ative o Authenticator e insira o código gerado abaixo',
    qrCode: 'Código QR',
    activateProtection: 'Ativar Proteção 2FA',
    protectionActive: 'Proteção 2FA está ativa',
    twoFactorCode: 'Código 2FA',
    disableProtection: 'Desativar Proteção 2FA',
    language: 'Idioma',
    dashboardCurrency: 'Moeda do Painel',
    confirmNewPassword: 'Confirmar nova senha',

    yourLink: 'SEU LINK DE REFERÊNCIA',
    referredFriends: 'AMIGOS REFERENCIADOS',
    id: 'ID',
    name: 'Nome',
    registered: 'Registrado',
    level: 'Nível',
    payout: 'Pagamento',
    lastPayouts: 'ÚLTIMOS PAGAMENTOS DE REFERÊNCIA',
    time: 'Hora',
    amount: 'Quantia',
    currency: 'Moeda',
    info: 'Info',

    Jan: 'Jan',
    Feb: 'Fev',
    Mar: 'Mar',
    Apr: 'Abr',
    May: 'Mai',
    Jun: 'Jun',
    Jul: 'Jul',
    Aug: 'Ago',
    Sep: 'Set',
    Oct: 'Out',
    Nov: 'Nov',
    Dec: 'Dez',

    orderTypes: [
      'Comprar',
      'Vender',
      'Buy Limit',
      'Sell Limit',
      'Buy Stop',
      'Sell Stop',
    ],
    statuses: ['Pendente', 'Aprovado', 'Recusado', 'Processando'],

    NOT_FOUND: 'Erro na solicitação',
    FORBIDDEN: 'Acesso negado. Faça login novamente',
    SERVER_ERROR: 'Ação falhou. Tente novamente mais tarde',
    INVALID_ACCOUNT: 'Sessão expirada. Faça login novamente',
    INVALID_EMAIL: 'E-mail inválido',
    INVALID_PHONE: 'Telefone inválido',
    INVALID_COUNTRY: 'País inválido',
    INVALID_LOGIN: 'Credenciais inválidas',
    USER_BLOCKED: 'Conta bloqueada. Contate o suporte',
    USER_REGISTERED: 'Usuário com e-mail ou telefone já registrado',
    INVALID_USER: 'Usuário não encontrado',
    REJECTED: 'Operação não permitida pelas regras da plataforma',
    INVALID_OLD_PASSWORD: 'Senha antiga inválida',
    INVALID_SYMBOL: 'Símbolo de negociação inválido',
    INVALID_SYMBOL_PRECISION: 'Precisão do símbolo inválida',
    INVALID_FRAME: 'Intervalo de gráfico inválido',
    INVALID_CURRENCY: 'Moeda inválida',
    INVALID_PRODUCT: 'Tipo de conta inválido',
    INSUFFICIENT_FUNDS: 'Fundos insuficientes',
    INVALID_WITHDRAWAL: 'Retirada não encontrada',
    INVALID_STATUS: 'Status inválido',
    INVALID_FILE: 'Extensão de arquivo inválida ou muito grande',
    INVALID_DOCUMENT: 'Documento não encontrado',
    INVALID_NAME: 'Nome inválido',
    INVALID_LOT_SIZE: 'Tamanho de lote inválido',
    INVALID_LOT_STEP: 'Incremento de lote inválido',
    INVALID_MIN_VOLUME: 'Volume mínimo inválido',
    INVALID_MAX_VOLUME: 'Volume máximo inválido',
    INVALID_GROUP: 'Grupo inválido',
    INVALID_SPREAD: 'Spread inválido',
    REQUEST_TIMEOUT: 'Tempo de solicitação esgotado. Tente novamente',
    INVALID_TYPE: 'Tipo de ordem inválido',
    INVALID_VOLUME: 'Volume de ordem inválido',
    INVALID_SL: 'Valor de stop loss inválido',
    INVALID_TP: 'Valor de take profit inválido',
    INVALID_PRICE: 'Preço de ordem inválido',
    INVALID_EXPIRATION: 'Expiração de ordem inválida',
    NOT_ENOUGH_MARGIN: 'Margem insuficiente',
    INVALID_ORDER: 'Ordem não encontrada',
    MARKET_CLOSED: 'Negociação indisponível. Tente novamente mais tarde',
    INVALID_BALANCE_TYPE: 'Tipo de operação de saldo inválido',
    INVALID_HASH: 'Hash inválido',
    HASH_EXPIRED: 'Link de reset de senha expirado. Solicite um novo',
    INVALID_CODE: 'Código 2FA inválido',
    CHAT_DISABLED: 'Acesso ao chat de suporte encerrado',
    WITHDRAWAL_NOT_ALLOWED: 'Acesso a retiradas encerrado',
    TRADING_DISABLED: 'Negociação desabilitada para esta conta',
    PENDING_DEPOSITS_LIMIT: 'Limite de depósitos excedido',
    LOCAL_ONE_PENDING_WITHDRAWAL: 'Apenas uma retirada pendente permitida',
    LOCAL_DEPOSIT_ONLY_REAL: 'Depósito disponível apenas para conta real',
    LOCAL_DEPOSIT_POSITIVE: 'Valor do depósito deve ser maior que 0',
    LOCAL_INVALID_CARD_NUMBER: 'Número de cartão inválido',
    LOCAL_INVALID_CARD_EXPIRATION: 'Validade do cartão inválida',
    LOCAL_INVALID_CVC: 'Código CVV/CVC inválido',
    LOCAL_PASSWORDS_NOT_MATCH: 'Senhas não coincidem, tente novamente',
    LOCAL_NO_TRADING_ACCOUNTS:
      'Nenhuma conta de negociação disponível. Contate o suporte',
    LOCAL_MIN_DEPOSIT: 'Depósito mínimo é $',
    LOCAL_MIN_WITHDRAWAL: 'Retirada mínima é $',
    LOCAL_INVALID_FILE_TYPE:
      'Formato de arquivo não suportado. Use JPG, PNG ou PDF',
    LOCAL_MIN_STAKING: 'Depósito mínimo para esta moeda é ',
    FLOOD_REJECTED:
      'Você está enviando mensagens muito rápido. Tente novamente mais tarde',

    countries: {
      AF: 'Afeganistão',
      AX: 'Ilhas de Aland',
      AL: 'Albânia',
      DZ: 'Argélia',
      AS: 'Samoa Americana',
      AD: 'Andorra',
      AO: 'Angola',
      AI: 'Anguilla',
      AQ: 'Antártica',
      AG: 'Antígua e Barbuda',
      AR: 'Argentina',
      AM: 'Armênia',
      AW: 'Aruba',
      AU: 'Austrália',
      AT: 'Áustria',
      AZ: 'Azerbaijão',
      BS: 'Bahamas',
      BH: 'Bahrein',
      BD: 'Bangladesh',
      BB: 'Barbados',
      BY: 'Bielorrússia',
      BE: 'Bélgica',
      BZ: 'Belize',
      BJ: 'Benin',
      BM: 'Bermudas',
      BT: 'Butão',
      BO: 'Bolívia',
      BA: 'Bósnia e Herzegovina',
      BW: 'Botsuana',
      BV: 'Ilha Bouvet',
      BR: 'Brasil',
      IO: 'Território Britânico do Oceano Índico',
      BN: 'Brunei',
      BG: 'Bulgária',
      BF: 'Burquina Faso',
      BI: 'Burundi',
      KH: 'Camboja',
      CM: 'Camarões',
      CA: 'Canadá',
      CV: 'Cabo Verde',
      KY: 'Ilhas Cayman',
      CF: 'República Centro-Africana',
      TD: 'Chade',
      CL: 'Chile',
      CN: 'China',
      CX: 'Ilha Christmas',
      CC: 'Ilhas Cocos (Keeling)',
      CO: 'Colômbia',
      KM: 'Comores',
      CG: 'Congo',
      CD: 'República Democrática do Congo',
      CK: 'Ilhas Cook',
      CR: 'Costa Rica',
      CI: 'Costa do Marfim',
      HR: 'Croácia',
      CU: 'Cuba',
      CY: 'Chipre',
      CZ: 'República Tcheca',
      DK: 'Dinamarca',
      DJ: 'Djibuti',
      DM: 'Dominica',
      DO: 'República Dominicana',
      EC: 'Equador',
      EG: 'Egito',
      SV: 'El Salvador',
      GQ: 'Guiné Equatorial',
      ER: 'Eritreia',
      EE: 'Estônia',
      ET: 'Etiópia',
      FK: 'Ilhas Malvinas',
      FO: 'Ilhas Faroe',
      FJ: 'Fiji',
      FI: 'Finlândia',
      FR: 'França',
      GF: 'Guiana Francesa',
      PF: 'Polinésia Francesa',
      TF: 'Territórios Franceses do Sul',
      GA: 'Gabão',
      GM: 'Gâmbia',
      GE: 'Geórgia',
      DE: 'Alemanha',
      GH: 'Gana',
      GI: 'Gibraltar',
      GR: 'Grécia',
      GL: 'Groenlândia',
      GD: 'Granada',
      GP: 'Guadalupe',
      GU: 'Guam',
      GT: 'Guatemala',
      GG: 'Guernsey',
      GN: 'Guiné',
      GW: 'Guiné-Bissau',
      GY: 'Guiana',
      HT: 'Haiti',
      HM: 'Ilhas Heard e McDonald',
      VA: 'Cidade do Vaticano',
      HN: 'Honduras',
      HK: 'Hong Kong',
      HU: 'Hungria',
      IS: 'Islândia',
      IN: 'Índia',
      ID: 'Indonésia',
      IR: 'Irã',
      IQ: 'Iraque',
      IE: 'Irlanda',
      IM: 'Ilha de Man',
      IL: 'Israel',
      IT: 'Itália',
      JM: 'Jamaica',
      JP: 'Japão',
      JE: 'Jersey',
      JO: 'Jordânia',
      KZ: 'Cazaquistão',
      KE: 'Quênia',
      KI: 'Kiribati',
      KR: 'Coreia do Sul',
      KW: 'Kuwait',
      KG: 'Quirguistão',
      LA: 'República Popular Democrática do Laos',
      LV: 'Letônia',
      LB: 'Líbano',
      LS: 'Lesoto',
      LR: 'Libéria',
      LY: 'Líbia',
      LI: 'Liechtenstein',
      LT: 'Lituânia',
      LU: 'Luxemburgo',
      MO: 'Macau',
      MK: 'Macedônia do Norte',
      MG: 'Madagascar',
      MW: 'Malawi',
      MY: 'Malásia',
      MV: 'Maldivas',
      ML: 'Mali',
      MT: 'Malta',
      MH: 'Ilhas Marshall',
      MQ: 'Martinica',
      MR: 'Mauritânia',
      MU: 'Maurício',
      YT: 'Mayotte',
      MX: 'México',
      FM: 'Micronésia',
      MD: 'Moldávia',
      MC: 'Mônaco',
      MN: 'Mongólia',
      ME: 'Montenegro',
      MS: 'Montserrat',
      MA: 'Marrocos',
      MZ: 'Moçambique',
      MM: 'Myanmar',
      NA: 'Namíbia',
      NR: 'Nauru',
      NP: 'Nepal',
      NL: 'Países Baixos',
      AN: 'Antilhas Neerlandesas',
      NC: 'Nova Caledônia',
      NZ: 'Nova Zelândia',
      NI: 'Nicarágua',
      NE: 'Níger',
      NG: 'Nigéria',
      NU: 'Niue',
      NF: 'Ilha Norfolk',
      MP: 'Ilhas Marianas do Norte',
      NO: 'Noruega',
      OM: 'Omã',
      PK: 'Paquistão',
      PW: 'Palau',
      PS: 'Território Palestino',
      PA: 'Panamá',
      PG: 'Papua-Nova Guiné',
      PY: 'Paraguai',
      PE: 'Peru',
      PH: 'Filipinas',
      PN: 'Pitcairn',
      PL: 'Polônia',
      PT: 'Portugal',
      PR: 'Porto Rico',
      QA: 'Catar',
      RE: 'Reunião',
      RO: 'Romênia',
      RU: 'Rússia',
      RW: 'Ruanda',
      BL: 'São Bartolomeu',
      SH: 'Santa Helena',
      KN: 'São Cristóvão e Neves',
      LC: 'Santa Lúcia',
      MF: 'São Martinho',
      PM: 'Saint-Pierre e Miquelon',
      VC: 'São Vicente e Granadinas',
      WS: 'Samoa',
      SM: 'San Marino',
      ST: 'São Tomé e Príncipe',
      SA: 'Arábia Saudita',
      SN: 'Senegal',
      RS: 'Sérvia',
      SC: 'Seicheles',
      SL: 'Serra Leoa',
      SG: 'Cingapura',
      SK: 'Eslováquia',
      SI: 'Eslovênia',
      SB: 'Ilhas Salomão',
      SO: 'Somália',
      ZA: 'África do Sul',
      GS: 'Geórgia do Sul e Sandwich do Sul',
      ES: 'Espanha',
      LK: 'Sri Lanka',
      SD: 'Sudão',
      SR: 'Suriname',
      SJ: 'Svalbard e Jan Mayen',
      SZ: 'Eswatini',
      SE: 'Suécia',
      CH: 'Suíça',
      SY: 'Síria',
      TW: 'Taiwan',
      TJ: 'Tajiquistão',
      TZ: 'Tanzânia',
      TH: 'Tailândia',
      TL: 'Timor-Leste',
      TG: 'Togo',
      TK: 'Toquelau',
      TO: 'Tonga',
      TT: 'Trinidad e Tobago',
      TN: 'Tunísia',
      TR: 'Turquia',
      TM: 'Turcomenistão',
      TC: 'Ilhas Turks e Caicos',
      TV: 'Tuvalu',
      UG: 'Uganda',
      UA: 'Ucrânia',
      AE: 'Emirados Árabes Unidos',
      GB: 'Reino Unido',
      US: 'Estados Unidos',
      UM: 'Ilhas Menores Distantes dos EUA',
      UY: 'Uruguai',
      UZ: 'Uzbequistão',
      VU: 'Vanuatu',
      VE: 'Venezuela',
      VN: 'Vietnã',
      VG: 'Ilhas Virgens Britânicas',
      VI: 'Ilhas Virgens Americanas',
      WF: 'Wallis e Futuna',
      EH: 'Saara Ocidental',
      YE: 'Iêmen',
      ZM: 'Zâmbia',
      ZW: 'Zimbábue',
    },
  },
  ro: {
    _name: 'Română',
    policy: 'Politica de confidențialitate',
    policyAML: 'Politica AML',
    policyKYC: 'Politica KYC',
    locense: 'Licență',
    view_all: 'Vezi tot',
    sell_btn: 'Vinde',
    buy_btn: 'Cumpără',
    currency_action: 'monedă',

    importantAccountDetails: 'Detalii importante despre cont',
    viewAdditionalSettings: 'Vezi setări suplimentare',
    switchDarkMode: 'Comută mod întunecat/luminos',
    writeProblem: 'Scrie-ne problema ta',
    darkMode: 'Mod întunecat',

    yay: 'Ura',
    purchased: 'Ai cumpărat cu succes',
    from: 'din',
    walet: 'Portofel',
    trade: 'Tranzacționează',

    withdrawDetails: 'Detalii retragere',
    saveDetails: 'Salvează detaliile pentru data viitoare',
    amountToWithdraw: 'Sumă de retras',
    withdrawLimit: 'Limită zilnică de retragere rămasă: 1.000.000,00 $',

    serviceFee: 'Taxă de serviciu',
    youWillPay: 'Vei plăti',
    cancel: 'Anulează',
    understand: 'Am înțeles, continuă',

    select: 'Selectează',
    enterAmount: 'Introdu sumă',
    orderInfo: 'Informații comandă',
    confirmOrder: 'Confirmă comanda',
    get: 'Primește',
    spend: 'Cheltuie',
    buying: 'Cumpărare',
    accountTransactions: 'Tranzacții cont',
    overview: 'Prezentare generală',
    accountBalances: 'Solduri cont',
    details: 'Detalii',
    loginHistory: 'Istoric autentificări',
    device: 'Dispozitiv',
    contactUs: 'Contactează-ne',
    sessionLog: 'Sesiuni și istoric autentificări',
    selectMethods: 'Selectează metode',
    depositDetails: 'Detalii depunere',
    order: 'Comandă',
    support: 'Suport',
    supportChat: 'Chat suport',
    createChat: 'Creează chat',
    homepage: 'Acasă',
    takeProfitStopLoss: 'Take Profit & Stop Loss',
    takeProfit: 'Take Profit',
    stopLoss: 'Stop Loss',
    updateOrder: 'Actualizează comanda',
    balance: 'Sold',
    credit: 'Credit',
    equity: 'Capital propriu',
    practice: 'DEMO',
    real: 'REAL',
    account: 'CONT',
    invested: 'Investit',
    profit: 'Profit',
    loss: 'Pierdere',
    margin: 'Marjă',
    marginLevel: 'Nivel marjă',
    marginFree: 'Marjă liberă',
    cfd: 'CFD',
    platform: 'Platformă',
    deposit: 'Depunere',
    marketWatch: 'Observator de piață',
    activeOrders: 'Comenzi deschise',
    tradingHistory: 'Istoric tranzacții',
    economicCalendar: 'Calendar economic',
    marketNews: 'Știri de piață',
    closeOrder: 'Închide poziție',
    areYouSure: 'Ești sigur că vrei să închizi poziția?',
    buy: 'Cumpără',
    sell: 'Vinde',
    yes: 'Da',
    no: 'Nu',
    addNewChart: 'Adaugă grafic nou',
    watchlist: 'Listă de urmărire',
    asset: 'Activ',
    price: 'Preț',
    changePct: 'Schimbare 24h',
    pending: 'În așteptare',
    assetPrice: 'Preț activ',
    current: 'Curent',
    revert: 'Revenire la prețul pieței',
    automatically:
      'Poziția se va deschide automat când prețul atinge acest nivel',
    default: 'implicit',
    volume: 'Volum',
    lots: 'loturi',
    units: 'unități',
    currency: 'monedă',
    contractSize: 'Dimensiune contract',
    position: 'Poziție',
    freeMargin: 'Marjă liberă',
    market: 'Piață',
    leverage: 'Levier',
    spread: 'Spread',
    notSet: 'Neprecizat',
    at: 'la',
    supportBanner: 'ZILNIC, NON-STOP',
    currentTime: 'ORA ACTUALĂ',
    liveChat: 'Chat live',
    pnl: 'PnL',
    profitTotal: 'PnL total',
    dateRegistered: 'Data înregistrării',
    userId: 'ID utilizator',
    dashboard: 'Tablou de bord',
    personalData: 'Date personale',
    withdrawFunds: 'Retrage fonduri',
    savings: 'Economii',
    settings: 'Setări',
    logout: 'Deconectare',
    BT_INVOICE: 'Introdu sumă și generează factură',
    BT_TITLE: 'Detaliile noastre bancare',
    bank_name: 'Denumire bancă',
    beneficiary: 'Beneficiar',
    beneficiary_address: 'Adresă beneficiar',
    swift: 'SWIFT',
    iban: 'IBAN',
    ru_inn: 'INN',
    ru_kpp: 'KPP',
    corresponding_account: 'Cont corespondent',
    TOKEN_AMOUNT: 'Sumă',
    TOKEN_SUBTOTAL: 'Subtotal',
    TOKEN_TOTAL: 'Total',
    TOKEN_DESCRIPTION: 'Descriere',
    TOKEN_PAYMENT_DETAILS: 'Detalii plată',
    PENDING_DEPOSITS_LIMIT: 'Limită depuneri',
    makeDeposit: 'Efectuează o depunere',
    practiceAccount: 'Cont demo',
    realAccount: 'Cont real',
    noWithdrawals: 'Fără retrageri',
    easyWithdrawals: 'Retrageri ușoare',
    allAssets: 'Toate activele disponibile',
    fullFledged: 'Platformă completă',
    fillUpTo: 'Completează până la',
    freeReplenishment: 'Reumplere gratuită',
    topUp: 'Reîncarcă contul',
    minimumAmount: 'Sumă minimă',
    maxAmount: 'Sumă maximă',
    withdrawalType: 'Tip de retragere',
    canSwitch: 'Poți comuta între conturi oricând',
    chartGrids: 'GRID-URI GRAFIC',
    chart1: '1 grafic',
    chart2: '2 grafice',
    chart3: '3 grafice',
    chart4: '4 grafice',
    connectionLost: 'Conexiunea la server pierdută',
    retryNow: 'Reîncearcă',
    loginToTradeRoom: 'Autentificare în zona de tranzacționare',
    email: 'Adresă de e-mail',
    enterEmail: 'Introdu e-mailul',
    twoFactor: 'Cod 2FA (dacă este activat)',
    twoFactorAuth: 'Autentificare cu doi factori',
    password: 'Parolă',
    yourPassword: 'Parola ta',
    signIn: 'Autentificare',
    dontHaveAccount: 'Nu ai cont?',
    restore: 'Restabilește',
    fullName: 'Nume complet',
    havePromo: 'Am un cod promoțional',
    promo: 'Cod promoțional',
    login: 'Autentificare',
    haveAccount: 'Ai deja cont?',
    hide: 'Ascunde',
    goTo: 'Înapoi',

    setNewPassword: 'Setează o parolă nouă',
    newPassword: 'Parolă nouă',
    confirmNewPassword: 'Confirmă parola nouă',
    setButton: 'Setează',

    repeatPassword: 'Repetă parola',
    createNewAccount: 'Creează un cont nou',
    firstName: 'Prenume',
    lastName: 'Nume',
    country: 'Țară',
    phone: 'Telefon',
    createAccount: 'Creează cont',

    forgotPassword: 'Ai uitat parola?',
    submitEmail:
      'Introdu e-mailul folosit la înregistrare, verifică-ți inbox-ul și urmează instrucțiunile',
    submit: 'Trimite',
    error: 'Eroare',
    success: 'Succes',
    deposit: 'Depunere',
    withdrawal: 'Retragere',
    depositApproved: 'Depunerea a fost aprobată',
    depositDeclined: 'Depunerea a fost refuzată',
    withdrawalApproved: 'Retragerea a fost aprobată',
    withdrawalDeclined: 'Retragerea a fost refuzată',

    forex: 'Forex',
    stocks: 'Acțiuni',
    commodities: 'Mărfuri',
    indices: 'Indici',
    crypto: 'Criptomonede',
    metals: 'Metale',
    nft: 'NFT',

    buy: 'CUMPĂRĂ',
    profitCalculator: 'Calculator profit',
    sell: 'VINDE',
    entryPrice: 'Preț intrare',
    takeProfit: 'Take Profit',
    stopLoss: 'Stop Loss',
    maxPosition: 'Poziție maximă',
    calculate: 'Calculează',
    calculationsFor: 'Calcule pentru',
    leverage: 'Levier',
    requiredMargin: 'Marjă necesară',
    profitFromTP: 'Profit de la TP',
    lossFromSL: 'Pierdere de la SL',
    roe: 'ROE',

    title: 'Depunere reușită',
    text: 'Depunerea ta a fost procesată cu succes!',

    title_fail: 'Depunere eșuată',
    text_fail: 'Depunerea ta nu a fost procesată.',

    marketWatch: 'Observator de piață',
    search: 'Caută...',

    commission: 'Comision',
    volume: 'Volum',
    margin: 'Marjă',
    active: 'Activ',
    pending: 'În așteptare',
    activeOrders: 'Comenzi active',
    portfolio: 'Portofoliu',
    allPositions: 'Toate pozițiile',
    noPositionsLine1: 'Nu aveți poziții',
    noPositionsLine2: 'deschise încă',
    show: 'Arată',
    more: 'mai mult',
    less: 'mai puțin',
    purchaseTime: 'Ora achiziției',
    closePosition: 'Închide poziția',
    priceOpen: 'Preț de achiziție',
    priceSl: 'Preț Stop Loss',
    priceTp: 'Preț Take Profit',
    type: 'Direcția poziției',
    pnl: 'Profit/Pierdere',
    cancelOrder: 'Anulează comanda',
    orderType: 'Tip comandă',
    cancelled: 'Anulat',
    tradingHistory: 'Istoric tranzacții',
    noHistoryLine1: 'Nu aveți',
    noHistoryLine2: 'tranzacții închise încă',

    economicCalendar: 'Calendar economic',

    marketNews: 'Știri de piață',

    ordersActive: 'Comenzi active',
    ordersHistory: 'Comenzi închise',
    id: 'ID',
    symbol: 'Simbol',
    documentType: 'Tip',
    volume: 'Volum',
    openPrice: 'Preț deschidere',
    openTime: 'Ora deschidere',
    closePrice: 'Preț închidere',
    closeTime: 'Ora închidere',
    sl: 'SL',
    tp: 'TP',
    price: 'Preț',
    pnl: 'PnL',
    actions: 'Acțiuni',
    edit: 'Editează',
    close: 'Închide',
    swap: 'Swap',
    swapLong: 'Swap Long',
    swapShort: 'Swap Short',

    assetInfo: 'Informații activ',
    tradingConditions: 'Condiții tranzacționare',
    information: 'Schimbare sesiune',
    bid: 'Bid',
    ask: 'Ask',
    sessionChange: 'Schimbare sesiune',
    tradeNow: 'Tranzacționează acum',
    opens: 'Deschide',
    closes: 'Închide',
    at: 'la',
    open247: 'Deschis 24/7',
    today: 'astăzi',
    tomorrow: 'mâine',
    sunday: 'duminică',
    monday: 'luni',
    tuesday: 'marți',
    wednesday: 'miercuri',
    thursday: 'joi',
    friday: 'vineri',
    saturday: 'sâmbătă',
    contractSpecification: 'Specificații contract',
    name: 'Nume',
    market: 'Piață',
    baseCurrency: 'Monedă de bază',
    digits: 'Zecimale',
    lotSize: 'Dimensiune lot',
    lotStep: 'Pas lot',
    minVolume: 'Volum minim',
    maxVolume: 'Volum maxim',
    leverage: 'Levier',
    schedule: 'Programare',
    weekday: 'Zi săptămână',
    tradingTime: 'Orar tranzacționare',
    closed: 'închis',
    sell: 'Vinde',
    buy: 'Cumpără',
    low: 'Scăzut',
    medium: 'Mediu',
    high: 'Ridicat',
    oneHourChange: 'Schimbare 1h',
    oneDayChange: 'Schimbare 1z',
    oneWeekChange: 'Schimbare 1s',
    oneMonthChange: 'Schimbare 1l',
    threeMonthsChange: 'Schimbare 3l',
    oneYearChange: 'Schimbare 1a',
    loading: 'Se încarcă...',

    traderTitle: 'Comerciant auto',
    traderConfirm: 'Confirmați și salvați',
    riskLevelLow: 'Nivel risc: ',
    riskLevelMedium: 'Nivel risc: Mediu',
    riskLevelHigh: 'Nivel risc: Ridicat',
    perDay: 'Tranzacții pe zi:',
    desc: `Tranzacționarea CFD-urilor și a altor produse cu efect de levier poate duce la pierderi. Înainte de tranzacționare, clienții trebuie
        să citească declarațiile de risc de pe pagina noastră de Dezvăluire a Riscurilor. Tranzacționarea automatizată nu garantează rezultate.
        Compania nu își asumă responsabilitatea pentru pierderile din tranzacționarea automată.
        Asigurați-vă că înțelegeți pe deplin riscurile și luați măsuri de gestionare a acestora.`,
    accept: 'Acceptă',

    trade: 'Tranzacționează',
    startTrading: 'Începe tranzacționarea',
    deposit: 'Depozit',
    dashboard: 'Tablou de bord',
    personalInfo: 'Date personale',
    withdrawal: 'Retragere',
    verification: 'Verificare',
    accounts: 'Conturi',
    liveChat: 'Chat live',
    savings: 'Economii',
    settings: 'Setări',
    logOut: 'Deconectare',

    methods: 'METODE',
    confirm: 'Confirmă în aplicația băncii tale',
    sendOtp: 'Trimite OTP',
    otpCode: 'Cod OTP',
    addWalletAddress:
      'Portofel pentru această metodă nu este setat. Contactează agentul sau suportul.',
    addressReceipt: 'Așteaptă încărcarea adresei',
    makeDeposit: 'REALIZEAZĂ UN DEPOZIT',
    instant: 'Instant',
    minutes: 'minute',
    hours: 'ore',
    days: 'zile',
    amount: 'Sumă',
    continue: 'Continuă',
    qrCode: 'Cod QR',
    depositAddress: 'ADRESĂ DE DEPOZIT',
    copy: 'Copiază',
    last: 'ULTIMUL',
    deposits: 'DEPOZITE',
    time: 'Ora',
    currency: 'Monedă',
    status: 'Stare',
    info: 'Info',

    dragAndDrop: 'trage și plasează documentul aici',
    documentsList: 'LISTA DOCUMENTELOR ÎNCĂRCATE',
    document: 'Document',
    timeUploaded: 'Ora încărcării',
    timeProcessed: 'Ora procesării',
    status: 'Stare',
    types: [
      'Dovadă de identitate',
      'Dovadă de reședință',
      'Fața cardului de credit',
      'Spatele cardului de credit',
      'Spatele actului de identitate',
      'Selfie',
    ],
    types2: [
      'Dovadă de identificare (POI)',
      'Dovadă de adresă',
      'Fața cardului de credit',
      'Spatele cardului de credit',
      'Spatele dovezii de identificare',
      'Selfie cu act de identitate',
    ],

    upload: 'Încarcă',
    isConfirmed: 'este confirmat',
    uploadAnotherDocument: 'Încarcă un alt document',
    isUnderReview: 'este în curs de revizuire',
    questionnaire: 'Chestionar',
    sendAnswers: 'Trimite răspunsuri',
    progressBarOf: 'din',
    progressBarText: 'din documentele tale au fost încărcate și confirmate',

    manageAccounts: 'Transferă fonduri între conturile tale',
    transferFrom: 'De la contul',
    transferTo: 'Către contul',
    amount: 'Sumă',
    makeTransfer: 'Efectuează transfer',
    yourAccounts: 'Conturile tale',
    account: 'Cont',
    currency: 'Monedă',
    balance: 'Sold',
    credit: 'Credit',
    makeActive: 'Activează',
    active: 'Activ',

    sendMessage: 'Trimite mesaj',

    pct_0: 'Flexibil',
    pct_30: 'Blocare 1 lună',
    pct_90: 'Blocare 1 trimestru',
    pct_180: 'Blocare 6 luni',
    pct_365: 'Blocare 1 an',
    savings: 'Economii',
    detailedInformation: 'Informații detaliate',
    pleaseSelect: 'Selectează o monedă și o perioadă',
    openSavings: 'Deschide Economii',
    currentTime: 'Ora curentă',
    releaseTime: 'Ora eliberării',
    currencyChosen: 'Monedă aleasă',
    periodChosen: 'Perioadă aleasă',
    yourRate: 'Rata ta',
    yourEarnings: 'Câștigurile tale',
    accountFrom: 'Cont de transferat fonduri de la',
    enterAmount: 'Introdu sumă',
    in: 'În',
    openAndInvest: 'Deschide cont de economii și investește',
    investment: 'Investiție',
    period: 'Perioadă',
    daysTotal: 'Zile total',
    finalEarnings: 'Câștiguri finale',
    created: 'Creat',
    daysElapsed: 'Zile trecute',
    days: 'zile',
    earnings: 'Câștiguri',
    fundsReleasedIn: 'Fonduri eliberate în',
    claim: 'Revendică',

    updatePassword: 'ACTUALIZEAZĂ PAROLA',
    currentPassword: 'Parolă curentă',
    newPassword: 'Parolă nouă',
    changePassword: 'Schimbă parola',
    activationForGoogle: 'Cod de activare Google Authenticator',
    activateAndEnter:
      'Activează Authenticator și introdu codul generat mai jos',
    qrCode: 'Cod QR',
    activateProtection: 'Activează protecție 2FA',
    protectionActive: 'Protecția 2FA este activă',
    twoFactorCode: 'Cod 2FA',
    disableProtection: 'Dezactivează protecție 2FA',
    language: 'Limbă',
    dashboardCurrency: 'Monedă tabloul de bord',
    confirmNewPassword: 'Confirmă parola nouă',

    yourLink: 'LINK-UL TĂU DE REFERINȚĂ',
    referredFriends: 'PRIETENI REFERIȚI',
    id: 'ID',
    name: 'Nume',
    registered: 'Înregistrat',
    level: 'Nivel',
    payout: 'Plată',
    lastPayouts: 'ULTIMELE PLĂȚI DE REFERINȚĂ',
    time: 'Timp',
    amount: 'Sumă',
    currency: 'Monedă',
    info: 'Info',

    Jan: 'Ian',
    Feb: 'Feb',
    Mar: 'Mar',
    Apr: 'Apr',
    May: 'Mai',
    Jun: 'Iun',
    Jul: 'Iul',
    Aug: 'Aug',
    Sep: 'Sep',
    Oct: 'Oct',
    Nov: 'Nov',
    Dec: 'Dec',

    orderTypes: [
      'Cumpără',
      'Vinde',
      'Limită Cumpărare',
      'Limită Vânzare',
      'Stop Cumpărare',
      'Stop Vânzare',
    ],
    statuses: ['În așteptare', 'Aprobat', 'Respins', 'În procesare'],

    NOT_FOUND: 'Eroare cerere',
    FORBIDDEN: 'Acces interzis. Reautentifică-te',
    SERVER_ERROR: 'Acțiune eșuată. Încearcă mai târziu',
    INVALID_ACCOUNT: 'Sesiune expirată. Reautentifică-te',
    INVALID_EMAIL: 'Adresă de e-mail invalidă',
    INVALID_PHONE: 'Număr de telefon invalid',
    INVALID_COUNTRY: 'Țară invalidă',
    INVALID_LOGIN: 'Date de autentificare invalide',
    USER_BLOCKED: 'Cont blocat. Contactează suportul',
    USER_REGISTERED: 'Utilizator cu e-mail sau telefon deja înregistrat',
    INVALID_USER: 'Utilizator inexistent',
    REJECTED: 'Operațiune nepermisă de setările platformei',
    INVALID_OLD_PASSWORD: 'Parola veche este invalidă',
    INVALID_SYMBOL: 'Simbol tranzacționare invalid',
    INVALID_SYMBOL_PRECISION: 'Precizie simbol invalidă',
    INVALID_FRAME: 'Interval de grafic invalid',
    INVALID_CURRENCY: 'Monedă invalidă',
    INVALID_PRODUCT: 'Tip cont invalid',
    INSUFFICIENT_FUNDS: 'Fonduri insuficiente',
    INVALID_WITHDRAWAL: 'Retragere inexistentă',
    INVALID_STATUS: 'Stare invalidă',
    INVALID_FILE: 'Extensie fișier invalidă sau prea mare',
    INVALID_DOCUMENT: 'Document inexistent',
    INVALID_NAME: 'Nume invalid',
    INVALID_LOT_SIZE: 'Dimensiune lot invalidă',
    INVALID_LOT_STEP: 'Pas lot invalid',
    INVALID_MIN_VOLUME: 'Volum minim invalid',
    INVALID_MAX_VOLUME: 'Volum maxim invalid',
    INVALID_GROUP: 'Grup invalid',
    INVALID_SPREAD: 'Spread invalid',
    REQUEST_TIMEOUT: 'Timp cerere expirat. Încearcă din nou',
    INVALID_TYPE: 'Tip comandă invalid',
    INVALID_VOLUME: 'Volum comandă invalid',
    INVALID_SL: 'Valoare stop loss invalidă',
    INVALID_TP: 'Valoare take profit invalidă',
    INVALID_PRICE: 'Preț comandă invalid',
    INVALID_EXPIRATION: 'Expirare invalidă',
    NOT_ENOUGH_MARGIN: 'Marjă insuficientă',
    INVALID_ORDER: 'Comandă inexistentă',
    MARKET_CLOSED: 'Tranzacționare indisponibilă. Încearcă mai târziu',
    INVALID_BALANCE_TYPE: 'Tip operațiune sold invalid',
    INVALID_HASH: 'Hash invalid',
    HASH_EXPIRED: 'Link resetare parolă expirat. Solicită unul nou',
    INVALID_CODE: 'Cod 2FA invalid',
    CHAT_DISABLED: 'Acces chat suport închis',
    WITHDRAWAL_NOT_ALLOWED: 'Acces retrageri închis',
    TRADING_DISABLED: 'Tranzacționare dezactivată pentru acest cont',
    PENDING_DEPOSITS_LIMIT: 'Limită depuneri depășită',
    LOCAL_ONE_PENDING_WITHDRAWAL: 'Doar o retragere pendinte permisa',
    LOCAL_DEPOSIT_ONLY_REAL: 'Depunere disponibilă doar pentru cont real',
    LOCAL_DEPOSIT_POSITIVE: 'Suma depunerii trebuie să fie > 0',
    LOCAL_INVALID_CARD_NUMBER: 'Număr card invalid',
    LOCAL_INVALID_CARD_EXPIRATION: 'Expirare card invalidă',
    LOCAL_INVALID_CVC: 'Cod CVV/CVC invalid',
    LOCAL_PASSWORDS_NOT_MATCH: 'Parolele nu se potrivesc, încearcă din nou',
    LOCAL_NO_TRADING_ACCOUNTS:
      'Niciun cont de tranzacționare disponibil. Contactează suportul',
    LOCAL_MIN_DEPOSIT: 'Depozit minim este $',
    LOCAL_MIN_WITHDRAWAL: 'Retragere minimă este $',
    LOCAL_INVALID_FILE_TYPE:
      'Format fișier neacceptat. Utilizează JPG, PNG sau PDF',
    LOCAL_MIN_STAKING: 'Depozit minim pentru această monedă este ',
    FLOOD_REJECTED: 'Trimiți prea des mesaje. Încearcă mai târziu',
    countries: {
      AF: 'Afganistan',
      AX: 'Insulele Aland',
      AL: 'Albania',
      DZ: 'Algeria',
      AS: 'Samoa Americană',
      AD: 'Andorra',
      AO: 'Angola',
      AI: 'Anguilla',
      AQ: 'Antarctica',
      AG: 'Antigua și Barbuda',
      AR: 'Argentina',
      AM: 'Armenia',
      AW: 'Aruba',
      AU: 'Australia',
      AT: 'Austria',
      AZ: 'Azerbaidjan',
      BS: 'Bahamas',
      BH: 'Bahrain',
      BD: 'Bangladesh',
      BB: 'Barbados',
      BY: 'Belarus',
      BE: 'Belgia',
      BZ: 'Belize',
      BJ: 'Benin',
      BM: 'Bermude',
      BT: 'Bhutan',
      BO: 'Bolivia',
      BA: 'Bosnia și Herțegovina',
      BW: 'Botswana',
      BV: 'Insula Bouvet',
      BR: 'Brazilia',
      IO: 'Teritoriul Britanic din Oceanul Indian',
      BN: 'Brunei',
      BG: 'Bulgaria',
      BF: 'Burkina Faso',
      BI: 'Burundi',
      KH: 'Cambodgia',
      CM: 'Camerun',
      CA: 'Canada',
      CV: 'Capul Verde',
      KY: 'Insulele Cayman',
      CF: 'Republica Centrafricană',
      TD: 'Ciad',
      CL: 'Chile',
      CN: 'China',
      CX: 'Insula Christmas',
      CC: 'Insulele Cocos (Keeling)',
      CO: 'Columbia',
      KM: 'Comore',
      CG: 'Congo',
      CD: 'Congo (R.D.)',
      CK: 'Insulele Cook',
      CR: 'Costa Rica',
      CI: 'Coasta de Fildeș',
      HR: 'Croația',
      CU: 'Cuba',
      CY: 'Cipru',
      CZ: 'Republica Cehă',
      DK: 'Danemarca',
      DJ: 'Djibouti',
      DM: 'Dominica',
      DO: 'Republica Dominicană',
      EC: 'Ecuador',
      EG: 'Egipt',
      SV: 'El Salvador',
      GQ: 'Guineea Ecuatorială',
      ER: 'Eritreea',
      EE: 'Estonia',
      ET: 'Etiopia',
      FK: 'Insulele Falkland',
      FO: 'Insulele Feroe',
      FJ: 'Fiji',
      FI: 'Finlanda',
      FR: 'Franța',
      GF: 'Guiana Franceză',
      PF: 'Polinezia Franceză',
      TF: 'Teritoriile Australe și Antarctice Franceze',
      GA: 'Gabon',
      GM: 'Gambia',
      GE: 'Georgia',
      DE: 'Germania',
      GH: 'Ghana',
      GI: 'Gibraltar',
      GR: 'Grecia',
      GL: 'Groenlanda',
      GD: 'Grenada',
      GP: 'Guadelupa',
      GU: 'Guam',
      GT: 'Guatemala',
      GG: 'Guernsey',
      GN: 'Guineea',
      GW: 'Guineea-Bissau',
      GY: 'Guyana',
      HT: 'Haiti',
      HM: 'Insulele Heard și McDonald',
      VA: 'Vatican',
      HN: 'Honduras',
      HK: 'Hong Kong',
      HU: 'Ungaria',
      IS: 'Islanda',
      IN: 'India',
      ID: 'Indonezia',
      IR: 'Iran',
      IQ: 'Irak',
      IE: 'Irlanda',
      IM: 'Insula Man',
      IL: 'Israel',
      IT: 'Italia',
      JM: 'Jamaica',
      JP: 'Japonia',
      JE: 'Jersey',
      JO: 'Iordania',
      KZ: 'Kazahstan',
      KE: 'Kenya',
      KI: 'Kiribati',
      KR: 'Coreea de Sud',
      KW: 'Kuweit',
      KG: 'Kârgâzstan',
      LA: 'Republica Democrată Populară Laos',
      LV: 'Letonia',
      LB: 'Liban',
      LS: 'Lesotho',
      LR: 'Liberia',
      LY: 'Libia',
      LI: 'Liechtenstein',
      LT: 'Lituania',
      LU: 'Luxemburg',
      MO: 'Macao',
      MK: 'Macedonia de Nord',
      MG: 'Madagascar',
      MW: 'Malawi',
      MY: 'Malaezia',
      MV: 'Maldive',
      ML: 'Mali',
      MT: 'Malta',
      MH: 'Insulele Marshall',
      MQ: 'Martinica',
      MR: 'Mauritania',
      MU: 'Mauritius',
      YT: 'Mayotte',
      MX: 'Mexic',
      FM: 'Micronezia',
      MD: 'Moldova',
      MC: 'Monaco',
      MN: 'Mongolia',
      ME: 'Muntenegru',
      MS: 'Montserrat',
      MA: 'Maroc',
      MZ: 'Mozambic',
      MM: 'Myanmar',
      NA: 'Namibia',
      NR: 'Nauru',
      NP: 'Nepal',
      NL: 'Țările de Jos',
      AN: 'Antilele Olandeze',
      NC: 'Noua Caledonie',
      NZ: 'Noua Zeelandă',
      NI: 'Nicaragua',
      NE: 'Niger',
      NG: 'Nigeria',
      NU: 'Niue',
      NF: 'Insula Norfolk',
      MP: 'Mariana de Nord',
      NO: 'Norvegia',
      OM: 'Oman',
      PK: 'Pakistan',
      PW: 'Palau',
      PS: 'Teritoriile Palestiniene',
      PA: 'Panama',
      PG: 'Papua Noua Guinee',
      PY: 'Paraguay',
      PE: 'Peru',
      PH: 'Filipine',
      PN: 'Pitcairn',
      PL: 'Polonia',
      PT: 'Portugalia',
      PR: 'Puerto Rico',
      QA: 'Qatar',
      RE: 'Reunion',
      RO: 'România',
      RU: 'Rusia',
      RW: 'Rwanda',
      BL: 'Saint-Barthélemy',
      SH: 'Sfânta Elena',
      KN: 'Saint Kitts și Nevis',
      LC: 'Sfânta Lucia',
      MF: 'Saint-Martin',
      PM: 'Saint-Pierre și Miquelon',
      VC: 'Saint Vincent și Grenadine',
      WS: 'Samoa',
      SM: 'San Marino',
      ST: 'Sao Tome și Principe',
      SA: 'Arabia Saudită',
      SN: 'Senegal',
      RS: 'Serbia',
      SC: 'Seychelles',
      SL: 'Sierra Leone',
      SG: 'Singapore',
      SK: 'Slovacia',
      SI: 'Slovenia',
      SB: 'Insulele Solomon',
      SO: 'Somalia',
      ZA: 'Africa de Sud',
      GS: 'Georgia de Sud și Sandwich de Sud',
      ES: 'Spania',
      LK: 'Sri Lanka',
      SD: 'Sudan',
      SR: 'Surinam',
      SJ: 'Svalbard și Jan Mayen',
      SZ: 'Swasiland',
      SE: 'Suedia',
      CH: 'Elveția',
      SY: 'Siria',
      TW: 'Taiwan',
      TJ: 'Tadjikistan',
      TZ: 'Tanzania',
      TH: 'Thailanda',
      TL: 'Timorul de Est',
      TG: 'Togo',
      TK: 'Tokelau',
      TO: 'Tonga',
      TT: 'Trinidad și Tobago',
      TN: 'Tunisia',
      TR: 'Turcia',
      TM: 'Turkmenistan',
      TC: 'Insulele Turks și Caicos',
      TV: 'Tuvalu',
      UG: 'Uganda',
      UA: 'Ucraina',
      AE: 'Emiratele Arabe Unite',
      GB: 'Regatul Unit',
      US: 'Statele Unite',
      UM: 'Insulele Minore îndepărtate ale SUA',
      UY: 'Uruguay',
      UZ: 'Uzbekistan',
      VU: 'Vanuatu',
      VE: 'Venezuela',
      VN: 'Vietnam',
      VG: 'Insulele Virgine Britanice',
      VI: 'Insulele Virgine Americane',
      WF: 'Wallis și Futuna',
      EH: 'Sahara de Vest',
      YE: 'Yemen',
      ZM: 'Zambia',
      ZW: 'Zimbabwe',
    },
  },
  ge: {
    _name: 'ქართული',
    policy: 'კონფიდენციალურობის პოლიტიკა',
    policyAML: 'AML პოლიტიკა',
    policyKYC: 'KYC პოლიტიკა',
    locense: 'ლიცენზია',
    view_all: 'ყველას ნახვა',
    sell_btn: 'გაყიდვა',
    buy_btn: 'გაყიდვა',
    currency_action: 'ვალუტა',

    importantAccountDetails: 'ანგარიშის მნიშვნელოვანი დეტალები',
    viewAdditionalSettings: 'დამატებითი პარამეტრების ნახვა',
    switchDarkMode: 'ღამის/ღიად რეჟიმის გადართვა',
    writeProblem: 'დაგვწერეთ თქვენი პრობლემა',
    darkMode: 'ღამის რეჟიმი',

    yay: 'ჰურა',
    purchased: 'წარმატებით შეიძინეთ',
    from: 'დან',
    walet: 'საფულე',
    trade: 'ტრანზაქცია',

    withdrawDetails: 'გაყვანის დეტალები',
    saveDetails: 'დეტალების შენახვა შემდეგჯერ',
    amountToWithdraw: 'გაყვანის თანხა',
    withdrawLimit: 'დღიური ლიმიტი დარჩა: $1,000,000.00',

    serviceFee: 'სამსახურის საფასური',
    youWillPay: 'გადაიხდით',
    cancel: 'გაუქმება',
    understand: 'გასაგებია, გაგრძელება',

    select: 'არჩევა',
    enterAmount: 'მომდენი თანხის შეყვანა',
    orderInfo: 'შეკვეთის ინფორმაცია',
    confirmOrder: 'შეკვეთის დადასტურება',
    get: 'მიიღეთ',
    spend: 'ხარჯვა',
    buying: 'ყიდვა',
    accountTransactions: 'ანგარიშის ტრანზაქციები',
    overview: 'მიმოხილვა',
    accountBalances: 'ანგარიშის ბალანსი',
    details: 'დეტალები',
    loginHistory: 'ავტორიზაციის ისტორია',
    device: 'მოწყობილობა',
    contactUs: 'დაგვიკავშირდით',
    sessionLog: 'სესიის და ავტორიზაციის ლოგი',
    selectMethods: 'მეთოდების არჩევა',
    depositDetails: 'ანაბრის დეტალები',
    order: 'შეკვეთა',
    support: 'მხარდაჭერა',
    supportChat: 'ჩატი',
    createChat: 'ჩატის შექმნა',
    homepage: 'მთავარი',
    takeProfitStopLoss: 'Take Profit & Stop Loss',
    takeProfit: 'Take Profit',
    stopLoss: 'Stop Loss',
    updateOrder: 'შეკვეთის განახლება',
    balance: 'ბალანსი',
    credit: 'კრედიტი',
    equity: 'მონაწილეობა',
    practice: 'პრაქტიკა',
    real: 'ცენტრალური',
    account: 'ანგარიში',
    invested: 'დაბანდებულია',
    profit: 'მოგება',
    loss: 'ზარალი',
    margin: 'მარინა',
    marginLevel: 'მარინ. დონე',
    marginFree: 'თავისუფალი მარინა',
    cfd: 'CFD',
    platform: 'პლატფორმა',
    deposit: 'ანაბარი',
    marketWatch: 'ბაზრის მონიტორინგი',
    activeOrders: 'ღია შეკვეთები',
    tradingHistory: 'ტრანზაქციების ისტორია',
    economicCalendar: 'ეკონომიკური კალენდარი',
    marketNews: 'ბაზრის სიახლეები',
    closeOrder: 'პოზიციის დახურვა',
    areYouSure: 'დარწმუნებული ხართ?',
    buy: 'ყიდვა',
    sell: 'გაყიდვა',
    yes: 'დიახ',
    no: 'არა',
    addNewChart: 'ახალი გრაფიკის დამატება',
    watchlist: 'გადახედვის სიაში',
    asset: 'აქტივი',
    price: 'ფასი',
    changePct: 'ცვლა 24სთ-ში',
    pending: 'მიმდინარე',
    assetPrice: 'აქტივის ფასი',
    current: 'მიმდინარე',
    revert: 'ბაზრის ისევ ფასი',
    automatically: 'პოზიცია ავტომატურად გაიხსნება დაგეგმილი ქულით',
    default: 'სტანდარტული',
    volume: 'მოცულობა',
    lots: 'ლოტები',
    units: 'ერთეულები',
    currency: 'ვალუტა',
    contractSize: 'კონტრაქტის ზომა',
    position: 'პოზიცია',
    freeMargin: 'თავისუფალი მარინა',
    market: 'ბაზარი',
    leverage: 'ლევერიჯი',
    spread: 'სპრედი',
    notSet: 'არ არის მითითებული',
    at: 'ზე',
    open247: 'ღია 24/7',
    today: 'დღეს',
    tomorrow: 'ხვალ',
    sunday: 'კვირა',
    monday: 'ორშაბათი',
    tuesday: 'სამშაბათი',
    wednesday: 'ოთხშაბათი',
    thursday: 'ხუთშაბათი',
    friday: 'პარასკევი',
    saturday: 'შაბათი',
    contractSpecification: 'კონტრაქტის სპეციფიკაცია',
    name: 'სახელი',
    baseCurrency: 'ძირითადი ვალუტა',
    digits: 'ციფრები',
    lotSize: 'ლოტის ზომა',
    lotStep: 'ლოტის ნაბიჯი',
    minVolume: 'მინ. მოცულობა',
    maxVolume: 'მაქს. მოცულობა',
    leverage: 'ლევერიჯი',
    schedule: 'განრიგი',
    weekday: 'კვირის დღე',
    tradingTime: 'ტრანზაქციების დრო',
    closed: 'დახურული',
    low: 'ქვედა',
    medium: 'საშუალო',
    high: 'ზედა',
    oneHourChange: '1სა ცვლილება',
    oneDayChange: '1დღ ცვლილება',
    oneWeekChange: '1კვირ ცვლილება',
    oneMonthChange: '1თვ ცვლილება',
    threeMonthsChange: '3თვ ცვლილება',
    oneYearChange: '1წ შეცვლ.',
    loading: 'იტვირთება…',

    traderTitle: 'ავტო ტრეიდერი',
    traderConfirm: 'დაადასტურეთ და შეინახეთ',
    riskLevelLow: 'რისკი: დაბალი',
    riskLevelMedium: 'რისკი: საშუალო',
    riskLevelHigh: 'რისკი: მაღალი',
    perDay: 'ტრანზაქციები დღეში:',
    desc: `CFD-ებისა და სხვა ფოზიციების ვაჭრობა მატებს რისკს.
        გაეცანით ჩვენს რისკის პოლიტიკას. ავტომატური ვაჭრობა შედეგებს არ განაღდებს.`,
    accept: 'აღიქვა',

    trade: 'გარიგება',
    startTrading: 'ტრანზაქციის დაწყება',
    deposit: 'ანაბარი',
    dashboard: 'პანელი',
    personalData: 'პირადი მონაცემები',
    withdrawFunds: 'შეღარაგები',
    savings: 'შენახვა',
    settings: 'პარამეტრები',
    logout: 'გასვლა',

    BT_INVOICE: 'ნომრის შეყვანა და ინვოისის გენერატორი',
    BT_TITLE: 'ბანკის დეტალები',
    bank_name: 'ბანკის სახელი',
    beneficiary: 'ბენეფიციარი',
    beneficiary_address: 'ბენეფიციარის მისამართი',
    swift: 'SWIFT',
    iban: 'IBAN',
    ru_inn: 'INN',
    ru_kpp: 'KPP',
    corresponding_account: 'კორესპონდენტი ანგარიში',

    TOKEN_AMOUNT: 'რაოდენობა',
    TOKEN_SUBTOTAL: 'ქვეჯამი',
    TOKEN_TOTAL: 'ჯამი',
    TOKEN_DESCRIPTION: 'აღწერა',
    TOKEN_PAYMENT_DETAILS: 'გადახდის დეტალები',
    PENDING_DEPOSITS_LIMIT: 'ანაბრის ლიმიტი',
    makeDeposit: 'ანაბრის განთავსება',
    practiceAccount: 'დემო ანგარიში',
    realAccount: 'რეალური ანგარიში',
    noWithdrawals: 'გარიგება არ არის',
    easyWithdrawals: 'შელამაზეს გაღება',
    allAssets: 'მიმდინ. აქტივები',
    fullFledged: 'სრული პლატფორმა',
    fillUpTo: 'შევსება',
    freeReplenishment: 'უფასო შევსება',
    topUp: 'ანგარიშის შევსება',
    minimumAmount: 'მინ. თანხა',
    maxAmount: 'მაქს. თანხა',
    withdrawalType: 'გარიგების ტიპი',
    canSwitch: 'ანგარიშებს შორის გადართვა ნებისმიერ დროს',
    chartGrids: 'გრაფიკის გრიდები',
    chart1: '1 გრაფიკი',
    chart2: '2 გრაფიკი',
    chart3: '3 გრაფიკი',
    chart4: '4 გრაფიკი',
    connectionLost: 'კავშირი დაკარგულია',
    retryNow: 'გაიმეორე ახლა',
    loginToTradeRoom: 'შეიყვანოთ სავაჭრო ოთახში',
    email: 'ელ–ფოსტა',
    enterEmail: 'შეიყვანეთ ელ–ფოსტა',
    twoFactor: '2FA კოდი',
    twoFactorAuth: 'ორი ფაქტორიანი ავტორიზაცია',
    password: 'პაროლი',
    yourPassword: 'თქვენი პაროლი',
    signIn: 'ავტორიზაცია',
    dontHaveAccount: 'ანგარიში არ გაქვთ?',
    restore: 'აღდგენა',
    fullName: 'სახელი და გვარი',
    havePromo: 'პრომო კოდი მაქვს',
    promo: 'პრომო კოდი',
    login: 'შესვლა',
    haveAccount: 'უკვე გაქვს ანგარიში?',
    hide: 'დამალვა',
    goTo: 'უკან',

    setNewPassword: 'პაროლის შეცვლა',
    newPassword: 'ახალი პაროლი',
    confirmNewPassword: 'პაროლის დადასტურება',
    setButton: 'გამოყენება',

    repeatPassword: 'პაროლის გამეორება',
    createNewAccount: 'ანგარიშის შექმნა',
    firstName: 'სრული სახელი',
    lastName: 'გვარი',
    country: 'ქვეყანა',
    phone: 'ტელეფონი',
    createAccount: 'ანგარიშის შექმნა',
    currency: 'ვალუტა',

    forgotPassword: 'პაროლი დაგავიწყდა?',
    submitEmail: 'გთხოვთ, შეყვანოთ რეგისტრაციის ელ-ფოსტა და მიჰყვეთ მითითებებს',
    submit: 'გაგზავნა',
    error: 'შეცდომა',
    success: 'წარმატება',
    depositApproved: 'ანაბარი დამტკიცებულია',
    depositDeclined: 'ანაბარი უარყოფილია',
    withdrawalApproved: 'გასვლა დამტკიცებულია',
    withdrawalDeclined: 'გასვლა უარყოფილია',

    forex: 'ფორექსი',
    stocks: 'ერთი აქცია',
    commodities: 'კომოდიტიები',
    indices: 'ინდექსები',
    crypto: 'კრიპტო',
    metals: 'მეტალები',
    nft: 'NFT',

    buy: 'ყიდვა',
    profitCalculator: 'მოგების კალკულატორი',
    sell: 'გაყიდვა',
    volume: 'მოცულობა',
    entryPrice: 'შეღავათის ფასი',
    takeProfit: 'Take Profit',
    stopLoss: 'Stop Loss',
    maxPosition: 'მაქს. პოზიცია',
    calculate: 'განგარიშობა',
    calculationsFor: 'განგარიშობა',
    leverage: 'ლევერიჯი',
    requiredMargin: 'საჭირო მარინა',
    profitFromTP: 'მოგება TP–ით',
    lossFromSL: 'ზარალი SL–ით',
    roe: 'ROE',

    title: 'განაღდება წარმატებულია',
    text: 'განაღდვა წარმატებით განხორციელდა!',

    title_fail: 'განაღდვა 실패',
    text_fail: 'განაღდვა ვერ განხორციელდა.',

    marketWatch: 'ბაზრის მონიტორინგი',
    search: 'ძიება...',

    commission: 'კომისია',
    volume: 'მოცულობა',
    margin: 'მარიჯა',
    active: 'აქტიური',
    pending: 'მიმდინარე',
    activeOrders: 'აქტიური შეკვეთები',
    portfolio: 'პორტფოლიო',
    allPositions: 'ყველა პოზიცია',
    noPositionsLine1: 'თქვენ არ გაქვთ',
    noPositionsLine2: 'ღია პოზიცია მაინც',
    show: 'ჩვენება',
    more: 'მეტი',
    less: 'ნაკლები',
    purchaseTime: 'შეძენის დრო',
    closePosition: 'პოზიციის დახურვა',
    priceOpen: 'შეძენის ფასი',
    priceSl: 'სტოპ ლოსის ფასი',
    priceTp: 'თეიკ პროფიტის ფასი',
    type: 'პოზიციის მიმართულება',
    pnl: 'მოგება/ზარალი',
    cancelOrder: 'შეკვეთის გაუქმება',
    orderType: 'შეკვეთის ტიპი',
    cancelled: 'გაუქმებულია',
    tradingHistory: 'ტრანზაქციების ისტორია',
    noHistoryLine1: 'თქვენ არ გაქვთ',
    noHistoryLine2: 'დახურული გარიგებები',

    economicCalendar: 'ეკონომიკური კალენდარი',

    marketNews: 'ბაზრის სიახლეები',

    ordersActive: 'აქტიური შეკვეთები',
    ordersHistory: 'დახურული შეკვეთები',
    id: 'ID',
    symbol: 'სიმბოლო',
    documentType: 'ტიპი',
    openPrice: 'გახსნის ფასი',
    openTime: 'გახსნის დრო',
    closePrice: 'დახურვის ფასი',
    closeTime: 'დახურვის დრო',
    sl: 'SL',
    tp: 'TP',
    price: 'ფასი',
    pnl: 'PnL',
    actions: 'ქმედებები',
    edit: 'რედაქტირება',
    close: 'დახურვა',
    swap: 'სვოპი',
    swapLong: 'სვოპი ლონგი',
    swapShort: 'სვოპი შორტი',

    assetInfo: 'აქტივის ინფორმაცია',
    tradingConditions: 'გარიგების პირობები',
    information: 'სესიის ცვლილება',
    bid: 'ყიდვა',
    ask: 'გაყიდვა',
    sessionChange: 'სესიის ცვლილება',
    tradeNow: 'გარიგება ახლა',
    opens: 'იხსნება',
    closes: 'იხურება',
    logOut: 'გამოსვლა',

    methods: 'მეთოდები',
    confirm: 'დაადასტურეთ ბანკის აპლიკაციაში',
    sendOtp: 'OTP-ის გაგზავნა',
    otpCode: 'OTP კოდი',
    addWalletAddress:
      'საფულის მისამართი არ არის მითითებული. მიმართეთ აგენტს ან მხარდაჭერას.',
    addressReceipt: 'გთხოვთ დაელოდოთ მისამართის ჩატვირთვას',
    makeDeposit: 'დააბანდეთ დეპოზიტი',
    instant: 'მყისიერი',
    minutes: 'წუთი',
    hours: 'საათი',
    days: 'დღე',
    amount: 'თანხა',
    continue: 'გაგრძელება',
    qrCode: 'QR კოდი',
    depositAddress: 'დეპოზიტის მისამართი',
    copy: 'კოპირება',
    last: 'ბოლო',
    deposits: 'დეპოზიტები',
    time: 'დრო',
    currency: 'ვალუტა',
    status: 'სტატუსი',
    info: 'ინფორმაცია',

    pleaseWait: 'გთხოვთ დაელოდოთ. კავშირი/payment provider...',
    cardPayment: 'ბარათით გადახდა',
    inOrder: 'თანხის გაგზავნისათვის',
    pleaseProvide: 'გთხოვთ მიაწოდოთ ბარათის დეტალები:',

    completeVerification: 'ვერიფიკაციის დასრულება',
    noOrderYet: 'ჯერ არ არის შეკვეთა',
    totalBalance: 'ჯამური ბალანსი',
    totalDeposits: 'ჯამური დეპოზიტები',
    profitableOrders: 'ლाभიანი შეკვეთები',
    totalPnl: 'PnL ჯამში',
    roi: 'ROI',
    activityLog: 'აქტივობის ლოგი',
    loginFromIp: 'ავტორიზაცია IP-დან',
    tradingResults: 'ტრანზაქციების შედეგები',
    week: 'კვირა',
    month: 'თვე',
    year: 'წელი',
    successRate: 'წარმატების დონე',
    closedWithProfit: 'დახურული პეზიციები ლाभით',
    closedWithLoss: 'დახურული პოზიციები ზარალით',
    account: 'ანგარიში',
    balance: 'ბალანსი',
    leverage: 'ლევერიჯი',
    credit: 'კრედიტი',
    tradeNow: 'გარიგება ახლა',
    usingCurrentRate: 'მიმდინარე კურსით',

    personalDetails: 'პირადი დეტალები',
    profilePhoto: 'პრომო ფოტო',
    firstName: 'სახელი',
    country: 'ქვეყანა',
    lastName: 'გვარი',
    address: 'მისამართი',
    email: 'ელ.ფოსტა',
    phone: 'ტელეფონი',
    saveChanges: 'ცვლილებების შენახვა',

    dropFile: 'ჩააგდეთ ფაილი ატვირთვის სექციაში',
    notAllowed: 'გამავრცელებისთვის არაა ნებადართული',
    notAllowedLine1: 'პორნოგრაფიული ფოტოების ატვირთვა მკაცრად აიკრძალება',
    notAllowedLine2: 'ეთნიკური ან რასობრივი სიძულვილის ამაღლების მიზნით',
    notAllowedLine3: '18 წლამდე პირების ფოტოების ატვირთვა',
    notAllowedLine4: 'პირადი ან ქოპირების უფლებით დაცული შინაარსი',
    notAllowedLine5: '5MB-ზე დიდი JPG, GIF ან PNG ფაილი არ მიიღება',
    requirements:
      'თქვენი სახე უნდა იყო ნათლად გარჩევადი. სხვა პირობები უნდა შესრულდეს.',

    withdrawalOff: 'გთხოვთ მიმართოთ თქვენი ანგარიშის მენეჯერს დეტალებისთვის',
    cryptocurrency: 'კრიპტოვალუტა',
    withdrawal: 'გამოტანა',
    requestNewWithdrawal: 'ახალი გამოტანის მოთხოვნა',
    amount: 'თანხა',
    currentBalance: 'თქვენი მიმდინარე ბალანსია',
    withdrawAll: 'ყველა გამოტანა',
    requestWithdrawal: 'გამოტანის მოთხოვნა',
    last: 'ბოლო',
    withdrawalRequests: 'გამოტანის მოთხოვნები',
    time: 'დრო',
    currency: 'ვალუტა',
    info: 'ინფორმაცია',
    status: 'სტატუსი',
    bank: 'банк',
    bitcoin: 'ბიტკოინი',
    card: 'ბარათი',
    ethereum: 'ეთერიუმი',
    eth: 'ეთერიუმი',
    usdt: 'USDT',
    withdrawalDetails: 'გამოტანის დეტალები',
    address: 'საფულის მისამართი',
    bankAccount: 'ანგარიშის ნომერი',
    bankHolder: 'ანგარიშის მფლობელი',
    bankIban: 'IBAN',
    bankSwift: 'SWIFT კოდი',
    cardNumber: 'ბარათის ნომერი',
    cardHolder: 'ბარათის მფლობელი',

    dragAndDrop: 'გადაათრიეთ და მოათავსეთ აქ',
    documentsList: 'ატვირთული დოკუმენტების სია',
    document: 'დოკუმენტი',
    timeUploaded: 'ატვირთვის დრო',
    timeProcessed: 'პროცესირების დრო',
    status: 'სტატუსი',
    types: [
      'დოკუმენტი იდენტიფიკაციისთვის',
      'საბინაო დოკუმენტი',
      'ბარათის წინა მხარე',
      'ბარათის უკანა მხარე',
      'პირადობის უკანა მხარე',
      'სელფი',
    ],
    types2: [
      'POI დოკუმენტი',
      'მისამართის დოკუმენტი',
      'ბარათის წინა მხარე',
      'ბარათის უკანა მხარე',
      'პირადობის უკანა მხარე',
      'სელფი ID-თან ერთად',
    ],

    upload: 'ატვირთვა',
    isConfirmed: 'დადასტურებულია',
    uploadAnotherDocument: 'ატვირთვა სხვა დოკუმენტის',
    isUnderReview: 'შეფასების პროცესშია',
    questionnaire: 'ითხოვნა',
    sendAnswers: 'პასუხების გაგზავნა',
    progressBarOf: '-დან',
    progressBarText: 'თქვენი დოკუმენტები ატვირთულია და დადასტურებულია',

    manageAccounts: 'ანგარიშების შორის თანხის გადარიცხვა',
    transferFrom: 'ანგარიშიდან',
    transferTo: 'ანგარიშზე',
    amount: 'თანხა',
    makeTransfer: 'გადარიცხვა',
    yourAccounts: 'თქვენი ანგარიშები',
    account: 'ანგარიში',
    currency: 'ვალუტა',
    balance: 'ბალანსი',
    credit: 'ბალანსი ციფრულად',
    makeActive: ' გააქტიურება',
    active: 'აქტიური',

    sendMessage: 'შეტყობინების გაგზავნა',

    pct_0: 'მორგებადი',
    pct_30: 'ბლოკირებული 1 თვე',
    pct_90: 'ბლოკირებული 1 კვარტალი',
    pct_180: 'ბლოკირებული 6 თვე',
    pct_365: 'ბლოკირებული 1 წელი',
    savings: 'შენატანები',
    detailedInformation: 'დეტალური ინფორმაცია',
    pleaseSelect: 'აირჩიეთ ვალუტა და პერიოდი',
    openSavings: 'შენატანების გახსნა',
    currentTime: 'მიმდინარე დრო',
    releaseTime: 'გამოსვლის დრო',
    currencyChosen: 'არჩეული ვალუტა',
    periodChosen: 'არჩეული პერიოდი',
    yourRate: 'თქვენი განაკვეთი',
    yourEarnings: 'თქვენი მოგებული',
    accountFrom: 'ანგარიში, საიდანაც გადაირიცხება',
    enterAmount: 'თანხის შეყვანა',
    in: '-ში',
    openAndInvest: 'შენატანების ანგარიში და ინვესტიცია',
    investment: 'ინვესტიცია',
    period: 'პერიოდი',
    daysTotal: 'დღეების რაოდენობა',
    finalEarnings: 'საბოლოო მოგება',
    created: 'შექმნილია',
    daysElapsed: 'გავლილი დღეები',
    days: 'დღეები',
    earnings: 'შემოსავალი',
    fundsReleasedIn: 'რის გამოც განთავისუფლდება',
    claim: 'მოთხოვნა',

    updatePassword: 'პაროლის განახლება',
    currentPassword: 'მიმდინარე პაროლი',
    newPassword: 'ახალი პაროლი',
    changePassword: 'პაროლის შეცვლა',
    activationForGoogle: 'Google Authenticator-ის აქტივაციის კოდი',
    activateAndEnter: 'აქტივაცია და კოდის შეყვანა ქვემოთ',
    qrCode: 'QR კოდი',
    activateProtection: '2FA დაცვაზე გადართვა',
    protectionActive: '2FA დაცვა აქტიურია',
    twoFactorCode: '2FA კოდი',
    disableProtection: '2FA დაცვის გამორთვა',
    language: 'ენა',
    dashboardCurrency: 'ტაბლოს ვალუტა',
    confirmNewPassword: 'ახალი პაროლის დადასტურება',

    yourLink: 'თქვენი რეფერალური ბმული',
    referredFriends: 'რეფერირებული მეგობრები',
    id: 'ID',
    name: 'სახელი',
    registered: 'დარეგისტრირებული',
    level: 'საფეხური',
    payout: 'გადახდა',
    lastPayouts: 'ბოლო რეფერალური გადახდები',
    time: 'დრო',
    amount: 'თანხა',
    info: 'ინფო',

    Jan: 'იან',
    Feb: 'თებ',
    Mar: 'მარ',
    Apr: 'აპრ',
    May: 'მაი',
    Jun: 'ივნ',
    Jul: 'ივლ',
    Aug: 'აგვ',
    Sep: 'სენ',
    Oct: 'ოქტ',
    Nov: 'ნოვ',
    Dec: 'დეკ',

    orderTypes: [
      'ყიდვა',
      'გაყიდვა',
      'ყიდვა ლიმიტით',
      'გაყიდვა ლიმიტით',
      'ყიდვა სტოპით',
      'გაყიდვა სტოპით',
    ],
    statuses: [
      'მიმდინარე',
      'დამტკიცებული',
      'უარყოფილი',
      'მიმდინარე რეალიზაცია',
    ],

    NOT_FOUND: 'შეთავსების შეცდომა',
    FORBIDDEN: 'წვდომა აკრძალულია. გთხოვთ გაიაროთ ავტორიზაცია',
    SERVER_ERROR: 'მოქმედება ვერ შესრულდა. გთხოვთ გაიმეოროთ მოგვიანებით',
    INVALID_ACCOUNT: 'სესიის ვადა ამოიწურა. გთხოვთ გაიაროთ ავტორიზაცია',
    INVALID_EMAIL: 'არასწორი ელ-ფოსტა',
    INVALID_PHONE: 'არასწორი ტელეფონის №',
    INVALID_COUNTRY: 'არასწორი ქვეყანა',
    INVALID_LOGIN: 'არასწორი ავტორიზაცია',
    USER_BLOCKED: 'ანგარიში დაბლოკილია. მიმართეთ მხარდაჭერას',
    USER_REGISTERED: 'უნდა ჰქონდეს რეგისტრირებული ელ-ფოსტა ან ტელეფონი',
    INVALID_USER: 'მომხმარებელი ვერ მოიძებნა',
    REJECTED: 'ოპერაცია აკრძალულია პლატფორმის წესებით',
    INVALID_OLD_PASSWORD: 'ძველი პაროლი არასწორია',
    INVALID_SYMBOL: 'არასწორი სიმბოლო',
    INVALID_SYMBOL_PRECISION: 'სიმბოლოს რეგულირება არასწორია',
    INVALID_FRAME: 'არასწორი ჩარტის ჩარჩო',
    INVALID_CURRENCY: 'არასწორი ვალუტა',
    INVALID_PRODUCT: 'არასწორი სავაჭრო ტიპი',
    INSUFFICIENT_FUNDS: 'მარაგი არ არის საკმარისი',
    INVALID_WITHDRAWAL: 'გამოტანა ვერ მოიძებნა',
    INVALID_STATUS: 'არასწორი სტატუსი',
    INVALID_FILE: 'არასწორი ფაილის გაფართოება ან ზომა',
    INVALID_DOCUMENT: 'დოკუმენტი ვერ მოიძებნა',
    INVALID_NAME: 'არასწორი სახელი',
    INVALID_LOT_SIZE: 'არასწორი ლოტის ზომა',
    INVALID_LOT_STEP: 'არასწორი ლოტის ნაბიჯი',
    INVALID_MIN_VOLUME: 'არესო მინ. მოცულობა',
    INVALID_MAX_VOLUME: 'არესო მაქს. მოცულობა',
    INVALID_GROUP: 'არასწორი ჯგუფი',
    INVALID_SPREAD: 'არასწორი სპრედი',
    REQUEST_TIMEOUT: 'მოთხოვნის ვადა დასრულდა. გთხოვთ გაიმეოროთ',
    INVALID_TYPE: 'არასწორი შეკვეთის ტიპი',
    INVALID_VOLUME: 'არასწორი რაოდენობა',
    INVALID_SL: 'არასწორი Stop Loss',
    INVALID_TP: 'არასწორი Take Profit',
    INVALID_PRICE: 'არასწორი ფასი',
    INVALID_EXPIRATION: 'არასწორი ვადა',
    NOT_ENOUGH_MARGIN: 'მარაგი არ არის საკმარისი',
    INVALID_ORDER: 'შეკვეთა ვერ მოიძებნა',
    MARKET_CLOSED: 'ბაზარი დახურულია. გთხოვთ სცადოთ მოგვიანებით',
    INVALID_BALANCE_TYPE: 'არასწორი ბალანსის ტიპი',
    INVALID_HASH: 'არასწორი ჰეში',
    HASH_EXPIRED: 'პაროლის შეცვლის ბმული ვადაგასულია. გთხოვთ მოითხოვოთ ახალი',
    INVALID_CODE: 'არასწორი 2FA კოდი',
    CHAT_DISABLED: 'მხარდაჭერის ჩატი დახურულია',
    WITHDRAWAL_NOT_ALLOWED: 'გამოტანა მიუწვდომელია',
    TRADING_DISABLED: 'სავაჭრო მიუწვდომელია ამ ანგარიშზე',
    PENDING_DEPOSITS_LIMIT: 'ანაბრების ლიმიტი გადაჭარბებულია',
    LOCAL_ONE_PENDING_WITHDRAWAL: 'ერთმანეთი ერთი გამოტანის მოთხოვნაა',
    LOCAL_DEPOSIT_ONLY_REAL: 'ანაბარი მხოლოდ რეალურ ანგარიშზეა',
    LOCAL_DEPOSIT_POSITIVE: 'ანაბრის ოდენობა უნდა იყოს > 0',
    LOCAL_INVALID_CARD_NUMBER: 'არასწორი ბარათის №',
    LOCAL_INVALID_CARD_EXPIRATION: 'არასწორი ვადაგასვლის დრო',
    LOCAL_INVALID_CVC: 'არასწორი CVV/CVC',
    LOCAL_PASSWORDS_NOT_MATCH: 'პაროლები არ ემთხვევა',
    LOCAL_NO_TRADING_ACCOUNTS:
      'სავაჭრო ანგარიშები არ გაქვთ. მიმართეთ მხარდაჭერას',
    LOCAL_MIN_DEPOSIT: 'მინ. ანაბარი არის $',
    LOCAL_MIN_WITHDRAWAL: 'მინ. გამოტანა არის $',
    LOCAL_INVALID_FILE_TYPE:
      'ფაილის ფორმატი არ მხარდაჭერილია. მხოლოდ JPG, PNG, PDF',
    LOCAL_MIN_STAKING: 'მინ. ანაბარი ამ ვალუტაში არის ',
    FLOOD_REJECTED: 'პაროლები ხშირად არასწორია. გთხოვთ სცადოთ მოგვიანებით',

    countries: {
      AF: 'აფგანისტანი',
      AX: 'ალანდის კუნძულები',
      AL: 'ალბანეთი',
      DZ: 'ალჟირი',
      AS: 'ამერიკულ სამოა',
      AD: 'ანდორა',
      AO: 'ანგოლა',
      AI: 'ანგილა',
      AQ: 'ანტარქტიკა',
      AG: 'ანტიგუა და ბარბუდა',
      AR: 'არგენტინა',
      AM: 'სომხეთი',
      AW: 'ნარარუ',
      AU: 'ავსტრალია',
      AT: 'ავსტრია',
      AZ: 'აზერბაიჯანი',
      BS: 'ბაჰამის კუნძლები',
      BH: 'ბაჰრეინი',
      BD: 'ბანგლადეში',
      BB: 'ბარბადოსი',
      BY: 'ბელარუსი',
      BE: 'ბელგია',
      BZ: 'ბელიზი',
      BJ: 'ბენინი',
      BM: 'ბერმუდის კუნძულები',
      BT: 'ბუტანი',
      BO: 'ბოლივია',
      BA: 'ბოსნია და ჰერცეგოვინა',
      BW: 'ბოტსვანა',
      BV: 'ბუვეს კუნძული',
      BR: 'ბრაზილია',
      IO: 'ბრიტანეთის ინდოეთის ოკეანის ტერიტორია',
      BN: 'ბრუნე',
      BG: 'ბულგარეთი',
      BF: 'ბურკინა ფასო',
      BI: 'ბურუნდი',
      KH: 'კამბოჯა',
      CM: 'კამერუნი',
      CA: 'კანადა',
      CV: 'კაბო-ვერდე',
      KY: 'კეიმანის კუნძულები',
      CF: 'ცენტრალური აფრიკის რესპუბლიკა',
      TD: 'ჩადი',
      CL: 'ჩილე',
      CN: 'ჩინეთი',
      CX: 'შობა კუნძული',
      CC: 'კოკოსის კუნძულები',
      CO: 'კოლუმბია',
      KM: 'კომორი',
      CG: 'კონგო',
      CD: 'კონგოს დემოკრატიული რესპუბლიკა',
      CK: 'კუკის კუნძულები',
      CR: 'კოსტა-რიკა',
      CI: 'კოტ-დ’ივუარი',
      HR: 'ხორვატია',
      CU: 'კუბა',
      CY: 'კვიპროსი',
      CZ: 'ჩეხეთის რესპუბლიკა',
      DK: 'დანია',
      DJ: 'ჯიბუტი',
      DM: 'დომინიკა',
      DO: 'დომინიკის რესპუბლიკა',
      EC: 'ეკვადორი',
      EG: 'ეგვიპტე',
      SV: 'სალვადორი',
      GQ: 'ეკვატორიული გვინეა',
      ER: 'ერისი',
      EE: 'ესტონეთი',
      ET: 'ეთიოპია',
      FK: 'ფალკლანდის კუნძულები',
      FO: 'ფარერის კუნძულები',
      FJ: 'ფიჯი',
      FI: 'ფინეთი',
      FR: 'საფრანგეთი',
      GF: 'ფრანგული გვიანა',
      PF: 'ფრანგული პოლინეზია',
      TF: 'ფრანგული სამხრეთი ტერიტორიები',
      GA: 'გვაბონი',
      GM: 'განა',
      GE: 'საქართველო',
      DE: 'გერმანია',
      GH: 'ღანა',
      GI: 'გიბრალტარი',
      GR: 'საბერძნეთი',
      GL: 'გრენლანდია',
      GD: 'გრენადა',
      GP: 'გვადელუპა',
      GU: 'გუამი',
      GT: 'გვატემალა',
      GG: 'გერნსი',
      GN: 'გვინეა',
      GW: 'გვინეა - ბისაუ',
      GY: 'გაიანა',
      HT: 'ჰაიტი',
      HM: 'ჰერდი და მაკდონალდის კუნძულები',
      VA: 'ვატიკანი',
      HN: 'ჰონდურასი',
      HK: 'ჰონგ კონგი',
      HU: 'უნგრეთი',
      IS: 'ისლანდია',
      IN: 'ინდოეთი',
      ID: 'ინდონეზია',
      IR: 'ირანი',
      IQ: 'ირანი',
      IE: 'ირლანდია',
      IM: 'მან კუნძული',
      IL: 'ისრაელი',
      IT: 'იტალია',
      JM: 'იამაიკა',
      JP: 'იაპონია',
      JE: 'ჯერსი',
      JO: 'იორდანია',
      KZ: 'ყაზახეთი',
      KE: 'კენია',
      KI: 'კირიბატი',
      KR: 'სამხრეთ კორეა',
      KW: 'ქუვეითი',
      KG: 'ყირგიზეთი',
      LA: 'ლაოსის სახალხო დემოკრატიული რესპუბლიკა',
      LV: 'ლატვია',
      LB: 'ლესოთო',
      LS: 'ლიბერია',
      LY: 'ლიბია',
      LI: 'ლიხტენშტაინი',
      LT: 'ლიტვა',
      LU: 'ლუქსემბურგი',
      MO: 'მაკაო',
      MK: 'მაკედონია',
      MG: 'მადაგასკარი',
      MW: 'მალავი',
      MY: 'მალაიზია',
      MV: 'მალტები',
      ML: 'მალი',
      MT: 'მალტა',
      MH: 'მარშალის კუნძულები',
      MQ: 'მარტინიკის კუნძულები',
      MR: 'მავრიტანია',
      MU: 'მავრიკი',
      YT: 'მაიოტი',
      MX: 'მექსიკა',
      FM: 'მიკრონეზია',
      MD: 'მოლდოვა',
      MC: 'მონაკო',
      MN: 'მონღოლეთი',
      ME: 'მოგენეგრო',
      MS: 'მონტსერატი',
      MA: 'მოროკო',
      MZ: 'მოზამბიკი',
      MM: 'მიანმა',
      NA: 'ნამიბია',
      NR: 'ნაურუ',
      NP: 'ნეპალი',
      NL: 'ნიდერლანდები',
      AN: 'ნიდერლანდების ანტილები',
      NC: 'ახალი კალედონია',
      NZ: 'ახალი ზელანდია',
      NI: 'ნიკარაგუა',
      NE: 'ნიგერი',
      NG: 'ნიგერია',
      NU: 'ნიოე',
      NF: 'ნორფოლკის კუნძული',
      MP: 'ჩრდილოეთ მარიანას კუნძულები',
      NO: 'ნორვეგია',
      OM: 'ომანი',
      PK: 'პაკისტანი',
      PW: 'პალაუ',
      PS: 'პალესტინის ოკუპირებული ტერიტორიები',
      PA: 'პანამა',
      PG: 'პაპუა ახალი გვინეა',
      PY: 'პარაგვაი',
      PE: 'პერუ',
      PH: 'ფილიპინები',
      PN: 'პიტკერნის კუნძულები',
      PL: 'პოლონეთი',
      PT: 'პორტუგალია',
      PR: 'პუერტო-რიკო',
      QA: 'კატარი',
      RE: 'რეიუენიონი',
      RO: 'რუმინეთი',
      RU: 'რუსეთი',
      RW: 'რუანდა',
      BL: 'სეინტ-ბარტელემი',
      SH: 'სეინთ-ჰელენა',
      KN: 'სეინთ-კიტსი და ნევისი',
      LC: 'სეინთ-ლ Lucie',
      MF: 'სეინთ-მარტინი',
      PM: 'სეინთ-პიერ-ემი და მიქელონი',
      VC: 'სეინთ-ვინსენტი და გRENადინები',
      WS: 'სამოა',
      SM: 'სან-მარინო',
      ST: 'საო ტომე და პრინსიპე',
      SA: 'საუდის არაბეთი',
      SN: 'სენეგალი',
      RS: 'სერბეთი',
      SC: 'სეიშელის კუნძულები',
      SL: 'სიერა ლეონე',
      SG: 'სინგაპური',
      SK: 'სლოვაკეთი',
      SI: 'სლოვენია',
      SB: 'სოლომონის კუნძულები',
      SO: 'სამალი',
      ZA: 'სამხრეთ აფრიკა',
      GS: 'სამხრეთ ჯორჯია და სენდვიჩის კუნძულები',
      ES: 'ესპანეთი',
      LK: 'შრი-ლანკა',
      SD: 'სუდანი',
      SR: 'სურინამი',
      SJ: 'სვალბარდი და იან მაიენი',
      SZ: 'ესუატინი',
      SE: 'შვედეთი',
      CH: 'შვეიცარია',
      SY: 'სირიის არაბული რესპუბლიკა',
      TW: 'ტაივანი',
      TJ: 'ტაჯიკეთი',
      TZ: 'ტანზანია',
      TH: 'ტაილანდი',
      TL: 'თიმორი-ლესთე',
      TG: 'ტოგო',
      TK: 'ტომელაუ',
      TO: 'ტონგა',
      TT: 'ტრინიდადი და ტობაგო',
      TN: 'ტუნისი',
      TR: 'თურქეთი',
      TM: 'თურქმენეთი',
      TC: 'თურქს და ქეკოს კუნძულები',
      TV: 'ტუვალუ',
      UG: 'უგანკა',
      UA: 'უკრაინა',
      AE: 'ონაერთებული არაბთა ემირატები',
      GB: 'დიდი ბრიტანეთი',
      US: 'აშშ',
      UM: 'აშშ-ის შორეული კუნძულები',
      UY: 'ურუგვაი',
      UZ: 'უზბეკეთი',
      VU: 'ვანუატუ',
      VE: 'ვენესუელა',
      VN: 'ვიეტნამი',
      VG: 'ბრიტანეთის დედაქალაქი კუნძულები',
      VI: 'აშშ-ის ვირჯინიის კუნძულები',
      WF: 'ვალისი და ფუტუნა',
      EH: 'დასავლეთი საჰარა',
      YE: 'იემენი',
      ZM: 'ზამბია',
      ZW: 'ზიმბაბვე',
    },
  },
  rs: {
    _name: 'Srpski',
    policy: 'Политика приватности',
    policyAML: 'AML политика',
    policyKYC: 'KYC политика',
    locense: 'Лиценца',
    view_all: 'Прикажи све',
    sell_btn: 'Продај',
    buy_btn: 'Купи',
    currency_action: 'валута',

    importantAccountDetails: 'Важни подаци о налогу',
    viewAdditionalSettings: 'Погледај додатна подешавања',
    switchDarkMode: 'Пређи на тамни/светли режим',
    writeProblem: 'Опиши нам свој проблем',
    darkMode: 'Тамни режим',

    yay: 'Јупи',
    purchased: 'Успешно сте купили',
    from: 'од',
    walet: 'Новчаник',
    trade: 'Тргуј',

    withdrawDetails: 'Детаљи повлачења',
    saveDetails: 'Сачувај детаље за следећи пут',
    amountToWithdraw: 'Износ за повлачење',
    withdrawLimit: 'Дневни лимит за повлачење од $1.000.000,00 остао.',

    serviceFee: 'Накнада за услугу',
    youWillPay: 'Платите',
    cancel: 'Откажи',
    understand: 'Разумем, настави',

    select: 'Изабери',
    enterAmount: 'Унеси износ',
    orderInfo: 'Информације о налогу',
    confirmOrder: 'Потврди налог',
    get: 'Добиј',
    spend: 'Потроши',
    buying: 'Куповина',
    accountTransactions: 'Трансакције на рачуну',
    overview: 'Преглед',
    accountBalances: 'Стања на рачуну',
    details: 'Детаљи',
    loginHistory: 'Историја пријава',
    device: 'Уређај',
    contactUs: 'Контактирајте нас',
    sessionLog: 'Сесије и историја пријава',
    selectMethods: 'Изабери методе',
    depositDetails: 'Детаљи уплате',
    order: 'Налог',
    support: 'Подршка',
    supportChat: 'Подршка ћаскање',
    createChat: 'Креирај ћаскање',
    homepage: 'Почетна страница',
    takeProfitStopLoss: 'Зарада и стоп лосс',
    takeProfit: 'Зарада',
    stopLoss: 'Стоп лосс',
    updateOrder: 'Ажурирај налог',
    balance: 'Стање',
    credit: 'Кредит',
    equity: 'Капитал',
    practice: 'ПРАКТИКА',
    real: 'ПРАВО',
    account: 'НАЛОГ',
    invested: 'Уложено',
    profit: 'Добит',
    loss: 'Губитак',
    margin: 'Маргина',
    marginLevel: 'Ниво маргине',
    marginFree: 'Слободна маргина',
    cfd: 'CFD',
    platform: 'Платформа',
    deposit: 'Уплата',
    marketWatch: 'Преглед тржишта',
    activeOrders: 'Отворени налози',
    tradingHistory: 'Историја трговања',
    economicCalendar: 'Економски календар',
    marketNews: 'Вести са тржишта',
    closeOrder: 'Затвори позицију',
    areYouSure: 'Да ли сте сигурни да желите затворити позицију',
    buy: 'Купи',
    sell: 'Продај',
    yes: 'Да',
    no: 'Не',
    addNewChart: 'Додај нови графикон',
    watchlist: 'Листа праћења',
    asset: 'Средство',
    price: 'Цена',
    changePct: 'Промена за 24ч',
    pending: 'На чекању',
    assetPrice: 'Цена средства',
    current: 'Тренутно',
    revert: 'Врати на тржишну цену',
    automatically:
      'Позиција ће бити отворена аутоматски када цена достигне овај ниво',
    default: 'подразумевано',
    volume: 'Обим',
    lots: 'лотови',
    units: 'јединице',
    currency: 'валута',
    contractSize: 'Величина уговора',
    position: 'Позиција',
    margin: 'Маргина',
    freeMargin: 'Слободна маргина',
    takeProfitStopLoss: 'Зарада и стоп лосс',
    pending: 'На чекању',
    market: 'Тржиште',
    leverage: 'Полуга',
    spread: 'Спред',
    notSet: 'Није постављено',
    at: 'по',
    buy: 'купи',
    sell: 'продај',
    supportBanner: 'СВАКОГ ДАНА, 24 САТА',
    currentTime: 'Тренутно време',
    liveChat: 'Уживо ћаскање',
    balance: 'Стање',
    credit: 'Кредит',
    equity: 'Капитал',
    margin: 'Маргина',
    marginLevel: 'Ниво маргине',
    freeMargin: 'Слободна маргина',
    pnl: 'ПнЛ',
    profitTotal: 'Укупни ПнЛ',
    dateRegistered: 'Датум регистрације',
    userId: 'ID корисника',
    dashboard: 'Контролна табла',
    personalData: 'Лични подаци',
    deposit: 'Уплата',
    withdrawFunds: 'Подигни средства',
    savings: 'Штедња',
    settings: 'Подешавања',
    logout: 'Одјави се',
    BT_INVOICE: 'Унеси износ и генериши фактуру',
    BT_TITLE: 'Наши банкарски подаци',
    account: 'Рачун',
    bank_name: 'Назив банке',
    beneficiary: 'Прималац',
    beneficiary_address: 'Адреса примаоца',
    swift: 'SWIFT',
    iban: 'IBAN',
    ru_inn: 'ИНН',
    ru_kpp: 'КПП',
    corresponding_account: 'Кореспондентски рачун',
    TOKEN_AMOUNT: 'Износ',
    TOKEN_SUBTOTAL: 'Међузбир',
    TOKEN_TOTAL: 'Укупно',
    TOKEN_DESCRIPTION: 'Опис',
    TOKEN_PAYMENT_DETAILS: 'Детаљи плаћања',
    PENDING_DEPOSITS_LIMIT: 'Лимит уплата',
    makeDeposit: 'Изврши уплату',
    practiceAccount: 'Демо рачун',
    realAccount: 'Прави рачун',
    noWithdrawals: 'Нема исплата',
    easyWithdrawals: 'Лаке исплате',
    allAssets: 'Сва расположива средства',
    fullFledged: 'Потпуна платформа',
    fillUpTo: 'Допуни до',
    freeReplenishment: 'Бесплатно допуњавање',
    topUp: 'Допуни рачун',
    minimumAmount: 'Минимални износ',
    maxAmount: 'Максимални износ',
    withdrawalType: 'Тип повлачења',
    canSwitch: 'Можете се пребацити између рачуна у било ком тренутку',
    chartGrids: 'МРЕЖЕ ГРАФИКОНА',
    chart1: '1 графикон',
    chart2: '2 графикона',
    chart3: '3 графикона',
    chart4: '4 графикона',
    connectionLost: 'Веза са сервером је изгубљена',
    retryNow: 'Покушај поново',
    loginToTradeRoom: 'Пријави се у трговачку собу',
    email: 'Адреса е-поште',
    enterEmail: 'Унеси своју е-пошту',
    twoFactor: '2FA код (ако је омогућено)',
    twoFactorAuth: 'Двофакторска аутентификација',
    password: 'Лозинка',
    yourPassword: 'Ваша лозинка',
    signIn: 'Пријави се',
    dontHaveAccount: 'Немате налог?',
    restore: 'Врати',
    fullName: 'Пуно име',
    havePromo: 'Имам промо код',
    promo: 'Промо код',
    login: 'Пријава',
    haveAccount: 'Већ имате налог?',
    hide: 'Сакриј',
    goTo: 'Врати се назад',

    setNewPassword: 'Постави нову лозинку',
    newPassword: 'Нова лозинка',
    confirmNewPassword: 'Потврди нову лозинку',
    setButton: 'Постави',

    repeatPassword: 'Понови лозинку',
    createNewAccount: 'Креирај нови налог',
    email: 'Адреса е-поште',
    firstName: 'Име',
    lastName: 'Презиме',
    country: 'Држава',
    phone: 'Телефон',
    password: 'Лозинка',
    createAccount: 'Креирај налог',
    currency: 'Валута',

    forgotPassword: 'Заборавили сте лозинку?',
    submitEmail:
      'Молимо унесите е-пошту коришћену за регистрацију, проверите пријемно сандуче и пратите добијена упутства',
    submit: 'Пошаљи',
    error: 'Грешка',
    success: 'Успех',
    deposit: 'Уплата',
    withdrawal: 'Исплата',
    depositApproved: 'Уплата је одобрена',
    depositDeclined: 'Уплата је одбијена',
    withdrawalApproved: 'Исплата је одобрена',
    withdrawalDeclined: 'Исплата је одбијена',

    forex: 'Форекс',
    stocks: 'Акције',
    commodities: 'Роба',
    indices: 'Индекси',
    crypto: 'Крипто',
    metals: 'Метали',
    nft: 'НФТ',

    buy: 'КУПИ',
    profitCalculator: 'Калкулатор профита',
    sell: 'ПРОДАЈ',
    volume: 'Обим',
    entryPrice: 'Улазна цена',
    takeProfit: 'Зарада',
    stopLoss: 'Стоп лосс',
    maxPosition: 'Максимална позиција',
    calculate: 'Израчунај',
    calculationsFor: 'Израчунавања за',
    leverage: 'Полуга',
    requiredMargin: 'Потребна маргина',
    profitFromTP: 'Профит од ТП',
    lossFromSL: 'Губитак од СЛ',
    roe: 'ROE',

    title: 'Уплата успешна',
    text: 'Ваша уплата је успешно обрађена!',

    title: 'Уплата неуспешна',
    text: 'Ваша уплата није обрађена.',

    marketWatch: 'Преглед тржишта',
    search: 'Претражи...',
    commission: 'Провизија',
    volume: 'Обим',
    margin: 'Маргина',
    active: 'Активно',
    pending: 'На чекању',
    activeOrders: 'Активни налози',
    portfolio: 'Портфељ',
    allPositions: 'Све позиције',
    noPositionsLine1: 'Немате отворених',
    noPositionsLine2: 'позиција још',
    show: 'Прикажи',
    more: 'више',
    less: 'мање',
    purchaseTime: 'Време куповине',
    closePosition: 'Затвори позицију',
    priceOpen: 'Цена куповине',
    priceSl: 'Цена стоп-лосса',
    priceTp: 'Цена циљане зараде',
    type: 'Смер позиције',
    pnl: 'Добит/Губитак',
    cancelOrder: 'Откажи налог',
    orderType: 'Тип налога',
    cancelled: 'Отказано',
    tradingHistory: 'Историја трговања',
    noHistoryLine1: 'Немате',
    noHistoryLine2: 'затворених налога још',

    economicCalendar: 'Економски календар',

    marketNews: 'Вести са тржишта',

    ordersActive: 'Активни налози',
    ordersHistory: 'Затворени налози',
    id: 'ID',
    symbol: 'Симбол',
    documentType: 'Тип',
    volume: 'Обим',
    openPrice: 'Отворена цена',
    openTime: 'Време отварања',
    closePrice: 'Затворена цена',
    closeTime: 'Време затварања',
    sl: 'SL',
    tp: 'TP',
    price: 'Цена',
    pnl: 'ПнЛ',
    actions: 'Акције',
    edit: 'Измени',
    close: 'Затвори',
    commission: 'Провизија',
    swap: 'Своп',
    swapLong: 'Своп Long',
    swapShort: 'Своп Short',

    assetInfo: 'Информације о средству',
    tradingConditions: 'Услови трговања',
    information: 'Промена сесије',
    bid: 'Понуда',
    ask: 'Потражња',
    sessionChange: 'Промена сесије',
    tradeNow: 'Тргуј одмах',
    opens: 'Отвара се',
    closes: 'Затвара се',
    at: 'у',
    open247: 'Отворено 24/7',
    today: 'данас',
    tomorrow: 'сутра',
    sunday: 'недеља',
    monday: 'понедељак',
    tuesday: 'уторак',
    wednesday: 'среда',
    thursday: 'четвртак',
    friday: 'петак',
    saturday: 'субота',
    contractSpecification: 'Спецификација уговора',
    symbol: 'Симбол',
    name: 'Назив',
    market: 'Тржиште',
    baseCurrency: 'Основна валута',
    digits: 'Децимале',
    lotSize: 'Величина лота',
    lotStep: 'Корак лота',
    minVolume: 'Минимални обим',
    maxVolume: 'Максимални обим',
    leverage: 'Полуга',
    commission: 'Провизија',
    swapLong: 'Своп Long',
    swapShort: 'Своп Short',
    schedule: 'Распоред',
    weekday: 'Дан у недељи',
    tradingTime: 'Време трговања',
    closed: 'затворено',
    sell: 'Продај',
    buy: 'Купи',
    low: 'Низак',
    medium: 'Средњи',
    high: 'Висок',
    oneHourChange: 'Промена за 1 сат',
    oneDayChange: 'Промена за 1 дан',
    oneWeekChange: 'Промена за 1 недељу',
    oneMonthChange: 'Промена за 1 месец',
    threeMonthsChange: 'Промена за 3 месеца',
    oneYearChange: 'Промена за 1 годину',
    loading: 'Учитавам...',

    traderTitle: 'Ауто Трговац',
    traderConfirm: 'Потврди и сачувај',
    riskLevelLow: 'Ниво ризика: ',
    riskLevelMedium: 'Ниво ризика: Средњи',
    riskLevelHigh: 'Ниво ризика: Висок',
    perDay: 'Трговина дневно:',
    desc: `Трговање CFD-овима и другим продуктима са полугом може довести до губитака. Пре трговања, клијенти би требало
да прочитају релевантна упозорења о ризику на нашој страници о ризицима. Аутоматизовано трговање не гарантује резултате. Компанија не сноси одговорност за губитак средстава у аутоматизованом трговању. Молимо уверите се да у потпуности разумете ризике и предузмете мере за њихово управљање.`,
    accept: 'Прихвати',

    trade: 'Тргуј',
    startTrading: 'Почни трговање',
    deposit: 'Уплата',
    dashboard: 'Контролна табла',
    personalInfo: 'Лични подаци',
    withdrawal: 'Исплата',
    verification: 'Верификација',
    accounts: 'Налози',
    liveChat: 'Уживо ћаскање',
    savings: 'Штедња',
    settings: 'Подешавања',
    logOut: 'Одјави се',

    methods: 'МЕТОДЕ',
    confirm: 'Потврдите у апликацији ваше банке',
    sendOtp: 'Пошаљи OTP',
    otpCode: 'OTP код',
    addWalletAddress:
      'Новчаник за ову методу уплате није подешен. Молимо контактирајте вашег агента или тим за подршку.',
    addressReceipt: 'Молимо сачекајте да се адреса учита',
    makeDeposit: 'ИЗВРШИ УПЛАТУ',
    instant: 'Одмах',
    minutes: 'минута',
    hours: 'сати',
    days: 'дана',
    amount: 'Износ',
    continue: 'Настави',
    qrCode: 'QR КОД',
    depositAddress: 'АДРЕСА ЗА УПЛАТУ',
    copy: 'Копирај',
    last: 'ПОСЛЕДЊЕ',
    deposits: 'УПЛАТЕ',
    time: 'Време',
    currency: 'Валута',
    status: 'Статус',
    info: 'Инфо',

    pleaseWait:
      'Молимо сачекајте. Повезујем се са провајдером платних услуга...',
    cardPayment: 'Плаћање картицом',
    inOrder: 'Да бисте послали износ',
    pleaseProvide: 'молимо наведите податке о картици:',

    completeVerification: 'Молимо завршите верификацију',
    noOrderYet: 'Још нема налога',
    totalBalance: 'Укупно стање',
    totalDeposits: 'Укупне уплате',
    profitableOrders: 'Профитабилни налози',
    totalPnl: 'Укупан ПнЛ',
    roi: 'ROI',
    activityLog: 'Дневник активности',
    loginFromIp: 'Пријава са IP',
    tradingResults: 'Резултати трговања',
    week: 'Недеља',
    month: 'Месец',
    year: 'Година',
    successRate: 'Стопа успеха',
    closedWithProfit: 'Затворено са профитом',
    closedWithLoss: 'Затворено са губитком',
    account: 'Налог',
    balance: 'Стање',
    leverage: 'Полуга',
    credit: 'Кредит',
    tradeNow: 'Тргуј одмах',
    usingCurrentRate: 'користећи тренутни девизни курс',

    personalDetails: 'Лични подаци',
    profilePhoto: 'Профилна фотографија',
    firstName: 'Име',
    country: 'Држава',
    lastName: 'Презиме',
    address: 'Адреса',
    email: 'E-mail',
    phone: 'Број телефона',
    saveChanges: 'Сачувај промене',

    dropFile: 'Превуците и отпустите документ овде да бисте га отпремили',
    notAllowed: 'Није дозвољено објављивање',
    notAllowedLine1:
      'Фотографије експлицитно сексуалне или порнографске природе',
    notAllowedLine2: 'Слике које подстичу етничку или расну мржњу или агресију',
    notAllowedLine3: 'Фотографије које укључују лица млађа од 18 година',
    notAllowedLine4: 'Фотографије заштићене ауторским правима трећих лица',
    notAllowedLine5:
      'Слике веће од 5 МБ и у формату другом осим JPG, GIF или PNG',
    requirements:
      'Ваше лице мора бити јасно видљиво на фотографији. Све фотографије и видео снимci које отпремите морају испуњавати ове захтеве, иначе могу бити уклоњени.',

    withdrawalOff:
      'Молимо контактирајте менаџера вашег налога за детаље исплате',
    cryptocurrency: 'Криптовалута',
    withdrawal: 'Исплата',
    requestNewWithdrawal: 'ЗАТРАЖИТЕ НОВУ ИСПЛАТУ',
    amount: 'Износ',
    currentBalance: 'Ваше тренутно стање на рачуну је',
    withdrawAll: 'Подигни све',
    requestWithdrawal: 'Затражи исплату',
    last: 'ПОСЛЕДЊЕ',
    withdrawalRequests: 'ЗАХТЕВИ ЗА ИСПЛАТУ',
    time: 'Време',
    currency: 'Валута',
    info: 'Инфо',
    status: 'Статус',
    bank: 'Банка',
    bitcoin: 'Биткоин',
    card: 'Картица',
    ethereum: 'Етеријум',
    eth: 'Етеријум',
    usdt: 'USDT',
    withdrawalDetails: 'Детаљи исплате',
    address: 'Адреса новчаника',
    bankAccount: 'Број рачуна',
    bankHolder: 'Име власника рачуна',
    bankIban: 'IBAN',
    bankSwift: 'SWIFT код банке',
    cardNumber: 'Број картице',
    cardHolder: 'Име власника картице',

    dragAndDrop: 'Превуците и отпустите документ овде да бисте га отпремили',
    documentsList: 'ЛИСТА ОТПРЕМЉЕНИХ ДОКУМЕНАТА',
    document: 'Документ',
    timeUploaded: 'Време отпремања',
    timeProcessed: 'Време обраде',
    status: 'Статус',
    types: [
      'Доказ о идентитету',
      'Доказ о адреси пребивалишта',
      'Предња страна кредитне картице',
      'Задња страна кредитне картице',
      'Задња страна доказа о идентитету',
      'Селфи',
    ],
    types2: [
      'Доказ о идентификацији (POI)',
      'Доказ о адреси пребивалишта',
      'Предња страна кредитне картице',
      'Задња страна кредитне картице',
      'Задња страна доказа о идентификацији',
      'Селфи са личном картом',
    ],
    upload: 'Отпреми',
    isConfirmed: 'је потврђен',
    uploadAnotherDocument: 'Отпреми други документ',
    isUnderReview: 'је на прегледу',
    questionnaire: 'Анкета',
    sendAnswers: 'Пошаљи одговоре',
    progressBarOf: 'од',
    progressBarText: 'ваших докумената је отпремљено и потврђено',

    manageAccounts: 'Пренос средстава између ваших налога',
    transferFrom: 'Са налога',
    transferTo: 'На налог',
    amount: 'Износ',
    makeTransfer: 'Изврши трансфер',
    yourAccounts: 'Ваши налози',
    account: 'Налог',
    currency: 'Валута',
    balance: 'Стање',
    credit: 'Кредит',
    makeActive: 'Постави активно',
    active: 'Активно',

    sendMessage: 'Пошаљи поруку',

    pct_0: 'Флексибилно',
    pct_30: 'Закључано 1 месец',
    pct_90: 'Закључано 1 квартал',
    pct_180: 'Закључано 6 месеци',
    pct_365: 'Закључано 1 година',
    savings: 'Штедња',
    detailedInformation: 'Детаљне информације',
    pleaseSelect: 'Изаберите валуту и период',
    openSavings: 'Отвори штедњу',
    currentTime: 'Тренутно време',
    releaseTime: 'Време ослобађања',
    currencyChosen: 'Одабрана валута',
    periodChosen: 'Одабрани период',
    yourRate: 'Ваша каматна стопа',
    yourEarnings: 'Ваша зарада',
    accountFrom: 'Рачун са ког се преносе средства',
    enterAmount: 'Унесите износ',
    in: 'у',
    openAndInvest: 'Отворите штедни рачун и уложите',
    investment: 'Улагање',
    period: 'Период',
    daysTotal: 'Укупно дана',
    finalEarnings: 'Коначна зарада',
    created: 'Креирано',
    daysElapsed: 'Прошло дана',
    days: 'дана',
    earnings: 'Зарада',
    fundsReleasedIn: 'Средства ће бити ослобођена за',
    claim: 'Захтевај',

    updatePassword: 'АЖУРИРАЈТЕ ЛОЗИНКУ',
    currentPassword: 'Тренутна лозинка',
    newPassword: 'Нова лозинка',
    changePassword: 'Промени лозинку',
    activationForGoogle: 'Активирајте код за Google Authenticator',
    activateAndEnter:
      'Активирајте аутентификатор и унесите генерисани код у поље испод',
    qrCode: 'QR код',
    activateProtection: 'Активирајте 2FA заштиту',
    protectionActive: '2FA заштита је активна',
    twoFactorCode: '2FA код',
    disableProtection: 'Онемогући 2FA заштиту',
    language: 'Језик',
    dashboardCurrency: 'Валута контролне табле',
    confirmNewPassword: 'Потврдите нову лозинку',

    yourLink: 'ВАШ ПРЕПОРУЧНИ ЛИНК',
    referredFriends: 'ПРЕПОРУЧЕНИ ПРИЈАТЕЉИ',
    id: 'ID',
    name: 'Име',
    registered: 'Регистрован',
    level: 'Ниво',
    payout: 'Исплата',
    lastPayouts: 'ПОСЛЕДЊЕ РЕФЕРАЛНЕ ИСПЛАТЕ',
    time: 'Време',
    amount: 'Износ',
    currency: 'Валута',
    info: 'Инфо',

    Jan: 'Јан',
    Feb: 'Феб',
    Mar: 'Мар',
    Apr: 'Апр',
    May: 'Мај',
    Jun: 'Јун',
    Jul: 'Јул',
    Aug: 'Авг',
    Sep: 'Сеп',
    Oct: 'Окт',
    Nov: 'Нов',
    Dec: 'Дец',

    orderTypes: [
      'Купи',
      'Продај',
      'Купи лимит',
      'Продај лимит',
      'Купи стоп',
      'Продај стоп',
    ],
    statuses: ['На чекању', 'Одобрено', 'Одбијено', 'У обради'],

    NOT_FOUND: 'Грешка у захтеву',
    FORBIDDEN: 'Приступ одбијен. Пријавите се поново',
    SERVER_ERROR: 'Акција није успела. Покушајте касније',
    INVALID_ACCOUNT: 'Сесија је истекла. Пријавите се поново',
    INVALID_EMAIL: 'Неважећа адреса е-поште',
    INVALID_PHONE: 'Неважећи број телефона',
    INVALID_COUNTRY: 'Неважећа држава',
    INVALID_LOGIN: 'Неважећи подаци за пријаву',
    USER_BLOCKED: 'Налог је блокиран. Контактирајте подршку',
    USER_REGISTERED:
      'Корисник са унетом адресом е-поште или бројем телефона већ је регистрован',
    INVALID_USER: 'Корисник није пронађен',
    REJECTED: 'Операција није дозвољена због ограничења платформе',
    INVALID_OLD_PASSWORD: 'Стара лозинка је неважећа',
    INVALID_SYMBOL: 'Неважећи симбол за трговање',
    INVALID_SYMBOL_PRECISION: 'Неважећа прецизност симбола',
    INVALID_FRAME: 'Неважећи оквир графикона',
    INVALID_CURRENCY: 'Неважећа валута',
    INVALID_PRODUCT: 'Неважећи тип трговачког налога',
    INSUFFICIENT_FUNDS: 'Недовољно средстава',
    INVALID_WITHDRAWAL: 'Исплата није пронађена',
    INVALID_STATUS: 'Неважећи статус',
    INVALID_FILE: 'Неважећа екстензија или превелика датотека',
    INVALID_DOCUMENT: 'Документ није пронађен',
    INVALID_NAME: 'Неважеће име',
    INVALID_LOT_SIZE: 'Неважећа величина лота',
    INVALID_LOT_STEP: 'Неважећи корак лота',
    INVALID_MIN_VOLUME: 'Неважећи минимални обим',
    INVALID_MAX_VOLUME: 'Неважећи максимални обим',
    INVALID_GROUP: 'Неважећа група',
    INVALID_SPREAD: 'Неважећи спред',
    REQUEST_TIMEOUT: 'Време захтева је истекло. Покушајте касније',
    INVALID_TYPE: 'Неважећи тип налога',
    INVALID_VOLUME: 'Неважећи обим налога',
    INVALID_SL: 'Неважећа вредност стоп-лосса',
    INVALID_TP: 'Неважећа вредност циљане зараде',
    INVALID_PRICE: 'Неважећа цена налога',
    INVALID_EXPIRATION: 'Неважећи рок истека налога',
    NOT_ENOUGH_MARGIN: 'Недовољно маргине',
    INVALID_ORDER: 'Налог није пронађен',
    MARKET_CLOSED: 'Трговање није доступно. Покушајте касније',
    INVALID_BALANCE_TYPE: 'Неважећи тип стања',
    INVALID_HASH: 'Неважећи hash',
    HASH_EXPIRED: 'Линк за ресетовање лозинке је истекао. Затражите нови',
    INVALID_CODE: 'Неважећи 2FA код',
    CHAT_DISABLED: 'Приступ ћаскању подршке је онемогућен',
    WITHDRAWAL_NOT_ALLOWED: 'Приступ исплатама је онемогућен',
    TRADING_DISABLED: 'Трговање је онемогућено за тренутни налог',
    PENDING_DEPOSITS_LIMIT: 'Премашен лимит уплата',
    LOCAL_ONE_PENDING_WITHDRAWAL: 'Дозвољена је само једна исплата у процесу',
    LOCAL_DEPOSIT_ONLY_REAL: 'Уплата је доступна само за прави налог',
    LOCAL_DEPOSIT_POSITIVE: 'Износ уплате мора бити већи од 0',
    LOCAL_INVALID_CARD_NUMBER: 'Неважећи број картице',
    LOCAL_INVALID_CARD_EXPIRATION: 'Неважећи рок важења картице',
    LOCAL_INVALID_CVC: 'Неважећи CVV/CVC код',
    LOCAL_PASSWORDS_NOT_MATCH: 'Лозинке се не поклапају, унесите поново',
    LOCAL_NO_TRADING_ACCOUNTS:
      'Немате расположиве трговачке налоге. Контактирајте подршку',
    LOCAL_MIN_DEPOSIT: 'Минимална уплата је $',
    LOCAL_MIN_WITHDRAWAL: 'Минимални износ за исплату је $',
    LOCAL_INVALID_FILE_TYPE:
      'Формат датотеке није подржан. Приложите само JPG, PNG или PDF',
    LOCAL_MIN_STAKING: 'Минимална уплата за ову валуту је ',
    FLOOD_REJECTED: 'Слање порука превише често. Покушајте касније',
    countries: {
      AF: 'Авганистан',
      AX: 'Оландска острва',
      AL: 'Албанија',
      DZ: 'Алжир',
      AS: 'Америчка Самоа',
      AD: 'Андора',
      AO: 'Ангола',
      AI: 'Ангвила',
      AQ: 'Антарктик',
      AG: 'Антигва и Барбуда',
      AR: 'Аргентина',
      AM: 'Јерменија',
      AW: 'Аруба',
      AU: 'Аустралија',
      AT: 'Аустрија',
      AZ: 'Азербејџан',
      BS: 'Бахами',
      BH: 'Бахреин',
      BD: 'Бангладеш',
      BB: 'Барбадос',
      BY: 'Белорусија',
      BE: 'Белгија',
      BZ: 'Белизе',
      BJ: 'Бенин',
      BM: 'Бермуда',
      BT: 'Бутан',
      BO: 'Боливија',
      BA: 'Босна и Херцеговина',
      BW: 'Боцвана',
      BV: 'Буве острво',
      BR: 'Бразил',
      IO: 'Британска територија Индијског океана',
      BN: 'Брунеј Дарусалам',
      BG: 'Бугарска',
      BF: 'Буркина Фасо',
      BI: 'Бурунди',
      KH: 'Камбоџа',
      CM: 'Камерун',
      CA: 'Канада',
      CV: 'Зеленортска Острва',
      KY: 'Кајманска Острва',
      CF: 'Централноафричка Република',
      TD: 'Чад',
      CL: 'Чиле',
      CN: 'Кина',
      CX: 'Божићно Острво',
      CC: 'Кокосова (Килингова) Острва',
      CO: 'Колумбија',
      KM: 'Комори',
      CG: 'Конго',
      CD: 'Демократска Република Конго',
      CK: 'Кукова Острва',
      CR: 'Костарика',
      CI: 'Обала Слоноваче',
      HR: 'Хрватска',
      CU: 'Куба',
      CY: 'Кипар',
      CZ: 'Чешка Република',
      DK: 'Данска',
      DJ: 'Џибути',
      DM: 'Доминика',
      DO: 'Доминиканска Република',
      EC: 'Еквадор',
      EG: 'Египат',
      SV: 'Ел Салвадор',
      GQ: 'Екваторијална Гвинеја',
      ER: 'Еритреја',
      EE: 'Естонија',
      ET: 'Етиопија',
      FK: 'Фокландска Острва (Малвинска)',
      FO: 'Фарска Острва',
      FJ: 'Фиџи',
      FI: 'Финска',
      FR: 'Француска',
      GF: 'Француска Гвајана',
      PF: 'Француска Полинезија',
      TF: 'Француска Јужна Територија',
      GA: 'Габон',
      GM: 'Гамбија',
      GE: 'Грузија',
      DE: 'Немачка',
      GH: 'Гана',
      GI: 'Гибралтар',
      GR: 'Грчка',
      GL: 'Гренланд',
      GD: 'Гренада',
      GP: 'Гвадалупе',
      GU: 'Гвам',
      GT: 'Гватемала',
      GG: 'Гернзи',
      GN: 'Гвинеја',
      GW: 'Гвинеја-Бисао',
      GY: 'Гвајана',
      HT: 'Хаити',
      HM: 'Острво Херд и Острва Мекдоналд',
      VA: 'Ватикан (Света Столица)',
      HN: 'Хондурас',
      HK: 'Хонг Конг',
      HU: 'Мађарска',
      IS: 'Исланд',
      IN: 'Индија',
      ID: 'Индонезија',
      IR: 'Иран',
      IQ: 'Ирак',
      IE: 'Ирска',
      IM: 'Острво Ман',
      IL: 'Израел',
      IT: 'Италија',
      JM: 'Јамајка',
      JP: 'Јапан',
      JE: 'Џерзи',
      JO: 'Јордан',
      KZ: 'Казахстан',
      KE: 'Кенија',
      KI: 'Кирибати',
      KR: 'Кореја',
      KW: 'Кувајт',
      KG: 'Киргистан',
      LA: 'Лаос (Народна Демократска Република)',
      LV: 'Летонија',
      LB: 'Либан',
      LS: 'Лесото',
      LR: 'Либерија',
      LY: 'Либија',
      LI: 'Лихтенштајн',
      LT: 'Литванија',
      LU: 'Луксембург',
      MO: 'Макао',
      MK: 'Северна Македонија',
      MG: 'Мадагаскар',
      MW: 'Малави',
      MY: 'Малезија',
      MV: 'Малдиви',
      ML: 'Мали',
      MT: 'Малта',
      MH: 'Маршалова Острва',
      MQ: 'Мартиник',
      MR: 'Мавританија',
      MU: 'Маурицијус',
      YT: 'Мајот',
      MX: 'Мексико',
      FM: 'Микронезија',
      MD: 'Молдавија',
      MC: 'Монако',
      MN: 'Монголија',
      ME: 'Црна Гора',
      MS: 'Монсерат',
      MA: 'Мароко',
      MZ: 'Мозамбик',
      MM: 'Мијанмар',
      NA: 'Намибија',
      NR: 'Науру',
      NP: 'Непал',
      NL: 'Холандија',
      AN: 'Холандски Антили',
      NC: 'Нова Каледонија',
      NZ: 'Нови Зеланд',
      NI: 'Никарагва',
      NE: 'Нигер',
      NG: 'Нигерија',
      NU: 'Није',
      NF: 'Острво Норфолк',
      MP: 'Северна Маријанска Острва',
      NO: 'Норвешка',
      OM: 'Оман',
      PK: 'Пакистан',
      PW: 'Палау',
      PS: 'Палестинске Територије, окупиране',
      PA: 'Панама',
      PG: 'Папуа Нова Гвинеја',
      PY: 'Парагвај',
      PE: 'Перу',
      PH: 'Филипини',
      PN: 'Питкерн',
      PL: 'Пољска',
      PT: 'Португал',
      PR: 'Порторико',
      QA: 'Катар',
      RE: 'Реунион',
      RO: 'Румунија',
      RU: 'Русија',
      RW: 'Руанда',
      BL: 'Сен Бартелеми',
      SH: 'Света Јелена',
      KN: 'Сент Китс и Невис',
      LC: 'Сент Луција',
      MF: 'Сент Мартен',
      PM: 'Сент Пјер и Микелон',
      VC: 'Сент Винсент и Гренадини',
      WS: 'Самоа',
      SM: 'Сан Марино',
      ST: 'Сао Томе и Принципе',
      SA: 'Саудијска Арабија',
      SN: 'Сенегал',
      RS: 'Србија',
      SC: 'Сејшели',
      SL: 'Сијера Леоне',
      SG: 'Сингапур',
      SK: 'Словачка',
      SI: 'Словенија',
      SB: 'Соломонска Острва',
      SO: 'Сомалија',
      ZA: 'Јужноафричка Република',
      GS: 'Јужна Џорџија и Сендвич Острва',
      ES: 'Шпанија',
      LK: 'Шри Ланка',
      SD: 'Судан',
      SR: 'Суринам',
      SJ: 'Свалбард и Јан Мајен',
      SZ: 'Свазиленд',
      SE: 'Шведска',
      CH: 'Швајцарска',
      SY: 'Сиријска Арапска Република',
      TW: 'Тајван',
      TJ: 'Таџикистан',
      TZ: 'Танзанија',
      TH: 'Тајланд',
      TL: 'Источни Тимор',
      TG: 'Того',
      TK: 'Токелау',
      TO: 'Тонга',
      TT: 'Тринидад и Тобаго',
      TN: 'Тунис',
      TR: 'Турска',
      TM: 'Туркменистан',
      TC: 'Туркс и Кајкос Острва',
      TV: 'Тувалу',
      UG: 'Уганда',
      UA: 'Украјина',
      AE: 'Уједињени Арапски Емирати',
      GB: 'Уједињено Краљевство',
      US: 'Сједињене Америчке Државе',
      UM: 'Спољна Острва Сједињених Америчких Држава',
      UY: 'Уругвај',
      UZ: 'Узбекистан',
      VU: 'Вануату',
      VE: 'Венецуела',
      VN: 'Вијетнам',
      VG: 'Британска Девичанска Острва',
      VI: 'Девичанска Острва (САД)',
      WF: 'Валис и Футуна',
      EH: 'Западна Сахара',
      YE: 'Јемен',
      ZM: 'Замбија',
      ZW: 'Зимбабве',
    },
  },
  al: {
    _name: 'Albanian',
    policy: 'Politika e Privatësisë',
    policyAML: 'Politika AML',
    policyKYC: 'Politika KYC',
    locense: 'Leje',
    view_all: 'Shiko të gjitha',
    sell_btn: 'Shit',
    buy_btn: 'Blej',
    currency_action: 'monedhë',

    importantAccountDetails: 'Detajet e rëndësishme të llogarisë',
    viewAdditionalSettings: 'Shiko cilësimet shtesë',
    switchDarkMode: 'Ndrysho modalitetin errësirë/dritë',
    writeProblem: 'Shkruaj problemin tek ne',
    darkMode: 'Modaliteti errësirë',

    yay: 'Jupi',
    purchased: 'Ju keni blerë me sukses',
    from: 'nga',
    walet: 'Portofol',
    trade: 'Tregtoni',

    withdrawDetails: 'Detajet e tërheqjes',
    saveDetails: 'Ruaj detajet për herën tjetër',
    amountToWithdraw: 'Shuma për të tërhequr',
    withdrawLimit: 'Kufiri i tërheqjes ditore prej 1.000.000,00 $ mbetet.',

    serviceFee: 'Tarifa e shërbimit',
    youWillPay: 'Ju do të paguani',
    cancel: 'Anulo',
    understand: 'E kuptoj, vazhdo',

    select: 'Zgjidh',
    enterAmount: 'Shkruaj shumën',
    orderInfo: 'Informacioni i porosisë',
    confirmOrder: 'Konfirmo porosinë',
    get: 'Merr',
    spend: 'Shpenzo',
    buying: 'Duke blerë',
    accountTransactions: 'Transaksionet e llogarisë',
    overview: 'Përmbledhje',
    accountBalances: 'Balancat e llogarisë',
    details: 'Detaje',
    loginHistory: 'Historia e hyrjes',
    device: 'Pajisja',
    contactUs: 'Kontakto na',
    sessionLog: 'Sesione & historia e hyrjeve',
    selectMethods: 'Zgjidh metodat',
    depositDetails: 'Detajet e depozitës',
    order: 'Porosi',
    support: 'Mbështetje',
    supportChat: 'Bisedë mbështetjeje',
    createChat: 'Krijo bisedë',
    homepage: 'Faqja kryesore',
    takeProfitStopLoss: 'Marr Fitimin & Ndali Humbjen',
    takeProfit: 'Marr Fitimin',
    stopLoss: 'Ndali Humbjen',
    updateOrder: 'Përditëso porosinë',
    balance: 'Bilanci',
    credit: 'Kredi',
    equity: 'Ekuivalencë',
    practice: 'PRAKTIKË',
    real: 'E VËRTETË',
    account: 'LLOGARI',
    invested: 'Investuar',
    profit: 'Fitim',
    loss: 'Humbje',
    margin: 'Margjina',
    marginLevel: 'Niveli i margjinës',
    marginFree: 'Margjina e lirë',
    cfd: 'CFD',
    platform: 'Platformë',
    deposit: 'Depozitë',
    marketWatch: 'Vëzhgim i tregut',
    activeOrders: 'Porositë e hapura',
    tradingHistory: 'Historia e tregtimit',
    economicCalendar: 'Kalendari ekonomik',
    marketNews: 'Lajmet e tregut',
    closeOrder: 'Mbyll pozicionin',
    areYouSure: 'A jeni i sigurt që të mbyllni pozicionin',
    buy: 'Blej',
    sell: 'Shit',
    yes: 'Po',
    no: 'Jo',
    addNewChart: 'Shto grafikë të ri',
    watchlist: 'Lista e vëzhgimit',
    asset: 'Pasuri',
    price: 'Çmim',
    changePct: 'Ndryshim 24h',
    pending: 'Në pritje',
    assetPrice: 'Çmimi i pasurisë',
    current: 'Aktualisht',
    revert: 'Kthehu te Çmimi i Tregut',
    automatically:
      'Pozicioni do të hapet automatikisht kur çmimi arrin këtë nivel',
    default: 'parazgjedhje',
    volume: 'Vëllimi',
    lots: 'sete',
    units: 'njësi',
    currency: 'monedhë',
    contractSize: 'Madhësia e kontratës',
    position: 'Pozicioni',
    margin: 'Margjina',
    freeMargin: 'Margjina e lirë',
    takeProfitStopLoss: 'Marr Fitimin & Ndali Humbjen',
    pending: 'Në pritje',
    market: 'Tregu',
    leverage: 'Leverage',
    spread: 'Spread',
    notSet: 'Nuk është vendosur',
    at: 'në',
    buy: 'blej',
    sell: 'shit',
    supportBanner: 'ÇDO DITË, GJATË NËNËZËR',
    currentTime: 'KOHA AKTUALE',
    liveChat: 'Bisedë e drejtpërdrejtë',
    balance: 'Bilanci',
    credit: 'Kredi',
    equity: 'Ekuivalencë',
    margin: 'Margjina',
    marginLevel: 'Niveli i margjinës',
    freeMargin: 'Margjina e lirë',
    pnl: 'P&L',
    profitTotal: 'P&L i jetës',
    dateRegistered: 'Data e regjistrimit',
    userId: 'ID përdoruesi',
    dashboard: 'Paneli',
    personalData: 'Të dhënat personale',
    deposit: 'Depozitë',
    withdrawFunds: 'Tërhiq fonde',
    savings: ' Kursime',
    settings: 'Cilësime',
    logout: 'Dil',
    BT_INVOICE: 'Shkruaj shumën dhe krijo faturë',
    BT_TITLE: 'Detajet tona bankare',
    account: 'Llogaria',
    bank_name: 'Emri i bankës',
    beneficiary: 'Përfituesi',
    beneficiary_address: 'Adresa e përfituesit',
    swift: 'Swift',
    iban: 'IBAN',
    ru_inn: 'INN',
    ru_kpp: 'KPP',
    corresponding_account: 'Llogari korresponduese',
    TOKEN_AMOUNT: 'Shuma',
    TOKEN_SUBTOTAL: 'Nëntotali',
    TOKEN_TOTAL: 'Totali',
    TOKEN_DESCRIPTION: 'Përshkrimi',
    TOKEN_PAYMENT_DETAILS: 'Detajet e pagesës',
    PENDING_DEPOSITS_LIMIT: 'Kufiri i depozitave',
    makeDeposit: 'Bëj një depozitë',
    practiceAccount: 'Llogari praktike',
    realAccount: 'Llogari reale',
    noWithdrawals: 'Asnjë tërheqje',
    easyWithdrawals: 'Tërheqje të lehta',
    allAssets: 'Të gjitha pasuritë në dispozicion',
    fullFledged: 'Platformë me kapacitete të plota',
    fillUpTo: 'Mbush deri në',
    freeReplenishment: 'Rifreskim falas',
    topUp: 'Mbush llogarinë tënde',
    minimumAmount: 'Shuma minimale',
    maxAmount: 'Shuma maksimale',
    withdrawalType: 'Lloji i tërheqjes',
    canSwitch: 'Mund të ndërrosh ndërmjet llogarive në çdo çast',
    chartGrids: 'RRJETAT E GRAFIKËVE',
    chart1: '1 grafik',
    chart2: '2 grafika',
    chart3: '3 grafika',
    chart4: '4 grafika',
    connectionLost: 'Lidhja me serverin është humbur',
    retryNow: 'Provo përsëri tani',
    loginToTradeRoom: 'Hyr në dhomën e tregtimit',
    email: 'Adresa e email-it',
    enterEmail: 'Shkruaj email-in tënd',
    twoFactor: 'Kodi 2FA (nëse është aktivizuar)',
    twoFactorAuth: 'Autentikimi me dy faktorë',
    password: 'Fjalëkalimi',
    yourPassword: 'Fjalëkalimi yt',
    signIn: 'Hyni',
    dontHaveAccount: 'Nuk keni llogari?',
    restore: 'Rikthe',
    fullName: 'Emri i plotë',
    havePromo: 'Kam kod promo',
    promo: 'Kodi promo',
    login: 'Hyr',
    haveAccount: 'Ke tashmë një llogari?',
    hide: 'Fshih',
    goTo: 'Kthehu mbrapsht',

    setNewPassword: 'Vendos fjalëkalim të ri',
    newPassword: 'Fjalëkalim i ri',
    confirmNewPassword: 'Konfirmo fjalëkalimin e ri',
    setButton: 'Vendos',

    repeatPassword: 'Përsërit fjalëkalimin',
    createNewAccount: 'Krijo një llogari të re',
    email: 'Adresa e email-it',
    firstName: 'Emri',
    lastName: 'Mbiemri',
    country: 'Shteti',
    phone: 'Telefoni',
    password: 'Fjalëkalimi',
    createAccount: 'Krijo llogari',
    currency: 'Monedha',

    forgotPassword: 'Harruat fjalëkalimin?',
    submitEmail:
      'Ju lutemi dërgoni një email të përdorur për regjistrimin, kontrolloni postën dhe ndiqni udhëzimet',
    submit: 'Dërgo',
    error: 'Gabim',
    success: 'Sukses',
    deposit: 'Depozitë',
    withdrawal: 'Tërheqje',
    depositApproved: 'Depozita është miratuar',
    depositDeclined: 'Depozita është refuzuar',
    withdrawalApproved: 'Tërheqja është miratuar',
    withdrawalDeclined: 'Tërheqja është refuzuar',

    forex: 'Forex',
    stocks: 'Aksione',
    commodities: 'Mallra',
    indices: 'Indekse',
    crypto: 'Kripto',
    metals: 'Metale',
    nft: 'NFT',

    buy: 'BLEJ',
    profitCalculator: 'Llogaritësi i fitimit',
    sell: 'SHTIT',
    volume: 'Vëllim',
    entryPrice: 'Çmimi i hyrjes',
    takeProfit: 'Marr Fitimin',
    stopLoss: 'Ndali Humbjen',
    maxPosition: 'Pozicioni maksimal',
    calculate: 'Llogarit',
    calculationsFor: 'Llogaritje për',
    leverage: 'Leverage',
    requiredMargin: 'Margjina e nevojshme',
    profitFromTP: 'Fitim nga TP',
    lossFromSL: 'Humbje nga SL',
    roe: 'ROE',

    title: 'Depozita e suksesshme',
    text: 'Depozita juaj është përpunuar me sukses!',

    title: 'Depozita dështoi',
    text: 'Depozita juaj nuk u përpunua.',

    marketWatch: 'Vëzhgimi i tregut',
    search: 'Kërko...',
    commission: 'Komision',
    volume: 'Vëllim',
    margin: 'Margjina',
    active: 'Aktiv',
    pending: 'Në pritje',
    activeOrders: 'Porosi aktive',
    portfolio: 'Portofol',
    allPositions: 'Të gjitha pozicionet',
    noPositionsLine1: 'Ju nuk keni ende asnjë',
    noPositionsLine2: 'pozicion të hapur',
    show: 'Shiko',
    more: 'më shumë',
    less: 'më pak',
    purchaseTime: 'Koha e blerjes',
    closePosition: 'Mbyll pozicionin',
    priceOpen: 'Çmimi i blerjes',
    priceSl: 'Çmimi Stop Loss',
    priceTp: 'Çmimi Take Profit',
    type: 'Drejtimi i pozicionit',
    pnl: 'Fitim/Humbje',
    cancelOrder: 'Anulo porosinë',
    orderType: 'Lloji i porosisë',
    cancelled: 'Anuluar',
    tradingHistory: 'Historia e tregtimit',
    noHistoryLine1: 'Ju nuk keni asnjë',
    noHistoryLine2: 'marrëveshje të mbyllura ende',
    economicCalendar: 'Kalendari ekonomik',
    marketNews: 'Lajmet e tregut',
    ordersActive: 'Porositë aktive',
    ordersHistory: 'Porositë e mbyllura',
    id: 'ID',
    symbol: 'Simbol',
    documentType: 'Lloji',
    volume: 'Vëllim',
    openPrice: 'Çmimi i hapjes',
    openTime: 'Koha e hapjes',
    closePrice: 'Çmimi i mbylljes',
    closeTime: 'Koha e mbylljes',
    sl: 'SL',
    tp: 'TP',
    price: 'Çmimi',
    pnl: 'P&L',
    actions: 'Veprimet',
    edit: 'Redakto',
    close: 'Mbyll',
    commission: 'Komision',
    swap: 'Swap',
    swapLong: 'Swap Long',
    swapShort: 'Swap Short',

    assetInfo: 'Informacion mbi pasurinë',
    tradingConditions: 'Kushtet e tregtimit',
    information: 'Ndryshimi i seancës',
    bid: 'Oferta',
    ask: 'Kërkesa',
    sessionChange: 'Ndryshimi i seancës',
    tradeNow: 'Tregtoni tani',
    opens: 'Hapet',
    closes: 'Mbyllet',
    at: 'në',
    open247: 'Hapet 24/7',
    today: 'sot',
    tomorrow: 'nesër',
    sunday: 'E Diel',
    monday: 'E hënë',
    tuesday: 'E martë',
    wednesday: 'E mërkurë',
    thursday: 'E enjte',
    friday: 'E premte',
    saturday: 'E shtunë',
    contractSpecification: 'Specifikimi i kontratës',
    symbol: 'Simbol',
    name: 'Emri',
    market: 'Tregu',
    baseCurrency: 'Monedha bazë',
    digits: 'Shifra',
    lotSize: 'Madhësia e lotit',
    lotStep: 'Hapi i lotit',
    minVolume: 'Volumi minimal',
    maxVolume: 'Volumi maksimal',
    leverage: 'Leverage',
    commission: 'Komision',
    swapLong: 'Swap Long',
    swapShort: 'Swap Short',
    schedule: 'Orari',
    weekday: 'Dita e javës',
    tradingTime: 'Koha e tregtimit',
    closed: 'mbyllur',
    sell: 'Shit',
    buy: 'Blej',
    low: 'I ulët',
    medium: 'Mesatar',
    high: 'I lartë',
    oneHourChange: 'Ndryshim 1 ore',
    oneDayChange: 'Ndryshim 1 dite',
    oneWeekChange: 'Ndryshim 1 javë',
    oneMonthChange: 'Ndryshim 1 muaj',
    threeMonthsChange: 'Ndryshim 3 muaj',
    oneYearChange: 'Ndryshim 1 vit',
    loading: 'Po ngarkohet...',

    traderTitle: 'Tregëtar Automatik',
    traderConfirm: 'Konfirmo dhe ruaj',
    riskLevelLow: 'Niveli i riskut: I ulët',
    riskLevelMedium: 'Niveli i riskut: Mesatar',
    riskLevelHigh: 'Niveli i riskut: I lartë',
    perDay: 'Tregti në ditë:',
    desc: `Tregtimi i CFD-ve dhe produkteve të tjera me levë mund të sjellë humbje. Para se të tregtoni, klientët duhet të  
lexojnë deklaratat përkatëse të rrezikut në faqen tonë të Zbulimit të Rrezikut. Tregtimi i automatizuar nuk garanton rezultate.  
Kompania nuk pranon asnjë përgjegjësi për humbjen e fondeve në tregtimin automatik. Ju lutemi sigurohuni që të  
kuptoni plotësisht rreziqet dhe të merrni masa për menaxhimin e tyre.`,
    accept: 'Prano',

    trade: 'Tregtoni',
    startTrading: 'Filloni të tregtoni',
    deposit: 'Depozitë',
    dashboard: 'Paneli',
    personalInfo: 'Informacion personal',
    withdrawal: 'Tërheqje',
    verification: 'Verifikim',
    accounts: 'Llogaritë',
    liveChat: 'Bisedë e drejtpërdrejtë',
    savings: 'Kursime',
    settings: 'Cilësimet',
    logOut: 'Dil',

    methods: 'METODAT',
    confirm: 'Konfirmo në aplikacionin e bankës tuaj',
    sendOtp: 'Dërgo OTP',
    otpCode: 'Kodi OTP',
    addWalletAddress:
      'Portofoli për këtë mënyrë depozite nuk është vendosur. Ju lutemi kontaktoni agjentin tuaj ose ekipin e mbështetjes.',
    addressReceipt: 'Ju lutemi prisni që të ngarkohet adresa',
    makeDeposit: 'BËNI NJË DEPOZITË',
    instant: 'Instant',
    minutes: 'minuta',
    hours: 'orë',
    days: 'ditë',
    amount: 'Shuma',
    continue: 'Vazhdo',
    qrCode: 'Kodi QR',
    depositAddress: 'ADRESA E DEPOZITËS',
    copy: 'Kopjo',
    last: 'FUNDI',
    deposits: 'DEPOZITA',
    time: 'Koha',
    currency: 'Monedha',
    status: 'Statusi',
    info: 'Informacioni',

    pleaseWait:
      'Ju lutemi prisni. Duke u lidhur me ofruesin e shërbimit të pagesave...',
    cardPayment: 'Pagesa me kartë',
    inOrder: 'Për të dërguar shumën',
    pleaseProvide: 'ju lutemi jepni detajet e kartës:',

    completeVerification: 'Ju lutemi përfundoni verifikimin',
    noOrderYet: 'Asnjë porosi ende',
    totalBalance: 'Bilanci total',
    totalDeposits: 'Depozitat totale',
    profitableOrders: 'Porosi fitimprurëse',
    totalPnl: 'P&L totali',
    roi: 'ROI',
    activityLog: 'Regjistri i aktivitetit',
    loginFromIp: 'Hyrje nga IP',
    tradingResults: 'Rezultatet e tregtimit',
    week: 'Java',
    month: 'Muaji',
    year: 'Viti',
    successRate: 'Shkalla e suksesit',
    closedWithProfit: 'Mbyllur me fitim',
    closedWithLoss: 'Mbyllur me humbje',
    account: 'Llogaria',
    balance: 'Bilanci',
    leverage: 'Leverage',
    credit: 'Kredi',
    tradeNow: 'Tregtoni tani',
    usingCurrentRate: 'duke përdorur kursin aktual',

    personalDetails: 'Detajet personale',
    profilePhoto: 'Foto e profilit',
    firstName: 'Emri',
    country: 'Shteti',
    lastName: 'Mbiemri',
    address: 'Adresa',
    email: 'E-mail',
    phone: 'Numri i telefonit',
    saveChanges: 'Ruaj ndryshimet',

    dropFile: 'Hidh një skedar mbi rrethin më sipër për të ngarkuar',
    notAllowed: 'Nuk lejohet të publikohet',
    notAllowedLine1: 'Foto me natyrë tërësisht seksuale ose pornografike',
    notAllowedLine2:
      'Imazhe që synojnë të nxisin urrejtje ose agresion etnik apo racor',
    notAllowedLine3: 'Foto që përfshijnë persona nën 18 vjeç',
    notAllowedLine4:
      'Foto të mbrojtura nga e drejta e autorit të palëve të treta',
    notAllowedLine5:
      'Imazhe më të mëdha se 5 MB dhe në format tjetër përveç JPG, GIF ose PNG',
    requirements:
      'Do të jetë fytyra juaj e dukshme qartë në foto. Të gjitha fotografitë dhe videot e ngarkuara nga ju duhet të përmbushin këto kërkesa, përndryshe ato mund të hiqen.',

    withdrawalOff:
      'Ju lutemi kontaktoni menaxherin e llogarisë për detajet e tërheqjes',
    cryptocurrency: 'Kriptomonedhë',
    withdrawal: 'Tërheqje',
    requestNewWithdrawal: 'KERKONI NJË TËRHEQJE TË RE',
    amount: 'Shuma',
    currentBalance: 'Bilanci juaj aktual i llogarisë është',
    withdrawAll: 'Tërhiq gjithçka',
    requestWithdrawal: 'Kërko tërheqje',
    last: 'FUNDI',
    withdrawalRequests: 'KERKESAT E TËRHEQJES',
    time: 'Koha',
    currency: 'Monedha',
    info: 'Informacioni',
    status: 'Statusi',
    bank: 'Banka',
    bitcoin: 'Bitcoin',
    card: 'Kartë',
    ethereum: 'Ethereum',
    eth: 'Ethereum',
    usdt: 'USDT',
    withdrawalDetails: 'Detajet e tërheqjes',
    address: 'Adresa e portofolit',
    bankAccount: 'Numri i llogarisë bankare',
    bankHolder: 'Emri i mbajtësit të llogarisë',
    bankIban: 'IBAN i bankës',
    bankSwift: 'Kodi SWIFT i bankës',
    cardNumber: 'Numri i kartës',
    cardHolder: 'Emri i mbajtësit të kartës',

    dragAndDrop: 'terhiq dhe le të rëzohet dokumenti në këtë zonë',
    documentsList: 'LISTA E DOKUMENTEVE TË NGARKUARA',
    document: 'Dokumenti',
    timeUploaded: 'Koha e ngarkimit',
    timeProcessed: 'Koha e përpunimit',
    status: 'Statusi',
    types: [
      'Dëshmi identiteti',
      'Dëshmi e vendbanimit',
      'Pjesa e përparme e kartës së kreditit',
      'Pjesa e pasme e kartës së kreditit',
      'Pjesa e pasme e dëshmisë së identitetit',
      'Selfi',
    ],
    types2: [
      'Dëshmi e identifikimit (POI)',
      'Dëshmi e adresës së banimit',
      'Pjesa e përparme e kartës së kreditit',
      'Pjesa e pasme e kartës së kreditit',
      'Dëshmi e identifikimit (pas)',
      'Selfi me ID',
    ],
    upload: 'Ngarko',
    isConfirmed: 'është konfirmuar',
    uploadAnotherDocument: 'Ngarko dokument tjetër',
    isUnderReview: 'është nën shqyrtim',
    questionnaire: 'Pyetësor',
    sendAnswers: 'Dërgo përgjigjet',
    progressBarOf: 'nga',
    progressBarText: 'dokumentet tuaja janë ngarkuar dhe konfirmuar',

    manageAccounts: 'Transfero fonde midis llogarive tuaja',
    transferFrom: 'Nga llogaria',
    transferTo: 'Në llogarinë',
    amount: 'Shuma',
    makeTransfer: 'Bëj transferim',
    yourAccounts: 'Llogaritë tuaja',
    account: 'Llogaria',
    currency: 'Monedha',
    balance: 'Bilanci',
    credit: 'Kredi',
    makeActive: 'Bëj aktive',
    active: 'Aktive',

    sendMessage: 'Dërgo mesazh',

    pct_0: 'Fleksibël',
    pct_30: 'I bllokuar 1 muaj',
    pct_90: 'I bllokuar 1 tremujor',
    pct_180: 'I bllokuar 6 muaj',
    pct_365: 'I bllokuar 1 vit',
    savings: 'Kurime',
    detailedInformation: 'Informacion i detajuar',
    pleaseSelect: 'Ju lutemi zgjidhni një monedhë dhe një periudhë',
    openSavings: 'Hap llogari kursimi',
    currentTime: 'Koha aktuale',
    releaseTime: 'Koha e lirimit',
    currencyChosen: 'Monedha e zgjedhur',
    periodChosen: 'Periudha e zgjedhur',
    yourRate: 'Norma juaj',
    yourEarnings: 'Të ardhurat tuaja',
    accountFrom: 'Llogaria për të transferuar fonde',
    enterAmount: 'Shkruaj shumën',
    in: 'Në',
    openAndInvest: 'Hap llogarinë e kursimit dhe investo',
    investment: 'Investim',
    period: 'Periudha',
    daysTotal: 'Ditë gjithsej',
    finalEarnings: 'Të ardhurat përfundimtare',
    created: 'Krijuar',
    daysElapsed: 'Ditë të kaluara',
    days: 'ditë',
    earnings: 'Të ardhura',
    fundsReleasedIn: 'Fonde të liruar në',
    claim: 'Kërko',

    updatePassword: 'PËRDITËSO FJALËKALIMIN',
    currentPassword: 'Fjalëkalimi aktual',
    newPassword: 'Fjalëkalim i ri',
    changePassword: 'Ndrysho fjalëkalimin',
    activationForGoogle: 'Kodi i aktivizimit për Google Authenticator',
    activateAndEnter:
      'Aktivizo Authenticator dhe shkruaj kodin e gjeneruar më poshtë',
    qrCode: 'Kodi QR',
    activateProtection: 'Aktivizo mbrojtjen 2FA',
    protectionActive: 'Mbrojtja 2FA është aktive',
    twoFactorCode: 'Kodi 2FA',
    disableProtection: 'Çaktivizo mbrojtjen 2FA',
    language: 'Gjuha',
    dashboardCurrency: 'Monedha e panelit',
    confirmNewPassword: 'Konfirmo fjalëkalimin e ri',

    yourLink: 'LIDHJA JUAJ REFERUESE',
    referredFriends: 'MIQ REFERUESE',
    id: 'ID',
    name: 'Emri',
    registered: 'Regjistruar',
    level: 'Niveli',
    payout: 'Pagesa',
    lastPayouts: 'PAGESAT E FUNDIT REFERUESE',
    time: 'Koha',
    amount: 'Shuma',
    currency: 'Monedha',
    info: 'Informacion',

    Jan: 'Jan',
    Feb: 'Shk',
    Mar: 'Mar',
    Apr: 'Pri',
    May: 'Maj',
    Jun: 'Qer',
    Jul: 'Kor',
    Aug: 'Gus',
    Sep: 'Sht',
    Oct: 'Tet',
    Nov: 'Nën',
    Dec: 'Dhj',

    orderTypes: [
      'Blej',
      'Shit',
      'Blej Limit',
      'Shit Limit',
      'Blej Stop',
      'Shit Stop',
    ],
    statuses: ['Në pritje', 'Miratuar', 'Refuzuar', 'Në përpunim'],

    NOT_FOUND: 'Gabim në kërkesë',
    FORBIDDEN: 'Qasje e mohuar. Ju lutemi rilogohuni',
    SERVER_ERROR: 'Veprimi dështoi. Ju lutemi provoni më vonë',
    INVALID_ACCOUNT: 'Sesioni ka skaduar. Ju lutemi rilogohuni',
    INVALID_EMAIL: 'Adresa e e-mail-it është e pavlefshme',
    INVALID_PHONE: 'Numri i telefonit është i pavlefshëm',
    INVALID_COUNTRY: 'Shteti është i pavlefshëm',
    INVALID_LOGIN: 'Kredencialet e hyrjes janë të pavlefshme',
    USER_BLOCKED: 'Llogaria është bllokuar. Ju lutemi kontaktoni mbështetjen',
    USER_REGISTERED:
      'Përdoruesi me e-mail-in ose numrin e telefonit të futur është tashmë i regjistruar',
    INVALID_USER: 'Përdoruesi nuk u gjet',
    REJECTED: 'Operacioni nuk lejohet për shkak të kufizimeve të platformës',
    INVALID_OLD_PASSWORD: 'Fjalëkalimi i vjetër është i pavlefshëm',
    INVALID_SYMBOL: 'Simbol tregtimi i pavlefshëm',
    INVALID_SYMBOL_PRECISION: 'Saktësia e simbolit e pavlefshme',
    INVALID_FRAME: 'Korniza e grafikës është e pavlefshme',
    INVALID_CURRENCY: 'Monedha është e pavlefshme',
    INVALID_PRODUCT: 'Lloji i llogarisë tregtare është i pavlefshëm',
    INSUFFICIENT_FUNDS: 'Fonde të pamjaftueshme',
    INVALID_WITHDRAWAL: 'Tërheqja nuk u gjet',
    INVALID_STATUS: 'Statusi është i pavlefshëm',
    INVALID_FILE:
      'Zgjerimi i skedarit është i pavlefshëm ose skedari është shumë i madh',
    INVALID_DOCUMENT: 'Dokumenti nuk u gjet',
    INVALID_NAME: 'Emri është i pavlefshëm',
    INVALID_LOT_SIZE: 'Madhësia e lotit është e pavlefshme',
    INVALID_LOT_STEP: 'Hapi i lotit është i pavlefshëm',
    INVALID_MIN_VOLUME: 'Volumi minimal është i pavlefshëm',
    INVALID_MAX_VOLUME: 'Volumi maksimal është i pavlefshëm',
    INVALID_GROUP: 'Grupi është i pavlefshëm',
    INVALID_SPREAD: 'Spread-i është i pavlefshëm',
    REQUEST_TIMEOUT:
      'Kërkesa ka kaluar kohën. Ju lutemi provoni përsëri më vonë',
    INVALID_TYPE: 'Lloji i porosisë është i pavlefshëm',
    INVALID_VOLUME: 'Volumi i porosisë është i pavlefshëm',
    INVALID_SL: 'Vlera e stop loss-it është e pavlefshme',
    INVALID_TP: 'Vlera e take profit-it është e pavlefshme',
    INVALID_PRICE: 'Çmimi i porosisë është i pavlefshëm',
    INVALID_EXPIRATION: 'Skadimi i porosisë është i pavlefshëm',
    NOT_ENOUGH_MARGIN: 'Nuk ka mjaftueshëm margjinë',
    INVALID_ORDER: 'Porosia nuk u gjet',
    MARKET_CLOSED:
      'Tregtimi nuk është i disponueshëm. Ju lutemi provoni më vonë',
    INVALID_BALANCE_TYPE: 'Lloji i operacionit të bilancit është i pavlefshëm',
    INVALID_HASH: 'Hash-i është i pavlefshëm',
    HASH_EXPIRED:
      'Lidhja juaj për rivendosjen e fjalëkalimit ka skaduar. Ju lutemi kërkoni një të re',
    INVALID_CODE: 'Kodi 2FA është i pavlefshëm',
    CHAT_DISABLED: 'Qasja në bisedën e mbështetjes është e mbyllur',
    WITHDRAWAL_NOT_ALLOWED: 'Qasja në tërheqje është e mbyllur',
    TRADING_DISABLED: 'Tregtimi është i çaktivizuar për llogarinë aktuale',
    PENDING_DEPOSITS_LIMIT: 'Kufiri i depozitave është tejkaluar',
    LOCAL_ONE_PENDING_WITHDRAWAL: 'Vetëm një tërheqje në pritje lejohet',
    LOCAL_DEPOSIT_ONLY_REAL:
      'Depozita është e disponueshme vetëm për llogarinë reale',
    LOCAL_DEPOSIT_POSITIVE: 'Shuma e depozitës duhet të jetë më shumë se 0',
    LOCAL_INVALID_CARD_NUMBER: 'Numri i kartës është i pavlefshëm',
    LOCAL_INVALID_CARD_EXPIRATION: 'Skadimi i kartës është i pavlefshëm',
    LOCAL_INVALID_CVC: 'CVC/CVV është i pavlefshëm',
    LOCAL_PASSWORDS_NOT_MATCH:
      'Fjalëkalimet nuk përputhen, ju lutemi shkruani përsëri',
    LOCAL_NO_TRADING_ACCOUNTS:
      'Nuk keni llogari tregtare në dispozicion. Ju lutemi kontaktoni mbështetjen',
    LOCAL_MIN_DEPOSIT: 'Depozita minimale është $',
    LOCAL_MIN_WITHDRAWAL: 'Shuma minimale e tërheqjes është $',
    LOCAL_INVALID_FILE_TYPE:
      'Formati i skedarit nuk mbështetet. Ju lutemi bashkëngjitni vetëm JPG, PNG ose PDF',
    LOCAL_MIN_STAKING: 'Depozita minimale për këtë monedhë është ',
    FLOOD_REJECTED:
      'Po dërgoni mesazhe shumë shpesh. Ju lutemi provoni më vonë',
    countries: {
      AF: 'Afganistan',
      AX: 'Ishujt Aland',
      AL: 'Shqipëria',
      DZ: 'Algjeria',
      AS: 'Samoa Amerikane',
      AD: 'Andora',
      AO: 'Angola',
      AI: 'Angvila',
      AQ: 'Antarktika',
      AG: 'Antigua dhe Barbuda',
      AR: 'Argjentinë',
      AM: 'Armeni',
      AW: 'Aruba',
      AU: 'Australi',
      AT: 'Austri',
      AZ: 'Azerbajxhan',
      BS: 'Bahamas',
      BH: 'Bahrein',
      BD: 'Bangladeshi',
      BB: 'Barbados',
      BY: 'Bjellorusi',
      BE: 'Belgjikë',
      BZ: 'Belize',
      BJ: 'Benini',
      BM: 'Bermuda',
      BT: 'Butan',
      BO: 'Bolivi',
      BA: 'Bosnja dhe Hercegovina',
      BW: 'Botsvana',
      BV: 'Ishulli Buve',
      BR: 'Brazil',
      IO: 'Territori Britanik i Oqeanit Indian',
      BN: 'Brunei Daruselam',
      BG: 'Bullgari',
      BF: 'Burkina Faso',
      BI: 'Burundi',
      KH: 'Kamboxhia',
      CM: 'Kamerun',
      CA: 'Kanada',
      CV: 'Kepi i Gjelbër',
      KY: 'Ishujt Kajman',
      CF: 'Republika e Afrikës Qendrore',
      TD: 'Çadi',
      CL: 'Kili',
      CN: 'Kina',
      CX: 'Ishulli i Krishtlindjes',
      CC: 'Ishujt Koko (Keeling)',
      CO: 'Kolumbi',
      KM: 'Komore',
      CG: 'Kongo',
      CD: 'Republika Demokratike e Kongos',
      CK: 'Ishujt Kuk',
      CR: 'Kosta Rika',
      CI: 'Bregu i Fildishtë',
      HR: 'Kroaci',
      CU: 'Kubë',
      CY: 'Qipro',
      CZ: 'Republika Çeke',
      DK: 'Danimarkë',
      DJ: 'Xhibut',
      DM: 'Dominika',
      DO: 'Republika Dominikane',
      EC: 'Ekuador',
      EG: 'Egjipt',
      SV: 'El Salvador',
      GQ: 'Guineja Ekuatoriale',
      ER: 'Eritre',
      EE: 'Estoni',
      ET: 'Etiopi',
      FK: 'Ishujt Falkland (Malvinas)',
      FO: 'Ishujt Faroe',
      FJ: 'Fixhi',
      FI: 'Finlandë',
      FR: 'Francë',
      GF: 'Guajana Franceze',
      PF: 'Polinezia Franceze',
      TF: 'Territorët Jugorë Francezë',
      GA: 'Gabon',
      GM: 'Gambie',
      GE: 'Gjeorgji',
      DE: 'Gjermani',
      GH: 'Gana',
      GI: 'Gjybraltar',
      GR: 'Greqi',
      GL: 'Grenlandë',
      GD: 'Grenada',
      GP: 'Gvadelupë',
      GU: 'Guam',
      GT: 'Guatemalë',
      GG: 'Guernsey',
      GN: 'Guine',
      GW: 'Guine-Bisau',
      GY: 'Guajanë',
      HT: 'Haiti',
      HM: 'Ishulli Herd & Ishujt Mëkdolande',
      VA: 'Selia e Shenjtë (Shteti i Vatikanit)',
      HN: 'Hondurë',
      HK: 'Hong Kong',
      HU: 'Hungari',
      IS: 'Islandë',
      IN: 'Indi',
      ID: 'Indonezi',
      IR: 'Iran',
      IQ: 'Irak',
      IE: 'Irlandë',
      IM: 'Ishulli i Manit',
      IL: 'Izrael',
      IT: 'Itali',
      JM: 'Xhamajkë',
      JP: 'Japoni',
      JE: 'Xhersej',
      JO: 'Jordan',
      KZ: 'Kazakistan',
      KE: 'Kenia',
      KI: 'Kiribati',
      KR: 'Korea',
      KW: 'Kuvajt',
      KG: 'Kirgistan',
      LA: 'Republika Popullore Demokratike e Laosit',
      LV: 'Letoni',
      LB: 'Liban',
      LS: 'Lesoto',
      LR: 'Liberi',
      LY: 'Jamahiriya Arabe Libiane',
      LI: 'Lihtenshtajn',
      LT: 'Lituani',
      LU: 'Luksemburg',
      MO: 'Makao',
      MK: 'Maqedonia',
      MG: 'Madagaskar',
      MW: 'Malavi',
      MY: 'Malajzi',
      MV: 'Maldivet',
      ML: 'Mali',
      MT: 'Maltë',
      MH: 'Ishujt Marshall',
      MQ: 'Martinikë',
      MR: 'Mauritani',
      MU: 'Mauricius',
      YT: 'Majot',
      MX: 'Meksikë',
      FM: 'Mikronezi',
      MD: 'Moldavi',
      MC: 'Monako',
      MN: 'Mongoli',
      ME: 'Mali i Zi',
      MS: 'Montserat',
      MA: 'Marok',
      MZ: 'Mozambik',
      MM: 'Myanmar',
      NA: 'Namibi',
      NR: 'Nauru',
      NP: 'Nepal',
      NL: 'Holandë',
      AN: 'Antilet Holandeze',
      NC: 'Kaledonia e Re',
      NZ: 'Zelanda e Re',
      NI: 'Nikaragua',
      NE: 'Nizer',
      NG: 'Nigeri',
      NU: 'Niue',
      NF: 'Ishulli Norfolk',
      MP: 'Ishujt Mariana Veriore',
      NO: 'Norvegji',
      OM: 'Oman',
      PK: 'Pakistan',
      PW: 'Palau',
      PS: 'Territori Palestinian, i Okupuаr',
      PA: 'Panama',
      PG: 'Papua Guinea e Re',
      PY: 'Paraguaj',
      PE: 'Peru',
      PH: 'Filipine',
      PN: 'Pitkern',
      PL: 'Poloni',
      PT: 'Portugali',
      PR: 'Puerto Riko',
      QA: 'Katar',
      RE: 'Reunion',
      RO: 'Rumani',
      RU: 'Rusi',
      RW: 'Ruanda',
      BL: 'Shën Bartenli',
      SH: 'Shën Helenë',
      KN: 'Shën Kits dhe Nevis',
      LC: 'Shën Lucia',
      MF: 'Shën Martin',
      PM: 'Shën Pjer dhe Mikelon',
      VC: 'Shën Vincenc dhe Grenadinat',
      WS: 'Samoë',
      SM: 'San Marino',
      ST: 'Sao Tome e Prinsipi',
      SA: 'Arabia Saudite',
      SN: 'Senegali',
      RS: 'Serbi',
      SC: 'Sejshelle',
      SL: 'Sierra Leone',
      SG: 'Singapor',
      SK: 'Sllovaki',
      SI: 'Slloveni',
      SB: 'Ishujt Solomon',
      SO: 'Somali',
      ZA: 'Afrika e Jugut',
      GS: 'Georgia e Jugut dhe Ishujt Sandwich',
      ES: 'Spanjë',
      LK: 'Sri Lanka',
      SD: 'Sudani',
      SR: 'Suriname',
      SJ: 'Svalbard dhe Jan Majen',
      SZ: 'Suaziland',
      SE: 'Suedi',
      CH: 'Zvicër',
      SY: 'Republika Arabe Siriane',
      TW: 'Tajvan',
      TJ: 'Taxhikistan',
      TZ: 'Tanzani',
      TH: 'Tajlandë',
      TL: 'Timor-Leste',
      TG: 'Togo',
      TK: 'Tokelau',
      TO: 'Tonga',
      TT: 'Trinidad dhe Tobago',
      TN: 'Tunizi',
      TR: 'Turqi',
      TM: 'Turkmenistan',
      TC: 'Ishujt Turks e Caicos',
      TV: 'Tuvalu',
      UG: 'Ugandë',
      UA: 'Ukrainë',
      AE: 'Emiratet e Bashkuara Arabe',
      GB: 'Mbretëria e Bashkuar',
      US: 'Shtetet e Bashkuara',
      UM: 'Ishujt rrethoresh të Shteteve të Bashkuara',
      UY: 'Uruguaj',
      UZ: 'Uzbekistan',
      VU: 'Vanuatu',
      VE: 'Venezuelë',
      VN: 'Vietnam',
      VG: 'Ishujt Virgjin, Britanikë',
      VI: 'Ishujt Virgjin, SHBA',
      WF: 'Wallis dhe Futuna',
      EH: 'Sahara Perëndimore',
      YE: 'Jemen',
      ZM: 'Zambi',
      ZW: 'Zimbabve',
    },
  },
}
